import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Decimal: { input: any; output: any; }
  Int64: { input: any; output: any; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
  openfed__Scope: { input: any; output: any; }
};

export type AcceptAndStartTaskInput = {
  putawayTaskID: Scalars['UUID']['input'];
};

export type AccountJournal = {
  __typename?: 'AccountJournal';
  accountJournalID: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AccountJournalPaged = {
  __typename?: 'AccountJournalPaged';
  items?: Maybe<Array<AccountJournal>>;
  pagination: PaginationResult;
};

export type AccountJournalQopFilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AccountJournalQopInput = {
  filters?: InputMaybe<AccountJournalQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type AdminResetPasswordInput = {
  username: Scalars['String']['input'];
};

export type AdminResetPasswordResponse = {
  __typename?: 'AdminResetPasswordResponse';
  newPassword: Scalars['String']['output'];
};

export type AiAppClient = {
  __typename?: 'AiAppClient';
  apiKey: Scalars['String']['output'];
  appId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  domains: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rateLimitPerMin: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type AiChatCreateSessionInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AiChatMessage = {
  __typename?: 'AiChatMessage';
  content: Scalars['String']['output'];
  createdTimeUtc: Scalars['String']['output'];
  messageID: Scalars['String']['output'];
  senderRole: Scalars['String']['output'];
  sessionID: Scalars['String']['output'];
};

export type AiChatMessagePaged = {
  __typename?: 'AiChatMessagePaged';
  items: Array<AiChatMessage>;
  pageInfo: AiChatPageInfo;
};

export type AiChatMessageQopInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sessionID: Scalars['String']['input'];
  sortDir?: InputMaybe<Scalars['String']['input']>;
};

export type AiChatPageInfo = {
  __typename?: 'AiChatPageInfo';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AiChatRenameSessionInput = {
  sessionID: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AiChatSendMessageInput = {
  message: Scalars['String']['input'];
  sessionID?: InputMaybe<Scalars['String']['input']>;
};

export type AiChatSendMessageResponse = {
  __typename?: 'AiChatSendMessageResponse';
  messageID: Scalars['String']['output'];
  response: Scalars['String']['output'];
  sessionID: Scalars['String']['output'];
};

export type AiChatSession = {
  __typename?: 'AiChatSession';
  branchCode?: Maybe<Scalars['String']['output']>;
  branchID?: Maybe<Scalars['String']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  createdTimeUtc: Scalars['String']['output'];
  lastMessageAt: Scalars['String']['output'];
  sessionID: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AiChatSessionPaged = {
  __typename?: 'AiChatSessionPaged';
  items: Array<AiChatSession>;
  pageInfo: AiChatPageInfo;
};

export type AiChatSessionQopInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
};

export type AiDlpGuardConfig = {
  __typename?: 'AiDlpGuardConfig';
  maskEmails: Scalars['Boolean']['output'];
  maskPhones: Scalars['Boolean']['output'];
  maskSecrets: Scalars['Boolean']['output'];
};

export type AiGuardrailsConfig = {
  __typename?: 'AiGuardrailsConfig';
  defaultApp: Scalars['String']['output'];
  dlp: AiDlpGuardConfig;
  prompt: AiPromptGuardConfig;
  sql: AiSqlGuardConfig;
};

export type AiPromptGuardConfig = {
  __typename?: 'AiPromptGuardConfig';
  jailbreakPatterns: Array<Scalars['String']['output']>;
};

export type AiScopeConfig = {
  __typename?: 'AiScopeConfig';
  tables: Array<AiScopeTable>;
  tools: Array<AiScopeTool>;
};

export type AiScopeTable = {
  __typename?: 'AiScopeTable';
  description: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AiScopeTool = {
  __typename?: 'AiScopeTool';
  description: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requiredScope: Scalars['String']['output'];
};

export type AiSqlGuardConfig = {
  __typename?: 'AiSqlGuardConfig';
  blockedTables: Array<Scalars['String']['output']>;
  forbiddenStmts: Array<Scalars['String']['output']>;
  readOnly: Scalars['Boolean']['output'];
};

export type AiUpdateDlpGuardInput = {
  maskEmails?: InputMaybe<Scalars['Boolean']['input']>;
  maskPhones?: InputMaybe<Scalars['Boolean']['input']>;
  maskSecrets?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiUpdateGuardrailsInput = {
  defaultApp?: InputMaybe<Scalars['String']['input']>;
  dlp?: InputMaybe<AiUpdateDlpGuardInput>;
  prompt?: InputMaybe<AiUpdatePromptGuardInput>;
  sql?: InputMaybe<AiUpdateSqlGuardInput>;
};

export type AiUpdatePromptGuardInput = {
  jailbreakPatterns?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AiUpdateScopeTableInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type AiUpdateScopeToolInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type AiUpdateSqlGuardInput = {
  blockedTables?: InputMaybe<Array<Scalars['String']['input']>>;
  forbiddenStmts?: InputMaybe<Array<Scalars['String']['input']>>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiUpsertAppClientInput = {
  appId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  domains: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  rateLimitPerMin?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type App = {
  __typename?: 'App';
  appID: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
};

export type AppCreateInput = {
  appID: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type AppPaged = {
  __typename?: 'AppPaged';
  items?: Maybe<Array<App>>;
  pagination: PaginationResult;
};

export type AppQopFilterInput = {
  appName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type AppQopInput = {
  filters?: InputMaybe<AppQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type AppRole = {
  __typename?: 'AppRole';
  appID: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  roleID: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
};

export type AppRolePermission = {
  __typename?: 'AppRolePermission';
  appID: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  roles?: Maybe<Array<RoleProfile>>;
};

export type AppUpdateInput = {
  appID: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type AssignTaskInput = {
  assignedToUserID: Scalars['UUID']['input'];
  putawayTaskID: Scalars['UUID']['input'];
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  accessToken: Scalars['String']['output'];
  appRolePermissions?: Maybe<Array<AppRolePermission>>;
  appRoles?: Maybe<Array<AppRole>>;
  branches?: Maybe<Array<BranchProfile>>;
  defaultBranchCode?: Maybe<Scalars['String']['output']>;
  defaultBranchID?: Maybe<Scalars['UUID']['output']>;
  defaultBranchName?: Maybe<Scalars['String']['output']>;
  defaultRoleAppID?: Maybe<Scalars['String']['output']>;
  defaultRoleAppName?: Maybe<Scalars['String']['output']>;
  defaultRoleID?: Maybe<Scalars['UUID']['output']>;
  defaultRoleName?: Maybe<Scalars['String']['output']>;
  defaultWarehouseID?: Maybe<Scalars['UUID']['output']>;
  defaultWarehouseName?: Maybe<Scalars['String']['output']>;
  isAllBranches?: Maybe<Scalars['Boolean']['output']>;
  refreshToken: Scalars['String']['output'];
  user: UserProfile;
};

export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  backgroundJobID: Scalars['UUID']['output'];
  branchID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  finishedDatetime?: Maybe<Scalars['Time']['output']>;
  finishedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  jobCategory: Scalars['String']['output'];
  jobData: Scalars['String']['output'];
  jobDescription: Scalars['String']['output'];
  jobKey: Scalars['String']['output'];
  jobMessage: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  retryCount: Scalars['Int']['output'];
  startedDatetime?: Maybe<Scalars['Time']['output']>;
  startedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type BackgroundJobCreateInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  finishedDatetime?: InputMaybe<Scalars['Time']['input']>;
  finishedDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  jobCategory: Scalars['String']['input'];
  jobData?: InputMaybe<Scalars['String']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  jobKey: Scalars['String']['input'];
  jobMessage?: InputMaybe<Scalars['String']['input']>;
  jobType: Scalars['String']['input'];
  processedCount?: InputMaybe<Scalars['Int']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  startedDatetime?: InputMaybe<Scalars['Time']['input']>;
  startedDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  status: Scalars['String']['input'];
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type BackgroundJobPaged = {
  __typename?: 'BackgroundJobPaged';
  items?: Maybe<Array<BackgroundJob>>;
  pagination: PaginationResult;
};

export type BackgroundJobQopFilterInput = {
  backgroundJobIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  finishedDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  finishedDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  jobCategory?: InputMaybe<Scalars['String']['input']>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  startedDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  startedDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type BackgroundJobQopInput = {
  filters?: InputMaybe<BackgroundJobQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BackgroundJobUpdateInput = {
  backgroundJobID: Scalars['UUID']['input'];
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  finishedDatetime?: InputMaybe<Scalars['Time']['input']>;
  finishedDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  jobCategory: Scalars['String']['input'];
  jobData?: InputMaybe<Scalars['String']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  jobKey: Scalars['String']['input'];
  jobMessage?: InputMaybe<Scalars['String']['input']>;
  jobType: Scalars['String']['input'];
  processedCount?: InputMaybe<Scalars['Int']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  startedDatetime?: InputMaybe<Scalars['Time']['input']>;
  startedDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  status: Scalars['String']['input'];
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type Bank = {
  __typename?: 'Bank';
  bankID: Scalars['UUID']['output'];
  bankName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  bank: Bank;
  bankAccountID: Scalars['UUID']['output'];
  bankAccountNumber: Scalars['String']['output'];
  bankID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  journalAccountCode: Scalars['String']['output'];
  journalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  journalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type BankAccountCreateInput = {
  bankAccountNumber: Scalars['String']['input'];
  bankID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
};

export type BankAccountPaged = {
  __typename?: 'BankAccountPaged';
  items?: Maybe<Array<BankAccount>>;
  pagination: PaginationResult;
};

export type BankAccountQopFilterInput = {
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BankAccountQopInput = {
  filters?: InputMaybe<BankAccountQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankAccountUpdateInput = {
  bankAccountID: Scalars['UUID']['input'];
  bankAccountNumber: Scalars['String']['input'];
  bankID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
};

export type BankCreateInput = {
  bankName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BankDataRow = {
  __typename?: 'BankDataRow';
  amount: Scalars['Float']['output'];
  approvalCode: Scalars['String']['output'];
  bankAccountID: Scalars['UUID']['output'];
  bankDataRowID: Scalars['UUID']['output'];
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankName: Scalars['String']['output'];
  bankReconciliationID?: Maybe<Scalars['UUID']['output']>;
  bankReconciliationItemID?: Maybe<Scalars['UUID']['output']>;
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName: Scalars['String']['output'];
  cardNumber: Scalars['String']['output'];
  externalTransactionID: Scalars['String']['output'];
  isMatched: Scalars['Boolean']['output'];
  matchedAt?: Maybe<Scalars['Time']['output']>;
  mdrAmount: Scalars['Float']['output'];
  merchantID: Scalars['String']['output'];
  merchantName: Scalars['String']['output'];
  netAmount: Scalars['Float']['output'];
  referenceNumber: Scalars['String']['output'];
  settlementDate?: Maybe<Scalars['Time']['output']>;
  terminalID: Scalars['String']['output'];
  transactionDate: Scalars['Time']['output'];
  transactionTime: Scalars['String']['output'];
  uploadBatchID?: Maybe<Scalars['UUID']['output']>;
  uploadFilename: Scalars['String']['output'];
};

export type BankDataRowPaged = {
  __typename?: 'BankDataRowPaged';
  items: Array<BankDataRow>;
  pagination: PaginationResult;
};

export type BankDataRowQopFilterInput = {
  approvalCode?: InputMaybe<Scalars['String']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankReconciliationID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  isMatched?: InputMaybe<Scalars['Boolean']['input']>;
  merchantID?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  transactionDateFrom?: InputMaybe<Scalars['Time']['input']>;
  transactionDateTo?: InputMaybe<Scalars['Time']['input']>;
  uploadBatchID?: InputMaybe<Scalars['UUID']['input']>;
};

export type BankDataRowQopInput = {
  filters?: InputMaybe<BankDataRowQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankPaged = {
  __typename?: 'BankPaged';
  items?: Maybe<Array<Bank>>;
  pagination: PaginationResult;
};

export type BankQopFilterInput = {
  bankName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BankQopInput = {
  filters?: InputMaybe<BankQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankReconciliation = {
  __typename?: 'BankReconciliation';
  bankID: Scalars['UUID']['output'];
  bankName: Scalars['String']['output'];
  bankReconciliationID: Scalars['UUID']['output'];
  bankReconciliationNumber: Scalars['String']['output'];
  branches: Array<BankReconciliationBranch>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  doneByUserID?: Maybe<Scalars['UUID']['output']>;
  doneByUserName?: Maybe<Scalars['String']['output']>;
  doneDatetime?: Maybe<Scalars['Time']['output']>;
  doneDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  reconDate: Scalars['Time']['output'];
  reconDatetime: Scalars['Time']['output'];
  reconDatetimeUtc: Scalars['Time']['output'];
  settlementDateFrom?: Maybe<Scalars['Time']['output']>;
  settlementDateTo?: Maybe<Scalars['Time']['output']>;
  statementFileID?: Maybe<Scalars['UUID']['output']>;
  statementFileName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalItems: Scalars['Int']['output'];
  totalMatched: Scalars['Int']['output'];
  totalPartialMatched: Scalars['Int']['output'];
  totalUnmatched: Scalars['Int']['output'];
};

export type BankReconciliationBranch = {
  __typename?: 'BankReconciliationBranch';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
};

export type BankReconciliationCancelInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['UUID']['input'];
};

export type BankReconciliationColumnMapInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationCreateInput = {
  bankID: Scalars['UUID']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  branchIDs: Array<Scalars['UUID']['input']>;
  reconDate?: InputMaybe<Scalars['Time']['input']>;
  transactionDateFrom: Scalars['Time']['input'];
  transactionDateTo: Scalars['Time']['input'];
};

export type BankReconciliationExport = {
  __typename?: 'BankReconciliationExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type BankReconciliationExportInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  statuses: Array<Scalars['String']['input']>;
};

export type BankReconciliationFile = {
  __typename?: 'BankReconciliationFile';
  bankID: Scalars['UUID']['output'];
  bankReconciliationFileID: Scalars['UUID']['output'];
  bankReconciliationID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  midFailureCount: Scalars['Int']['output'];
  rowCount: Scalars['Int']['output'];
  settlementDateFrom?: Maybe<Scalars['Time']['output']>;
  settlementDateTo?: Maybe<Scalars['Time']['output']>;
  statementFileID: Scalars['UUID']['output'];
  statementFileName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type BankReconciliationFileMappingInput = {
  columns: Array<BankReconciliationColumnMapInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type BankReconciliationFinalizeInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type BankReconciliationImportDuplicateMerchantId = {
  __typename?: 'BankReconciliationImportDuplicateMerchantID';
  branches: Array<BankReconciliationImportMerchantBranch>;
  merchantID: Scalars['String']['output'];
};

export type BankReconciliationImportMerchantBranch = {
  __typename?: 'BankReconciliationImportMerchantBranch';
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
};

export type BankReconciliationImportRowReport = {
  __typename?: 'BankReconciliationImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  validTotalAmount: Scalars['Float']['output'];
  violationGroups: Array<BankReconciliationImportRowViolationGroup>;
  violationSample: Array<BankReconciliationImportRowViolation>;
};

export type BankReconciliationImportRowViolation = {
  __typename?: 'BankReconciliationImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BankReconciliationImportRowViolationGroup = {
  __typename?: 'BankReconciliationImportRowViolationGroup';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  sampleRowNumbers: Array<Scalars['Int']['output']>;
  sampleValue: Scalars['String']['output'];
  standardKey: Scalars['String']['output'];
};

export type BankReconciliationImportValidateInput = {
  bankID: Scalars['UUID']['input'];
  fileID: Scalars['UUID']['input'];
  fileMapping: BankReconciliationFileMappingInput;
  reconDate: Scalars['Time']['input'];
};

export type BankReconciliationImportValidateResult = {
  __typename?: 'BankReconciliationImportValidateResult';
  alreadyReconciledAmount: Scalars['Float']['output'];
  alreadyReconciledCount: Scalars['Int']['output'];
  duplicateMerchantIDs: Array<BankReconciliationImportDuplicateMerchantId>;
  missingMerchantIDs: Array<Scalars['String']['output']>;
  rowReport: BankReconciliationImportRowReport;
};

export type BankReconciliationItem = {
  __typename?: 'BankReconciliationItem';
  amount: Scalars['Float']['output'];
  approvalCode: Scalars['String']['output'];
  bankAccountID: Scalars['UUID']['output'];
  bankBranchID?: Maybe<Scalars['UUID']['output']>;
  bankBranchName: Scalars['String']['output'];
  bankExist: Scalars['Boolean']['output'];
  bankReconciliationID: Scalars['UUID']['output'];
  bankReconciliationItemID: Scalars['UUID']['output'];
  cardNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalTransactionID: Scalars['String']['output'];
  isReconciliation: Scalars['Boolean']['output'];
  issuer: Scalars['String']['output'];
  matchedAt?: Maybe<Scalars['Time']['output']>;
  matchedAtUtc?: Maybe<Scalars['Time']['output']>;
  matchedSalesInvoicePaymentID?: Maybe<Scalars['UUID']['output']>;
  mdrAmount: Scalars['Float']['output'];
  merchantID: Scalars['String']['output'];
  merchantName: Scalars['String']['output'];
  netAmount: Scalars['Float']['output'];
  note: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentApprovalCode: Scalars['String']['output'];
  paymentBankReferenceNumber: Scalars['String']['output'];
  paymentBranchID?: Maybe<Scalars['UUID']['output']>;
  paymentBranchName: Scalars['String']['output'];
  paymentCardNumber: Scalars['String']['output'];
  paymentCashierUserName: Scalars['String']['output'];
  paymentDate?: Maybe<Scalars['Time']['output']>;
  paymentDatetime?: Maybe<Scalars['Time']['output']>;
  paymentMethodID?: Maybe<Scalars['UUID']['output']>;
  paymentMethodName: Scalars['String']['output'];
  rawDescription: Scalars['String']['output'];
  reconciliationStatus: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  resolution: Scalars['String']['output'];
  resolutionReason: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Time']['output']>;
  resolvedAtUtc?: Maybe<Scalars['Time']['output']>;
  resolvedByUserID?: Maybe<Scalars['UUID']['output']>;
  resolvedByUserName?: Maybe<Scalars['String']['output']>;
  salesInvoiceID?: Maybe<Scalars['UUID']['output']>;
  salesInvoiceNumber: Scalars['String']['output'];
  salesInvoicePaymentID?: Maybe<Scalars['UUID']['output']>;
  salesPaymentExist: Scalars['Boolean']['output'];
  settlementDate?: Maybe<Scalars['Time']['output']>;
  terminalID: Scalars['String']['output'];
  transactionDate?: Maybe<Scalars['Time']['output']>;
  transactionTime: Scalars['String']['output'];
};

export type BankReconciliationItemManualMatchInput = {
  bankReconciliationItemID: Scalars['UUID']['input'];
  matchedSalesInvoicePaymentID?: InputMaybe<Scalars['UUID']['input']>;
  reconciliationStatus: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationItemMergeInput = {
  reconciliationStatus: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
  sourceItemID: Scalars['UUID']['input'];
  targetItemID: Scalars['UUID']['input'];
};

export type BankReconciliationItemPaged = {
  __typename?: 'BankReconciliationItemPaged';
  items: Array<BankReconciliationItem>;
  pagination: PaginationResult;
};

export type BankReconciliationItemQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  approvalCode?: InputMaybe<Scalars['String']['input']>;
  bankBranchID?: InputMaybe<Scalars['UUID']['input']>;
  bankReconciliationID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  merchantID?: InputMaybe<Scalars['String']['input']>;
  paymentBranchID?: InputMaybe<Scalars['UUID']['input']>;
  paymentDateFrom?: InputMaybe<Scalars['String']['input']>;
  paymentDateTo?: InputMaybe<Scalars['String']['input']>;
  reconciliationStatus?: InputMaybe<Scalars['String']['input']>;
  reconciliationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationItemQopInput = {
  filters?: InputMaybe<BankReconciliationItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankReconciliationItemResolveInput = {
  bankReconciliationItemID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  resolution: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationItemsBulkResolveByFilterInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  filters?: InputMaybe<BankReconciliationItemQopFilterInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  resolution: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationItemsBulkResolveInput = {
  bankReconciliationItemIDs: Array<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  resolution: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationPaged = {
  __typename?: 'BankReconciliationPaged';
  items: Array<BankReconciliation>;
  pagination: PaginationResult;
};

export type BankReconciliationProcessInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type BankReconciliationQopFilterInput = {
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankReconciliationNumber?: InputMaybe<Scalars['String']['input']>;
  reconDateEnd?: InputMaybe<Scalars['Time']['input']>;
  reconDateStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BankReconciliationQopInput = {
  filters?: InputMaybe<BankReconciliationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankReconciliationRemoveFileInput = {
  bankReconciliationFileID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type BankReconciliationUploadFileInput = {
  bankID: Scalars['UUID']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  fileMapping: BankReconciliationFileMappingInput;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  reconDate?: InputMaybe<Scalars['Time']['input']>;
  statementFileID: Scalars['UUID']['input'];
};

export type BankReconciliationUploadPoolFileInput = {
  bankID: Scalars['UUID']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  fileMapping: BankReconciliationFileMappingInput;
  statementFileID: Scalars['UUID']['input'];
};

export type BankUpdateInput = {
  bankID: Scalars['UUID']['input'];
  bankName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BarcodeConflictOwner = {
  __typename?: 'BarcodeConflictOwner';
  barcode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isConsignment: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
};

export type BaseModelAddress = {
  __typename?: 'BaseModelAddress';
  cityID?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryID?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  provinceID?: Maybe<Scalars['String']['output']>;
  provinceName?: Maybe<Scalars['String']['output']>;
  subdistrictID?: Maybe<Scalars['String']['output']>;
  subdistrictName?: Maybe<Scalars['String']['output']>;
};

export type BatchExecutionInput = {
  executions: Array<RecordExecutionInput>;
  putawayTaskID: Scalars['UUID']['input'];
};

export type BatchExecutionResult = {
  __typename?: 'BatchExecutionResult';
  errors: Array<Scalars['String']['output']>;
  failureCount: Scalars['Int']['output'];
  results: Array<ExecutionResult>;
  successCount: Scalars['Int']['output'];
};

export type BiKnowledge = {
  __typename?: 'BiKnowledge';
  biKnowledgeID: Scalars['UUID']['output'];
  category: Scalars['String']['output'];
  contentMD: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  sourceFile: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BiKnowledgeCreateInput = {
  category: Scalars['String']['input'];
  contentMD: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
  sourceFile: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BiKnowledgePaged = {
  __typename?: 'BiKnowledgePaged';
  items?: Maybe<Array<BiKnowledge>>;
  pagination: PaginationResult;
};

export type BiKnowledgeQopFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BiKnowledgeQopInput = {
  filters?: InputMaybe<BiKnowledgeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BiKnowledgeUpdateInput = {
  biKnowledgeID: Scalars['UUID']['input'];
  category: Scalars['String']['input'];
  contentMD: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
  sourceFile: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BiLeader = {
  __typename?: 'BiLeader';
  count: Scalars['Int']['output'];
  successRate: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type BiMonitorSummary = {
  __typename?: 'BiMonitorSummary';
  activeUsers7d: Scalars['Int']['output'];
  leaders: Array<BiLeader>;
  questionsToday: Scalars['Int']['output'];
  successRate7d: Scalars['Int']['output'];
  topTables: Array<BiTableUsage>;
  usage14d: Array<BiUsageDay>;
};

export type BiRole = {
  __typename?: 'BiRole';
  allowedCategories: Scalars['String']['output'];
  blockedTables: Scalars['String']['output'];
  canSeeAllBranches: Scalars['Boolean']['output'];
  consignmentOnly: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  role: Scalars['String']['output'];
};

export type BiRoleCreateInput = {
  allowedCategories: Scalars['String']['input'];
  blockedTables: Scalars['String']['input'];
  canSeeAllBranches: Scalars['Boolean']['input'];
  consignmentOnly: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type BiRolePaged = {
  __typename?: 'BiRolePaged';
  items?: Maybe<Array<BiRole>>;
  pagination: PaginationResult;
};

export type BiRoleQopFilterInput = {
  role?: InputMaybe<Scalars['String']['input']>;
};

export type BiRoleQopInput = {
  filters?: InputMaybe<BiRoleQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BiRoleUpdateInput = {
  allowedCategories: Scalars['String']['input'];
  blockedTables: Scalars['String']['input'];
  canSeeAllBranches: Scalars['Boolean']['input'];
  consignmentOnly: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type BiScopeTable = {
  __typename?: 'BiScopeTable';
  category: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  tableName: Scalars['String']['output'];
};

export type BiScopeTableBulkUpdateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  tableNames: Array<Scalars['String']['input']>;
};

export type BiScopeTableBulkUpdateResult = {
  __typename?: 'BiScopeTableBulkUpdateResult';
  updatedCount: Scalars['Int']['output'];
};

export type BiScopeTableCreateInput = {
  category: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  tableName: Scalars['String']['input'];
};

export type BiScopeTablePaged = {
  __typename?: 'BiScopeTablePaged';
  items?: Maybe<Array<BiScopeTable>>;
  pagination: PaginationResult;
};

export type BiScopeTableQopFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
};

export type BiScopeTableQopInput = {
  filters?: InputMaybe<BiScopeTableQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BiScopeTableUpdateInput = {
  category: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  tableName: Scalars['String']['input'];
};

export type BiTableUsage = {
  __typename?: 'BiTableUsage';
  count: Scalars['Int']['output'];
  tableName: Scalars['String']['output'];
};

export type BiUsageDay = {
  __typename?: 'BiUsageDay';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type BiUser = {
  __typename?: 'BiUser';
  allowedBranchNames: Scalars['String']['output'];
  allowedBranches: Scalars['String']['output'];
  biUserID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  requestEmail: Scalars['String']['output'];
  role: Scalars['String']['output'];
  telegramUserID: Scalars['Int']['output'];
  vendorID: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

export type BiUserCreateInput = {
  allowedBranchNames?: InputMaybe<Scalars['String']['input']>;
  allowedBranches: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
  telegramUserID: Scalars['Int']['input'];
  vendorID: Scalars['String']['input'];
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type BiUserPaged = {
  __typename?: 'BiUserPaged';
  items?: Maybe<Array<BiUser>>;
  pagination: PaginationResult;
};

export type BiUserQopFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type BiUserQopInput = {
  filters?: InputMaybe<BiUserQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BiUserUpdateInput = {
  allowedBranchNames?: InputMaybe<Scalars['String']['input']>;
  allowedBranches: Scalars['String']['input'];
  biUserID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
  telegramUserID: Scalars['Int']['input'];
  vendorID: Scalars['String']['input'];
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type BillOfMaterial = {
  __typename?: 'BillOfMaterial';
  billOfMaterialID: Scalars['UUID']['output'];
  components: Array<BillOfMaterialComponent>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uom?: Maybe<Uom>;
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
};

export type BillOfMaterialComponent = {
  __typename?: 'BillOfMaterialComponent';
  billOfMaterialComponentID: Scalars['UUID']['output'];
  billOfMaterialID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uom?: Maybe<Uom>;
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
};

export type BillOfMaterialComponentCreateInput = {
  billOfMaterialComponentID?: InputMaybe<Scalars['UUID']['input']>;
  isActive: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type BillOfMaterialComponentPaged = {
  __typename?: 'BillOfMaterialComponentPaged';
  items?: Maybe<Array<BillOfMaterialComponent>>;
  pagination: PaginationResult;
};

export type BillOfMaterialComponentQopFilterInput = {
  billOfMaterialID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  qty?: InputMaybe<Scalars['Float']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BillOfMaterialComponentQopInput = {
  filters?: InputMaybe<BillOfMaterialComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BillOfMaterialComponentUpdateInput = {
  billOfMaterialComponentID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type BillOfMaterialCreateInput = {
  components?: InputMaybe<Array<BillOfMaterialComponentCreateInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type BillOfMaterialPaged = {
  __typename?: 'BillOfMaterialPaged';
  items?: Maybe<Array<BillOfMaterial>>;
  pagination: PaginationResult;
};

export type BillOfMaterialQopFilterInput = {
  billOfMaterialName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BillOfMaterialQopInput = {
  filters?: InputMaybe<BillOfMaterialQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BillOfMaterialUpdateInput = {
  billOfMaterialID: Scalars['UUID']['input'];
  components?: InputMaybe<Array<BillOfMaterialComponentCreateInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type Branch = {
  __typename?: 'Branch';
  addressLabel?: Maybe<Scalars['String']['output']>;
  branchCategory?: Maybe<BranchCategory>;
  branchCategoryID: Scalars['UUID']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  branchPosBookmarks: Array<BranchPosBookmark>;
  branchSalesPaymentMethods: Array<BranchSalesPaymentMethod>;
  branchStoreSupervisors: Array<BranchStoreSupervisor>;
  branchType: Scalars['String']['output'];
  canSell?: Maybe<Scalars['Boolean']['output']>;
  cashJournalAccountCode?: Maybe<Scalars['String']['output']>;
  cashJournalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  cashJournalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  edcTerminals: Array<EdcTerminal>;
  entityAuditMetadata: EntityAuditMetadata;
  erpRefCode?: Maybe<Scalars['String']['output']>;
  erpRefID?: Maybe<Scalars['String']['output']>;
  erpRefName?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isMain?: Maybe<Scalars['Boolean']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  mainSupplyWarehouse?: Maybe<Warehouse>;
  mainSupplyWarehouseID?: Maybe<Scalars['UUID']['output']>;
  pettyCashJournalAccountCode?: Maybe<Scalars['String']['output']>;
  pettyCashJournalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  pettyCashJournalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  picName?: Maybe<Scalars['String']['output']>;
  picPhoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  pricelist?: Maybe<Pricelist>;
  pricelistID?: Maybe<Scalars['UUID']['output']>;
  productAvailabilityTemplate?: Maybe<ProductAvailabilityTemplate>;
  productAvailabilityTemplateID?: Maybe<Scalars['UUID']['output']>;
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  subdistrict?: Maybe<Subdistrict>;
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  warehouseDeliveryLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseID?: Maybe<Scalars['UUID']['output']>;
  warehouseInboundLocationID?: Maybe<Scalars['UUID']['output']>;
  warehousePackingLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseTransitID?: Maybe<Scalars['UUID']['output']>;
  warehouseTransitLocationID?: Maybe<Scalars['UUID']['output']>;
};

export type BranchBankAccount = {
  __typename?: 'BranchBankAccount';
  bankAccount?: Maybe<BankAccount>;
  bankAccountID: Scalars['UUID']['output'];
  branch: Branch;
  branchBankAccountID: Scalars['UUID']['output'];
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  merchantID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchBankAccountCreateInput = {
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  merchantID: Scalars['String']['input'];
};

export type BranchBankAccountPaged = {
  __typename?: 'BranchBankAccountPaged';
  items: Array<BranchBankAccount>;
  pagination: PaginationResult;
};

export type BranchBankAccountQopFilterInput = {
  bankAccountID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  merchantID?: InputMaybe<Scalars['String']['input']>;
};

export type BranchBankAccountQopInput = {
  filters?: InputMaybe<BranchBankAccountQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchBankAccountUpdateInput = {
  bankAccountID: Scalars['UUID']['input'];
  branchBankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  merchantID: Scalars['String']['input'];
};

export type BranchCategory = {
  __typename?: 'BranchCategory';
  branchCategoryID: Scalars['UUID']['output'];
  branchCategoryName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchCategoryCreateInput = {
  branchCategoryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BranchCategoryPaged = {
  __typename?: 'BranchCategoryPaged';
  items?: Maybe<Array<BranchCategory>>;
  pagination: PaginationResult;
};

export type BranchCategoryQopFilterInput = {
  branchCategoryName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchCategoryQopInput = {
  filters?: InputMaybe<BranchCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchCategoryUpdateInput = {
  branchCategoryID: Scalars['UUID']['input'];
  branchCategoryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BranchCreateInput = {
  addressLabel?: InputMaybe<Scalars['String']['input']>;
  branchCategoryID: Scalars['UUID']['input'];
  branchCode: Scalars['String']['input'];
  branchName: Scalars['String']['input'];
  branchPosBookmarks?: InputMaybe<Array<BranchPosBookmarkInput>>;
  branchSalesPaymentMethods?: InputMaybe<Array<BranchSalesPaymentMethodInput>>;
  branchStoreSupervisors?: InputMaybe<Array<BranchStoreSupervisorInput>>;
  branchType: Scalars['String']['input'];
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  cashJournalAccountCode?: InputMaybe<Scalars['String']['input']>;
  cashJournalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  cashJournalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  erpRefCode?: InputMaybe<Scalars['String']['input']>;
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mainSupplyWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashJournalAccountCode?: InputMaybe<Scalars['String']['input']>;
  pettyCashJournalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  pettyCashJournalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  picName?: InputMaybe<Scalars['String']['input']>;
  picPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One entry of the branch picker: a name to show, an id to
 * store, and the warehouse the device will book stock against.
 *
 * Every field here is lightweight and safe for dropdowns / POS first-run.
 * Contact details, journal account codes, addresses and coordinates stay on `Branch`, behind
 * `branches`/`branch`, which remain authenticated.
 */
export type BranchLite = {
  __typename?: 'BranchLite';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  /**
   * Warehouse the device books stock against. Null for a branch with no warehouse
   *   configured. POS needs it at setup time: the authenticated backfill that would
   *   otherwise fill it in only runs on the next sync, which is after login.
   */
  warehouseID?: Maybe<Scalars['UUID']['output']>;
};

export type BranchPaged = {
  __typename?: 'BranchPaged';
  items?: Maybe<Array<Branch>>;
  pagination: PaginationResult;
};

export type BranchPosBookmark = {
  __typename?: 'BranchPosBookmark';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  branchPosBookmarkID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  posBookmark?: Maybe<PosBookmark>;
  posBookmarkID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchPosBookmarkCreateInput = {
  branchID: Scalars['UUID']['input'];
  posBookmarkID: Scalars['UUID']['input'];
};

export type BranchPosBookmarkInput = {
  branchPosBookmarkID?: InputMaybe<Scalars['UUID']['input']>;
  posBookmarkID: Scalars['UUID']['input'];
};

export type BranchPosBookmarkPaged = {
  __typename?: 'BranchPosBookmarkPaged';
  items?: Maybe<Array<BranchPosBookmark>>;
  pagination: PaginationResult;
};

export type BranchPosBookmarkQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  posBookmarkID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchPosBookmarkQopInput = {
  filters?: InputMaybe<BranchPosBookmarkQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchPosBookmarkUpdateInput = {
  branchID: Scalars['UUID']['input'];
  branchPosBookmarkID: Scalars['UUID']['input'];
  posBookmarkID: Scalars['UUID']['input'];
};

export type BranchProductSalesChannelItem = {
  __typename?: 'BranchProductSalesChannelItem';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchProductSalesChannelItemID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  note: Scalars['String']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  salesChannelCategoryGroupID?: Maybe<Scalars['UUID']['output']>;
  salesChannelID: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchProductSalesChannelItemDisableInput = {
  branchID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type BranchProductSalesChannelItemPaged = {
  __typename?: 'BranchProductSalesChannelItemPaged';
  items?: Maybe<Array<BranchProductSalesChannelItem>>;
  pagination: PaginationResult;
};

export type BranchProductSalesChannelItemQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchProductSalesChannelItemQopInput = {
  filters?: InputMaybe<BranchProductSalesChannelItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchProductSalesChannelItemRestoreInput = {
  branchID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type BranchProfile = {
  __typename?: 'BranchProfile';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  warehouse?: Maybe<BranchWarehouseProfile>;
  warehouseInboundLocation?: Maybe<BranchWarehouseLocationProfile>;
  warehouseTransitLocation?: Maybe<BranchWarehouseLocationProfile>;
};

export type BranchQopFilterInput = {
  branchCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  branchType?: InputMaybe<Scalars['String']['input']>;
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  mainSupplyWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchQopInput = {
  filters?: InputMaybe<BranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchQrisMerchant = {
  __typename?: 'BranchQrisMerchant';
  bank: Bank;
  bankID: Scalars['UUID']['output'];
  bankName: Scalars['String']['output'];
  branch: Branch;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  branchQrisMerchantID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  merchantName: Scalars['String']['output'];
  nmid: Scalars['String']['output'];
  providerCode: Scalars['String']['output'];
  terminalID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchQrisMerchantCreateInput = {
  bankID: Scalars['UUID']['input'];
  bankName: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  merchantName: Scalars['String']['input'];
  nmid: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  terminalID: Scalars['String']['input'];
};

export type BranchQrisMerchantPaged = {
  __typename?: 'BranchQrisMerchantPaged';
  items: Array<BranchQrisMerchant>;
  pagination: PaginationResult;
};

export type BranchQrisMerchantQopFilterInput = {
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  nmid?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  terminalID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchQrisMerchantQopInput = {
  filters?: InputMaybe<BranchQrisMerchantQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchQrisMerchantUpdateInput = {
  bankID: Scalars['UUID']['input'];
  bankName: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  branchQrisMerchantID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  merchantName: Scalars['String']['input'];
  nmid: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  terminalID: Scalars['String']['input'];
};

export type BranchSalesChannelCategoryGroup = {
  __typename?: 'BranchSalesChannelCategoryGroup';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  branchSalesChannelCategoryGroupID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryGroupName: Scalars['String']['output'];
  salesChannelID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchSalesChannelCategoryGroupCreateInput = {
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID: Scalars['String']['input'];
};

export type BranchSalesChannelCategoryGroupPaged = {
  __typename?: 'BranchSalesChannelCategoryGroupPaged';
  items?: Maybe<Array<BranchSalesChannelCategoryGroup>>;
  pagination: PaginationResult;
};

export type BranchSalesChannelCategoryGroupQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchSalesChannelCategoryGroupQopInput = {
  filters?: InputMaybe<BranchSalesChannelCategoryGroupQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchSalesChannelCategoryGroupUpdateInput = {
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  branchSalesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID: Scalars['String']['input'];
};

export type BranchSalesChannelMerchantMap = {
  __typename?: 'BranchSalesChannelMerchantMap';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  branchSalesChannelMerchantMapID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalMerchantID: Scalars['String']['output'];
  externalStoreID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isPaused: Scalars['Boolean']['output'];
  operatingHours?: Maybe<OperatingHours>;
  packagingChargeAmount: Scalars['Float']['output'];
  packagingProduct?: Maybe<Product>;
  packagingProductID?: Maybe<Scalars['UUID']['output']>;
  packagingQty: Scalars['Float']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchSalesChannelMerchantMapCreateInput = {
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  externalMerchantID: Scalars['String']['input'];
  externalStoreID: Scalars['String']['input'];
  isActive?: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName?: InputMaybe<Scalars['String']['input']>;
};

export type BranchSalesChannelMerchantMapPaged = {
  __typename?: 'BranchSalesChannelMerchantMapPaged';
  items?: Maybe<Array<BranchSalesChannelMerchantMap>>;
  pagination: PaginationResult;
};

export type BranchSalesChannelMerchantMapQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  externalStoreID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPaused?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchSalesChannelMerchantMapQopInput = {
  filters?: InputMaybe<BranchSalesChannelMerchantMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchSalesChannelMerchantMapUpdateInput = {
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
  externalMerchantID: Scalars['String']['input'];
  externalStoreID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName?: InputMaybe<Scalars['String']['input']>;
};

export type BranchSalesChannelOperatingHoursUpdateInput = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
  operatingHours: OperatingHoursInput;
};

export type BranchSalesChannelPackagingUpdateInput = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
  packagingChargeAmount?: Scalars['Float']['input'];
  packagingProductID?: InputMaybe<Scalars['UUID']['input']>;
  packagingQty?: Scalars['Float']['input'];
};

export type BranchSalesChannelPauseUpdateInput = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
  duration?: InputMaybe<PauseDuration>;
  isPaused: Scalars['Boolean']['input'];
};

export type BranchSalesPaymentMethod = {
  __typename?: 'BranchSalesPaymentMethod';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  branchSalesPaymentMethodID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  paymentMethod?: Maybe<SalesPaymentMethod>;
  paymentMethodID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchSalesPaymentMethodCreateInput = {
  branchID: Scalars['UUID']['input'];
  paymentMethodID: Scalars['UUID']['input'];
};

export type BranchSalesPaymentMethodInput = {
  branchSalesPaymentMethodID?: InputMaybe<Scalars['UUID']['input']>;
  paymentMethodID: Scalars['UUID']['input'];
};

export type BranchSalesPaymentMethodPaged = {
  __typename?: 'BranchSalesPaymentMethodPaged';
  items?: Maybe<Array<BranchSalesPaymentMethod>>;
  pagination: PaginationResult;
};

export type BranchSalesPaymentMethodQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  paymentMethodID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchSalesPaymentMethodQopInput = {
  filters?: InputMaybe<BranchSalesPaymentMethodQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchSalesPaymentMethodUpdateInput = {
  branchID: Scalars['UUID']['input'];
  branchSalesPaymentMethodID: Scalars['UUID']['input'];
  paymentMethodID: Scalars['UUID']['input'];
};

export type BranchStoreSupervisor = {
  __typename?: 'BranchStoreSupervisor';
  branchID: Scalars['UUID']['output'];
  branchStoreSupervisorID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
  user?: Maybe<User>;
  userID: Scalars['UUID']['output'];
};

export type BranchStoreSupervisorCreateInput = {
  branchID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  userIDs: Array<Scalars['UUID']['input']>;
};

export type BranchStoreSupervisorCreated = {
  __typename?: 'BranchStoreSupervisorCreated';
  branchID: Scalars['UUID']['output'];
  branchStoreSupervisorID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
  userID: Scalars['UUID']['output'];
};

export type BranchStoreSupervisorInput = {
  branchStoreSupervisorID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  userID: Scalars['UUID']['input'];
};

export type BranchStoreSupervisorPaged = {
  __typename?: 'BranchStoreSupervisorPaged';
  items?: Maybe<Array<BranchStoreSupervisor>>;
  pagination: PaginationResult;
};

export type BranchStoreSupervisorQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  userID?: InputMaybe<Scalars['UUID']['input']>;
};

export type BranchStoreSupervisorQopInput = {
  filters?: InputMaybe<BranchStoreSupervisorQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchStoreSupervisorUpdateInput = {
  branchStoreSupervisorID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BranchUpdateInput = {
  addressLabel?: InputMaybe<Scalars['String']['input']>;
  branchCategoryID: Scalars['UUID']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  branchPosBookmarks?: InputMaybe<Array<BranchPosBookmarkInput>>;
  branchSalesPaymentMethods?: InputMaybe<Array<BranchSalesPaymentMethodInput>>;
  branchStoreSupervisors?: InputMaybe<Array<BranchStoreSupervisorInput>>;
  branchType: Scalars['String']['input'];
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  cashJournalAccountCode?: InputMaybe<Scalars['String']['input']>;
  cashJournalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  cashJournalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  erpRefCode?: InputMaybe<Scalars['String']['input']>;
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mainSupplyWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashJournalAccountCode?: InputMaybe<Scalars['String']['input']>;
  pettyCashJournalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  pettyCashJournalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  picName?: InputMaybe<Scalars['String']['input']>;
  picPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
};

export type BranchWarehouseLocationProfile = {
  __typename?: 'BranchWarehouseLocationProfile';
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type BranchWarehouseProfile = {
  __typename?: 'BranchWarehouseProfile';
  warehouseCode: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseName: Scalars['String']['output'];
  warehouseType: Scalars['String']['output'];
};

export type BulkConsignmentEmailResult = {
  __typename?: 'BulkConsignmentEmailResult';
  error: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  vendorConsignmentInvoiceID: Scalars['UUID']['output'];
};

export type BulkConsignmentGenerateResult = {
  __typename?: 'BulkConsignmentGenerateResult';
  error: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  vendorConsignmentInvoiceID: Scalars['UUID']['output'];
};

export type BulkConsignmentPayResult = {
  __typename?: 'BulkConsignmentPayResult';
  error: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  vendorConsignmentInvoiceID: Scalars['UUID']['output'];
};

export type BulkContainerGenerationInput = {
  packingTaskID: Scalars['UUID']['input'];
  packingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
};

export type CancelTaskInput = {
  putawayTaskID: Scalars['UUID']['input'];
};

export type ChangePasswordInput = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type ChannelTaxonomyNode = {
  __typename?: 'ChannelTaxonomyNode';
  externalCategoryID: Scalars['String']['output'];
  externalCategoryName: Scalars['String']['output'];
  externalParentCategoryID: Scalars['String']['output'];
  externalParentCategoryName: Scalars['String']['output'];
};

export type CheckOtpRequest = {
  tokenCode: Scalars['String']['input'];
  tokenType: TokenType;
  userName: Scalars['String']['input'];
};

export type CheckOtpResponse = {
  __typename?: 'CheckOTPResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CheckReadyGenerateDeliveryOrderBulk = {
  __typename?: 'CheckReadyGenerateDeliveryOrderBulk';
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  isReadyGenerateDeliveryOrder: Scalars['Boolean']['output'];
  reasonNotReadyGenerateDeliveryOrder: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalContainerReady: Scalars['Float']['output'];
};

export type City = {
  __typename?: 'City';
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  subdistricts?: Maybe<Array<Subdistrict>>;
  uniqueKey: Scalars['String']['output'];
};

export type CityCreateInput = {
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
};

export type CityPaged = {
  __typename?: 'CityPaged';
  items: Array<City>;
  pagination: PaginationResult;
};

export type CityQop = {
  filters?: InputMaybe<CityQopFilter>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type CityQopFilter = {
  cityID?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
};

export type CityUpdateInput = {
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
};

export type ConsignmentPayoutBankInput = {
  payoutBankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  payoutBankID?: InputMaybe<Scalars['UUID']['input']>;
  payoutBankName?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type ConsignmentSettlementBranchChange = {
  __typename?: 'ConsignmentSettlementBranchChange';
  branchID: Scalars['String']['output'];
  branchName: Scalars['String']['output'];
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
};

export type ConsignmentSettlementBranchInput = {
  branchID: Scalars['UUID']['input'];
  branchName?: InputMaybe<Scalars['String']['input']>;
  commissionAmount: Scalars['Float']['input'];
  payout: Scalars['Float']['input'];
  subtotal: Scalars['Float']['input'];
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type ConsignmentSettlementBranchRow = {
  __typename?: 'ConsignmentSettlementBranchRow';
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  commissionAmount: Scalars['Float']['output'];
  payout: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
};

export type ConsignmentSettlementExportResult = {
  __typename?: 'ConsignmentSettlementExportResult';
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type ConsignmentSettlementFieldChange = {
  __typename?: 'ConsignmentSettlementFieldChange';
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
};

export type ConsignmentSettlementHistory = {
  __typename?: 'ConsignmentSettlementHistory';
  branchChanges: Array<ConsignmentSettlementBranchChange>;
  editedAt: Scalars['Time']['output'];
  editedByUserID?: Maybe<Scalars['UUID']['output']>;
  editedByUserName: Scalars['String']['output'];
  fieldChanges: Array<ConsignmentSettlementFieldChange>;
  reason: Scalars['String']['output'];
  vendorConsignmentInvoiceHistoryID: Scalars['UUID']['output'];
};

export type ConsignmentSettlementListExportFilterInput = {
  periodEndDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentSettlementPeriod = {
  __typename?: 'ConsignmentSettlementPeriod';
  emailableCount: Scalars['Int']['output'];
  periodEndDate: Scalars['Time']['output'];
  periodStartDate: Scalars['Time']['output'];
  sentCount: Scalars['Int']['output'];
  totalCommission: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  totalPayout: Scalars['Float']['output'];
};

export type ConsignmentSettlementPivotRow = {
  __typename?: 'ConsignmentSettlementPivotRow';
  barcode: Scalars['String']['output'];
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  commissionAmount: Scalars['Float']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type ConsignmentStockIn = {
  __typename?: 'ConsignmentStockIn';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  consignmentStockInDatetime: Scalars['Time']['output'];
  consignmentStockInID: Scalars['UUID']['output'];
  consignmentStockInNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalReferenceNumber?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<ConsignmentStockInFile>>;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  receivedByName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItemWeightReceived: Scalars['Float']['output'];
  vendor: Vendor;
  vendorID: Scalars['UUID']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type ConsignmentStockInCreateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockInDatetime: Scalars['Time']['input'];
  consignmentStockInNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<ConsignmentStockInFileInput>>;
  items: Array<ConsignmentStockInItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockInFile = {
  __typename?: 'ConsignmentStockInFile';
  consignmentStockInFileID: Scalars['UUID']['output'];
  consignmentStockInFileType: Scalars['String']['output'];
  consignmentStockInID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ConsignmentStockInFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type ConsignmentStockInItem = {
  __typename?: 'ConsignmentStockInItem';
  baseUomQty: Scalars['Float']['output'];
  consignmentStockInID: Scalars['UUID']['output'];
  consignmentStockInItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ConsignmentStockInItemCreateInput = {
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockInItemPaged = {
  __typename?: 'ConsignmentStockInItemPaged';
  items: Array<ConsignmentStockInItem>;
  pagination: PaginationResult;
};

export type ConsignmentStockInItemQopFilterInput = {
  consignmentStockInID?: InputMaybe<Scalars['String']['input']>;
  consignmentStockInItemID?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInItemQopInput = {
  filters?: InputMaybe<ConsignmentStockInItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInItemUpdateInput = {
  consignmentStockInItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockInPaged = {
  __typename?: 'ConsignmentStockInPaged';
  items: Array<ConsignmentStockIn>;
  pagination: PaginationResult;
};

export type ConsignmentStockInQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentStockInDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockInDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockInNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInQopInput = {
  filters?: InputMaybe<ConsignmentStockInQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequest = {
  __typename?: 'ConsignmentStockInRequest';
  approvedByUserID?: Maybe<Scalars['UUID']['output']>;
  approvedByUserName?: Maybe<Scalars['String']['output']>;
  approvedDatetime?: Maybe<Scalars['Time']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  consignmentStockInID?: Maybe<Scalars['UUID']['output']>;
  consignmentStockInNumber: Scalars['String']['output'];
  consignmentStockInRequestID: Scalars['UUID']['output'];
  consignmentStockInRequestNumber: Scalars['String']['output'];
  consignmentStockOutID?: Maybe<Scalars['UUID']['output']>;
  consignmentStockOutNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  estimatedDeliveryDate: Scalars['Time']['output'];
  gmt: Scalars['Int']['output'];
  noteAdditional: Scalars['String']['output'];
  rejectedByUserID?: Maybe<Scalars['UUID']['output']>;
  rejectedByUserName?: Maybe<Scalars['String']['output']>;
  rejectedDatetime?: Maybe<Scalars['Time']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestDatetime: Scalars['Time']['output'];
  requestDatetimeUtc: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  submittedByUserID?: Maybe<Scalars['UUID']['output']>;
  submittedByUserName?: Maybe<Scalars['String']['output']>;
  submittedDatetime?: Maybe<Scalars['Time']['output']>;
  totalItemQtyApproved: Scalars['Float']['output'];
  totalItemQtyRequested: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
};

export type ConsignmentStockInRequestApproveInput = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<ConsignmentStockInRequestFileInput>>;
  items: Array<ConsignmentStockInRequestApproveItemInput>;
  receivedByName: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestApproveItemInput = {
  consignmentStockInRequestItemID: Scalars['UUID']['input'];
  expiredDate?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  qtyReceived: Scalars['Float']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentStockInRequestCancelInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  consignmentStockInRequestID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestCreateInput = {
  branchID: Scalars['UUID']['input'];
  estimatedDeliveryDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<ConsignmentStockInRequestFileInput>>;
  items: Array<ConsignmentStockInRequestItemInput>;
  noteAdditional?: InputMaybe<Scalars['String']['input']>;
  submit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsignmentStockInRequestFile = {
  __typename?: 'ConsignmentStockInRequestFile';
  consignmentStockInRequestFileID: Scalars['UUID']['output'];
  consignmentStockInRequestFileRole: Scalars['String']['output'];
  consignmentStockInRequestID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ConsignmentStockInRequestFileInput = {
  fileID: Scalars['UUID']['input'];
  fileRole: Scalars['String']['input'];
};

export type ConsignmentStockInRequestFilePaged = {
  __typename?: 'ConsignmentStockInRequestFilePaged';
  items: Array<ConsignmentStockInRequestFile>;
  pagination: PaginationResult;
};

export type ConsignmentStockInRequestFileQopFilterInput = {
  consignmentStockInRequestFileRole?: InputMaybe<Scalars['String']['input']>;
  consignmentStockInRequestID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInRequestFileQopInput = {
  filters?: InputMaybe<ConsignmentStockInRequestFileQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequestItem = {
  __typename?: 'ConsignmentStockInRequestItem';
  baseUomQtyApproved: Scalars['Float']['output'];
  baseUomQtyRequested: Scalars['Float']['output'];
  consignmentStockInRequestID: Scalars['UUID']['output'];
  consignmentStockInRequestItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiredDate?: Maybe<Scalars['Time']['output']>;
  expiredDateConfirmed?: Maybe<Scalars['Time']['output']>;
  noteReason: Scalars['String']['output'];
  noteRequester: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyApproved: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  qtyRequested: Scalars['Float']['output'];
  receivingReason: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ConsignmentStockInRequestItemInput = {
  expiredDate?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestItemPaged = {
  __typename?: 'ConsignmentStockInRequestItemPaged';
  items: Array<ConsignmentStockInRequestItem>;
  pagination: PaginationResult;
};

export type ConsignmentStockInRequestItemQopFilterInput = {
  consignmentStockInRequestID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInRequestItemQopInput = {
  filters?: InputMaybe<ConsignmentStockInRequestItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequestLabel = {
  __typename?: 'ConsignmentStockInRequestLabel';
  barcode: Scalars['String']['output'];
  copies: Scalars['Int']['output'];
  expiredDate?: Maybe<Scalars['Time']['output']>;
  printable: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
};

export type ConsignmentStockInRequestPaged = {
  __typename?: 'ConsignmentStockInRequestPaged';
  items: Array<ConsignmentStockInRequest>;
  pagination: PaginationResult;
};

export type ConsignmentStockInRequestQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  consignmentStockInRequestNumber?: InputMaybe<Scalars['String']['input']>;
  requestDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  requestDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInRequestQopInput = {
  filters?: InputMaybe<ConsignmentStockInRequestQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequestRejectInput = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
  rejectionReason: Scalars['String']['input'];
};

export type ConsignmentStockInRequestSubmitInput = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestSummary = {
  __typename?: 'ConsignmentStockInRequestSummary';
  approved: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  totalRequest: Scalars['Int']['output'];
};

export type ConsignmentStockInRequestUpdateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockInRequestID: Scalars['UUID']['input'];
  estimatedDeliveryDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<ConsignmentStockInRequestFileInput>>;
  items: Array<ConsignmentStockInRequestItemInput>;
  noteAdditional?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentStockInUpdateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockInDatetime: Scalars['Time']['input'];
  consignmentStockInID: Scalars['UUID']['input'];
  consignmentStockInNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<ConsignmentStockInFileInput>>;
  items: Array<ConsignmentStockInItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockOut = {
  __typename?: 'ConsignmentStockOut';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  consignmentStockOutDatetime: Scalars['Time']['output'];
  consignmentStockOutID: Scalars['UUID']['output'];
  consignmentStockOutNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalReferenceNumber?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<ConsignmentStockOutFile>>;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  receivedByVendorName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItemWeight: Scalars['Float']['output'];
  vendor: Vendor;
  vendorID: Scalars['UUID']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type ConsignmentStockOutCreateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockOutDatetime: Scalars['Time']['input'];
  consignmentStockOutNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<ConsignmentStockOutFileInput>>;
  items: Array<ConsignmentStockOutItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByVendorName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockOutFile = {
  __typename?: 'ConsignmentStockOutFile';
  consignmentStockOutFileID: Scalars['UUID']['output'];
  consignmentStockOutFileType: Scalars['String']['output'];
  consignmentStockOutID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ConsignmentStockOutFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type ConsignmentStockOutItem = {
  __typename?: 'ConsignmentStockOutItem';
  baseUomQty: Scalars['Float']['output'];
  consignmentStockOutID: Scalars['UUID']['output'];
  consignmentStockOutItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ConsignmentStockOutItemCreateInput = {
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockOutItemPaged = {
  __typename?: 'ConsignmentStockOutItemPaged';
  items: Array<ConsignmentStockOutItem>;
  pagination: PaginationResult;
};

export type ConsignmentStockOutItemQopFilterInput = {
  consignmentStockOutID?: InputMaybe<Scalars['String']['input']>;
  consignmentStockOutItemID?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockOutItemQopInput = {
  filters?: InputMaybe<ConsignmentStockOutItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockOutItemUpdateInput = {
  consignmentStockOutItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockOutPaged = {
  __typename?: 'ConsignmentStockOutPaged';
  items: Array<ConsignmentStockOut>;
  pagination: PaginationResult;
};

export type ConsignmentStockOutQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentStockOutDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockOutDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockOutNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockOutQopInput = {
  filters?: InputMaybe<ConsignmentStockOutQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockOutUpdateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockOutDatetime: Scalars['Time']['input'];
  consignmentStockOutID: Scalars['UUID']['input'];
  consignmentStockOutNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<ConsignmentStockOutFileInput>>;
  items: Array<ConsignmentStockOutItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByVendorName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentTagItem = {
  __typename?: 'ConsignmentTagItem';
  barcode: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  found: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
  stickerCode: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
};

export type ConsignmentTagPricesInput = {
  branchID: Scalars['UUID']['input'];
  skus: Array<Scalars['String']['input']>;
};

export type ConversationTurn = {
  __typename?: 'ConversationTurn';
  answer: Scalars['String']['output'];
  conversationTurnID: Scalars['UUID']['output'];
  createdAt: Scalars['Time']['output'];
  generatedSQL: Scalars['String']['output'];
  intent: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  telegramUserID: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type ConversationTurnPaged = {
  __typename?: 'ConversationTurnPaged';
  items?: Maybe<Array<ConversationTurn>>;
  pagination: PaginationResult;
};

export type ConversationTurnQopFilterInput = {
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  telegramUserID?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationTurnQopInput = {
  filters?: InputMaybe<ConversationTurnQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type CostAdjustmentImportInput = {
  branchID: Scalars['UUID']['input'];
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryAdjustmentOpeningBalanceImportFileMappingInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  warehouseID: Scalars['UUID']['input'];
};

export type CostAdjustmentImportValidateCodesInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryAdjustmentOpeningBalanceImportFileMappingInput;
  warehouseID: Scalars['UUID']['input'];
};

export type CostAdjustmentImportValidateCodesResult = {
  __typename?: 'CostAdjustmentImportValidateCodesResult';
  invalidRows: Scalars['Int']['output'];
  missingProductCodes: Array<Scalars['String']['output']>;
  totalRows: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type CountryCreateInput = {
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type CountryPaged = {
  __typename?: 'CountryPaged';
  items: Array<Country>;
  pagination: PaginationResult;
};

export type CountryQop = {
  filters?: InputMaybe<CountryQopFilter>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type CountryQopFilter = {
  countryID?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryUpdateInput = {
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type CreateErpProductInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  canBePurchased?: InputMaybe<Scalars['Boolean']['input']>;
  canBeSold?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mainImageFileLargePathURL?: InputMaybe<Scalars['String']['input']>;
  mainImageFileMediumPathURL?: InputMaybe<Scalars['String']['input']>;
  mainImageFileSmallPathURL?: InputMaybe<Scalars['String']['input']>;
  productCategoryID?: InputMaybe<Scalars['Int']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
  productType?: InputMaybe<Scalars['String']['input']>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['Int']['input']>;
  purchaseUomID?: InputMaybe<Scalars['Int']['input']>;
  salesTaxID?: InputMaybe<Scalars['Int']['input']>;
  salesUomID?: InputMaybe<Scalars['Int']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate?: InputMaybe<Scalars['Boolean']['input']>;
  trackStock?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateManualConsignmentProformaInput = {
  cutoffDate: Scalars['Time']['input'];
  periodEndDate: Scalars['Time']['input'];
  periodStartDate: Scalars['Time']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  addresses: Array<CustomerAddress>;
  customerCode: Scalars['String']['output'];
  customerID: Scalars['UUID']['output'];
  customerName: Scalars['String']['output'];
  customerPointTransactions: CustomerPointTransactionPaged;
  email?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gender?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isMember: Scalars['Boolean']['output'];
  joinDate: Scalars['Time']['output'];
  memberPoints: Scalars['Int']['output'];
  memberType?: Maybe<MemberType>;
  memberTypeID?: Maybe<Scalars['UUID']['output']>;
  phoneNumber: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};


export type CustomerCustomerPointTransactionsArgs = {
  qop?: InputMaybe<CustomerPointTransactionQopInput>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  addressLabel: Scalars['String']['output'];
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  customerAddressID: Scalars['UUID']['output'];
  customerID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fullAddress: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  postalCode: Scalars['String']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  subdistrict?: Maybe<Subdistrict>;
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type CustomerAddressCreateInput = {
  addressLabel: Scalars['String']['input'];
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  customerID: Scalars['UUID']['input'];
  fullAddress: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type CustomerAddressDeleteInput = {
  customerAddressID: Scalars['UUID']['input'];
};

export type CustomerAddressInput = {
  addressLabel: Scalars['String']['input'];
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  customerAddressID?: InputMaybe<Scalars['UUID']['input']>;
  fullAddress: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type CustomerAddressPaged = {
  __typename?: 'CustomerAddressPaged';
  items?: Maybe<Array<CustomerAddress>>;
  pagination: PaginationResult;
};

export type CustomerAddressQopFilterInput = {
  addressLabel?: InputMaybe<Scalars['String']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type CustomerAddressQopInput = {
  filters?: InputMaybe<CustomerAddressQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type CustomerAddressUpdateInput = {
  addressLabel: Scalars['String']['input'];
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  customerAddressID: Scalars['UUID']['input'];
  customerID: Scalars['UUID']['input'];
  fullAddress: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type CustomerCreateFromPosInput = {
  customerName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CustomerCreateInput = {
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type CustomerImportInput = {
  customerCode: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  joinDate?: InputMaybe<Scalars['Time']['input']>;
  memberPoints: Scalars['Int']['input'];
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type CustomerPaged = {
  __typename?: 'CustomerPaged';
  items?: Maybe<Array<Customer>>;
  pagination: PaginationResult;
};

export type CustomerPointTransaction = {
  __typename?: 'CustomerPointTransaction';
  branchID: Scalars['UUID']['output'];
  customerCode: Scalars['String']['output'];
  customerID: Scalars['UUID']['output'];
  customerName: Scalars['String']['output'];
  customerPointTransactionID: Scalars['UUID']['output'];
  customerPointTransactionNumber: Scalars['String']['output'];
  earnedPoint: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  memberTypeID: Scalars['UUID']['output'];
  memberTypeName: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  pointAfter: Scalars['Int']['output'];
  pointBefore: Scalars['Int']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  transactionDatetime: Scalars['String']['output'];
  transactionDatetimeUtc: Scalars['Time']['output'];
};

export type CustomerPointTransactionPaged = {
  __typename?: 'CustomerPointTransactionPaged';
  items: Array<CustomerPointTransaction>;
  pagination: PaginationResult;
};

export type CustomerPointTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  customerPointTransactionNumber?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  transactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
};

export type CustomerPointTransactionQopInput = {
  filters?: InputMaybe<CustomerPointTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type CustomerQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isMember?: InputMaybe<Scalars['Boolean']['input']>;
  joinDateFrom?: InputMaybe<Scalars['Time']['input']>;
  joinDateTo?: InputMaybe<Scalars['Time']['input']>;
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type CustomerQopInput = {
  filters?: InputMaybe<CustomerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type CustomerSetDefaultInput = {
  customerID: Scalars['UUID']['input'];
};

export type CustomerUpdateInput = {
  addresses?: InputMaybe<Array<CustomerAddressInput>>;
  customerCode: Scalars['String']['input'];
  customerID: Scalars['UUID']['input'];
  customerName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type CustomerVoucherTransaction = {
  __typename?: 'CustomerVoucherTransaction';
  branchID: Scalars['UUID']['output'];
  customerCode: Scalars['String']['output'];
  customerID: Scalars['UUID']['output'];
  customerName: Scalars['String']['output'];
  customerVoucherTransactionID: Scalars['UUID']['output'];
  customerVoucherTransactionNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  journalAccountCode: Scalars['String']['output'];
  memberTypeID: Scalars['UUID']['output'];
  memberTypeName: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionDatetime: Scalars['Time']['output'];
  transactionDatetimeUtc: Scalars['Time']['output'];
  voucherCode: Scalars['String']['output'];
  voucherID: Scalars['UUID']['output'];
  voucherItemCode: Scalars['String']['output'];
  voucherItemID: Scalars['UUID']['output'];
  voucherName: Scalars['String']['output'];
  voucherType: Scalars['String']['output'];
  voucherValue: Scalars['Float']['output'];
};

export type CustomerVoucherTransactionBackfillInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  salesInvoiceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CustomerVoucherTransactionBackfillItem = {
  __typename?: 'CustomerVoucherTransactionBackfillItem';
  customerVoucherTransactionID: Scalars['UUID']['output'];
  customerVoucherTransactionNumber: Scalars['String']['output'];
  error: Scalars['String']['output'];
  journalAccountCode: Scalars['String']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  skipReason: Scalars['String']['output'];
  updated: Scalars['Boolean']['output'];
  voucherItemID: Scalars['UUID']['output'];
  voucherType: Scalars['String']['output'];
};

export type CustomerVoucherTransactionBackfillResult = {
  __typename?: 'CustomerVoucherTransactionBackfillResult';
  dryRun: Scalars['Boolean']['output'];
  failed: Scalars['Int']['output'];
  results: Array<CustomerVoucherTransactionBackfillItem>;
  skipped: Scalars['Int']['output'];
  totalScanned: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type CustomerVoucherTransactionPaged = {
  __typename?: 'CustomerVoucherTransactionPaged';
  items: Array<CustomerVoucherTransaction>;
  pagination: PaginationResult;
};

export type CustomerVoucherTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  customerVoucherTransactionNumber?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  transactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
};

export type CustomerVoucherTransactionQopInput = {
  filters?: InputMaybe<CustomerVoucherTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUTC?: Maybe<Scalars['Time']['output']>;
  deliveredDatetime?: Maybe<Scalars['Time']['output']>;
  deliveredDatetimeUTC?: Maybe<Scalars['Time']['output']>;
  deliveryAddress: Scalars['String']['output'];
  deliveryBy: Scalars['String']['output'];
  deliveryOrderDatetime: Scalars['Time']['output'];
  deliveryOrderDatetimeUTC: Scalars['Time']['output'];
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderNumber: Scalars['String']['output'];
  driverName: Scalars['String']['output'];
  driverPhoneNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  landedCost: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  shippedByUserID?: Maybe<Scalars['UUID']['output']>;
  shippedByUserName?: Maybe<Scalars['String']['output']>;
  shippedDatetime?: Maybe<Scalars['Time']['output']>;
  shippedDatetimeUTC?: Maybe<Scalars['Time']['output']>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalContainers: Scalars['Int']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItems: Scalars['Int']['output'];
  transferRequest?: Maybe<TransferRequest>;
  vehiclePlateNumber: Scalars['String']['output'];
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
  vendorRefNumber?: Maybe<Scalars['String']['output']>;
};

export type DeliveryOrderBatch = {
  __typename?: 'DeliveryOrderBatch';
  branchID: Scalars['UUID']['output'];
  containers?: Maybe<Array<DeliveryOrderBatchContainer>>;
  deliveredBy: Scalars['String']['output'];
  deliveryOrderBatchDatetime: Scalars['Time']['output'];
  deliveryOrderBatchDatetimeUtc: Scalars['Time']['output'];
  deliveryOrderBatchID: Scalars['UUID']['output'];
  deliveryOrderBatchNumber: Scalars['String']['output'];
  deliveryOrderDate?: Maybe<Scalars['Time']['output']>;
  driverName: Scalars['String']['output'];
  driverPhoneNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  generatedDatetime?: Maybe<Scalars['Time']['output']>;
  generatedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  gmt: Scalars['Int']['output'];
  isShipAfterGenerate: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  shippedDatetime?: Maybe<Scalars['Time']['output']>;
  sourceDocuments?: Maybe<Array<DeliveryOrderBatchSourceDocument>>;
  status: Scalars['String']['output'];
  toBranchID: Scalars['UUID']['output'];
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalFailedSourceDocuments: Scalars['Int']['output'];
  totalGeneratedDeliveryOrders: Scalars['Int']['output'];
  totalScannedContainers: Scalars['Int']['output'];
  totalShippedDeliveryOrders: Scalars['Int']['output'];
  vehiclePlateNumber: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorName: Scalars['String']['output'];
  vendorRefNumber: Scalars['String']['output'];
};

export type DeliveryOrderBatchContainer = {
  __typename?: 'DeliveryOrderBatchContainer';
  containerNumber: Scalars['String']['output'];
  deliveryOrderBatchContainerID: Scalars['UUID']['output'];
  deliveryOrderBatchID: Scalars['UUID']['output'];
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  itemCount: Scalars['Int']['output'];
  outboundContainerID: Scalars['UUID']['output'];
  scannedAt: Scalars['Time']['output'];
  scannedAtUtc: Scalars['Time']['output'];
  scannedByUserID: Scalars['UUID']['output'];
  scannedByUserName: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
};

export type DeliveryOrderBatchCreateInput = {
  destinationWarehouseID: Scalars['UUID']['input'];
  originWarehouseID: Scalars['UUID']['input'];
};

export type DeliveryOrderBatchDestinationSummary = {
  __typename?: 'DeliveryOrderBatchDestinationSummary';
  containersLeft: Scalars['Int']['output'];
  itemsLeft: Scalars['Int']['output'];
  toEligible: Scalars['Int']['output'];
  transferOrders?: Maybe<Array<DeliveryOrderBatchEligibleTransferOrder>>;
};

export type DeliveryOrderBatchEligibleTransferOrder = {
  __typename?: 'DeliveryOrderBatchEligibleTransferOrder';
  containerCount: Scalars['Int']['output'];
  itemCount: Scalars['Int']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderNumber: Scalars['String']['output'];
};

export type DeliveryOrderBatchGenerateInput = {
  allowPartial?: InputMaybe<Scalars['Boolean']['input']>;
  deliveredBy?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderBatchID: Scalars['UUID']['input'];
  deliveryOrderDate?: InputMaybe<Scalars['Time']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  shippedDatetime?: InputMaybe<Scalars['Time']['input']>;
  vehiclePlateNumber?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderBatchPaged = {
  __typename?: 'DeliveryOrderBatchPaged';
  items?: Maybe<Array<DeliveryOrderBatch>>;
  pagination: PaginationResult;
};

export type DeliveryOrderBatchQopFilterInput = {
  deliveryOrderBatchDatetimeFrom?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderBatchDatetimeTo?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderBatchNumber?: InputMaybe<Scalars['String']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeliveryOrderBatchQopInput = {
  filters?: InputMaybe<DeliveryOrderBatchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderBatchScanInput = {
  allowPendingDeliveryOrder?: InputMaybe<Scalars['Boolean']['input']>;
  containerNumber: Scalars['String']['input'];
  deliveryOrderBatchID: Scalars['UUID']['input'];
};

export type DeliveryOrderBatchScanResult = {
  __typename?: 'DeliveryOrderBatchScanResult';
  code: Scalars['String']['output'];
  container?: Maybe<DeliveryOrderBatchContainer>;
  message: Scalars['String']['output'];
  pendingDeliveryOrderNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Generate (and optional ship) outcome of one source document within a batch.
 *
 * status: pending -> generated -> shipped, or failed (see errorMessage).
 * A row can stay 'generated' with a non-empty errorMessage when the delivery order was created but shipping it failed.
 */
export type DeliveryOrderBatchSourceDocument = {
  __typename?: 'DeliveryOrderBatchSourceDocument';
  deliveryOrderBatchID: Scalars['UUID']['output'];
  deliveryOrderBatchSourceDocumentID: Scalars['UUID']['output'];
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  deliveryOrderNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalContainers: Scalars['Int']['output'];
};

export type DeliveryOrderCancelInput = {
  cancellationReason: Scalars['String']['input'];
  deliveryOrderID: Scalars['UUID']['input'];
};

export type DeliveryOrderContainerInput = {
  outboundContainerID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type DeliveryOrderContainerRemoveInput = {
  outboundContainerID: Scalars['UUID']['input'];
};

export type DeliveryOrderCreateInput = {
  allowPartial?: InputMaybe<Scalars['Boolean']['input']>;
  containers: Array<DeliveryOrderContainerInput>;
  deliveryBy: Scalars['String']['input'];
  deliveryOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
  vehiclePlateNumber?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderGenerateBulkInput = {
  transferOrderIDs: Array<Scalars['UUID']['input']>;
};

export type DeliveryOrderItem = {
  __typename?: 'DeliveryOrderItem';
  baseUomQty: Scalars['Float']['output'];
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderItemID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type DeliveryOrderItemPaged = {
  __typename?: 'DeliveryOrderItemPaged';
  items?: Maybe<Array<DeliveryOrderItem>>;
  pagination: PaginationResult;
};

export type DeliveryOrderItemQopFilterInput = {
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  deliveryOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeliveryOrderItemQopInput = {
  filters?: InputMaybe<DeliveryOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderItemSummary = {
  __typename?: 'DeliveryOrderItemSummary';
  baseUomQty: Scalars['Float']['output'];
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderItemSummaryID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  totalWeight: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type DeliveryOrderItemSummaryPaged = {
  __typename?: 'DeliveryOrderItemSummaryPaged';
  items: Array<DeliveryOrderItemSummary>;
  pagination: PaginationResult;
};

export type DeliveryOrderItemSummaryQopFilterInput = {
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderItemSummaryQopInput = {
  filters?: InputMaybe<DeliveryOrderItemSummaryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderPaged = {
  __typename?: 'DeliveryOrderPaged';
  items?: Maybe<Array<DeliveryOrder>>;
  pagination: PaginationResult;
};

export type DeliveryOrderQopFilterInput = {
  deliveryBy?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderDatetimeFrom?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderDatetimeTo?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderNumber?: InputMaybe<Scalars['String']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeliveryOrderQopInput = {
  filters?: InputMaybe<DeliveryOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderReceivingItemSummary = {
  __typename?: 'DeliveryOrderReceivingItemSummary';
  baseUomQty: Scalars['Float']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type DeliveryOrderReceivingItemSummaryPaged = {
  __typename?: 'DeliveryOrderReceivingItemSummaryPaged';
  items?: Maybe<Array<DeliveryOrderReceivingItemSummary>>;
  pagination: PaginationResult;
};

export type DeliveryOrderReceivingItemSummaryQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderReceivingItemSummaryQopInput = {
  filters?: InputMaybe<DeliveryOrderReceivingItemSummaryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderShippedInput = {
  deliveryBy: Scalars['String']['input'];
  deliveryOrderID: Scalars['UUID']['input'];
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  shippedDatetime: Scalars['Time']['input'];
  vehiclePlateNumber?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderUpdateInput = {
  containers?: InputMaybe<Array<DeliveryOrderContainerInput>>;
  deliveryBy?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderID: Scalars['UUID']['input'];
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  vehiclePlateNumber?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeltaItem = {
  __typename?: 'DeltaItem';
  createdAt: Scalars['String']['output'];
  op: ProductImageEmbeddingChangeOp;
  productAiImageId: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Int']['output'];
  sourceDeletedAt?: Maybe<Scalars['String']['output']>;
  sourceUpdatedAt: Scalars['String']['output'];
  vector?: Maybe<Array<Scalars['Float']['output']>>;
};

export type DeltaPage = {
  __typename?: 'DeltaPage';
  afterSeq: Scalars['Int']['output'];
  items: Array<DeltaItem>;
  limit: Scalars['Int']['output'];
  nextAfterSeq?: Maybe<Scalars['Int']['output']>;
};

export type EdcTerminal = {
  __typename?: 'EdcTerminal';
  bankAccount?: Maybe<BankAccount>;
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  edcTerminalID: Scalars['UUID']['output'];
  edcTerminalName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  serialNumber: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type EdcTerminalCreateInput = {
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  edcTerminalName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  serialNumber: Scalars['String']['input'];
};

export type EdcTerminalPaged = {
  __typename?: 'EdcTerminalPaged';
  items: Array<EdcTerminal>;
  pagination: PaginationResult;
};

export type EdcTerminalQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  edcTerminalName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type EdcTerminalQopInput = {
  filters?: InputMaybe<EdcTerminalQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type EdcTerminalUpdateInput = {
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  edcTerminalID: Scalars['UUID']['input'];
  edcTerminalName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  serialNumber: Scalars['String']['input'];
};

export type EditConsignmentSettlementInput = {
  branches?: InputMaybe<Array<ConsignmentSettlementBranchInput>>;
  chargeAmount?: InputMaybe<Scalars['Float']['input']>;
  commissionAmount?: InputMaybe<Scalars['Float']['input']>;
  periodEndDate?: InputMaybe<Scalars['Time']['input']>;
  periodStartDate?: InputMaybe<Scalars['Time']['input']>;
  reason: Scalars['String']['input'];
  transferFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
  vendorPayoutTotal?: InputMaybe<Scalars['Float']['input']>;
};

export type Employee = {
  __typename?: 'Employee';
  employeeCode: Scalars['String']['output'];
  employeeID: Scalars['UUID']['output'];
  employeeName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  erpReferenceID: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type EmployeeCreateInput = {
  employeeCode: Scalars['String']['input'];
  employeeName: Scalars['String']['input'];
  erpReferenceID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type EmployeePaged = {
  __typename?: 'EmployeePaged';
  items?: Maybe<Array<Employee>>;
  pagination: PaginationResult;
};

export type EmployeeQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  employeeCode?: InputMaybe<Scalars['String']['input']>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  erpReferenceID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type EmployeeQopInput = {
  filters?: InputMaybe<EmployeeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type EmployeeUpdateInput = {
  employeeCode: Scalars['String']['input'];
  employeeID: Scalars['UUID']['input'];
  employeeName: Scalars['String']['input'];
  erpReferenceID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type EntityAuditMetadata = {
  __typename?: 'EntityAuditMetadata';
  createdAt: Scalars['Time']['output'];
  createdByUserID?: Maybe<Scalars['UUID']['output']>;
  createdByUserName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  deletedByUserID?: Maybe<Scalars['UUID']['output']>;
  deletedByUserName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  updatedByUserID?: Maybe<Scalars['UUID']['output']>;
  updatedByUserName?: Maybe<Scalars['String']['output']>;
  version: Scalars['UUID']['output'];
};

export type ErpBranch = {
  __typename?: 'ErpBranch';
  balance: Scalars['Float']['output'];
  branchID: Scalars['Int']['output'];
  credit: Scalars['Float']['output'];
  debit: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  planID: Scalars['Int']['output'];
  planName: Scalars['String']['output'];
  ref: Scalars['String']['output'];
};

export type ErpBranchPaged = {
  __typename?: 'ErpBranchPaged';
  items?: Maybe<Array<ErpBranch>>;
  pagination: PaginationResult;
};

export type ErpBranchQopFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  planID?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type ErpBranchQopInput = {
  filters?: InputMaybe<ErpBranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpEmployee = {
  __typename?: 'ErpEmployee';
  coachName: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  department: Scalars['String']['output'];
  employeeID: Scalars['Int64']['output'];
  employeeName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  homeAddress: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  jobPosition: Scalars['String']['output'];
  nationality: Scalars['String']['output'];
  nomorIdentity: Scalars['String']['output'];
  workAddress: Scalars['String']['output'];
  workEmail: Scalars['String']['output'];
  workLocation: Scalars['String']['output'];
  workPhoneNumber: Scalars['String']['output'];
};

export type ErpEmployeePaged = {
  __typename?: 'ErpEmployeePaged';
  items?: Maybe<Array<ErpEmployee>>;
  pagination: PaginationResult;
};

export type ErpEmployeeQopFilterInput = {
  employeeName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  nomorIdentity?: InputMaybe<Scalars['String']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
};

export type ErpEmployeeQopInput = {
  filters?: InputMaybe<ErpEmployeeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpProduct = {
  __typename?: 'ErpProduct';
  barcode: Scalars['String']['output'];
  canBePurchased: Scalars['Boolean']['output'];
  canBeSold: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  mainImageFileLargePathURL: Scalars['String']['output'];
  mainImageFileMediumPathURL: Scalars['String']['output'];
  mainImageFileSmallPathURL: Scalars['String']['output'];
  productCategoryID: Scalars['Int']['output'];
  productCategoryName: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  purchaseCost: Scalars['Float']['output'];
  purchaseTaxID: Scalars['Int']['output'];
  purchaseUomID: Scalars['Int']['output'];
  purchaseUomName: Scalars['String']['output'];
  salesTaxID: Scalars['Int']['output'];
  salesUomID: Scalars['Int']['output'];
  salesUomName: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
  trackExpiredDate: Scalars['Boolean']['output'];
  trackStock: Scalars['Boolean']['output'];
  weight: Scalars['Float']['output'];
};

export type ErpProductCategory = {
  __typename?: 'ErpProductCategory';
  parentID: Scalars['Int']['output'];
  parentName: Scalars['String']['output'];
  productCategoryID: Scalars['Int']['output'];
  productCategoryName: Scalars['String']['output'];
};

export type ErpProductCategoryPaged = {
  __typename?: 'ErpProductCategoryPaged';
  items?: Maybe<Array<ErpProductCategory>>;
  pagination: PaginationResult;
};

export type ErpProductCategoryQopFilterInput = {
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
};

export type ErpProductCategoryQopInput = {
  filters?: InputMaybe<ErpProductCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpProductPaged = {
  __typename?: 'ErpProductPaged';
  items?: Maybe<Array<ErpProduct>>;
  pagination: PaginationResult;
};

export type ErpProductQopFilterInput = {
  productCategoryID?: InputMaybe<Scalars['Int']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type ErpProductQopInput = {
  filters?: InputMaybe<ErpProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpPurchaseOrderReceive = {
  __typename?: 'ErpPurchaseOrderReceive';
  erpID: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingNumber: Scalars['String']['output'];
  reasonFailed: Scalars['String']['output'];
  syncStatus: Scalars['String']['output'];
};

export type ErpPurchaseOrderReceivePaged = {
  __typename?: 'ErpPurchaseOrderReceivePaged';
  items?: Maybe<Array<ErpPurchaseOrderReceive>>;
  pagination: PaginationResult;
};

export type ErpPurchaseOrderReceiveQopFilterInput = {
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<Scalars['String']['input']>;
};

export type ErpPurchaseOrderReceiveQopInput = {
  filters?: InputMaybe<ErpPurchaseOrderReceiveQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpSyncFullRun = {
  __typename?: 'ErpSyncFullRun';
  completedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  dispatchedCount: Scalars['Int']['output'];
  entityType: Scalars['String']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  lastBatchIndex: Scalars['Int']['output'];
  startedAt: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type ErpSyncFullRunPaged = {
  __typename?: 'ErpSyncFullRunPaged';
  items?: Maybe<Array<ErpSyncFullRun>>;
  pagination: PaginationResult;
};

export type ErpSyncFullRunQopFilterInput = {
  entityType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ErpSyncFullRunQopInput = {
  filters?: InputMaybe<ErpSyncFullRunQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpTax = {
  __typename?: 'ErpTax';
  isActive: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  taxID: Scalars['Int']['output'];
  taxName: Scalars['String']['output'];
  taxType: Scalars['String']['output'];
};

export type ErpTaxPaged = {
  __typename?: 'ErpTaxPaged';
  items?: Maybe<Array<ErpTax>>;
  pagination: PaginationResult;
};

export type ErpTaxQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxName?: InputMaybe<Scalars['String']['input']>;
  taxType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ErpTaxQopInput = {
  filters?: InputMaybe<ErpTaxQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type ErpUom = {
  __typename?: 'ErpUom';
  categoryID: Scalars['Int']['output'];
  categoryName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uomID: Scalars['Int']['output'];
};

export type ErpUomCategory = {
  __typename?: 'ErpUomCategory';
  name: Scalars['String']['output'];
  uomCategoryID: Scalars['Int']['output'];
};

export type ErpUomCategoryPaged = {
  __typename?: 'ErpUomCategoryPaged';
  items?: Maybe<Array<ErpUomCategory>>;
  pagination: PaginationResult;
};

export type ErpUomCategoryQopFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ErpUomCategoryQopInput = {
  filters?: InputMaybe<ErpUomCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpUomPaged = {
  __typename?: 'ErpUomPaged';
  items?: Maybe<Array<ErpUom>>;
  pagination: PaginationResult;
};

export type ErpUomQopFilterInput = {
  categoryID?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ErpUomQopInput = {
  filters?: InputMaybe<ErpUomQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpVendor = {
  __typename?: 'ErpVendor';
  active: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  companyType: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  creditLimit: Scalars['Float']['output'];
  currencyName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  isCompany: Scalars['Boolean']['output'];
  isPkp: Scalars['Boolean']['output'];
  mobile: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  stateName: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2: Scalars['String']['output'];
  vat: Scalars['String']['output'];
  vendorID: Scalars['Int']['output'];
  website: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type ErpVendorPaged = {
  __typename?: 'ErpVendorPaged';
  items?: Maybe<Array<ErpVendor>>;
  pagination: PaginationResult;
};

export type ErpVendorQopFilterInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ErpVendorQopInput = {
  filters?: InputMaybe<ErpVendorQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpWarehouse = {
  __typename?: 'ErpWarehouse';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  companyID: Scalars['Int']['output'];
  companyName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  warehouseID: Scalars['Int']['output'];
};

export type ErpWarehousePaged = {
  __typename?: 'ErpWarehousePaged';
  items?: Maybe<Array<ErpWarehouse>>;
  pagination: PaginationResult;
};

export type ErpWarehouseQopFilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  companyID?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ErpWarehouseQopInput = {
  filters?: InputMaybe<ErpWarehouseQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ExecutionResult = {
  __typename?: 'ExecutionResult';
  executionID: Scalars['UUID']['output'];
  progressPercent: Scalars['Float']['output'];
  qtyExecuted: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  taskItemID: Scalars['UUID']['output'];
  totalQtyExecuted: Scalars['Float']['output'];
};

export type ExpenseItem = {
  __typename?: 'ExpenseItem';
  entityAuditMetadata: EntityAuditMetadata;
  expenseItemID: Scalars['UUID']['output'];
  expenseItemName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  journalAccountCode: Scalars['String']['output'];
  journalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  journalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type ExpenseItemCreateInput = {
  expenseItemName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseItemPaged = {
  __typename?: 'ExpenseItemPaged';
  items?: Maybe<Array<ExpenseItem>>;
  pagination: PaginationResult;
};

export type ExpenseItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  expenseItemName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ExpenseItemQopInput = {
  filters?: InputMaybe<ExpenseItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ExpenseItemUpdateInput = {
  expenseItemID: Scalars['UUID']['input'];
  expenseItemName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
};

export type File = {
  __typename?: 'File';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  fileSizeMB: Scalars['Float']['output'];
  imageProxyURL?: Maybe<Scalars['String']['output']>;
  imageProxyURLLarge?: Maybe<Scalars['String']['output']>;
  imageProxyURLMedium?: Maybe<Scalars['String']['output']>;
  imageProxyURLSmall?: Maybe<Scalars['String']['output']>;
  imageProxyURLThumbnail?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  originalFileName: Scalars['String']['output'];
  publicURL?: Maybe<Scalars['String']['output']>;
  storageBucket: Scalars['String']['output'];
  storagePath: Scalars['String']['output'];
};

export type FileCreateFromStorageObjectInput = {
  fileSizeMB?: InputMaybe<Scalars['Float']['input']>;
  mimeType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  storageBucket: Scalars['String']['input'];
  storagePath: Scalars['String']['input'];
};

export type FilePaged = {
  __typename?: 'FilePaged';
  items?: Maybe<Array<File>>;
  pagination: PaginationResult;
};

export type FileQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type FileQopInput = {
  filters?: InputMaybe<FileQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type FinishTaskInput = {
  putawayTaskID: Scalars['UUID']['input'];
};

export type GenerateConsignmentInvoiceInput = {
  payoutBankAccountNumber: Scalars['String']['input'];
  payoutBankID?: InputMaybe<Scalars['UUID']['input']>;
  payoutBankName?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type GenerateLinkResetPasswordInput = {
  userName?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type GenerateLinkResetPasswordResponse = {
  __typename?: 'GenerateLinkResetPasswordResponse';
  nextRetryDelay: Scalars['Int']['output'];
  nextSessionDelay: Scalars['Int']['output'];
  remainingAttempts: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type GenerateMultipleTasksInput = {
  putawayTaskDatetime: Scalars['Time']['input'];
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
  tasks: Array<TaskAllocationInput>;
};

export type GenerateOtpCodeInput = {
  channel: OtpChannel;
  type: OtpType;
  userName: Scalars['String']['input'];
};

export type GenerateSingleTaskInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
};

export type GenerateTransferRequestFromReplenishmentInput = {
  items: Array<GenerateTransferRequestFromReplenishmentItemInput>;
  noteForApprover: Scalars['String']['input'];
  replenishmentID: Scalars['UUID']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
};

export type GenerateTransferRequestFromReplenishmentItemInput = {
  qtyRequested: Scalars['Float']['input'];
  replenishmentItemID: Scalars['UUID']['input'];
};

export type InboundReceiving = {
  __typename?: 'InboundReceiving';
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  inboundReceivingDatetime: Scalars['Time']['output'];
  inboundReceivingDatetimeUtc: Scalars['Time']['output'];
  inboundReceivingID: Scalars['UUID']['output'];
  inboundReceivingNumber: Scalars['String']['output'];
  isPutawayCompleted: Scalars['Boolean']['output'];
  items: Array<InboundReceivingItem>;
  noteInternal: Scalars['String']['output'];
  originWarehouse?: Maybe<Warehouse>;
  originWarehouseID?: Maybe<Scalars['UUID']['output']>;
  originWarehouseLocation?: Maybe<WarehouseLocation>;
  originWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  simpleTransferOrder?: Maybe<SimpleTransferOrder>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItems: Scalars['Float']['output'];
  transferOrder?: Maybe<TransferOrder>;
  vendor?: Maybe<Vendor>;
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorRefNo?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InboundReceivingItem = {
  __typename?: 'InboundReceivingItem';
  baseUomQtyPutawayAssigned: Scalars['Float']['output'];
  baseUomQtyPutawayExecuted: Scalars['Float']['output'];
  baseUomQtyReceived: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inboundReceivingID: Scalars['UUID']['output'];
  inboundReceivingItemID: Scalars['UUID']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyPutawayAssigned: Scalars['Float']['output'];
  qtyPutawayExecuted: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type InboundReceivingPaged = {
  __typename?: 'InboundReceivingPaged';
  items: Array<InboundReceiving>;
  pagination: PaginationResult;
};

export type InboundReceivingQopFilterInput = {
  inboundReceivingDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  inboundReceivingDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  inboundReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  originWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InboundReceivingQopInput = {
  filters?: InputMaybe<InboundReceivingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type IngestionRunInfo = {
  __typename?: 'IngestionRunInfo';
  candidateCount: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  failureCount: Scalars['Float']['output'];
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startedAt: Scalars['String']['output'];
  status: IngestionRunStatus;
  successCount: Scalars['Float']['output'];
  watermarkFrom?: Maybe<Scalars['String']['output']>;
  watermarkTo?: Maybe<Scalars['String']['output']>;
};

export enum IngestionRunStatus {
  Failed = 'FAILED',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type InternalTransfer = {
  __typename?: 'InternalTransfer';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  confirmByUserID?: Maybe<Scalars['UUID']['output']>;
  confirmByUserName?: Maybe<Scalars['String']['output']>;
  confirmDatetime?: Maybe<Scalars['Time']['output']>;
  confirmDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  internalTransferDatetime: Scalars['Time']['output'];
  internalTransferDatetimeUtc: Scalars['Time']['output'];
  internalTransferID: Scalars['UUID']['output'];
  internalTransferNumber: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalItemQtyRequested: Scalars['Float']['output'];
  totalItemQtyTransferred: Scalars['Float']['output'];
  totalItemWeight: Scalars['Float']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InternalTransferCancelInput = {
  cancellationReason: Scalars['String']['input'];
  internalTransferID: Scalars['UUID']['input'];
};

export type InternalTransferConfirmInput = {
  internalTransferID: Scalars['UUID']['input'];
};

export type InternalTransferCreateInput = {
  description: Scalars['String']['input'];
  internalTransferDatetime: Scalars['Time']['input'];
  internalTransferNumber?: InputMaybe<Scalars['String']['input']>;
  items: Array<InternalTransferItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InternalTransferExecution = {
  __typename?: 'InternalTransferExecution';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  executedAtUtc: Scalars['Time']['output'];
  executedByUserID: Scalars['UUID']['output'];
  executedByUserName: Scalars['String']['output'];
  fromWarehouseLocationCode: Scalars['String']['output'];
  fromWarehouseLocationID: Scalars['UUID']['output'];
  internalTransferExecutionID: Scalars['UUID']['output'];
  internalTransferID: Scalars['UUID']['output'];
  internalTransferItemID: Scalars['UUID']['output'];
  noteInternal: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  toWarehouseLocationCode: Scalars['String']['output'];
  toWarehouseLocationID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
};

export type InternalTransferExecutionPaged = {
  __typename?: 'InternalTransferExecutionPaged';
  items: Array<InternalTransferExecution>;
  pagination: PaginationResult;
};

export type InternalTransferExecutionQopFilterInput = {
  executedAtEnd?: InputMaybe<Scalars['Time']['input']>;
  executedAtStart?: InputMaybe<Scalars['Time']['input']>;
  fromWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferExecutionID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  toWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InternalTransferExecutionQopInput = {
  filters?: InputMaybe<InternalTransferExecutionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InternalTransferItem = {
  __typename?: 'InternalTransferItem';
  baseUomQtyOutstanding: Scalars['Float']['output'];
  baseUomQtyRequested: Scalars['Float']['output'];
  baseUomQtyTransferred: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseLocationCode: Scalars['String']['output'];
  fromWarehouseLocationID: Scalars['UUID']['output'];
  fromWarehouseLocationName: Scalars['String']['output'];
  internalTransferID: Scalars['UUID']['output'];
  internalTransferItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  qtyRequested: Scalars['Float']['output'];
  qtyTransferred: Scalars['Float']['output'];
  toWarehouseLocationCode: Scalars['String']['output'];
  toWarehouseLocationID: Scalars['UUID']['output'];
  toWarehouseLocationName: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type InternalTransferItemCreateInput = {
  fromWarehouseLocationID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  toWarehouseLocationID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type InternalTransferItemPaged = {
  __typename?: 'InternalTransferItemPaged';
  items: Array<InternalTransferItem>;
  pagination: PaginationResult;
};

export type InternalTransferItemQopFilterInput = {
  fromWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  toWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InternalTransferItemQopInput = {
  filters?: InputMaybe<InternalTransferItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InternalTransferItemUpdateInput = {
  fromWarehouseLocationID: Scalars['UUID']['input'];
  internalTransferItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  toWarehouseLocationID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type InternalTransferPaged = {
  __typename?: 'InternalTransferPaged';
  items: Array<InternalTransfer>;
  pagination: PaginationResult;
};

export type InternalTransferQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  internalTransferDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  internalTransferDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  internalTransferNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InternalTransferQopInput = {
  filters?: InputMaybe<InternalTransferQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InternalTransferUpdateInput = {
  description: Scalars['String']['input'];
  internalTransferDatetime: Scalars['Time']['input'];
  internalTransferID: Scalars['UUID']['input'];
  internalTransferNumber: Scalars['String']['input'];
  items: Array<InternalTransferItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustment = {
  __typename?: 'InventoryAdjustment';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  confirmByUserID?: Maybe<Scalars['UUID']['output']>;
  confirmByUserName?: Maybe<Scalars['String']['output']>;
  confirmDatetime?: Maybe<Scalars['Time']['output']>;
  confirmDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<InventoryAdjustmentFile>>;
  inventoryAdjustmentDate: Scalars['Time']['output'];
  inventoryAdjustmentID: Scalars['UUID']['output'];
  inventoryAdjustmentNumber: Scalars['String']['output'];
  inventoryAdjustmentType: Scalars['String']['output'];
  isSystemGenerated: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sourceDocumentID?: Maybe<Scalars['UUID']['output']>;
  sourceDocumentNumber?: Maybe<Scalars['String']['output']>;
  sourceDocumentType?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  usedCost: Scalars['Boolean']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryAdjustmentCancelInput = {
  inventoryAdjustmentID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentConfirmInput = {
  inventoryAdjustmentID: Scalars['UUID']['input'];
  /** System Correction only: mirror to Odoo (true when the error already reached Odoo). Ignored for other types. */
  syncToErp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InventoryAdjustmentCreateInput = {
  branchID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<InventoryAdjustmentFileInput>>;
  inventoryAdjustmentDate: Scalars['Time']['input'];
  inventoryAdjustmentNumber?: InputMaybe<Scalars['String']['input']>;
  inventoryAdjustmentType: Scalars['String']['input'];
  items: Array<InventoryAdjustmentItemCreateInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  usedCost: Scalars['Boolean']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentCreateOpeningBalanceInput = {
  branchID: Scalars['UUID']['input'];
  inventoryAdjustmentDate: Scalars['Time']['input'];
  items: Array<InventoryAdjustmentItemCreateOpeningBalanceInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentCreateSystemInput = {
  branchID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<InventoryAdjustmentFileInput>>;
  inventoryAdjustmentDate: Scalars['Time']['input'];
  inventoryAdjustmentType: Scalars['String']['input'];
  items: Array<InventoryAdjustmentItemCreateInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  usedCost: Scalars['Boolean']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentFile = {
  __typename?: 'InventoryAdjustmentFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  inventoryAdjustmentFileID: Scalars['UUID']['output'];
  inventoryAdjustmentFileType: Scalars['String']['output'];
  inventoryAdjustmentID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type InventoryAdjustmentFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type InventoryAdjustmentItem = {
  __typename?: 'InventoryAdjustmentItem';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryAdjustmentID: Scalars['UUID']['output'];
  inventoryAdjustmentItemID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  reasonID: Scalars['UUID']['output'];
  reasonName: Scalars['String']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
  unitCost: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryAdjustmentItemCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentItemCreateOpeningBalanceInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentItemPaged = {
  __typename?: 'InventoryAdjustmentItemPaged';
  items: Array<InventoryAdjustmentItem>;
  pagination: PaginationResult;
};

export type InventoryAdjustmentItemQopFilterInput = {
  inventoryAdjustmentID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryAdjustmentItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  reasonID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryAdjustmentItemQopInput = {
  filters?: InputMaybe<InventoryAdjustmentItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryAdjustmentItemUpdateInput = {
  inventoryAdjustmentItemID?: InputMaybe<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentOpeningBalanceImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryAdjustmentOpeningBalanceImportFileMappingInput = {
  columns: Array<InventoryAdjustmentOpeningBalanceImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type InventoryAdjustmentOpeningBalanceImportInput = {
  branchID: Scalars['UUID']['input'];
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryAdjustmentOpeningBalanceImportFileMappingInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentOpeningBalanceImportMissingProductUom = {
  __typename?: 'InventoryAdjustmentOpeningBalanceImportMissingProductUom';
  productCode: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  uomName: Scalars['String']['output'];
};

export type InventoryAdjustmentOpeningBalanceImportRowReport = {
  __typename?: 'InventoryAdjustmentOpeningBalanceImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<InventoryAdjustmentOpeningBalanceImportRowViolation>;
};

export type InventoryAdjustmentOpeningBalanceImportRowViolation = {
  __typename?: 'InventoryAdjustmentOpeningBalanceImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InventoryAdjustmentOpeningBalanceImportValidateCodesInput = {
  branchID: Scalars['UUID']['input'];
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  fileMapping?: InputMaybe<InventoryAdjustmentOpeningBalanceImportFileMappingInput>;
  locationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentOpeningBalanceImportValidateCodesResult = {
  __typename?: 'InventoryAdjustmentOpeningBalanceImportValidateCodesResult';
  missingLocationNames: Array<Scalars['String']['output']>;
  missingProductCodes: Array<Scalars['String']['output']>;
  missingProductUoms: Array<InventoryAdjustmentOpeningBalanceImportMissingProductUom>;
  rowReport?: Maybe<InventoryAdjustmentOpeningBalanceImportRowReport>;
};

export type InventoryAdjustmentPaged = {
  __typename?: 'InventoryAdjustmentPaged';
  items?: Maybe<Array<InventoryAdjustment>>;
  pagination: PaginationResult;
};

export type InventoryAdjustmentQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryAdjustmentDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryAdjustmentDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  inventoryAdjustmentDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  inventoryAdjustmentNumber?: InputMaybe<Scalars['String']['input']>;
  inventoryAdjustmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryAdjustmentQopInput = {
  filters?: InputMaybe<InventoryAdjustmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryAdjustmentType = {
  __typename?: 'InventoryAdjustmentType';
  code: Scalars['String']['output'];
  inventoryAdjustmentTypeID: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Selectable in the Standard form dropdown */
  isStandard: Scalars['Boolean']['output'];
  /** A confirmed document mirrors stock to Odoo */
  isSyncToErp: Scalars['Boolean']['output'];
  /** Only system flows / IT tooling create it; operator forms reject it */
  isSystemGenerated: Scalars['Boolean']['output'];
  /** Created through the Waste form (type fixed) */
  isWaste: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type InventoryAdjustmentUpdateInput = {
  branchID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<InventoryAdjustmentFileInput>>;
  inventoryAdjustmentDate: Scalars['Time']['input'];
  inventoryAdjustmentID: Scalars['UUID']['input'];
  inventoryAdjustmentNumber?: InputMaybe<Scalars['String']['input']>;
  inventoryAdjustmentType: Scalars['String']['input'];
  items: Array<InventoryAdjustmentItemUpdateInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  usedCost: Scalars['Boolean']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryCountItemTemplate = {
  __typename?: 'InventoryCountItemTemplate';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountItemTemplateID: Scalars['UUID']['output'];
  inventoryCountItemTemplateItemPaged: InventoryCountItemTemplateItemPaged;
  inventoryCountItemTemplateName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
};


export type InventoryCountItemTemplateInventoryCountItemTemplateItemPagedArgs = {
  qop?: InputMaybe<InventoryCountItemTemplateItemQopInput>;
};

export type InventoryCountItemTemplateCreateInput = {
  inventoryCountItemTemplateName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryCountItemTemplateItem = {
  __typename?: 'InventoryCountItemTemplateItem';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountItemTemplateID: Scalars['UUID']['output'];
  inventoryCountItemTemplateItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type InventoryCountItemTemplateItemCreateInput = {
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type InventoryCountItemTemplateItemImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountItemTemplateItemImportFileMappingInput = {
  columns: Array<InventoryCountItemTemplateItemImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type InventoryCountItemTemplateItemImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryCountItemTemplateItemImportFileMappingInput;
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
};

export type InventoryCountItemTemplateItemImportResult = {
  __typename?: 'InventoryCountItemTemplateItemImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type InventoryCountItemTemplateItemImportRowReport = {
  __typename?: 'InventoryCountItemTemplateItemImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<InventoryCountItemTemplateItemImportRowViolation>;
};

export type InventoryCountItemTemplateItemImportRowViolation = {
  __typename?: 'InventoryCountItemTemplateItemImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InventoryCountItemTemplateItemImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryCountItemTemplateItemImportFileMappingInput;
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
};

export type InventoryCountItemTemplateItemImportValidateResult = {
  __typename?: 'InventoryCountItemTemplateItemImportValidateResult';
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: InventoryCountItemTemplateItemImportRowReport;
};

export type InventoryCountItemTemplateItemPaged = {
  __typename?: 'InventoryCountItemTemplateItemPaged';
  items?: Maybe<Array<InventoryCountItemTemplateItem>>;
  pagination: PaginationResult;
};

export type InventoryCountItemTemplateItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountItemTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type InventoryCountItemTemplateItemQopInput = {
  filters?: InputMaybe<InventoryCountItemTemplateItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountItemTemplatePaged = {
  __typename?: 'InventoryCountItemTemplatePaged';
  items?: Maybe<Array<InventoryCountItemTemplate>>;
  pagination: PaginationResult;
};

export type InventoryCountItemTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountItemTemplateName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type InventoryCountItemTemplateQopInput = {
  filters?: InputMaybe<InventoryCountItemTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountItemTemplateUpdateInput = {
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
  inventoryCountItemTemplateName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryCountTask = {
  __typename?: 'InventoryCountTask';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  cancelledAtUtc?: Maybe<Scalars['Time']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  inventoryCountTaskDatetime: Scalars['Time']['output'];
  inventoryCountTaskDatetimeUtc: Scalars['Time']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTaskNumber: Scalars['String']['output'];
  inventoryCountTransaction: InventoryCountTransaction;
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionLocations?: Maybe<Array<InventoryCountTransactionLocation>>;
  inventoryCountTransactionNumber: Scalars['String']['output'];
  isRecount: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  taskDoneAt?: Maybe<Scalars['Time']['output']>;
  taskDoneAtUtc?: Maybe<Scalars['Time']['output']>;
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  taskStartAtUtc?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyCounted: Scalars['Float']['output'];
  totalQtyDiff: Scalars['Float']['output'];
  totalQtySystem: Scalars['Float']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryCountTaskAssignedFinishInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskAssignee = {
  __typename?: 'InventoryCountTaskAssignee';
  assignedToUserID: Scalars['UUID']['output'];
  assignedToUserName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  finishedAt?: Maybe<Scalars['Time']['output']>;
  finishedAtUtc?: Maybe<Scalars['Time']['output']>;
  inventoryCountTask: InventoryCountTask;
  inventoryCountTaskAssigneeID: Scalars['UUID']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  sequenceNo: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['Time']['output']>;
  startedAtUtc?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
};

export type InventoryCountTaskAssigneeAddInput = {
  assignedToUserID: Scalars['UUID']['input'];
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskAssigneeDeleteInput = {
  inventoryCountTaskAssigneeID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskAssigneePaged = {
  __typename?: 'InventoryCountTaskAssigneePaged';
  items: Array<InventoryCountTaskAssignee>;
  pagination: PaginationResult;
};

export type InventoryCountTaskAssigneeQopFilterInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskAssigneeID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountTaskAssigneeQopInput = {
  filters?: InputMaybe<InventoryCountTaskAssigneeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskCancelInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskExecuteImportInput = {
  assigneeUserID: Scalars['UUID']['input'];
  fileID: Scalars['UUID']['input'];
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskExecuteImportResult = {
  __typename?: 'InventoryCountTaskExecuteImportResult';
  backgroundJobID: Scalars['UUID']['output'];
};

export type InventoryCountTaskExecutionDetailDeleteInput = {
  inventoryCountTaskExecutionItemDetailID: Scalars['UUID']['input'];
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskExecutionItem = {
  __typename?: 'InventoryCountTaskExecutionItem';
  barcode: Scalars['String']['output'];
  baseUomQtyCounted: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  baseUomUnitCostCounted: Scalars['Float']['output'];
  baseUomUnitCostDiff: Scalars['Float']['output'];
  baseUomUnitCostSystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTaskExecutionItemID: Scalars['UUID']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  isRecountRequired: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  resultItemDetails?: Maybe<Array<InventoryCountTransactionResultItemDetail>>;
  totalExecutionCount: Scalars['Int']['output'];
  unitCostSystem: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  virtualWarehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTaskExecutionItemDetail = {
  __typename?: 'InventoryCountTaskExecutionItemDetail';
  barcode: Scalars['String']['output'];
  baseUomQty: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  executedAtUtc: Scalars['Time']['output'];
  executedByUserID: Scalars['UUID']['output'];
  executedByUserName: Scalars['String']['output'];
  inputMethod: Scalars['String']['output'];
  inventoryCountTaskExecutionItemDetailID: Scalars['UUID']['output'];
  inventoryCountTaskExecutionItemID: Scalars['UUID']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionLocationDetailID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  sequenceNo: Scalars['Int']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  virtualWarehouseLocationName: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTaskExecutionItemDetailPaged = {
  __typename?: 'InventoryCountTaskExecutionItemDetailPaged';
  items: Array<InventoryCountTaskExecutionItemDetail>;
  pagination: PaginationResult;
};

export type InventoryCountTaskExecutionItemDetailQopFilterInput = {
  executedAtEnd?: InputMaybe<Scalars['Time']['input']>;
  executedAtStart?: InputMaybe<Scalars['Time']['input']>;
  executedByUserID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskExecutionItemDetailID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskExecutionItemID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationDetailID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTaskExecutionItemDetailQopInput = {
  filters?: InputMaybe<InventoryCountTaskExecutionItemDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskExecutionItemPaged = {
  __typename?: 'InventoryCountTaskExecutionItemPaged';
  items: Array<InventoryCountTaskExecutionItem>;
  pagination: PaginationResult;
};

export type InventoryCountTaskExecutionItemQopFilterInput = {
  inventoryCountTaskExecutionItemID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  isRecountRequired?: InputMaybe<Scalars['Boolean']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  qtyDiffEqual?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMax?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMin?: InputMaybe<Scalars['Float']['input']>;
  warehouseLocationIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryCountTaskExecutionItemQopInput = {
  filters?: InputMaybe<InventoryCountTaskExecutionItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskExecutionItemSummary = {
  __typename?: 'InventoryCountTaskExecutionItemSummary';
  barcode: Scalars['String']['output'];
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedByUserID: Scalars['UUID']['output'];
  executedByUserName: Scalars['String']['output'];
  inventoryCountTaskExecutionItemSummaryID: Scalars['UUID']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  sequenceNo: Scalars['Int']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTaskExecutionItemSummaryPaged = {
  __typename?: 'InventoryCountTaskExecutionItemSummaryPaged';
  items: Array<InventoryCountTaskExecutionItemSummary>;
  pagination: PaginationResult;
};

export type InventoryCountTaskExecutionItemSummaryQopFilterInput = {
  executedByUserID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTaskExecutionItemSummaryQopInput = {
  filters?: InputMaybe<InventoryCountTaskExecutionItemSummaryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskExportInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
};

export type InventoryCountTaskFinishInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskItemExecuteInput = {
  inputMethod: Scalars['String']['input'];
  inventoryCountTaskID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventoryCountTaskItemResetExecutedInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskPaged = {
  __typename?: 'InventoryCountTaskPaged';
  items: Array<InventoryCountTask>;
  pagination: PaginationResult;
};

export type InventoryCountTaskQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTaskDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTaskQopInput = {
  filters?: InputMaybe<InventoryCountTaskQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskRecountCreateInput = {
  assignedToUserIDs: Array<Scalars['UUID']['input']>;
  inventoryCountTaskDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionID: Scalars['UUID']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  parentInventoryCountTaskID: Scalars['UUID']['input'];
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskRecountItem = {
  __typename?: 'InventoryCountTaskRecountItem';
  barcode: Scalars['String']['output'];
  baseUomQtyCounted: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  baseUomUnitCostCounted: Scalars['Float']['output'];
  baseUomUnitCostDiff: Scalars['Float']['output'];
  baseUomUnitCostSystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTaskRecountItemID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  parentInventoryCountTaskID: Scalars['UUID']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type InventoryCountTaskRecountItemInput = {
  inventoryCountTransactionResultItemID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountTaskRecountItemPaged = {
  __typename?: 'InventoryCountTaskRecountItemPaged';
  items: Array<InventoryCountTaskRecountItem>;
  pagination: PaginationResult;
};

export type InventoryCountTaskRecountItemQopFilterInput = {
  difference?: InputMaybe<Scalars['Float']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskRecountItemID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionResultItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  qtyDiffMax?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMin?: InputMaybe<Scalars['Float']['input']>;
  totalCostMax?: InputMaybe<Scalars['Float']['input']>;
  totalCostMin?: InputMaybe<Scalars['Float']['input']>;
  unitCostDifference?: InputMaybe<Scalars['Float']['input']>;
};

export type InventoryCountTaskRecountItemQopInput = {
  filters?: InputMaybe<InventoryCountTaskRecountItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskStartInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskUpdateInput = {
  assignedToUserIDs: Array<Scalars['UUID']['input']>;
  inventoryCountTaskDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTaskID: Scalars['UUID']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  version: Scalars['UUID']['input'];
};

export type InventoryCountTransaction = {
  __typename?: 'InventoryCountTransaction';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  inventoryCountTransactionDatetime: Scalars['Time']['output'];
  inventoryCountTransactionDatetimeUtc: Scalars['Time']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionNumber: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
  totalCountTasks: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryCountTransactionCancelInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  inventoryCountTransactionID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTransactionCreateInput = {
  assignedToUserIDs: Array<Scalars['UUID']['input']>;
  excludeProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  inventoryCountTransactionDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  locationScopeType: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  partialProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  taskType: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryCountTransactionExport = {
  __typename?: 'InventoryCountTransactionExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type InventoryCountTransactionExportInput = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
};

export type InventoryCountTransactionFinishInput = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
  reasonID?: InputMaybe<Scalars['UUID']['input']>;
  version: Scalars['UUID']['input'];
};

export type InventoryCountTransactionItem = {
  __typename?: 'InventoryCountTransactionItem';
  barcode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionItemID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type InventoryCountTransactionItemPaged = {
  __typename?: 'InventoryCountTransactionItemPaged';
  items: Array<InventoryCountTransactionItem>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionItemQopFilterInput = {
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountTransactionItemQopInput = {
  filters?: InputMaybe<InventoryCountTransactionItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionLocation = {
  __typename?: 'InventoryCountTransactionLocation';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionLocationID: Scalars['UUID']['output'];
  sequenceNo: Scalars['Int']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTransactionLocationDetail = {
  __typename?: 'InventoryCountTransactionLocationDetail';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionLocationDetailID: Scalars['UUID']['output'];
  inventoryCountTransactionLocationID: Scalars['UUID']['output'];
  sequenceNo: Scalars['Int']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTransactionLocationDetailPaged = {
  __typename?: 'InventoryCountTransactionLocationDetailPaged';
  items: Array<InventoryCountTransactionLocationDetail>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionLocationDetailQopFilterInput = {
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationDetailID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationName?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountTransactionLocationDetailQopInput = {
  filters?: InputMaybe<InventoryCountTransactionLocationDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionLocationPaged = {
  __typename?: 'InventoryCountTransactionLocationPaged';
  items: Array<InventoryCountTransactionLocation>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionLocationQopFilterInput = {
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTransactionLocationQopInput = {
  filters?: InputMaybe<InventoryCountTransactionLocationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionPaged = {
  __typename?: 'InventoryCountTransactionPaged';
  items: Array<InventoryCountTransaction>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTransactionQopInput = {
  filters?: InputMaybe<InventoryCountTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionResultItem = {
  __typename?: 'InventoryCountTransactionResultItem';
  barcode: Scalars['String']['output'];
  baseUomQtyCounted: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  baseUomUnitCostCounted: Scalars['Float']['output'];
  baseUomUnitCostDiff: Scalars['Float']['output'];
  baseUomUnitCostSystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionResultItemID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  sequence: Scalars['Int']['output'];
  totalCost: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  virtualWarehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTransactionResultItemDetail = {
  __typename?: 'InventoryCountTransactionResultItemDetail';
  barcode: Scalars['String']['output'];
  baseUomQtyCounted: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionLocationDetailID: Scalars['UUID']['output'];
  inventoryCountTransactionResultItemDetailID: Scalars['UUID']['output'];
  inventoryCountTransactionResultItemID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  virtualWarehouseLocationName: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTransactionResultItemDetailPaged = {
  __typename?: 'InventoryCountTransactionResultItemDetailPaged';
  items: Array<InventoryCountTransactionResultItemDetail>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionResultItemDetailQopFilterInput = {
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationDetailID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionResultItemDetailID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionResultItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTransactionResultItemDetailQopInput = {
  filters?: InputMaybe<InventoryCountTransactionResultItemDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionResultItemPaged = {
  __typename?: 'InventoryCountTransactionResultItemPaged';
  items: Array<InventoryCountTransactionResultItem>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionResultItemQopFilterInput = {
  difference?: InputMaybe<Scalars['Float']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionResultItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  qtyDiffEqual?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMax?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMin?: InputMaybe<Scalars['Float']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  totalCostMax?: InputMaybe<Scalars['Float']['input']>;
  totalCostMin?: InputMaybe<Scalars['Float']['input']>;
  unitCostDifference?: InputMaybe<Scalars['Float']['input']>;
};

export type InventoryCountTransactionResultItemQopInput = {
  filters?: InputMaybe<InventoryCountTransactionResultItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionUpdateInput = {
  assignedToUserIDs: Array<Scalars['UUID']['input']>;
  excludeProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  inventoryCountTransactionDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionID: Scalars['UUID']['input'];
  inventoryCountTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  locationScopeType: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  partialProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  taskType: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryDailyMovement = {
  __typename?: 'InventoryDailyMovement';
  branchID: Scalars['UUID']['output'];
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  dcUsageQty: Scalars['Decimal']['output'];
  endingQty: Scalars['Decimal']['output'];
  endingQtyOnHand: Scalars['Decimal']['output'];
  endingQtyRejected: Scalars['Decimal']['output'];
  endingTotalCost: Scalars['Decimal']['output'];
  endingUnitCost: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  hasStartingStockOrStockIn: Scalars['Boolean']['output'];
  inventoryDailyMovementDate: Scalars['Time']['output'];
  inventoryDailyMovementID: Scalars['UUID']['output'];
  isConsignment: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qtyIn: Scalars['Decimal']['output'];
  qtyOut: Scalars['Decimal']['output'];
  qtyRejected: Scalars['Decimal']['output'];
  startingQty: Scalars['Decimal']['output'];
  startingQtyOnHand: Scalars['Decimal']['output'];
  startingQtyRejected: Scalars['Decimal']['output'];
  startingTotalCost: Scalars['Decimal']['output'];
  startingUnitCost: Scalars['Decimal']['output'];
  storeUsageQty: Scalars['Decimal']['output'];
  totalCostIn: Scalars['Decimal']['output'];
  totalCostOut: Scalars['Decimal']['output'];
  uniqueKey: Scalars['String']['output'];
  unitCostIn: Scalars['Decimal']['output'];
  unitCostOut: Scalars['Decimal']['output'];
  vendor?: Maybe<Vendor>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryDailyMovementPaged = {
  __typename?: 'InventoryDailyMovementPaged';
  items?: Maybe<Array<InventoryDailyMovement>>;
  pagination: PaginationResult;
};

export type InventoryDailyMovementQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  hasStartingStockOrStockIn?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryDailyMovementDate?: InputMaybe<Scalars['Time']['input']>;
  inventoryDailyMovementDateGte?: InputMaybe<Scalars['Time']['input']>;
  inventoryDailyMovementDateLte?: InputMaybe<Scalars['Time']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryDailyMovementQopInput = {
  filters?: InputMaybe<InventoryDailyMovementQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryLocation = {
  __typename?: 'InventoryLocation';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryLocationID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation?: Maybe<WarehouseLocation>;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryLocationPaged = {
  __typename?: 'InventoryLocationPaged';
  items?: Maybe<Array<InventoryLocation>>;
  pagination: PaginationResult;
};

export type InventoryLocationQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryLocationQopInput = {
  filters?: InputMaybe<InventoryLocationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryMovementSummary = {
  __typename?: 'InventoryMovementSummary';
  endingDate: Scalars['Time']['output'];
  endingQty: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qtyIn: Scalars['Decimal']['output'];
  qtyOut: Scalars['Decimal']['output'];
  startingDate: Scalars['Time']['output'];
  startingQty: Scalars['Decimal']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryMovementSummaryFilterInput = {
  dateEnd: Scalars['Time']['input'];
  dateStart: Scalars['Time']['input'];
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryMovementSummaryPaged = {
  __typename?: 'InventoryMovementSummaryPaged';
  items?: Maybe<Array<InventoryMovementSummary>>;
  pagination: PaginationResult;
};

export type InventoryMovementSummaryQopInput = {
  filters: InventoryMovementSummaryFilterInput;
  pagination?: InputMaybe<Pagination>;
};

export type InventoryPosition = {
  __typename?: 'InventoryPosition';
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  inventoryPositionID: Scalars['UUID']['output'];
  lotNumber: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  searchKey: Scalars['String']['output'];
  sortIndex: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryPositionPaged = {
  __typename?: 'InventoryPositionPaged';
  items?: Maybe<Array<InventoryPosition>>;
  pagination: PaginationResult;
};

export type InventoryPositionQopFilterInput = {
  expiryDateFrom?: InputMaybe<Scalars['Time']['input']>;
  expiryDateTo?: InputMaybe<Scalars['Time']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryPositionQopInput = {
  filters?: InputMaybe<InventoryPositionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryPositionSnapshot = {
  __typename?: 'InventoryPositionSnapshot';
  balanceLastUnitCost: Scalars['Decimal']['output'];
  balanceQty: Scalars['Decimal']['output'];
  balanceSortIndex: Scalars['Int']['output'];
  balanceTotalCost: Scalars['Decimal']['output'];
  balanceUnitCost: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  inventoryPositionID: Scalars['UUID']['output'];
  lotNumber: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  sortIndex: Scalars['Int']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryPositionSnapshotQopInput = {
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventorySummary = {
  __typename?: 'InventorySummary';
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  inventorySummaryID: Scalars['UUID']['output'];
  isConsignment: Scalars['Boolean']['output'];
  lastAvgCost: Scalars['Decimal']['output'];
  lastUnitCost: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  qtyAvailable: Scalars['Decimal']['output'];
  qtyCommitted: Scalars['Decimal']['output'];
  qtyOnHand: Scalars['Decimal']['output'];
  qtyRejected: Scalars['Decimal']['output'];
  totalCost: Scalars['Decimal']['output'];
  unitCost: Scalars['Decimal']['output'];
  vendor?: Maybe<Vendor>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventorySummaryPaged = {
  __typename?: 'InventorySummaryPaged';
  items?: Maybe<Array<InventorySummary>>;
  pagination: PaginationResult;
};

export type InventorySummaryQopFilterInput = {
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  qtyGt?: InputMaybe<Scalars['Float']['input']>;
  qtyLt?: InputMaybe<Scalars['Float']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventorySummaryQopInput = {
  filters?: InputMaybe<InventorySummaryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryTransaction = {
  __typename?: 'InventoryTransaction';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  counterpartWarehouse?: Maybe<Warehouse>;
  counterpartWarehouseID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  inventoryTransactionID: Scalars['UUID']['output'];
  inventoryTransactionKey: Scalars['String']['output'];
  inventoryTransactionNumber: Scalars['String']['output'];
  inventoryTransactionTransactionDate: Scalars['Time']['output'];
  inventoryTransactionTransactionDateUtc: Scalars['Time']['output'];
  itemCount: Scalars['Int']['output'];
  itemTotalCost: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryTransactionItemQopFilterInput = {
  costCalcType?: InputMaybe<Scalars['String']['input']>;
  inventoryTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryTransactionItemQopInput = {
  filters?: InputMaybe<InventoryTransactionItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryTransactionLine = {
  __typename?: 'InventoryTransactionLine';
  actualTotalCost: Scalars['Decimal']['output'];
  actualUnitCost: Scalars['Decimal']['output'];
  counterpartWarehouse?: Maybe<Warehouse>;
  counterpartWarehouseID?: Maybe<Scalars['UUID']['output']>;
  counterpartWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  direction: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryTransactionID: Scalars['UUID']['output'];
  inventoryTransactionLineID: Scalars['UUID']['output'];
  inventoryTransactionLineType: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  postedTotalCost: Scalars['Decimal']['output'];
  postedUnitCost: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  sourceDocumentDetailID2: Scalars['UUID']['output'];
  varianceCost: Scalars['Decimal']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryTransactionLineItem = {
  __typename?: 'InventoryTransactionLineItem';
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  direction: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryTransactionID: Scalars['UUID']['output'];
  inventoryTransactionLineID: Scalars['UUID']['output'];
  inventoryTransactionLineItemID: Scalars['UUID']['output'];
  isConsignment: Scalars['Boolean']['output'];
  isDCUsage: Scalars['Boolean']['output'];
  isStoreUsage: Scalars['Boolean']['output'];
  qty: Scalars['Decimal']['output'];
  totalCost: Scalars['Decimal']['output'];
  unitCost: Scalars['Decimal']['output'];
  varianceCost: Scalars['Decimal']['output'];
};

export type InventoryTransactionLineItemPaged = {
  __typename?: 'InventoryTransactionLineItemPaged';
  items?: Maybe<Array<InventoryTransactionLineItem>>;
  pagination: PaginationResult;
};

export type InventoryTransactionLinePaged = {
  __typename?: 'InventoryTransactionLinePaged';
  items?: Maybe<Array<InventoryTransactionLine>>;
  pagination: PaginationResult;
};

export type InventoryTransactionLineQopFilterInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  inventoryTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryTransactionLineType?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryTransactionLineQopInput = {
  filters?: InputMaybe<InventoryTransactionLineQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryTransactionLineUnit = {
  __typename?: 'InventoryTransactionLineUnit';
  actualTotalCost: Scalars['Decimal']['output'];
  actualUnitCost: Scalars['Decimal']['output'];
  balanceUpdate: Scalars['Boolean']['output'];
  direction: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate?: Maybe<Scalars['Time']['output']>;
  inventoryTransaction: InventoryTransaction;
  inventoryTransactionID: Scalars['UUID']['output'];
  inventoryTransactionLineID: Scalars['UUID']['output'];
  inventoryTransactionLineItemID: Scalars['UUID']['output'];
  inventoryTransactionLineUnitID: Scalars['UUID']['output'];
  lotNumber: Scalars['String']['output'];
  postedTotalCost: Scalars['Decimal']['output'];
  postedUnitCost: Scalars['Decimal']['output'];
  prevLocationQtyBalance: Scalars['Decimal']['output'];
  prevQtyBalance: Scalars['Decimal']['output'];
  prevWarehouseQtyBalance: Scalars['Decimal']['output'];
  prevWarehouseTotalCostBalance: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  sortIndex: Scalars['Int']['output'];
  varianceCost: Scalars['Decimal']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryTransactionLineUnitPaged = {
  __typename?: 'InventoryTransactionLineUnitPaged';
  items?: Maybe<Array<InventoryTransactionLineUnit>>;
  pagination: PaginationResult;
};

export type InventoryTransactionLineUnitQopFilterInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  expiryDateFrom?: InputMaybe<Scalars['Time']['input']>;
  expiryDateTo?: InputMaybe<Scalars['Time']['input']>;
  inventoryTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryTransactionLineID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryTransactionLineItemID?: InputMaybe<Scalars['UUID']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryTransactionLineUnitQopInput = {
  filters?: InputMaybe<InventoryTransactionLineUnitQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryTransactionPaged = {
  __typename?: 'InventoryTransactionPaged';
  items?: Maybe<Array<InventoryTransaction>>;
  pagination: PaginationResult;
};

export type InventoryTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  transactionDateFrom?: InputMaybe<Scalars['Time']['input']>;
  transactionDateTo?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryTransactionQopInput = {
  filters?: InputMaybe<InventoryTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type LocationValidationResult = {
  __typename?: 'LocationValidationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  warehouseLocationCode?: Maybe<Scalars['String']['output']>;
  warehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
};

export type LoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MarkConsignmentInvoicesPaidBulkInput = {
  paidReference?: InputMaybe<Scalars['String']['input']>;
  settlementBankAccountID: Scalars['UUID']['input'];
  vendorConsignmentInvoiceIDs: Array<Scalars['UUID']['input']>;
};

export type MarketplaceBackgroundJob = {
  __typename?: 'MarketplaceBackgroundJob';
  createdAtUtc: Scalars['Time']['output'];
  finishedAtUtc?: Maybe<Scalars['Time']['output']>;
  jobCategory: Scalars['String']['output'];
  jobMessage: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  marketplaceBackgroundJobID: Scalars['UUID']['output'];
  processedCount: Scalars['Int']['output'];
  retryCount: Scalars['Int']['output'];
  startedAtUtc?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
  updatedAtUtc: Scalars['Time']['output'];
};

export type MarketplaceBackgroundJobPaged = {
  __typename?: 'MarketplaceBackgroundJobPaged';
  items?: Maybe<Array<MarketplaceBackgroundJob>>;
  pagination: PaginationResult;
};

export type MarketplaceBackgroundJobQopFilterInput = {
  jobCategory?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceBackgroundJobQopInput = {
  filters?: InputMaybe<MarketplaceBackgroundJobQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceCampaign = {
  __typename?: 'MarketplaceCampaign';
  branchCode: Scalars['String']['output'];
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName: Scalars['String']['output'];
  createdAtUtc: Scalars['Time']['output'];
  customTag: Scalars['String']['output'];
  discountCap?: Maybe<Scalars['Float']['output']>;
  discountType: Scalars['String']['output'];
  discountValue?: Maybe<Scalars['Float']['output']>;
  eaterType: Scalars['String']['output'];
  endAtUtc: Scalars['Time']['output'];
  errorMessage: Scalars['String']['output'];
  externalCampaignID: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  marketplaceCampaignID: Scalars['UUID']['output'];
  minBasketAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  objectIDs: Array<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  quotaPerUser?: Maybe<Scalars['Int']['output']>;
  quotaTotal?: Maybe<Scalars['Int']['output']>;
  salesChannelID: Scalars['String']['output'];
  scopeType: Scalars['String']['output'];
  startAtUtc: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc: Scalars['Time']['output'];
};

export type MarketplaceCampaignCreateInput = {
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountType: Scalars['String']['input'];
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAtUtc: Scalars['Time']['input'];
  externalMerchantID: Scalars['String']['input'];
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  objectIDs: Array<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  quotaPerUser?: InputMaybe<Scalars['Int']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int']['input']>;
  salesChannelID: Scalars['String']['input'];
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startAtUtc: Scalars['Time']['input'];
};

export type MarketplaceCampaignExtendInput = {
  endAtUtc: Scalars['Time']['input'];
  marketplaceCampaignID: Scalars['UUID']['input'];
  startAtUtc?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceCampaignImportProductsInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: MarketplaceItemMapImportFileMappingInput;
  marketplaceCampaignID: Scalars['UUID']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceCampaignImportResult = {
  __typename?: 'MarketplaceCampaignImportResult';
  importedCount: Scalars['Int']['output'];
  missingBarcodes: Array<Scalars['String']['output']>;
  totalRows: Scalars['Int']['output'];
};

export type MarketplaceCampaignPaged = {
  __typename?: 'MarketplaceCampaignPaged';
  items?: Maybe<Array<MarketplaceCampaign>>;
  pagination: PaginationResult;
};

export type MarketplaceCampaignProduct = {
  __typename?: 'MarketplaceCampaignProduct';
  barcode?: Maybe<Scalars['String']['output']>;
  externalItemID?: Maybe<Scalars['String']['output']>;
  marketplaceCampaignProductID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode?: Maybe<Scalars['String']['output']>;
  productID?: Maybe<Scalars['UUID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceCampaignProductPaged = {
  __typename?: 'MarketplaceCampaignProductPaged';
  items?: Maybe<Array<MarketplaceCampaignProduct>>;
  pagination: PaginationResult;
};

export type MarketplaceCampaignProductQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  marketplaceCampaignID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceCampaignProductQopInput = {
  filters?: InputMaybe<MarketplaceCampaignProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceCampaignPublishFromPromoInput = {
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAtUtc: Scalars['Time']['input'];
  externalMerchantID: Scalars['String']['input'];
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  promoComponentID: Scalars['UUID']['input'];
  promoID: Scalars['UUID']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  quotaPerUser?: InputMaybe<Scalars['Int']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int']['input']>;
  salesChannelID: Scalars['String']['input'];
  startAtUtc: Scalars['Time']['input'];
};

export type MarketplaceCampaignQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAtUtc?: InputMaybe<Scalars['Time']['input']>;
  endAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  endAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  externalCampaignID?: InputMaybe<Scalars['String']['input']>;
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  marketplaceCampaignIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startAtUtc?: InputMaybe<Scalars['Time']['input']>;
  startAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  startAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceCampaignQopInput = {
  filters?: InputMaybe<MarketplaceCampaignQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceCampaignSyncInput = {
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceCampaignSyncResult = {
  __typename?: 'MarketplaceCampaignSyncResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MarketplaceCampaignUpdateInput = {
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountType: Scalars['String']['input'];
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAtUtc: Scalars['Time']['input'];
  marketplaceCampaignID: Scalars['UUID']['input'];
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  objectIDs: Array<Scalars['String']['input']>;
  quotaPerUser?: InputMaybe<Scalars['Int']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startAtUtc: Scalars['Time']['input'];
};

export type MarketplaceChannelApiLog = {
  __typename?: 'MarketplaceChannelAPILog';
  createdAt: Scalars['Time']['output'];
  direction: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  errorMessage: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  httpMethod: Scalars['String']['output'];
  marketplaceChannelAPILogID: Scalars['UUID']['output'];
  operation: Scalars['String']['output'];
  requestBody: Scalars['String']['output'];
  responseBody: Scalars['String']['output'];
  responseStatus: Scalars['Int']['output'];
  salesChannelID: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MarketplaceChannelApiLogPaged = {
  __typename?: 'MarketplaceChannelAPILogPaged';
  items?: Maybe<Array<MarketplaceChannelApiLog>>;
  pagination: PaginationResult;
};

export type MarketplaceChannelApiLogQopFilterInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  httpMethod?: InputMaybe<Scalars['String']['input']>;
  marketplaceChannelAPILogIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operation?: InputMaybe<Scalars['String']['input']>;
  responseStatus?: InputMaybe<Scalars['Int']['input']>;
  responseStatusEnd?: InputMaybe<Scalars['Int']['input']>;
  responseStatusStart?: InputMaybe<Scalars['Int']['input']>;
  responseStatuses?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesChannelIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MarketplaceChannelApiLogQopInput = {
  filters?: InputMaybe<MarketplaceChannelApiLogQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceChannelSyncHealth = {
  __typename?: 'MarketplaceChannelSyncHealth';
  grabPulledAtUtc?: Maybe<Scalars['Time']['output']>;
  menuPushError: Scalars['String']['output'];
  menuPushStatus: Scalars['Int']['output'];
  menuPushedAtUtc?: Maybe<Scalars['Time']['output']>;
  priceSyncedAtUtc?: Maybe<Scalars['Time']['output']>;
  recentFailureCount: Scalars['Int']['output'];
  salesChannelID: Scalars['String']['output'];
};

export type MarketplaceCronRunResult = {
  __typename?: 'MarketplaceCronRunResult';
  jobKey: Scalars['String']['output'];
  message: Scalars['String']['output'];
  ranAt: Scalars['Time']['output'];
  status: Scalars['String']['output'];
};

export type MarketplaceCronSetting = {
  __typename?: 'MarketplaceCronSetting';
  description: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  jobKey: Scalars['String']['output'];
  jobName: Scalars['String']['output'];
  lastRunAt?: Maybe<Scalars['Time']['output']>;
  lastRunMessage: Scalars['String']['output'];
  lastRunStatus?: Maybe<Scalars['String']['output']>;
  spec: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type MarketplaceCronSettingPaged = {
  __typename?: 'MarketplaceCronSettingPaged';
  items?: Maybe<Array<MarketplaceCronSetting>>;
  pagination: PaginationResult;
};

export type MarketplaceCronSettingQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceCronSettingQopInput = {
  filters?: InputMaybe<MarketplaceCronSettingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceCronSettingUpdateInput = {
  isEnabled: Scalars['Boolean']['input'];
  jobKey: Scalars['String']['input'];
};

export type MarketplaceInboundOrder = {
  __typename?: 'MarketplaceInboundOrder';
  acceptedAtUtc?: Maybe<Scalars['Time']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['String']['output'];
  branchName: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  eventKey: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  externalOrderID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  lastProcessAttemptAtUtc?: Maybe<Scalars['Time']['output']>;
  marketplaceInboundOrderID: Scalars['UUID']['output'];
  payload: Scalars['String']['output'];
  posInvoiceNumber: Scalars['String']['output'];
  processedAtUtc?: Maybe<Scalars['Time']['output']>;
  readyMarkedAtUtc?: Maybe<Scalars['Time']['output']>;
  receivedAtUtc: Scalars['Time']['output'];
  retryCount: Scalars['Int']['output'];
  salesChannelID: Scalars['String']['output'];
  settledAtUtc?: Maybe<Scalars['Time']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MarketplaceInboundOrderPaged = {
  __typename?: 'MarketplaceInboundOrderPaged';
  items?: Maybe<Array<MarketplaceInboundOrder>>;
  pagination: PaginationResult;
};

export type MarketplaceInboundOrderQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  externalOrderID?: InputMaybe<Scalars['String']['input']>;
  marketplaceInboundOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  receivedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  settledAtUtc?: InputMaybe<Scalars['Time']['input']>;
  settledAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  settledAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceInboundOrderQopInput = {
  filters?: InputMaybe<MarketplaceInboundOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceItemMapImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceItemMapImportFileMappingInput = {
  columns: Array<MarketplaceItemMapImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  rowFilters?: InputMaybe<Array<MarketplaceItemMapImportRowFilterInput>>;
};

export type MarketplaceItemMapImportRowFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
};

export type MarketplaceMenuSyncInput = {
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID: Scalars['String']['input'];
};

export type MarketplaceMenuSyncResult = {
  __typename?: 'MarketplaceMenuSyncResult';
  categoryCount?: Maybe<Scalars['Int']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  menuGroupName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  syncedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type MarketplaceMenuSyncStatus = {
  __typename?: 'MarketplaceMenuSyncStatus';
  code: Scalars['String']['output'];
  createdAtUtc: Scalars['Time']['output'];
  errors: Array<Scalars['String']['output']>;
  externalMerchantID: Scalars['String']['output'];
  failedSectionCount: Scalars['Int']['output'];
  salesChannelID: Scalars['String']['output'];
  updatedAtUtc: Scalars['Time']['output'];
};

export type MarketplaceOrder = {
  __typename?: 'MarketplaceOrder';
  acceptedAtUtc?: Maybe<Scalars['Time']['output']>;
  branchCode: Scalars['String']['output'];
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  customerPaymentAmount: Scalars['Float']['output'];
  deliveryFeeAmount: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  externalMerchantID: Scalars['String']['output'];
  externalOrderID: Scalars['String']['output'];
  externalOrderStatus: Scalars['String']['output'];
  externalStoreID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isEdited: Scalars['Boolean']['output'];
  items: Array<MarketplaceOrderItem>;
  marketplaceOrderID: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  noteInternal: Scalars['String']['output'];
  orderDatetimeUtc: Scalars['Time']['output'];
  paymentReconciledAtUtc?: Maybe<Scalars['Time']['output']>;
  paymentType: Scalars['String']['output'];
  posInvoiceNumber: Scalars['String']['output'];
  pricingIssues: Array<MarketplaceOrderPricingIssue>;
  pricingStatus: Scalars['String']['output'];
  promos: Array<MarketplaceOrderPromo>;
  readyMarkedAtUtc?: Maybe<Scalars['Time']['output']>;
  receiptMetadata?: Maybe<MarketplaceOrderReceiptMetadata>;
  receivedAtUtc: Scalars['Time']['output'];
  salesChannelAdditionalCharge: Scalars['Float']['output'];
  salesChannelID: Scalars['String']['output'];
  settledAtUtc?: Maybe<Scalars['Time']['output']>;
  shortOrderNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotalAmount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAtUtc: Scalars['Time']['output'];
  version: Scalars['UUID']['output'];
};

export type MarketplaceOrderCancelInput = {
  cancelCode: Scalars['Int']['input'];
  marketplaceOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type MarketplaceOrderCancelReason = {
  __typename?: 'MarketplaceOrderCancelReason';
  code: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export type MarketplaceOrderCancelableResult = {
  __typename?: 'MarketplaceOrderCancelableResult';
  cancelReasons: Array<MarketplaceOrderCancelReason>;
  cancelable: Scalars['Boolean']['output'];
  limitTimes?: Maybe<Scalars['Int']['output']>;
  limitType?: Maybe<Scalars['String']['output']>;
  nonCancellationReason?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceOrderDriverMetadata = {
  __typename?: 'MarketplaceOrderDriverMetadata';
  etaSeconds?: Maybe<Scalars['Int']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceOrderEditInput = {
  items: Array<MarketplaceOrderEditItemInput>;
  marketplaceOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type MarketplaceOrderEditItemInput = {
  isExternalItemID?: InputMaybe<Scalars['Boolean']['input']>;
  itemID: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceOrderExportFile = {
  __typename?: 'MarketplaceOrderExportFile';
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type MarketplaceOrderItem = {
  __typename?: 'MarketplaceOrderItem';
  addonComponents: Array<MarketplaceOrderItemAddon>;
  barcode: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  externalItemID: Scalars['String']['output'];
  externalItemName: Scalars['String']['output'];
  freeQty: Scalars['Float']['output'];
  item?: Maybe<MarketplaceOrderItemListing>;
  lineIndex: Scalars['Int']['output'];
  marketplaceOrderID: Scalars['UUID']['output'];
  marketplaceOrderItemID: Scalars['UUID']['output'];
  netAmount: Scalars['Float']['output'];
  note: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  promoNames: Array<Scalars['String']['output']>;
  qty: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type MarketplaceOrderItemAddon = {
  __typename?: 'MarketplaceOrderItemAddon';
  productCode: Scalars['String']['output'];
  productID: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type MarketplaceOrderItemListing = {
  __typename?: 'MarketplaceOrderItemListing';
  externalCategoryName: Scalars['String']['output'];
  externalItemID: Scalars['String']['output'];
  externalItemName: Scalars['String']['output'];
  externalVariantName: Scalars['String']['output'];
  imageURL?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  salesChannelCategoryName: Scalars['String']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
};

export type MarketplaceOrderItemPaged = {
  __typename?: 'MarketplaceOrderItemPaged';
  items?: Maybe<Array<MarketplaceOrderItem>>;
  pagination: PaginationResult;
};

export type MarketplaceOrderItemQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalItemID?: InputMaybe<Scalars['String']['input']>;
  externalItemName?: InputMaybe<Scalars['String']['input']>;
  lineIndex?: InputMaybe<Scalars['Int']['input']>;
  marketplaceOrderID?: InputMaybe<Scalars['UUID']['input']>;
  marketplaceOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketplaceOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  marketplaceOrderItemIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['String']['input']>;
  productIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceOrderItemQopInput = {
  filters?: InputMaybe<MarketplaceOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceOrderMarkReadyInput = {
  marketplaceOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type MarketplaceOrderPaged = {
  __typename?: 'MarketplaceOrderPaged';
  items?: Maybe<Array<MarketplaceOrder>>;
  pagination: PaginationResult;
};

export type MarketplaceOrderPricingIssue = {
  __typename?: 'MarketplaceOrderPricingIssue';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type MarketplaceOrderPromo = {
  __typename?: 'MarketplaceOrderPromo';
  code: Scalars['String']['output'];
  freeItemProductCode: Scalars['String']['output'];
  freeItemQty: Scalars['Float']['output'];
  fullAmount: Scalars['Float']['output'];
  kind: Scalars['String']['output'];
  level: Scalars['String']['output'];
  merchantAmount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type MarketplaceOrderPromoMetadata = {
  __typename?: 'MarketplaceOrderPromoMetadata';
  amount: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MarketplaceOrderQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  externalOrderID?: InputMaybe<Scalars['String']['input']>;
  externalOrderStatus?: InputMaybe<Scalars['String']['input']>;
  isEdited?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  orderDatetimeUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  orderDatetimeUtcStart?: InputMaybe<Scalars['Time']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  posInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  receivedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  settledAtUtc?: InputMaybe<Scalars['Time']['input']>;
  settledAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  settledAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  shortOrderNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceOrderQopInput = {
  filters?: InputMaybe<MarketplaceOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceOrderReceiptMetadata = {
  __typename?: 'MarketplaceOrderReceiptMetadata';
  cutleryRequired?: Maybe<Scalars['Boolean']['output']>;
  driver?: Maybe<MarketplaceOrderDriverMetadata>;
  estimatedPickupTime?: Maybe<Scalars['Time']['output']>;
  orderNotes?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  promoName?: Maybe<Scalars['String']['output']>;
  promos?: Maybe<Array<MarketplaceOrderPromoMetadata>>;
  virtualContact?: Maybe<MarketplaceOrderVirtualContact>;
};

export type MarketplaceOrderReconcilePaymentInput = {
  marketplaceOrderID: Scalars['UUID']['input'];
};

export type MarketplaceOrderSyncPosInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  externalOrderID?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<MarketplaceOrderEditItemInput>>;
  marketplaceOrderID?: InputMaybe<Scalars['UUID']['input']>;
  orderState?: InputMaybe<Scalars['String']['input']>;
  posInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  posOrderID?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceOrderSyncPosResult = {
  __typename?: 'MarketplaceOrderSyncPOSResult';
  externalOrderID: Scalars['String']['output'];
  paybillQRCode?: Maybe<Scalars['String']['output']>;
  posInvoiceNumber?: Maybe<Scalars['String']['output']>;
  posOrderID?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MarketplaceOrderVirtualContact = {
  __typename?: 'MarketplaceOrderVirtualContact';
  phone?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
};

export type MarketplacePromoForPublish = {
  __typename?: 'MarketplacePromoForPublish';
  components: Array<MarketplacePromoForPublishComponent>;
  name: Scalars['String']['output'];
  promoID: Scalars['String']['output'];
};

export type MarketplacePromoForPublishComponent = {
  __typename?: 'MarketplacePromoForPublishComponent';
  discountType: Scalars['String']['output'];
  discountValue: Scalars['Float']['output'];
  productCount: Scalars['Int']['output'];
  promoComponentID: Scalars['String']['output'];
  promoTypeName: Scalars['String']['output'];
  promoTypeUniqueKey: Scalars['String']['output'];
  publishable: Scalars['Boolean']['output'];
  scopeType: Scalars['String']['output'];
};

export type MarketplaceProviderCampaign = {
  __typename?: 'MarketplaceProviderCampaign';
  createdBy: Scalars['String']['output'];
  customTag: Scalars['String']['output'];
  discountCap?: Maybe<Scalars['Float']['output']>;
  discountType: Scalars['String']['output'];
  discountValue?: Maybe<Scalars['Float']['output']>;
  eaterType: Scalars['String']['output'];
  endAtUtc: Scalars['Time']['output'];
  id: Scalars['String']['output'];
  minBasketAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  objectIDs: Array<Scalars['String']['output']>;
  scopeType: Scalars['String']['output'];
  startAtUtc: Scalars['Time']['output'];
  state: Scalars['String']['output'];
};

export type MarketplaceProvisionablePromo = {
  __typename?: 'MarketplaceProvisionablePromo';
  endDate: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  promoID: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type MarketplaceStorePauseInput = {
  duration?: InputMaybe<Scalars['String']['input']>;
  externalMerchantID: Scalars['String']['input'];
  isPause: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type MarketplaceStoreStatus = {
  __typename?: 'MarketplaceStoreStatus';
  closeReason: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  isInSpecialOpeningHourRange: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  salesChannelID: Scalars['String']['output'];
};

export type MasterdataBackgroundJob = {
  __typename?: 'MasterdataBackgroundJob';
  backgroundJobID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  finishedDatetime?: Maybe<Scalars['Time']['output']>;
  finishedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  jobCategory: Scalars['String']['output'];
  jobDescription: Scalars['String']['output'];
  jobKey: Scalars['String']['output'];
  jobMessage: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  retryCount: Scalars['Int']['output'];
  startedDatetime?: Maybe<Scalars['Time']['output']>;
  startedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum MasterdataSyncEntityType {
  Branch = 'BRANCH',
  Product = 'PRODUCT',
  ProductCategory = 'PRODUCT_CATEGORY',
  ReasonInventoryAdjustment = 'REASON_INVENTORY_ADJUSTMENT',
  Tax = 'TAX',
  Uom = 'UOM',
  UomCategory = 'UOM_CATEGORY',
  Vendor = 'VENDOR',
  Warehouse = 'WAREHOUSE'
}

export type MemberType = {
  __typename?: 'MemberType';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  memberTypeID: Scalars['UUID']['output'];
  memberTypeName: Scalars['String']['output'];
  spendPerPoint: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type MemberTypeCreateInput = {
  isActive: Scalars['Boolean']['input'];
  memberTypeName: Scalars['String']['input'];
  spendPerPoint: Scalars['Int']['input'];
};

export type MemberTypePaged = {
  __typename?: 'MemberTypePaged';
  items?: Maybe<Array<MemberType>>;
  pagination: PaginationResult;
};

export type MemberTypeQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  memberTypeName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MemberTypeQopInput = {
  filters?: InputMaybe<MemberTypeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MemberTypeUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  memberTypeID: Scalars['UUID']['input'];
  memberTypeName: Scalars['String']['input'];
  spendPerPoint: Scalars['Int']['input'];
};

export type MobilePickingTask = {
  __typename?: 'MobilePickingTask';
  branchID: Scalars['UUID']['output'];
  items: Array<MobilePickingTaskItem>;
  pickingTaskDatetime: Scalars['Time']['output'];
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskNumber: Scalars['String']['output'];
  progressPercent: Scalars['Float']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyAssigned: Scalars['Float']['output'];
  totalQtyExecuted: Scalars['Float']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type MobilePickingTaskItem = {
  __typename?: 'MobilePickingTaskItem';
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskItemID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyAssigned: Scalars['Float']['output'];
  qtyExecuted: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  unfulfilledReason?: Maybe<Scalars['String']['output']>;
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type MobilePutawayTask = {
  __typename?: 'MobilePutawayTask';
  branchID: Scalars['UUID']['output'];
  fromWarehouseLocationCode: Scalars['String']['output'];
  fromWarehouseLocationID: Scalars['UUID']['output'];
  fromWarehouseLocationName: Scalars['String']['output'];
  items: Array<MobilePutawayTaskItem>;
  progressPercent: Scalars['Float']['output'];
  putawayTaskDatetime: Scalars['Time']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskNumber: Scalars['String']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyAssigned: Scalars['Float']['output'];
  totalQtyExecuted: Scalars['Float']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type MobilePutawayTaskItem = {
  __typename?: 'MobilePutawayTaskItem';
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskItemID: Scalars['UUID']['output'];
  qtyAssigned: Scalars['Float']['output'];
  qtyExecuted: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  suggestionWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  suggestionWarehouseLocationName?: Maybe<Scalars['String']['output']>;
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type MoveConsignmentItemsInput = {
  salesConsignmentInvoiceIDs: Array<Scalars['UUID']['input']>;
  targetVendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  SalesChannelCreate: SalesChannel;
  SalesChannelDelete: Scalars['Boolean']['output'];
  SalesChannelUpdate: SalesChannel;
  adminResetPassword: AdminResetPasswordResponse;
  aiChatCreateSession: AiChatSession;
  aiChatDeleteSession: Scalars['Boolean']['output'];
  aiChatRenameSession: AiChatSession;
  aiChatSendMessage: AiChatSendMessageResponse;
  aiDeleteAppClient: Scalars['Boolean']['output'];
  aiRegenerateAppClientKey: Scalars['String']['output'];
  aiUpdateGuardrailsConfig: AiGuardrailsConfig;
  aiUpdateScopeTable: AiScopeTable;
  aiUpdateScopeTool: AiScopeTool;
  aiUpsertAppClient: AiAppClient;
  appCreate: App;
  appDelete: Scalars['Boolean']['output'];
  appUpdate: App;
  authLogin: AuthResponse;
  authLoginVendor: AuthResponse;
  authRefreshToken: AuthResponse;
  authSetDefaultBranch: AuthResponse;
  backgroundJobCreate: BackgroundJob;
  backgroundJobDelete: Scalars['Boolean']['output'];
  backgroundJobUpdate: BackgroundJob;
  bankAccountCreate: BankAccount;
  bankAccountDelete: Scalars['Boolean']['output'];
  bankAccountUpdate: BankAccount;
  bankCreate: Bank;
  bankDelete: Scalars['Boolean']['output'];
  bankReconciliationCancel: BankReconciliation;
  bankReconciliationCreate: BankReconciliation;
  bankReconciliationExport: BankReconciliationExport;
  bankReconciliationFinalize: BankReconciliation;
  bankReconciliationImportValidate: BankReconciliationImportValidateResult;
  bankReconciliationItemManualMatch: BankReconciliation;
  bankReconciliationItemMerge: BankReconciliation;
  bankReconciliationItemResolve: BankReconciliation;
  bankReconciliationItemsBulkResolve: BankReconciliation;
  bankReconciliationItemsBulkResolveByFilter: BankReconciliation;
  bankReconciliationProcess: BankReconciliation;
  bankReconciliationRemoveFile?: Maybe<BankReconciliation>;
  bankReconciliationRetryPoolFile: BankReconciliationFile;
  bankReconciliationUploadFile: BankReconciliation;
  bankReconciliationUploadPoolFile: BankReconciliationFile;
  bankUpdate: Bank;
  biKnowledgeCreate: BiKnowledge;
  biKnowledgeDelete: Scalars['Boolean']['output'];
  biKnowledgeUpdate: BiKnowledge;
  biRoleCreate: BiRole;
  biRoleDelete: Scalars['Boolean']['output'];
  biRoleUpdate: BiRole;
  biScopeTableBulkUpdate: BiScopeTableBulkUpdateResult;
  biScopeTableCreate: BiScopeTable;
  biScopeTableDelete: Scalars['Boolean']['output'];
  biScopeTableUpdate: BiScopeTable;
  biUserCreate: BiUser;
  biUserDelete: Scalars['Boolean']['output'];
  biUserUpdate: BiUser;
  billOfMaterialComponentCreate: BillOfMaterialComponent;
  billOfMaterialComponentDelete: Scalars['Boolean']['output'];
  billOfMaterialComponentUpdate: BillOfMaterialComponent;
  billOfMaterialCreate: BillOfMaterial;
  billOfMaterialDelete: Scalars['Boolean']['output'];
  billOfMaterialUpdate: BillOfMaterial;
  branchBankAccountCreate: BranchBankAccount;
  branchBankAccountDelete: Scalars['Boolean']['output'];
  branchBankAccountUpdate: BranchBankAccount;
  branchCategoryCreate: BranchCategory;
  branchCategoryDelete: Scalars['Boolean']['output'];
  branchCategoryUpdate: BranchCategory;
  branchCreate: Branch;
  branchDelete: Scalars['Boolean']['output'];
  branchPosBookmarkCreate: BranchPosBookmark;
  branchPosBookmarkDelete: Scalars['Boolean']['output'];
  branchPosBookmarkUpdate: BranchPosBookmark;
  branchProductSalesChannelItemDisable: BranchProductSalesChannelItem;
  branchProductSalesChannelItemRestore: Scalars['Boolean']['output'];
  branchQrisMerchantCreate: BranchQrisMerchant;
  branchQrisMerchantDelete: Scalars['Boolean']['output'];
  branchQrisMerchantUpdate: BranchQrisMerchant;
  branchSalesChannelCategoryGroupCreate: BranchSalesChannelCategoryGroup;
  branchSalesChannelCategoryGroupDelete: Scalars['Boolean']['output'];
  branchSalesChannelCategoryGroupUpdate: BranchSalesChannelCategoryGroup;
  branchSalesChannelMerchantMapCreate: BranchSalesChannelMerchantMap;
  branchSalesChannelMerchantMapDelete: Scalars['Boolean']['output'];
  branchSalesChannelMerchantMapUpdate: BranchSalesChannelMerchantMap;
  branchSalesChannelOperatingHoursUpdate: BranchSalesChannelMerchantMap;
  branchSalesChannelPackagingUpdate: BranchSalesChannelMerchantMap;
  branchSalesChannelPauseUpdate: BranchSalesChannelMerchantMap;
  branchSalesPaymentMethodCreate: BranchSalesPaymentMethod;
  branchSalesPaymentMethodDelete: Scalars['Boolean']['output'];
  branchSalesPaymentMethodUpdate: BranchSalesPaymentMethod;
  branchStoreSupervisorCreate: Array<BranchStoreSupervisorCreated>;
  branchStoreSupervisorDelete: Scalars['Boolean']['output'];
  branchStoreSupervisorSync: Array<BranchStoreSupervisor>;
  branchStoreSupervisorUpdate: BranchStoreSupervisor;
  branchUpdate: Branch;
  cancelConsignmentInvoice: VendorConsignmentInvoice;
  changePassword: Scalars['Boolean']['output'];
  cityCreate: City;
  cityDelete: Scalars['Boolean']['output'];
  cityUpdate: City;
  consignmentStockInCancel: Scalars['Boolean']['output'];
  consignmentStockInConfirm: ConsignmentStockIn;
  consignmentStockInCreate: ConsignmentStockIn;
  consignmentStockInRequestApprove: ConsignmentStockInRequest;
  consignmentStockInRequestCancel: Scalars['Boolean']['output'];
  consignmentStockInRequestCreate: ConsignmentStockInRequest;
  consignmentStockInRequestReject: ConsignmentStockInRequest;
  consignmentStockInRequestSubmit: ConsignmentStockInRequest;
  consignmentStockInRequestUpdate: ConsignmentStockInRequest;
  consignmentStockInUpdate: ConsignmentStockIn;
  consignmentStockOutCancel: Scalars['Boolean']['output'];
  consignmentStockOutConfirm: ConsignmentStockOut;
  consignmentStockOutCreate: ConsignmentStockOut;
  consignmentStockOutUpdate: ConsignmentStockOut;
  costAdjustmentImport: Scalars['UUID']['output'];
  costAdjustmentImportValidateCodes: CostAdjustmentImportValidateCodesResult;
  countryCreate: Country;
  countryDelete: Scalars['Boolean']['output'];
  countryUpdate: Country;
  createErpProduct: Scalars['Int']['output'];
  createManualConsignmentProforma: VendorConsignmentInvoice;
  customerAddressCreate: CustomerAddress;
  customerAddressDelete: Scalars['Boolean']['output'];
  customerAddressUpdate: CustomerAddress;
  customerCreate: Customer;
  customerCreateFromPOS: Customer;
  customerDelete: Scalars['Boolean']['output'];
  customerImport: Array<Customer>;
  customerSetDefault: Customer;
  customerUpdate: Customer;
  customerVoucherTransactionBackfill: CustomerVoucherTransactionBackfillResult;
  deliveryOrderBatchAddLeftoverContainers: DeliveryOrderBatch;
  deliveryOrderBatchCancel: Scalars['Boolean']['output'];
  deliveryOrderBatchCreate: DeliveryOrderBatch;
  deliveryOrderBatchDetachSourceDocument: Scalars['Int']['output'];
  deliveryOrderBatchGenerate: DeliveryOrderBatch;
  deliveryOrderBatchGenerateAndShip: DeliveryOrderBatch;
  deliveryOrderBatchRegenerateFailed: DeliveryOrderBatch;
  deliveryOrderBatchRemoveContainer: Scalars['Boolean']['output'];
  deliveryOrderBatchScan: DeliveryOrderBatchScanResult;
  deliveryOrderCancel: DeliveryOrder;
  deliveryOrderCheckGenerateBulk?: Maybe<Array<CheckReadyGenerateDeliveryOrderBulk>>;
  deliveryOrderContainerRemove: Scalars['Boolean']['output'];
  deliveryOrderCreate: DeliveryOrder;
  deliveryOrderGenerateBulk: Scalars['Boolean']['output'];
  deliveryOrderShipped: DeliveryOrder;
  deliveryOrderUpdate: DeliveryOrder;
  edcTerminalCreate: EdcTerminal;
  edcTerminalDelete: Scalars['Boolean']['output'];
  edcTerminalUpdate: EdcTerminal;
  editConsignmentSettlement: VendorConsignmentInvoice;
  employeeCreate: Employee;
  employeeDelete: Scalars['Boolean']['output'];
  employeeUpdate: Employee;
  erpSyncAllBranches: SyncAllResult;
  erpSyncAllProductCategories: SyncAllResult;
  erpSyncAllProducts: SyncAllResult;
  erpSyncAllReasonInventoryAdjustments: SyncAllResult;
  erpSyncAllTaxes: SyncAllResult;
  erpSyncAllUomCategories: SyncAllResult;
  erpSyncAllUoms: SyncAllResult;
  erpSyncAllVendors: SyncAllResult;
  erpSyncAllWarehouses: SyncAllResult;
  erpSyncMasterdataByIds: SyncAllResult;
  erpSyncTransactionByIds: SyncAllResult;
  expenseItemCreate: ExpenseItem;
  expenseItemDelete: Scalars['Boolean']['output'];
  expenseItemUpdate: ExpenseItem;
  fileCreateFromStorageObject: File;
  generateConsignmentInvoice: VendorConsignmentInvoice;
  generateConsignmentInvoicesBulk: Array<BulkConsignmentGenerateResult>;
  generateLinkResetPassword: GenerateLinkResetPasswordResponse;
  generateOtpCode: GenerateLinkResetPasswordResponse;
  generateTransferRequestFromReplenishment: TransferRequest;
  internalTransferCancel: InternalTransfer;
  internalTransferConfirm: InternalTransfer;
  internalTransferCreate: InternalTransfer;
  internalTransferUpdate: InternalTransfer;
  inventoryAdjustmentCancel: InventoryAdjustment;
  inventoryAdjustmentConfirm: InventoryAdjustment;
  inventoryAdjustmentCreate: InventoryAdjustment;
  inventoryAdjustmentCreateOpeningBalance: InventoryAdjustment;
  inventoryAdjustmentCreateSystem: InventoryAdjustment;
  inventoryAdjustmentDelete: Scalars['Boolean']['output'];
  inventoryAdjustmentOpeningBalanceImport: Scalars['UUID']['output'];
  inventoryAdjustmentOpeningBalanceImportValidateCodes: InventoryAdjustmentOpeningBalanceImportValidateCodesResult;
  inventoryAdjustmentRetryFromBackgroundJob: Scalars['Boolean']['output'];
  inventoryAdjustmentUpdate: InventoryAdjustment;
  inventoryCountItemTemplateCreate: InventoryCountItemTemplate;
  inventoryCountItemTemplateDelete: Scalars['Boolean']['output'];
  inventoryCountItemTemplateItemCreate: InventoryCountItemTemplateItem;
  inventoryCountItemTemplateItemDelete: Scalars['Boolean']['output'];
  inventoryCountItemTemplateItemImport: InventoryCountItemTemplateItemImportResult;
  inventoryCountItemTemplateItemImportValidate: InventoryCountItemTemplateItemImportValidateResult;
  inventoryCountItemTemplateUpdate: InventoryCountItemTemplate;
  inventoryCountTaskAssignedFinish: Scalars['Boolean']['output'];
  inventoryCountTaskAssigneeAdd: Scalars['Boolean']['output'];
  inventoryCountTaskAssigneeDelete: Scalars['Boolean']['output'];
  inventoryCountTaskCancel: Scalars['Boolean']['output'];
  inventoryCountTaskExecuteImport: InventoryCountTaskExecuteImportResult;
  inventoryCountTaskExecutionDetailDelete?: Maybe<InventoryCountTaskExecutionItem>;
  inventoryCountTaskExportImportTemplate: InventoryCountTransactionExport;
  inventoryCountTaskExportRecountItems: InventoryCountTransactionExport;
  inventoryCountTaskFinish: Scalars['Boolean']['output'];
  inventoryCountTaskItemExecute: InventoryCountTask;
  inventoryCountTaskItemResetExecuted: Scalars['Boolean']['output'];
  inventoryCountTaskRecountCreate: InventoryCountTask;
  inventoryCountTaskStart: InventoryCountTask;
  inventoryCountTaskUpdate: InventoryCountTask;
  inventoryCountTransactionCancel: InventoryCountTransaction;
  inventoryCountTransactionCreate: InventoryCountTransaction;
  inventoryCountTransactionExportResults: InventoryCountTransactionExport;
  inventoryCountTransactionExportResultsByLocation: InventoryCountTransactionExport;
  inventoryCountTransactionFinish: InventoryCountTransaction;
  inventoryCountTransactionUpdate: InventoryCountTransaction;
  lockConsignmentDraftToProforma: VendorConsignmentInvoice;
  markConsignmentInvoicePaid: VendorConsignmentInvoice;
  markConsignmentInvoicesPaidBulk: Array<BulkConsignmentPayResult>;
  marketplaceCampaignAddItem: MarketplaceCampaign;
  marketplaceCampaignCreate: MarketplaceCampaign;
  marketplaceCampaignDelete: Scalars['Boolean']['output'];
  marketplaceCampaignDuplicate: MarketplaceCampaign;
  marketplaceCampaignExtend: MarketplaceCampaign;
  marketplaceCampaignImportProducts: MarketplaceCampaignImportResult;
  marketplaceCampaignPublishFromPromo: MarketplaceCampaign;
  marketplaceCampaignPush: MarketplaceCampaign;
  marketplaceCampaignRemoveItem: MarketplaceCampaign;
  marketplaceCampaignResume: MarketplaceCampaign;
  marketplaceCampaignStop: MarketplaceCampaign;
  marketplaceCampaignSync: MarketplaceCampaignSyncResult;
  marketplaceCampaignUpdate: MarketplaceCampaign;
  marketplaceCronRun: MarketplaceCronRunResult;
  marketplaceCronSettingUpdate: MarketplaceCronSetting;
  marketplaceMenuSync: MarketplaceMenuSyncResult;
  marketplaceOrderCancel: MarketplaceOrder;
  marketplaceOrderEdit: MarketplaceOrder;
  marketplaceOrderMarkReady: MarketplaceOrder;
  marketplaceOrderReconcilePayment: MarketplaceOrder;
  marketplaceOrderSyncPOS: MarketplaceOrderSyncPosResult;
  marketplaceStorePause: Scalars['Boolean']['output'];
  memberTypeCreate: MemberType;
  memberTypeDelete: Scalars['Boolean']['output'];
  memberTypeUpdate: MemberType;
  moveConsignmentItems: VendorConsignmentInvoice;
  outboundContainerBulkGeneration: Scalars['Boolean']['output'];
  outboundContainerCreate: OutboundContainer;
  outboundContainerDelete: Scalars['Boolean']['output'];
  outboundContainerOpenSeal: OutboundContainer;
  outboundContainerPackItem: OutboundContainer;
  outboundContainerUnpackItem: OutboundContainer;
  outboundContainerUpdatePackItem: OutboundContainer;
  packingTaskCancel: Scalars['Boolean']['output'];
  packingTaskFinish: PackingTask;
  packingTaskStart: PackingTask;
  packingTaskVerify: PackingTask;
  paymentProviderConfigUpdate: PaymentProviderConfig;
  paymentTransactionCancel: PaymentTransaction;
  paymentTransactionCheckStatus: PaymentTransactionCheckStatusResult;
  paymentTransactionCreateDynamicQris: PaymentTransaction;
  permissionCreate: Permission;
  permissionDelete: Scalars['Boolean']['output'];
  permissionUpdate: Permission;
  pettyCashAddFundTransactionCancel: PettyCashAddFundTransaction;
  pettyCashAddFundTransactionConfirm: PettyCashAddFundTransaction;
  pettyCashAddFundTransactionCreate: PettyCashAddFundTransaction;
  pettyCashAddFundTransactionDelete: Scalars['Boolean']['output'];
  pettyCashAddFundTransactionUpdate: PettyCashAddFundTransaction;
  pettyCashExpenseTransactionCancel: PettyCashExpenseTransaction;
  pettyCashExpenseTransactionConfirm: PettyCashExpenseTransaction;
  pettyCashExpenseTransactionCreate: PettyCashExpenseTransaction;
  pettyCashExpenseTransactionDelete: Scalars['Boolean']['output'];
  pettyCashExpenseTransactionUpdate: PettyCashExpenseTransaction;
  pettyCashRefundTransactionCancel: PettyCashRefundTransaction;
  pettyCashRefundTransactionConfirm: PettyCashRefundTransaction;
  pettyCashRefundTransactionCreate: PettyCashRefundTransaction;
  pettyCashRefundTransactionDelete: Scalars['Boolean']['output'];
  pettyCashRefundTransactionUpdate: PettyCashRefundTransaction;
  pickingTaskAcceptAndStart: PickingTask;
  pickingTaskAssign: PickingTask;
  pickingTaskCancel: Scalars['Boolean']['output'];
  pickingTaskExecute: PickingTask;
  pickingTaskFinish: PickingTask;
  pickingTaskGenerate: PickingTask;
  pickingTaskGenerateBulk: Array<PickingTask>;
  pickingTaskStart: PickingTask;
  pickingTaskUpdateUnfulfilledReasons: PickingTask;
  placeholder?: Maybe<Scalars['Boolean']['output']>;
  posBookmarkCreate: PosBookmark;
  posBookmarkDelete: Scalars['Boolean']['output'];
  posBookmarkProductCreate: PosBookmarkProduct;
  posBookmarkProductDelete: Scalars['Boolean']['output'];
  posBookmarkProductUpdate: PosBookmarkProduct;
  posBookmarkUpdate: PosBookmark;
  posSalesOrderCreate: PosSalesOrder;
  posSalesOrderUpdate: PosSalesOrder;
  posterCreate: Poster;
  posterDelete: Scalars['Boolean']['output'];
  posterUpdate: Poster;
  pricelistCreate: Pricelist;
  pricelistDelete: Pricelist;
  pricelistPeriodCreate: PricelistPeriod;
  pricelistPeriodDelete: Scalars['Boolean']['output'];
  pricelistPeriodUpdate: PricelistPeriod;
  pricelistProductBulkCreate: Array<PricelistProduct>;
  pricelistProductCreate: PricelistProduct;
  pricelistProductDelete: PricelistProduct;
  pricelistProductImport: PricelistProductImportResult;
  pricelistProductImportValidate: PricelistProductImportValidateResult;
  pricelistProductSalesChannelCreate: PricelistProductSalesChannel;
  pricelistProductSalesChannelDelete: Scalars['Boolean']['output'];
  pricelistProductSalesChannelUpdate: PricelistProductSalesChannel;
  pricelistProductSalesChannelUpsert: PricelistProductSalesChannel;
  pricelistProductUpdate: PricelistProduct;
  pricelistSalesChannelDelete: Scalars['Boolean']['output'];
  pricelistSalesChannelUpsert: PricelistSalesChannel;
  pricelistUpdate: Pricelist;
  productAIImageCreate: ProductAiImage;
  productAIImageDelete: Scalars['Boolean']['output'];
  productAIImageUpdate: ProductAiImage;
  productAccountingCategoryCreate: ProductAccountingCategory;
  productAccountingCategoryDelete: Scalars['Boolean']['output'];
  productAccountingCategoryUpdate: ProductAccountingCategory;
  productAddonComponentCreate: ProductAddonComponent;
  productAddonComponentDelete: ProductAddonComponent;
  productAddonComponentUpdate: ProductAddonComponent;
  productAddonCreate: ProductAddon;
  productAddonDelete: Scalars['Boolean']['output'];
  productAddonGroupCreate: ProductAddonGroup;
  productAddonGroupDelete: Scalars['Boolean']['output'];
  productAddonGroupItemCreate: ProductAddonGroupItem;
  productAddonGroupItemDelete: Scalars['Boolean']['output'];
  productAddonGroupItemUpdate: ProductAddonGroupItem;
  productAddonGroupUpdate: ProductAddonGroup;
  productAddonUpdate: ProductAddon;
  productAvailabilityTemplateCreate: ProductAvailabilityTemplate;
  productAvailabilityTemplateDelete: Scalars['Boolean']['output'];
  productAvailabilityTemplateItemCreate: ProductAvailabilityTemplateItem;
  productAvailabilityTemplateItemDelete: Scalars['Boolean']['output'];
  productAvailabilityTemplateItemExport: ProductAvailabilityTemplateItemExportResult;
  productAvailabilityTemplateItemImport: ProductAvailabilityTemplateItemImportResult;
  productAvailabilityTemplateItemImportValidate: ProductAvailabilityTemplateItemImportValidateResult;
  productAvailabilityTemplateItemSetChannels: ProductAvailabilityTemplateItem;
  productAvailabilityTemplateItemUpdate: ProductAvailabilityTemplateItem;
  productAvailabilityTemplateUpdate: ProductAvailabilityTemplate;
  productBarcodeMapCreate: ProductBarcodeMap;
  productBarcodeMapDelete: Scalars['Boolean']['output'];
  productBarcodeMapUpdate: ProductBarcodeMap;
  productBookmarkCreate: ProductBookmark;
  productBookmarkDelete: Scalars['Boolean']['output'];
  productBookmarkProductCreate: ProductBookmarkProduct;
  productBookmarkProductDelete: Scalars['Boolean']['output'];
  productBookmarkProductUpdate: ProductBookmarkProduct;
  productBookmarkUpdate: ProductBookmark;
  productBrandCreate: ProductBrand;
  productBrandDelete: Scalars['Boolean']['output'];
  productBrandUpdate: ProductBrand;
  productBundleComponentCreate: ProductBundleComponent;
  productBundleComponentDelete: ProductBundleComponent;
  productBundleComponentUpdate: ProductBundleComponent;
  productCategoryCreate: ProductCategory;
  productCategoryDelete: Scalars['Boolean']['output'];
  productCategorySalesChannelMapCreate: ProductCategorySalesChannelMap;
  productCategorySalesChannelMapDelete: Scalars['Boolean']['output'];
  productCategorySalesChannelMapExport: ProductCategorySalesChannelMapExportResult;
  productCategorySalesChannelMapImport: ProductCategorySalesChannelMapImportResult;
  productCategorySalesChannelMapImportValidate: ProductCategorySalesChannelMapImportValidateResult;
  productCategorySalesChannelMapUpdate: ProductCategorySalesChannelMap;
  productCategoryUpdate: ProductCategory;
  productConsignmentImport: ProductImportResult;
  productConsignmentImportValidate: ProductImportValidateResult;
  productCreate: Product;
  productDelete: Scalars['Boolean']['output'];
  productDepartmentCreate: ProductDepartment;
  productDepartmentDelete: Scalars['Boolean']['output'];
  productDepartmentUpdate: ProductDepartment;
  productDivisionCreate: ProductDivision;
  productDivisionDelete: Scalars['Boolean']['output'];
  productDivisionUpdate: ProductDivision;
  productFileCreate: ProductFile;
  productFileDelete: Scalars['Boolean']['output'];
  productFileUpdate: ProductFile;
  productNonConsignmentImport: ProductImportResult;
  productNonConsignmentImportValidate: ProductImportValidateResult;
  productSalesChannelItemMapCreate: ProductSalesChannelItemMap;
  productSalesChannelItemMapDelete: Scalars['Boolean']['output'];
  productSalesChannelItemMapUpdate: ProductSalesChannelItemMap;
  productSourceCreate: ProductSource;
  productSourceDelete: Scalars['Boolean']['output'];
  productSourceUpdate: ProductSource;
  productSubCategoryCreate: ProductSubCategory;
  productSubCategoryDelete: Scalars['Boolean']['output'];
  productSubCategoryUpdate: ProductSubCategory;
  productSubDepartmentCreate: ProductSubDepartment;
  productSubDepartmentDelete: Scalars['Boolean']['output'];
  productSubDepartmentUpdate: ProductSubDepartment;
  productTagCreate: ProductTag;
  productTagDelete: Scalars['Boolean']['output'];
  productTagProductCreate: ProductTagProduct;
  productTagProductDelete: Scalars['Boolean']['output'];
  productTagProductUpdate: ProductTagProduct;
  productTagUpdate: ProductTag;
  productUpdate: Product;
  productVendorCreate: ProductVendor;
  productVendorDelete: Scalars['Boolean']['output'];
  productVendorUpdate: ProductVendor;
  productionOrderCancel: ProductionOrder;
  productionOrderConfirm: ProductionOrder;
  productionOrderCreate: ProductionOrder;
  productionOrderUpdate: ProductionOrder;
  promoComponentImportValidate: PromoComponentImportValidateResult;
  promoCreate: Array<Promo>;
  promoDelete: Scalars['Boolean']['output'];
  /** Create a new promo quota config */
  promoQuotaCreate: PromoQuota;
  /** Delete promo quota config */
  promoQuotaDelete: Scalars['Boolean']['output'];
  /** Increment usage counter for a branch (creates usage record if not exists) */
  promoQuotaIncrementUsage: PromoQuotaBranchUsage;
  /** Reset usage counter for a branch */
  promoQuotaResetUsage: PromoQuotaBranchUsage;
  /** Update existing promo quota config */
  promoQuotaUpdate: PromoQuota;
  promoTypeCreate: PromoType;
  promoTypeDelete: Scalars['Boolean']['output'];
  promoTypeUpdate: PromoType;
  promoUpdate: Array<Promo>;
  provinceCreate: Province;
  provinceDelete: Scalars['Boolean']['output'];
  provinceUpdate: Province;
  purchaseAreaCreate: PurchaseArea;
  purchaseAreaDelete: Scalars['Boolean']['output'];
  purchaseAreaUpdate: PurchaseArea;
  purchaseOrderBackfillTotals: PurchaseOrderBackfillTotalsResult;
  purchaseOrderCancel: Scalars['Boolean']['output'];
  purchaseOrderClose: Scalars['Boolean']['output'];
  purchaseOrderConfirm: Scalars['Boolean']['output'];
  purchaseOrderCreate: PurchaseOrder;
  purchaseOrderForceClose: Scalars['Boolean']['output'];
  purchaseOrderImport: Scalars['UUID']['output'];
  purchaseOrderImportValidateCodes: PurchaseOrderImportValidateCodesResult;
  purchaseOrderReceivingCancel: Scalars['Boolean']['output'];
  purchaseOrderReceivingConfirm: PurchaseOrderReceiving;
  purchaseOrderReceivingCreate: PurchaseOrderReceiving;
  purchaseOrderReceivingUpdate: PurchaseOrderReceiving;
  purchaseOrderRevise: Scalars['Boolean']['output'];
  purchaseOrderSendEmail: Scalars['Boolean']['output'];
  purchaseOrderUpdate: PurchaseOrder;
  putawayTaskAcceptAndStart: MobilePutawayTask;
  putawayTaskAssign: PutawayTask;
  putawayTaskBatchExecutions: BatchExecutionResult;
  putawayTaskCancel: Scalars['Boolean']['output'];
  putawayTaskFinish: MobilePutawayTask;
  putawayTaskGenerateMultiple: Array<PutawayTask>;
  putawayTaskGenerateSingle: PutawayTask;
  putawayTaskRecordExecution: ExecutionResult;
  putawayTaskScanLocation: LocationValidationResult;
  putawayTaskScanProduct: ProductValidationResult;
  putawayTaskStart: MobilePutawayTask;
  putawayTaskUpdate: PutawayTask;
  reasonCreate: Reason;
  reasonDelete: Scalars['Boolean']['output'];
  reasonInventoryAdjustmentCreate: ReasonInventoryAdjustment;
  reasonInventoryAdjustmentDelete: Scalars['Boolean']['output'];
  reasonInventoryAdjustmentUpdate: ReasonInventoryAdjustment;
  reasonUpdate: Reason;
  recalculateAllConsignmentProformas: Scalars['Int']['output'];
  recalculateConsignmentProforma: VendorConsignmentInvoice;
  recomputeConsignmentDrafts: Scalars['Boolean']['output'];
  replenishmentCreate: Replenishment;
  replenishmentTemplateCategoryCreate: ReplenishmentTemplateCategory;
  replenishmentTemplateCategoryDelete: Scalars['Boolean']['output'];
  replenishmentTemplateCategoryUpdate: ReplenishmentTemplateCategory;
  replenishmentTemplateCreate: ReplenishmentTemplate;
  replenishmentTemplateDelete: Scalars['Boolean']['output'];
  replenishmentTemplateItemCreate: ReplenishmentTemplateItem;
  replenishmentTemplateItemDelete: Scalars['Boolean']['output'];
  replenishmentTemplateItemImport: ReplenishmentTemplateItemImportResult;
  replenishmentTemplateItemImportValidate: ReplenishmentTemplateItemImportValidateResult;
  replenishmentTemplateItemUpdate: ReplenishmentTemplateItem;
  replenishmentTemplateUpdate: ReplenishmentTemplate;
  resetPassword: Scalars['Boolean']['output'];
  resourceCreate: Resource;
  resourceDelete: Scalars['Boolean']['output'];
  resourceUpdate: Resource;
  revenueReportAccessLogExport: RevenueReportAccessLogExport;
  revenueReportApiKeyIssue: RevenueReportApiKeyIssued;
  revenueReportApiKeyRevoke: RevenueReportApiKey;
  revenueReportDetailCorrect: RevenueReportDetail;
  revenueReportDetailExport: RevenueReportDetailExport;
  revenueReportDetailVoid: RevenueReportDetail;
  revenueReportExport: RevenueReportExport;
  revenueReportGenerate: Array<RevenueReport>;
  revenueReportPartnerActivate: RevenueReportPartner;
  revenueReportPartnerBranchActivate: RevenueReportPartnerBranch;
  revenueReportPartnerBranchCreate: RevenueReportPartnerBranch;
  revenueReportPartnerBranchCredentialClear: RevenueReportPartnerBranch;
  revenueReportPartnerBranchCredentialSet: RevenueReportPartnerBranch;
  revenueReportPartnerBranchDeactivate: RevenueReportPartnerBranch;
  revenueReportPartnerBranchUpdate: RevenueReportPartnerBranch;
  revenueReportPartnerCreate: RevenueReportPartner;
  revenueReportPartnerCredentialSet: RevenueReportPartner;
  revenueReportPartnerDeactivate: RevenueReportPartner;
  revenueReportPartnerEndpointUpdate: RevenueReportPartner;
  revenueReportPartnerUpdate: RevenueReportPartner;
  revenueReportResend: RevenueReport;
  revenueReportResync: RevenueReport;
  revenueReportTemplateActivate: RevenueReportTemplate;
  revenueReportTemplateCreate: RevenueReportTemplate;
  revenueReportTemplateDeactivate: RevenueReportTemplate;
  revenueReportTemplateDelete: Scalars['Boolean']['output'];
  revenueReportTemplateDuplicate: RevenueReportTemplate;
  revenueReportTemplateFieldMapUpdate: RevenueReportTemplate;
  revenueReportTemplateUpdate: RevenueReportTemplate;
  revenueReportUserActivate: RevenueReportUser;
  revenueReportUserCreate: RevenueReportUser;
  revenueReportUserDeactivate: RevenueReportUser;
  revenueReportUserUpdate: RevenueReportUser;
  revenueSharingBranchCreate: RevenueSharingBranch;
  revenueSharingBranchDelete: Scalars['Boolean']['output'];
  revenueSharingBranchUpdate: RevenueSharingBranch;
  revenueSharingCorrectItem: Scalars['Boolean']['output'];
  revenueSharingExport: RevenueSharingExport;
  revenueSharingGenerate: Scalars['Boolean']['output'];
  revenueSharingReuploadDates: RevenueSharingReuploadResult;
  revenueSharingUpload: Scalars['Boolean']['output'];
  revenueSharingUploadAll: Scalars['Boolean']['output'];
  revenueSharingVoidItem: Scalars['Boolean']['output'];
  roleCreate: Roles;
  roleDelete: Scalars['Boolean']['output'];
  roleUpdate: Roles;
  salesChannelCampaignCancel: SalesChannelCampaign;
  salesChannelCampaignCreate: SalesChannelCampaign;
  salesChannelCampaignDelete: Scalars['Boolean']['output'];
  salesChannelCampaignPublish: SalesChannelCampaign;
  salesChannelCampaignPublishToStores: Array<SalesChannelCampaignPublishStoreResult>;
  salesChannelCampaignSetCategories: Array<SalesChannelCampaignCategory>;
  salesChannelCampaignSetChannels: Array<SalesChannelCampaignChannel>;
  salesChannelCampaignSetProducts: Array<SalesChannelCampaignProduct>;
  salesChannelCampaignStop: SalesChannelCampaign;
  salesChannelCampaignUpdate: SalesChannelCampaign;
  salesChannelCategoryCreate: SalesChannelCategory;
  salesChannelCategoryDelete: Scalars['Boolean']['output'];
  salesChannelCategoryGroupCreate: SalesChannelCategoryGroup;
  salesChannelCategoryGroupDelete: Scalars['Boolean']['output'];
  salesChannelCategoryGroupItemCreate: SalesChannelCategoryGroupItem;
  salesChannelCategoryGroupItemDelete: Scalars['Boolean']['output'];
  salesChannelCategoryGroupItemUpdate: SalesChannelCategoryGroupItem;
  salesChannelCategoryGroupProductCreate: SalesChannelCategoryGroupProduct;
  salesChannelCategoryGroupProductDelete: Scalars['Boolean']['output'];
  salesChannelCategoryGroupProductReorder: Scalars['Boolean']['output'];
  salesChannelCategoryGroupProductUpdate: SalesChannelCategoryGroupProduct;
  salesChannelCategoryGroupUpdate: SalesChannelCategoryGroup;
  salesChannelCategoryUpdate: SalesChannelCategory;
  salesChannelStockThresholdCreate: SalesChannelStockThreshold;
  salesChannelStockThresholdDelete: Scalars['Boolean']['output'];
  salesChannelStockThresholdUpdate: SalesChannelStockThreshold;
  salesInvoiceInventoryBackfill: SalesInvoiceInventoryBackfillResult;
  salesInvoiceReviewRefresh: SalesInvoiceReview;
  salesInvoiceReviewResolveBulk: Array<SalesInvoiceReviewResolveResult>;
  salesPaymentMethodCreate: SalesPaymentMethod;
  salesPaymentMethodDelete: Scalars['Boolean']['output'];
  salesPaymentMethodTypeCreate: SalesPaymentMethodType;
  salesPaymentMethodTypeDelete: Scalars['Boolean']['output'];
  salesPaymentMethodTypeUpdate: SalesPaymentMethodType;
  salesPaymentMethodUpdate: SalesPaymentMethod;
  sendConsignmentInvoiceEmail: VendorConsignmentInvoice;
  sendConsignmentInvoiceEmailsBulk: Array<BulkConsignmentEmailResult>;
  shiftSessionClose: ShiftSessionCloseResult;
  shiftSessionCreate: ShiftSession;
  shiftSessionDelete: Scalars['Boolean']['output'];
  shiftSessionRecompute: ShiftSession;
  shiftSessionResolveCashDiff: ShiftSession;
  simpleTransferOrderCancel: SimpleTransferOrder;
  simpleTransferOrderConfirm: SimpleTransferOrder;
  simpleTransferOrderCreate: SimpleTransferOrder;
  simpleTransferOrderDelete: Scalars['Boolean']['output'];
  simpleTransferOrderReceivingCancel: Scalars['Boolean']['output'];
  simpleTransferOrderReceivingConfirm: SimpleTransferOrderReceiving;
  simpleTransferOrderReceivingCreate: SimpleTransferOrderReceiving;
  simpleTransferOrderReceivingCreateAndConfirm: SimpleTransferOrderReceiving;
  simpleTransferOrderReceivingUpdate: SimpleTransferOrderReceiving;
  simpleTransferOrderReceivingUpdateAndConfirm: SimpleTransferOrderReceiving;
  simpleTransferOrderUpdate: SimpleTransferOrder;
  subdistrictCreate: Subdistrict;
  subdistrictDelete: Scalars['Boolean']['output'];
  subdistrictUpdate: Subdistrict;
  syncErpPurchaseOrderReceive: Scalars['Boolean']['output'];
  syncErpVendor: Scalars['Boolean']['output'];
  taxCreate: Tax;
  taxDelete: Scalars['Boolean']['output'];
  taxUpdate: Tax;
  transferOrderCancel: TransferOrder;
  transferOrderConfirm: TransferOrder;
  transferOrderCreate: TransferOrder;
  transferOrderDelete: Scalars['Boolean']['output'];
  transferOrderImport: Scalars['UUID']['output'];
  transferOrderImportValidateCodes: TransferOrderImportValidateCodesResult;
  transferOrderMarkAsDone: TransferOrder;
  transferOrderReceivingCancel: Scalars['Boolean']['output'];
  transferOrderReceivingConfirm: TransferOrderReceiving;
  transferOrderReceivingCreate: TransferOrderReceiving;
  transferOrderReceivingUpdate: TransferOrderReceiving;
  transferOrderUpdate: TransferOrder;
  transferRequestApprove: TransferRequest;
  transferRequestCancel: TransferRequest;
  transferRequestCreate: TransferRequest;
  transferRequestImport: Scalars['UUID']['output'];
  transferRequestImportValidateCodes: TransferRequestImportValidateCodesResult;
  transferRequestReject: TransferRequest;
  transferRequestSubmit: TransferRequest;
  transferRequestUpdate: TransferRequest;
  triggerProductImageEmbeddingRun: IngestionRunInfo;
  uomCategoryCreate: UomCategory;
  uomCategoryDelete: Scalars['Boolean']['output'];
  uomCategoryUpdate: UomCategory;
  uomCreate: Uom;
  uomDelete: Scalars['Boolean']['output'];
  uomUpdate: Uom;
  updateErpProduct: Scalars['Boolean']['output'];
  uploadTemplateCreate: UploadTemplate;
  uploadTemplateDelete: Scalars['Boolean']['output'];
  uploadTemplateUpdate: UploadTemplate;
  userCreate: User;
  userDelete: Scalars['Boolean']['output'];
  userRegeneratePIN: Scalars['String']['output'];
  userRegeneratePINSelf: Scalars['String']['output'];
  userUpdate: User;
  validateBeforeICFinish: Array<ValidateBeforeIcFinishRow>;
  validateBeforeICFinishConfirm: Scalars['Boolean']['output'];
  validateSupervisorPin: SupervisorPinValidationResult;
  vendorCategoryCreate: VendorCategory;
  vendorCategoryDelete: Scalars['Boolean']['output'];
  vendorCategoryUpdate: VendorCategory;
  vendorConsignmentBranchBulkDelete: VendorConsignmentBranchBulkDeleteResult;
  vendorConsignmentBranchCreate: VendorConsignmentBranch;
  vendorConsignmentBranchDelete: Scalars['Boolean']['output'];
  vendorConsignmentBranchPeriodGrant: VendorConsignmentBranchPeriod;
  vendorConsignmentBranchPeriodResume: VendorConsignmentBranchPeriod;
  vendorConsignmentBranchPeriodRevoke: VendorConsignmentBranchPeriod;
  vendorConsignmentBranchPeriodSuspend: VendorConsignmentBranchPeriod;
  vendorConsignmentBranchUpdate: VendorConsignmentBranch;
  vendorConsignmentInvoiceConfigCreate: VendorConsignmentInvoiceConfig;
  vendorConsignmentInvoiceConfigImport: VendorConsignmentInvoiceConfigImportResult;
  vendorConsignmentInvoiceConfigImportValidate: VendorConsignmentInvoiceConfigImportValidateResult;
  vendorConsignmentInvoiceConfigUpdate: VendorConsignmentInvoiceConfig;
  vendorConsignmentProductCreate: VendorConsignmentProduct;
  vendorConsignmentProductDelete: Scalars['Boolean']['output'];
  vendorConsignmentProductPriceBulkUpdate: VendorConsignmentProductBulkUpdateResult;
  vendorConsignmentProductUpdate: VendorConsignmentProduct;
  vendorConsignmentRentalPaymentApprove: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentCancel: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentCreate: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentReject: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentSubmit: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentUpdate: VendorConsignmentRentalPayment;
  vendorCreate: Vendor;
  vendorCreateAccess: Vendor;
  vendorDelete: Scalars['Boolean']['output'];
  vendorPicContactCreate: VendorPicContact;
  vendorPicContactDelete: Scalars['Boolean']['output'];
  vendorPicContactUpdate: VendorPicContact;
  vendorSetPortalAccessActive: Vendor;
  vendorUpdate: Vendor;
  vendorUpdateAccess: Vendor;
  villageCreate: Village;
  villageDelete: Scalars['Boolean']['output'];
  villageUpdate: Village;
  voucherCategoryCreate: VoucherCategory;
  voucherCategoryDelete: Scalars['Boolean']['output'];
  voucherCategoryUpdate: VoucherCategory;
  voucherCreate: Voucher;
  voucherDelete: Scalars['Boolean']['output'];
  voucherItemGenerate: Array<VoucherItem>;
  voucherItemImport: Array<VoucherItem>;
  voucherItemVoid: VoucherItem;
  voucherRecountItems: Voucher;
  voucherUpdate: Voucher;
  warehouseCreate: Warehouse;
  warehouseDelete: Scalars['Boolean']['output'];
  warehouseLocationCreate: WarehouseLocation;
  warehouseLocationCreateBulk: Array<WarehouseLocation>;
  warehouseLocationDelete: Scalars['Boolean']['output'];
  warehouseLocationGroupCreate: WarehouseLocationGroup;
  warehouseLocationGroupDelete: Scalars['Boolean']['output'];
  warehouseLocationGroupUpdate: WarehouseLocationGroup;
  warehouseLocationRelationMapCreate: WarehouseLocationRelationMap;
  warehouseLocationRelationMapDelete: Scalars['Boolean']['output'];
  warehouseLocationRelationMapUpdate: WarehouseLocationRelationMap;
  warehouseLocationUpdate: WarehouseLocation;
  warehouseProductLocationMapCreate: WarehouseProductLocationMap;
  warehouseProductLocationMapDelete: Scalars['Boolean']['output'];
  warehouseProductLocationMapUpdate: WarehouseProductLocationMap;
  warehouseReplenishmentTemplateCreate: WarehouseReplenishmentTemplate;
  warehouseReplenishmentTemplateCreateBulk: Array<WarehouseReplenishmentTemplate>;
  warehouseReplenishmentTemplateDelete: Scalars['Boolean']['output'];
  warehouseUpdate: Warehouse;
};


export type MutationSalesChannelCreateArgs = {
  input: SalesChannelCreateInput;
};


export type MutationSalesChannelDeleteArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type MutationSalesChannelUpdateArgs = {
  input: SalesChannelUpdateInput;
};


export type MutationAdminResetPasswordArgs = {
  input: AdminResetPasswordInput;
};


export type MutationAiChatCreateSessionArgs = {
  input?: InputMaybe<AiChatCreateSessionInput>;
};


export type MutationAiChatDeleteSessionArgs = {
  sessionID: Scalars['String']['input'];
};


export type MutationAiChatRenameSessionArgs = {
  input: AiChatRenameSessionInput;
};


export type MutationAiChatSendMessageArgs = {
  input: AiChatSendMessageInput;
};


export type MutationAiDeleteAppClientArgs = {
  appId: Scalars['String']['input'];
};


export type MutationAiRegenerateAppClientKeyArgs = {
  appId: Scalars['String']['input'];
};


export type MutationAiUpdateGuardrailsConfigArgs = {
  input: AiUpdateGuardrailsInput;
};


export type MutationAiUpdateScopeTableArgs = {
  input: AiUpdateScopeTableInput;
};


export type MutationAiUpdateScopeToolArgs = {
  input: AiUpdateScopeToolInput;
};


export type MutationAiUpsertAppClientArgs = {
  input: AiUpsertAppClientInput;
};


export type MutationAppCreateArgs = {
  input: AppCreateInput;
};


export type MutationAppDeleteArgs = {
  appID: Scalars['String']['input'];
};


export type MutationAppUpdateArgs = {
  input: AppUpdateInput;
};


export type MutationAuthLoginArgs = {
  input: LoginInput;
};


export type MutationAuthLoginVendorArgs = {
  input: LoginInput;
};


export type MutationAuthRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationAuthSetDefaultBranchArgs = {
  input: SetDefaultBranchInput;
};


export type MutationBackgroundJobCreateArgs = {
  input: BackgroundJobCreateInput;
};


export type MutationBackgroundJobDeleteArgs = {
  backgroundJobID: Scalars['UUID']['input'];
};


export type MutationBackgroundJobUpdateArgs = {
  input: BackgroundJobUpdateInput;
};


export type MutationBankAccountCreateArgs = {
  input: BankAccountCreateInput;
};


export type MutationBankAccountDeleteArgs = {
  bankAccountID: Scalars['UUID']['input'];
};


export type MutationBankAccountUpdateArgs = {
  input: BankAccountUpdateInput;
};


export type MutationBankCreateArgs = {
  input: BankCreateInput;
};


export type MutationBankDeleteArgs = {
  bankID: Scalars['UUID']['input'];
};


export type MutationBankReconciliationCancelArgs = {
  input: BankReconciliationCancelInput;
};


export type MutationBankReconciliationCreateArgs = {
  input: BankReconciliationCreateInput;
};


export type MutationBankReconciliationExportArgs = {
  input: BankReconciliationExportInput;
};


export type MutationBankReconciliationFinalizeArgs = {
  input: BankReconciliationFinalizeInput;
};


export type MutationBankReconciliationImportValidateArgs = {
  input: BankReconciliationImportValidateInput;
};


export type MutationBankReconciliationItemManualMatchArgs = {
  input: BankReconciliationItemManualMatchInput;
};


export type MutationBankReconciliationItemMergeArgs = {
  input: BankReconciliationItemMergeInput;
};


export type MutationBankReconciliationItemResolveArgs = {
  input: BankReconciliationItemResolveInput;
};


export type MutationBankReconciliationItemsBulkResolveArgs = {
  input: BankReconciliationItemsBulkResolveInput;
};


export type MutationBankReconciliationItemsBulkResolveByFilterArgs = {
  input: BankReconciliationItemsBulkResolveByFilterInput;
};


export type MutationBankReconciliationProcessArgs = {
  input: BankReconciliationProcessInput;
};


export type MutationBankReconciliationRemoveFileArgs = {
  input: BankReconciliationRemoveFileInput;
};


export type MutationBankReconciliationRetryPoolFileArgs = {
  bankReconciliationFileID: Scalars['UUID']['input'];
};


export type MutationBankReconciliationUploadFileArgs = {
  input: BankReconciliationUploadFileInput;
};


export type MutationBankReconciliationUploadPoolFileArgs = {
  input: BankReconciliationUploadPoolFileInput;
};


export type MutationBankUpdateArgs = {
  input: BankUpdateInput;
};


export type MutationBiKnowledgeCreateArgs = {
  input: BiKnowledgeCreateInput;
};


export type MutationBiKnowledgeDeleteArgs = {
  biKnowledgeID: Scalars['UUID']['input'];
};


export type MutationBiKnowledgeUpdateArgs = {
  input: BiKnowledgeUpdateInput;
};


export type MutationBiRoleCreateArgs = {
  input: BiRoleCreateInput;
};


export type MutationBiRoleDeleteArgs = {
  role: Scalars['String']['input'];
};


export type MutationBiRoleUpdateArgs = {
  input: BiRoleUpdateInput;
};


export type MutationBiScopeTableBulkUpdateArgs = {
  input: BiScopeTableBulkUpdateInput;
};


export type MutationBiScopeTableCreateArgs = {
  input: BiScopeTableCreateInput;
};


export type MutationBiScopeTableDeleteArgs = {
  tableName: Scalars['String']['input'];
};


export type MutationBiScopeTableUpdateArgs = {
  input: BiScopeTableUpdateInput;
};


export type MutationBiUserCreateArgs = {
  input: BiUserCreateInput;
};


export type MutationBiUserDeleteArgs = {
  biUserID: Scalars['UUID']['input'];
};


export type MutationBiUserUpdateArgs = {
  input: BiUserUpdateInput;
};


export type MutationBillOfMaterialComponentCreateArgs = {
  input: BillOfMaterialComponentCreateInput;
};


export type MutationBillOfMaterialComponentDeleteArgs = {
  billOfMaterialComponentID: Scalars['UUID']['input'];
};


export type MutationBillOfMaterialComponentUpdateArgs = {
  input: BillOfMaterialComponentUpdateInput;
};


export type MutationBillOfMaterialCreateArgs = {
  input: BillOfMaterialCreateInput;
};


export type MutationBillOfMaterialDeleteArgs = {
  billOfMaterialID: Scalars['UUID']['input'];
};


export type MutationBillOfMaterialUpdateArgs = {
  input: BillOfMaterialUpdateInput;
};


export type MutationBranchBankAccountCreateArgs = {
  input: BranchBankAccountCreateInput;
};


export type MutationBranchBankAccountDeleteArgs = {
  branchBankAccountID: Scalars['UUID']['input'];
};


export type MutationBranchBankAccountUpdateArgs = {
  input: BranchBankAccountUpdateInput;
};


export type MutationBranchCategoryCreateArgs = {
  input: BranchCategoryCreateInput;
};


export type MutationBranchCategoryDeleteArgs = {
  branchCategoryID: Scalars['UUID']['input'];
};


export type MutationBranchCategoryUpdateArgs = {
  input: BranchCategoryUpdateInput;
};


export type MutationBranchCreateArgs = {
  input: BranchCreateInput;
};


export type MutationBranchDeleteArgs = {
  branchID: Scalars['UUID']['input'];
};


export type MutationBranchPosBookmarkCreateArgs = {
  input: BranchPosBookmarkCreateInput;
};


export type MutationBranchPosBookmarkDeleteArgs = {
  branchPosBookmarkID: Scalars['UUID']['input'];
};


export type MutationBranchPosBookmarkUpdateArgs = {
  input: BranchPosBookmarkUpdateInput;
};


export type MutationBranchProductSalesChannelItemDisableArgs = {
  input: BranchProductSalesChannelItemDisableInput;
};


export type MutationBranchProductSalesChannelItemRestoreArgs = {
  input: BranchProductSalesChannelItemRestoreInput;
};


export type MutationBranchQrisMerchantCreateArgs = {
  input: BranchQrisMerchantCreateInput;
};


export type MutationBranchQrisMerchantDeleteArgs = {
  branchQrisMerchantID: Scalars['UUID']['input'];
};


export type MutationBranchQrisMerchantUpdateArgs = {
  input: BranchQrisMerchantUpdateInput;
};


export type MutationBranchSalesChannelCategoryGroupCreateArgs = {
  input: BranchSalesChannelCategoryGroupCreateInput;
};


export type MutationBranchSalesChannelCategoryGroupDeleteArgs = {
  branchSalesChannelCategoryGroupID: Scalars['UUID']['input'];
};


export type MutationBranchSalesChannelCategoryGroupUpdateArgs = {
  input: BranchSalesChannelCategoryGroupUpdateInput;
};


export type MutationBranchSalesChannelMerchantMapCreateArgs = {
  input: BranchSalesChannelMerchantMapCreateInput;
};


export type MutationBranchSalesChannelMerchantMapDeleteArgs = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
};


export type MutationBranchSalesChannelMerchantMapUpdateArgs = {
  input: BranchSalesChannelMerchantMapUpdateInput;
};


export type MutationBranchSalesChannelOperatingHoursUpdateArgs = {
  input: BranchSalesChannelOperatingHoursUpdateInput;
};


export type MutationBranchSalesChannelPackagingUpdateArgs = {
  input: BranchSalesChannelPackagingUpdateInput;
};


export type MutationBranchSalesChannelPauseUpdateArgs = {
  input: BranchSalesChannelPauseUpdateInput;
};


export type MutationBranchSalesPaymentMethodCreateArgs = {
  input: BranchSalesPaymentMethodCreateInput;
};


export type MutationBranchSalesPaymentMethodDeleteArgs = {
  branchSalesPaymentMethodID: Scalars['UUID']['input'];
};


export type MutationBranchSalesPaymentMethodUpdateArgs = {
  input: BranchSalesPaymentMethodUpdateInput;
};


export type MutationBranchStoreSupervisorCreateArgs = {
  input: BranchStoreSupervisorCreateInput;
};


export type MutationBranchStoreSupervisorDeleteArgs = {
  branchStoreSupervisorID: Scalars['UUID']['input'];
};


export type MutationBranchStoreSupervisorSyncArgs = {
  branchID: Scalars['UUID']['input'];
  supervisors: Array<BranchStoreSupervisorInput>;
};


export type MutationBranchStoreSupervisorUpdateArgs = {
  input: BranchStoreSupervisorUpdateInput;
};


export type MutationBranchUpdateArgs = {
  input: BranchUpdateInput;
};


export type MutationCancelConsignmentInvoiceArgs = {
  input: VendorConsignmentInvoiceCancelInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCityCreateArgs = {
  input: CityCreateInput;
};


export type MutationCityDeleteArgs = {
  cityID: Scalars['String']['input'];
};


export type MutationCityUpdateArgs = {
  input: CityUpdateInput;
};


export type MutationConsignmentStockInCancelArgs = {
  consignmentStockInID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockInConfirmArgs = {
  consignmentStockInID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockInCreateArgs = {
  input: ConsignmentStockInCreateInput;
};


export type MutationConsignmentStockInRequestApproveArgs = {
  input: ConsignmentStockInRequestApproveInput;
};


export type MutationConsignmentStockInRequestCancelArgs = {
  input: ConsignmentStockInRequestCancelInput;
};


export type MutationConsignmentStockInRequestCreateArgs = {
  input: ConsignmentStockInRequestCreateInput;
};


export type MutationConsignmentStockInRequestRejectArgs = {
  input: ConsignmentStockInRequestRejectInput;
};


export type MutationConsignmentStockInRequestSubmitArgs = {
  input: ConsignmentStockInRequestSubmitInput;
};


export type MutationConsignmentStockInRequestUpdateArgs = {
  input: ConsignmentStockInRequestUpdateInput;
};


export type MutationConsignmentStockInUpdateArgs = {
  input: ConsignmentStockInUpdateInput;
};


export type MutationConsignmentStockOutCancelArgs = {
  consignmentStockOutID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockOutConfirmArgs = {
  consignmentStockOutID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockOutCreateArgs = {
  input: ConsignmentStockOutCreateInput;
};


export type MutationConsignmentStockOutUpdateArgs = {
  input: ConsignmentStockOutUpdateInput;
};


export type MutationCostAdjustmentImportArgs = {
  input: CostAdjustmentImportInput;
};


export type MutationCostAdjustmentImportValidateCodesArgs = {
  input: CostAdjustmentImportValidateCodesInput;
};


export type MutationCountryCreateArgs = {
  input: CountryCreateInput;
};


export type MutationCountryDeleteArgs = {
  countryID: Scalars['String']['input'];
};


export type MutationCountryUpdateArgs = {
  input: CountryUpdateInput;
};


export type MutationCreateErpProductArgs = {
  input: CreateErpProductInput;
};


export type MutationCreateManualConsignmentProformaArgs = {
  input: CreateManualConsignmentProformaInput;
};


export type MutationCustomerAddressCreateArgs = {
  input: CustomerAddressCreateInput;
};


export type MutationCustomerAddressDeleteArgs = {
  input: CustomerAddressDeleteInput;
};


export type MutationCustomerAddressUpdateArgs = {
  input: CustomerAddressUpdateInput;
};


export type MutationCustomerCreateArgs = {
  input: CustomerCreateInput;
};


export type MutationCustomerCreateFromPosArgs = {
  input: CustomerCreateFromPosInput;
};


export type MutationCustomerDeleteArgs = {
  customerID: Scalars['UUID']['input'];
};


export type MutationCustomerImportArgs = {
  input: Array<CustomerImportInput>;
};


export type MutationCustomerSetDefaultArgs = {
  input: CustomerSetDefaultInput;
};


export type MutationCustomerUpdateArgs = {
  input: CustomerUpdateInput;
};


export type MutationCustomerVoucherTransactionBackfillArgs = {
  input: CustomerVoucherTransactionBackfillInput;
};


export type MutationDeliveryOrderBatchAddLeftoverContainersArgs = {
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type MutationDeliveryOrderBatchCancelArgs = {
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type MutationDeliveryOrderBatchCreateArgs = {
  input: DeliveryOrderBatchCreateInput;
};


export type MutationDeliveryOrderBatchDetachSourceDocumentArgs = {
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
};


export type MutationDeliveryOrderBatchGenerateArgs = {
  input: DeliveryOrderBatchGenerateInput;
};


export type MutationDeliveryOrderBatchGenerateAndShipArgs = {
  input: DeliveryOrderBatchGenerateInput;
};


export type MutationDeliveryOrderBatchRegenerateFailedArgs = {
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type MutationDeliveryOrderBatchRemoveContainerArgs = {
  deliveryOrderBatchContainerID: Scalars['UUID']['input'];
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type MutationDeliveryOrderBatchScanArgs = {
  input: DeliveryOrderBatchScanInput;
};


export type MutationDeliveryOrderCancelArgs = {
  input: DeliveryOrderCancelInput;
};


export type MutationDeliveryOrderCheckGenerateBulkArgs = {
  input: DeliveryOrderGenerateBulkInput;
};


export type MutationDeliveryOrderContainerRemoveArgs = {
  input: DeliveryOrderContainerRemoveInput;
};


export type MutationDeliveryOrderCreateArgs = {
  input: DeliveryOrderCreateInput;
};


export type MutationDeliveryOrderGenerateBulkArgs = {
  input: DeliveryOrderGenerateBulkInput;
};


export type MutationDeliveryOrderShippedArgs = {
  input: DeliveryOrderShippedInput;
};


export type MutationDeliveryOrderUpdateArgs = {
  input: DeliveryOrderUpdateInput;
};


export type MutationEdcTerminalCreateArgs = {
  input: EdcTerminalCreateInput;
};


export type MutationEdcTerminalDeleteArgs = {
  edcTerminalID: Scalars['UUID']['input'];
};


export type MutationEdcTerminalUpdateArgs = {
  input: EdcTerminalUpdateInput;
};


export type MutationEditConsignmentSettlementArgs = {
  input: EditConsignmentSettlementInput;
};


export type MutationEmployeeCreateArgs = {
  input: EmployeeCreateInput;
};


export type MutationEmployeeDeleteArgs = {
  employeeID: Scalars['UUID']['input'];
};


export type MutationEmployeeUpdateArgs = {
  input: EmployeeUpdateInput;
};


export type MutationErpSyncMasterdataByIdsArgs = {
  entityType: MasterdataSyncEntityType;
  ids: Array<Scalars['String']['input']>;
};


export type MutationErpSyncTransactionByIdsArgs = {
  entityType: TransactionSyncEntityType;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  salesInvoices?: InputMaybe<Array<SalesInvoiceBranchDateInput>>;
};


export type MutationExpenseItemCreateArgs = {
  input: ExpenseItemCreateInput;
};


export type MutationExpenseItemDeleteArgs = {
  expenseItemID: Scalars['UUID']['input'];
};


export type MutationExpenseItemUpdateArgs = {
  input: ExpenseItemUpdateInput;
};


export type MutationFileCreateFromStorageObjectArgs = {
  input: FileCreateFromStorageObjectInput;
};


export type MutationGenerateConsignmentInvoiceArgs = {
  input: GenerateConsignmentInvoiceInput;
};


export type MutationGenerateConsignmentInvoicesBulkArgs = {
  payoutBanks?: InputMaybe<Array<ConsignmentPayoutBankInput>>;
  vendorConsignmentInvoiceIDs: Array<Scalars['UUID']['input']>;
};


export type MutationGenerateLinkResetPasswordArgs = {
  input: GenerateLinkResetPasswordInput;
};


export type MutationGenerateOtpCodeArgs = {
  input: GenerateOtpCodeInput;
};


export type MutationGenerateTransferRequestFromReplenishmentArgs = {
  input: GenerateTransferRequestFromReplenishmentInput;
};


export type MutationInternalTransferCancelArgs = {
  input: InternalTransferCancelInput;
};


export type MutationInternalTransferConfirmArgs = {
  input: InternalTransferConfirmInput;
};


export type MutationInternalTransferCreateArgs = {
  input: InternalTransferCreateInput;
};


export type MutationInternalTransferUpdateArgs = {
  input: InternalTransferUpdateInput;
};


export type MutationInventoryAdjustmentCancelArgs = {
  input: InventoryAdjustmentCancelInput;
};


export type MutationInventoryAdjustmentConfirmArgs = {
  input: InventoryAdjustmentConfirmInput;
};


export type MutationInventoryAdjustmentCreateArgs = {
  input: InventoryAdjustmentCreateInput;
};


export type MutationInventoryAdjustmentCreateOpeningBalanceArgs = {
  input: InventoryAdjustmentCreateOpeningBalanceInput;
};


export type MutationInventoryAdjustmentCreateSystemArgs = {
  input: InventoryAdjustmentCreateSystemInput;
};


export type MutationInventoryAdjustmentDeleteArgs = {
  inventoryAdjustmentID: Scalars['UUID']['input'];
};


export type MutationInventoryAdjustmentOpeningBalanceImportArgs = {
  input: InventoryAdjustmentOpeningBalanceImportInput;
};


export type MutationInventoryAdjustmentOpeningBalanceImportValidateCodesArgs = {
  input: InventoryAdjustmentOpeningBalanceImportValidateCodesInput;
};


export type MutationInventoryAdjustmentRetryFromBackgroundJobArgs = {
  backgroundJobID: Scalars['UUID']['input'];
};


export type MutationInventoryAdjustmentUpdateArgs = {
  input: InventoryAdjustmentUpdateInput;
};


export type MutationInventoryCountItemTemplateCreateArgs = {
  input: InventoryCountItemTemplateCreateInput;
};


export type MutationInventoryCountItemTemplateDeleteArgs = {
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
};


export type MutationInventoryCountItemTemplateItemCreateArgs = {
  input: InventoryCountItemTemplateItemCreateInput;
};


export type MutationInventoryCountItemTemplateItemDeleteArgs = {
  inventoryCountItemTemplateItemID: Scalars['UUID']['input'];
};


export type MutationInventoryCountItemTemplateItemImportArgs = {
  input: InventoryCountItemTemplateItemImportInput;
};


export type MutationInventoryCountItemTemplateItemImportValidateArgs = {
  input: InventoryCountItemTemplateItemImportValidateInput;
};


export type MutationInventoryCountItemTemplateUpdateArgs = {
  input: InventoryCountItemTemplateUpdateInput;
};


export type MutationInventoryCountTaskAssignedFinishArgs = {
  input: InventoryCountTaskAssignedFinishInput;
};


export type MutationInventoryCountTaskAssigneeAddArgs = {
  input: InventoryCountTaskAssigneeAddInput;
};


export type MutationInventoryCountTaskAssigneeDeleteArgs = {
  input: InventoryCountTaskAssigneeDeleteInput;
};


export type MutationInventoryCountTaskCancelArgs = {
  input: InventoryCountTaskCancelInput;
};


export type MutationInventoryCountTaskExecuteImportArgs = {
  input: InventoryCountTaskExecuteImportInput;
};


export type MutationInventoryCountTaskExecutionDetailDeleteArgs = {
  input: InventoryCountTaskExecutionDetailDeleteInput;
};


export type MutationInventoryCountTaskExportImportTemplateArgs = {
  input: InventoryCountTaskExportInput;
};


export type MutationInventoryCountTaskExportRecountItemsArgs = {
  input: InventoryCountTaskExportInput;
};


export type MutationInventoryCountTaskFinishArgs = {
  input: InventoryCountTaskFinishInput;
};


export type MutationInventoryCountTaskItemExecuteArgs = {
  input: InventoryCountTaskItemExecuteInput;
};


export type MutationInventoryCountTaskItemResetExecutedArgs = {
  input: InventoryCountTaskItemResetExecutedInput;
};


export type MutationInventoryCountTaskRecountCreateArgs = {
  input: InventoryCountTaskRecountCreateInput;
};


export type MutationInventoryCountTaskStartArgs = {
  input: InventoryCountTaskStartInput;
};


export type MutationInventoryCountTaskUpdateArgs = {
  input: InventoryCountTaskUpdateInput;
};


export type MutationInventoryCountTransactionCancelArgs = {
  input: InventoryCountTransactionCancelInput;
};


export type MutationInventoryCountTransactionCreateArgs = {
  input: InventoryCountTransactionCreateInput;
};


export type MutationInventoryCountTransactionExportResultsArgs = {
  input: InventoryCountTransactionExportInput;
};


export type MutationInventoryCountTransactionExportResultsByLocationArgs = {
  input: InventoryCountTransactionExportInput;
};


export type MutationInventoryCountTransactionFinishArgs = {
  input: InventoryCountTransactionFinishInput;
};


export type MutationInventoryCountTransactionUpdateArgs = {
  input: InventoryCountTransactionUpdateInput;
};


export type MutationLockConsignmentDraftToProformaArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type MutationMarkConsignmentInvoicePaidArgs = {
  input: VendorConsignmentInvoicePayInput;
};


export type MutationMarkConsignmentInvoicesPaidBulkArgs = {
  input: MarkConsignmentInvoicesPaidBulkInput;
};


export type MutationMarketplaceCampaignAddItemArgs = {
  externalItemID: Scalars['String']['input'];
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignCreateArgs = {
  input: MarketplaceCampaignCreateInput;
};


export type MutationMarketplaceCampaignDeleteArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignDuplicateArgs = {
  endAtUtc?: InputMaybe<Scalars['Time']['input']>;
  marketplaceCampaignID: Scalars['UUID']['input'];
  startAtUtc?: InputMaybe<Scalars['Time']['input']>;
};


export type MutationMarketplaceCampaignExtendArgs = {
  input: MarketplaceCampaignExtendInput;
};


export type MutationMarketplaceCampaignImportProductsArgs = {
  input: MarketplaceCampaignImportProductsInput;
};


export type MutationMarketplaceCampaignPublishFromPromoArgs = {
  input: MarketplaceCampaignPublishFromPromoInput;
};


export type MutationMarketplaceCampaignPushArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignRemoveItemArgs = {
  externalItemID: Scalars['String']['input'];
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignResumeArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignStopArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignSyncArgs = {
  input?: InputMaybe<MarketplaceCampaignSyncInput>;
};


export type MutationMarketplaceCampaignUpdateArgs = {
  input: MarketplaceCampaignUpdateInput;
};


export type MutationMarketplaceCronRunArgs = {
  jobKey: Scalars['String']['input'];
};


export type MutationMarketplaceCronSettingUpdateArgs = {
  input: MarketplaceCronSettingUpdateInput;
};


export type MutationMarketplaceMenuSyncArgs = {
  input: MarketplaceMenuSyncInput;
};


export type MutationMarketplaceOrderCancelArgs = {
  input: MarketplaceOrderCancelInput;
};


export type MutationMarketplaceOrderEditArgs = {
  input: MarketplaceOrderEditInput;
};


export type MutationMarketplaceOrderMarkReadyArgs = {
  input: MarketplaceOrderMarkReadyInput;
};


export type MutationMarketplaceOrderReconcilePaymentArgs = {
  input: MarketplaceOrderReconcilePaymentInput;
};


export type MutationMarketplaceOrderSyncPosArgs = {
  input: MarketplaceOrderSyncPosInput;
};


export type MutationMarketplaceStorePauseArgs = {
  input: MarketplaceStorePauseInput;
};


export type MutationMemberTypeCreateArgs = {
  input: MemberTypeCreateInput;
};


export type MutationMemberTypeDeleteArgs = {
  memberTypeID: Scalars['UUID']['input'];
};


export type MutationMemberTypeUpdateArgs = {
  input: MemberTypeUpdateInput;
};


export type MutationMoveConsignmentItemsArgs = {
  input: MoveConsignmentItemsInput;
};


export type MutationOutboundContainerBulkGenerationArgs = {
  input: BulkContainerGenerationInput;
};


export type MutationOutboundContainerCreateArgs = {
  input: OutboundContainerCreateInput;
};


export type MutationOutboundContainerDeleteArgs = {
  input: RemoveContainerInput;
};


export type MutationOutboundContainerOpenSealArgs = {
  input: OpenSealContainerInput;
};


export type MutationOutboundContainerPackItemArgs = {
  input: OutboundContainerPackItemInput;
};


export type MutationOutboundContainerUnpackItemArgs = {
  input: OutboundContainerUnpackItemInput;
};


export type MutationOutboundContainerUpdatePackItemArgs = {
  input: OutboundContainerUpdatePackItemInput;
};


export type MutationPackingTaskCancelArgs = {
  input: PackingTaskCancelInput;
};


export type MutationPackingTaskFinishArgs = {
  input: PackingTaskFinishInput;
};


export type MutationPackingTaskStartArgs = {
  input: PackingTaskStartInput;
};


export type MutationPackingTaskVerifyArgs = {
  input: PackingTaskVerifyInput;
};


export type MutationPaymentProviderConfigUpdateArgs = {
  input: PaymentProviderConfigUpdateInput;
};


export type MutationPaymentTransactionCancelArgs = {
  input: PaymentTransactionCancelInput;
};


export type MutationPaymentTransactionCheckStatusArgs = {
  paymentTransactionID: Scalars['UUID']['input'];
};


export type MutationPaymentTransactionCreateDynamicQrisArgs = {
  input: PaymentTransactionCreateDynamicQrisInput;
};


export type MutationPermissionCreateArgs = {
  input: PermissionCreateInput;
};


export type MutationPermissionDeleteArgs = {
  permissionID: Scalars['String']['input'];
};


export type MutationPermissionUpdateArgs = {
  input: PermissionUpdateInput;
};


export type MutationPettyCashAddFundTransactionCancelArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashAddFundTransactionConfirmArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashAddFundTransactionCreateArgs = {
  input: PettyCashAddFundTransactionCreateInput;
};


export type MutationPettyCashAddFundTransactionDeleteArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashAddFundTransactionUpdateArgs = {
  input: PettyCashAddFundTransactionUpdateInput;
};


export type MutationPettyCashExpenseTransactionCancelArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashExpenseTransactionConfirmArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashExpenseTransactionCreateArgs = {
  input: PettyCashExpenseTransactionCreateInput;
};


export type MutationPettyCashExpenseTransactionDeleteArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashExpenseTransactionUpdateArgs = {
  input: PettyCashExpenseTransactionUpdateInput;
};


export type MutationPettyCashRefundTransactionCancelArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashRefundTransactionConfirmArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashRefundTransactionCreateArgs = {
  input: PettyCashRefundTransactionCreateInput;
};


export type MutationPettyCashRefundTransactionDeleteArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashRefundTransactionUpdateArgs = {
  input: PettyCashRefundTransactionUpdateInput;
};


export type MutationPickingTaskAcceptAndStartArgs = {
  input: PickingTaskStartInput;
};


export type MutationPickingTaskAssignArgs = {
  input: PickingTaskAssignInput;
};


export type MutationPickingTaskCancelArgs = {
  input: PickingTaskCancelInput;
};


export type MutationPickingTaskExecuteArgs = {
  input: PickingTaskExecuteInput;
};


export type MutationPickingTaskFinishArgs = {
  input: PickingTaskFinishInput;
};


export type MutationPickingTaskGenerateArgs = {
  input: PickingTaskGenerateInput;
};


export type MutationPickingTaskGenerateBulkArgs = {
  input: PickingTaskGenerateBulkInput;
};


export type MutationPickingTaskStartArgs = {
  input: PickingTaskStartInput;
};


export type MutationPickingTaskUpdateUnfulfilledReasonsArgs = {
  input: PickingTaskUpdateUnfulfilledReasonsInput;
};


export type MutationPosBookmarkCreateArgs = {
  input: PosBookmarkCreateInput;
};


export type MutationPosBookmarkDeleteArgs = {
  posBookmarkID: Scalars['UUID']['input'];
};


export type MutationPosBookmarkProductCreateArgs = {
  input: PosBookmarkProductCreateInput;
};


export type MutationPosBookmarkProductDeleteArgs = {
  posBookmarkProductID: Scalars['UUID']['input'];
};


export type MutationPosBookmarkProductUpdateArgs = {
  input: PosBookmarkProductUpdateInput;
};


export type MutationPosBookmarkUpdateArgs = {
  input: PosBookmarkUpdateInput;
};


export type MutationPosSalesOrderCreateArgs = {
  input: PosSalesOrderCreateInput;
};


export type MutationPosSalesOrderUpdateArgs = {
  input: PosSalesOrderUpdateInput;
};


export type MutationPosterCreateArgs = {
  input: PosterCreateInput;
};


export type MutationPosterDeleteArgs = {
  posterID: Scalars['UUID']['input'];
};


export type MutationPosterUpdateArgs = {
  input: PosterUpdateInput;
};


export type MutationPricelistCreateArgs = {
  input: PricelistCreateInput;
};


export type MutationPricelistDeleteArgs = {
  input: PricelistDeleteInput;
};


export type MutationPricelistPeriodCreateArgs = {
  input: PricelistPeriodCreateInput;
};


export type MutationPricelistPeriodDeleteArgs = {
  pricelistPeriodID: Scalars['UUID']['input'];
};


export type MutationPricelistPeriodUpdateArgs = {
  input: PricelistPeriodUpdateInput;
};


export type MutationPricelistProductBulkCreateArgs = {
  input: PricelistProductBulkCreateInput;
};


export type MutationPricelistProductCreateArgs = {
  input: PricelistProductCreateInput;
};


export type MutationPricelistProductDeleteArgs = {
  input: PricelistProductDeleteInput;
};


export type MutationPricelistProductImportArgs = {
  input: PricelistProductImportInput;
};


export type MutationPricelistProductImportValidateArgs = {
  input: PricelistProductImportValidateInput;
};


export type MutationPricelistProductSalesChannelCreateArgs = {
  input: PricelistProductSalesChannelCreateInput;
};


export type MutationPricelistProductSalesChannelDeleteArgs = {
  pricelistProductSalesChannelID: Scalars['UUID']['input'];
};


export type MutationPricelistProductSalesChannelUpdateArgs = {
  input: PricelistProductSalesChannelUpdateInput;
};


export type MutationPricelistProductSalesChannelUpsertArgs = {
  input: PricelistProductSalesChannelUpsertInput;
};


export type MutationPricelistProductUpdateArgs = {
  input: PricelistProductUpdateInput;
};


export type MutationPricelistSalesChannelDeleteArgs = {
  pricelistSalesChannelID: Scalars['UUID']['input'];
};


export type MutationPricelistSalesChannelUpsertArgs = {
  input: PricelistSalesChannelUpsertInput;
};


export type MutationPricelistUpdateArgs = {
  input: PricelistUpdateInput;
};


export type MutationProductAiImageCreateArgs = {
  input: ProductAiImageCreateInput;
};


export type MutationProductAiImageDeleteArgs = {
  productAIImageID: Scalars['UUID']['input'];
};


export type MutationProductAiImageUpdateArgs = {
  input: ProductAiImageUpdateInput;
};


export type MutationProductAccountingCategoryCreateArgs = {
  input: ProductAccountingCategoryCreateInput;
};


export type MutationProductAccountingCategoryDeleteArgs = {
  productAccountingCategoryID: Scalars['UUID']['input'];
};


export type MutationProductAccountingCategoryUpdateArgs = {
  input: ProductAccountingCategoryUpdateInput;
};


export type MutationProductAddonComponentCreateArgs = {
  input: ProductAddonComponentCreateInput;
};


export type MutationProductAddonComponentDeleteArgs = {
  productAddonComponentID: Scalars['UUID']['input'];
};


export type MutationProductAddonComponentUpdateArgs = {
  input: ProductAddonComponentUpdateInput;
};


export type MutationProductAddonCreateArgs = {
  input: ProductAddonCreateInput;
};


export type MutationProductAddonDeleteArgs = {
  productAddonID: Scalars['UUID']['input'];
};


export type MutationProductAddonGroupCreateArgs = {
  input: ProductAddonGroupCreateInput;
};


export type MutationProductAddonGroupDeleteArgs = {
  productAddonGroupID: Scalars['UUID']['input'];
};


export type MutationProductAddonGroupItemCreateArgs = {
  input: ProductAddonGroupItemCreateInput;
};


export type MutationProductAddonGroupItemDeleteArgs = {
  productAddonGroupItemID: Scalars['UUID']['input'];
};


export type MutationProductAddonGroupItemUpdateArgs = {
  input: ProductAddonGroupItemUpdateInput;
};


export type MutationProductAddonGroupUpdateArgs = {
  input: ProductAddonGroupUpdateInput;
};


export type MutationProductAddonUpdateArgs = {
  input: ProductAddonUpdateInput;
};


export type MutationProductAvailabilityTemplateCreateArgs = {
  input: ProductAvailabilityTemplateCreateInput;
};


export type MutationProductAvailabilityTemplateDeleteArgs = {
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};


export type MutationProductAvailabilityTemplateItemCreateArgs = {
  input: ProductAvailabilityTemplateItemCreateInput;
};


export type MutationProductAvailabilityTemplateItemDeleteArgs = {
  productAvailabilityTemplateItemID: Scalars['UUID']['input'];
};


export type MutationProductAvailabilityTemplateItemExportArgs = {
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};


export type MutationProductAvailabilityTemplateItemImportArgs = {
  input: ProductAvailabilityTemplateItemImportInput;
};


export type MutationProductAvailabilityTemplateItemImportValidateArgs = {
  input: ProductAvailabilityTemplateItemImportValidateInput;
};


export type MutationProductAvailabilityTemplateItemSetChannelsArgs = {
  input: ProductAvailabilityTemplateItemSetChannelsInput;
};


export type MutationProductAvailabilityTemplateItemUpdateArgs = {
  input: ProductAvailabilityTemplateItemUpdateInput;
};


export type MutationProductAvailabilityTemplateUpdateArgs = {
  input: ProductAvailabilityTemplateUpdateInput;
};


export type MutationProductBarcodeMapCreateArgs = {
  input: ProductBarcodeMapCreateInput;
};


export type MutationProductBarcodeMapDeleteArgs = {
  productBarcodeMapID: Scalars['UUID']['input'];
};


export type MutationProductBarcodeMapUpdateArgs = {
  input: ProductBarcodeMapUpdateInput;
};


export type MutationProductBookmarkCreateArgs = {
  input: ProductBookmarkCreateInput;
};


export type MutationProductBookmarkDeleteArgs = {
  productBookmarkID: Scalars['UUID']['input'];
};


export type MutationProductBookmarkProductCreateArgs = {
  input: ProductBookmarkProductCreateInput;
};


export type MutationProductBookmarkProductDeleteArgs = {
  productBookmarkProductID: Scalars['UUID']['input'];
};


export type MutationProductBookmarkProductUpdateArgs = {
  input: ProductBookmarkProductUpdateInput;
};


export type MutationProductBookmarkUpdateArgs = {
  input: ProductBookmarkUpdateInput;
};


export type MutationProductBrandCreateArgs = {
  input: ProductBrandCreateInput;
};


export type MutationProductBrandDeleteArgs = {
  productBrandID: Scalars['UUID']['input'];
};


export type MutationProductBrandUpdateArgs = {
  input: ProductBrandUpdateInput;
};


export type MutationProductBundleComponentCreateArgs = {
  input: ProductBundleComponentCreateInput;
};


export type MutationProductBundleComponentDeleteArgs = {
  productBundleComponentID: Scalars['UUID']['input'];
};


export type MutationProductBundleComponentUpdateArgs = {
  input: ProductBundleComponentUpdateInput;
};


export type MutationProductCategoryCreateArgs = {
  input: ProductCategoryCreateInput;
};


export type MutationProductCategoryDeleteArgs = {
  productCategoryID: Scalars['UUID']['input'];
};


export type MutationProductCategorySalesChannelMapCreateArgs = {
  input: ProductCategorySalesChannelMapCreateInput;
};


export type MutationProductCategorySalesChannelMapDeleteArgs = {
  productCategorySalesChannelMapID: Scalars['UUID']['input'];
};


export type MutationProductCategorySalesChannelMapExportArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type MutationProductCategorySalesChannelMapImportArgs = {
  input: ProductCategorySalesChannelMapImportInput;
};


export type MutationProductCategorySalesChannelMapImportValidateArgs = {
  input: ProductCategorySalesChannelMapImportValidateInput;
};


export type MutationProductCategorySalesChannelMapUpdateArgs = {
  input: ProductCategorySalesChannelMapUpdateInput;
};


export type MutationProductCategoryUpdateArgs = {
  input: ProductCategoryUpdateInput;
};


export type MutationProductConsignmentImportArgs = {
  input: ProductImportInput;
};


export type MutationProductConsignmentImportValidateArgs = {
  input: ProductImportInput;
};


export type MutationProductCreateArgs = {
  input: ProductCreateInput;
};


export type MutationProductDeleteArgs = {
  productID: Scalars['UUID']['input'];
};


export type MutationProductDepartmentCreateArgs = {
  input: ProductDepartmentCreateInput;
};


export type MutationProductDepartmentDeleteArgs = {
  productDepartmentID: Scalars['UUID']['input'];
};


export type MutationProductDepartmentUpdateArgs = {
  input: ProductDepartmentUpdateInput;
};


export type MutationProductDivisionCreateArgs = {
  input: ProductDivisionCreateInput;
};


export type MutationProductDivisionDeleteArgs = {
  productDivisionID: Scalars['UUID']['input'];
};


export type MutationProductDivisionUpdateArgs = {
  input: ProductDivisionUpdateInput;
};


export type MutationProductFileCreateArgs = {
  input: ProductFileCreateInput;
};


export type MutationProductFileDeleteArgs = {
  productFileID: Scalars['UUID']['input'];
};


export type MutationProductFileUpdateArgs = {
  input: ProductFileUpdateInput;
};


export type MutationProductNonConsignmentImportArgs = {
  input: ProductImportInput;
};


export type MutationProductNonConsignmentImportValidateArgs = {
  input: ProductImportInput;
};


export type MutationProductSalesChannelItemMapCreateArgs = {
  input: ProductSalesChannelItemMapCreateInput;
};


export type MutationProductSalesChannelItemMapDeleteArgs = {
  productSalesChannelItemMapID: Scalars['UUID']['input'];
};


export type MutationProductSalesChannelItemMapUpdateArgs = {
  input: ProductSalesChannelItemMapUpdateInput;
};


export type MutationProductSourceCreateArgs = {
  input: ProductSourceCreateInput;
};


export type MutationProductSourceDeleteArgs = {
  productSourceID: Scalars['UUID']['input'];
};


export type MutationProductSourceUpdateArgs = {
  input: ProductSourceUpdateInput;
};


export type MutationProductSubCategoryCreateArgs = {
  input: ProductSubCategoryCreateInput;
};


export type MutationProductSubCategoryDeleteArgs = {
  productSubCategoryID: Scalars['UUID']['input'];
};


export type MutationProductSubCategoryUpdateArgs = {
  input: ProductSubCategoryUpdateInput;
};


export type MutationProductSubDepartmentCreateArgs = {
  input: ProductSubDepartmentCreateInput;
};


export type MutationProductSubDepartmentDeleteArgs = {
  productSubDepartmentID: Scalars['UUID']['input'];
};


export type MutationProductSubDepartmentUpdateArgs = {
  input: ProductSubDepartmentUpdateInput;
};


export type MutationProductTagCreateArgs = {
  input: ProductTagCreateInput;
};


export type MutationProductTagDeleteArgs = {
  productTagID: Scalars['UUID']['input'];
};


export type MutationProductTagProductCreateArgs = {
  input: ProductTagProductCreateInput;
};


export type MutationProductTagProductDeleteArgs = {
  productTagProductID: Scalars['UUID']['input'];
};


export type MutationProductTagProductUpdateArgs = {
  input: ProductTagProductUpdateInput;
};


export type MutationProductTagUpdateArgs = {
  input: ProductTagUpdateInput;
};


export type MutationProductUpdateArgs = {
  input: ProductUpdateInput;
};


export type MutationProductVendorCreateArgs = {
  input: ProductVendorCreateInput;
};


export type MutationProductVendorDeleteArgs = {
  productVendorID: Scalars['UUID']['input'];
};


export type MutationProductVendorUpdateArgs = {
  input: ProductVendorUpdateInput;
};


export type MutationProductionOrderCancelArgs = {
  productionOrderID: Scalars['UUID']['input'];
};


export type MutationProductionOrderConfirmArgs = {
  productionOrderID: Scalars['UUID']['input'];
};


export type MutationProductionOrderCreateArgs = {
  input: ProductionOrderCreateInput;
};


export type MutationProductionOrderUpdateArgs = {
  input: ProductionOrderUpdateInput;
};


export type MutationPromoComponentImportValidateArgs = {
  input: PromoComponentImportValidateInput;
};


export type MutationPromoCreateArgs = {
  input: PromoBulkCreateInput;
};


export type MutationPromoDeleteArgs = {
  promoID: Scalars['UUID']['input'];
};


export type MutationPromoQuotaCreateArgs = {
  input: PromoQuotaCreateInput;
};


export type MutationPromoQuotaDeleteArgs = {
  promoQuotaID: Scalars['UUID']['input'];
};


export type MutationPromoQuotaIncrementUsageArgs = {
  input: PromoQuotaIncrementUsageInput;
};


export type MutationPromoQuotaResetUsageArgs = {
  input: PromoQuotaResetUsageInput;
};


export type MutationPromoQuotaUpdateArgs = {
  input: PromoQuotaUpdateInput;
};


export type MutationPromoTypeCreateArgs = {
  input: PromoTypeCreateInput;
};


export type MutationPromoTypeDeleteArgs = {
  promoTypeID: Scalars['UUID']['input'];
};


export type MutationPromoTypeUpdateArgs = {
  input: PromoTypeUpdateInput;
};


export type MutationPromoUpdateArgs = {
  input: PromoBulkUpdateInput;
};


export type MutationProvinceCreateArgs = {
  input: ProvinceCreateInput;
};


export type MutationProvinceDeleteArgs = {
  provinceID: Scalars['String']['input'];
};


export type MutationProvinceUpdateArgs = {
  input: ProvinceUpdateInput;
};


export type MutationPurchaseAreaCreateArgs = {
  input: PurchaseAreaCreateInput;
};


export type MutationPurchaseAreaDeleteArgs = {
  purchaseAreaID: Scalars['UUID']['input'];
};


export type MutationPurchaseAreaUpdateArgs = {
  input: PurchaseAreaUpdateInput;
};


export type MutationPurchaseOrderBackfillTotalsArgs = {
  input: PurchaseOrderBackfillTotalsInput;
};


export type MutationPurchaseOrderCancelArgs = {
  purchaseOrderID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderCloseArgs = {
  input: PurchaseOrderCloseInput;
};


export type MutationPurchaseOrderConfirmArgs = {
  purchaseOrderID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderCreateArgs = {
  input: PurchaseOrderCreateInput;
};


export type MutationPurchaseOrderForceCloseArgs = {
  input: PurchaseOrderForceCloseInput;
};


export type MutationPurchaseOrderImportArgs = {
  input: PurchaseOrderImportInput;
};


export type MutationPurchaseOrderImportValidateCodesArgs = {
  input: PurchaseOrderImportValidateCodesInput;
};


export type MutationPurchaseOrderReceivingCancelArgs = {
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderReceivingConfirmArgs = {
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderReceivingCreateArgs = {
  input: PurchaseOrderReceivingCreateInput;
};


export type MutationPurchaseOrderReceivingUpdateArgs = {
  input: PurchaseOrderReceivingUpdateInput;
};


export type MutationPurchaseOrderReviseArgs = {
  input: PurchaseOrderReviseInput;
};


export type MutationPurchaseOrderSendEmailArgs = {
  purchaseOrderID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderUpdateArgs = {
  input: PurchaseOrderUpdateInput;
};


export type MutationPutawayTaskAcceptAndStartArgs = {
  input: AcceptAndStartTaskInput;
};


export type MutationPutawayTaskAssignArgs = {
  input: AssignTaskInput;
};


export type MutationPutawayTaskBatchExecutionsArgs = {
  input: BatchExecutionInput;
};


export type MutationPutawayTaskCancelArgs = {
  input: CancelTaskInput;
};


export type MutationPutawayTaskFinishArgs = {
  input: FinishTaskInput;
};


export type MutationPutawayTaskGenerateMultipleArgs = {
  input: GenerateMultipleTasksInput;
};


export type MutationPutawayTaskGenerateSingleArgs = {
  input: GenerateSingleTaskInput;
};


export type MutationPutawayTaskRecordExecutionArgs = {
  input: RecordExecutionInput;
};


export type MutationPutawayTaskScanLocationArgs = {
  input: ScanLocationInput;
};


export type MutationPutawayTaskScanProductArgs = {
  input: ScanProductInput;
};


export type MutationPutawayTaskStartArgs = {
  input: StartTaskInput;
};


export type MutationPutawayTaskUpdateArgs = {
  input: PutawayTaskUpdateInput;
};


export type MutationReasonCreateArgs = {
  input: ReasonCreateInput;
};


export type MutationReasonDeleteArgs = {
  reasonID: Scalars['UUID']['input'];
};


export type MutationReasonInventoryAdjustmentCreateArgs = {
  input: ReasonInventoryAdjustmentCreateInput;
};


export type MutationReasonInventoryAdjustmentDeleteArgs = {
  reasonInventoryAdjustmentID: Scalars['UUID']['input'];
};


export type MutationReasonInventoryAdjustmentUpdateArgs = {
  input: ReasonInventoryAdjustmentUpdateInput;
};


export type MutationReasonUpdateArgs = {
  input: ReasonUpdateInput;
};


export type MutationRecalculateConsignmentProformaArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type MutationReplenishmentCreateArgs = {
  input: ReplenishmentCreateInput;
};


export type MutationReplenishmentTemplateCategoryCreateArgs = {
  input: ReplenishmentTemplateCategoryCreateInput;
};


export type MutationReplenishmentTemplateCategoryDeleteArgs = {
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
};


export type MutationReplenishmentTemplateCategoryUpdateArgs = {
  input: ReplenishmentTemplateCategoryUpdateInput;
};


export type MutationReplenishmentTemplateCreateArgs = {
  input: ReplenishmentTemplateCreateInput;
};


export type MutationReplenishmentTemplateDeleteArgs = {
  replenishmentTemplateID: Scalars['UUID']['input'];
};


export type MutationReplenishmentTemplateItemCreateArgs = {
  input: ReplenishmentTemplateItemCreateInput;
  replenishmentTemplateID: Scalars['UUID']['input'];
};


export type MutationReplenishmentTemplateItemDeleteArgs = {
  replenishmentTemplateItemID: Scalars['UUID']['input'];
};


export type MutationReplenishmentTemplateItemImportArgs = {
  input: ReplenishmentTemplateItemImportInput;
};


export type MutationReplenishmentTemplateItemImportValidateArgs = {
  input: ReplenishmentTemplateItemImportValidateInput;
};


export type MutationReplenishmentTemplateItemUpdateArgs = {
  input: ReplenishmentTemplateItemUpdateInput;
};


export type MutationReplenishmentTemplateUpdateArgs = {
  input: ReplenishmentTemplateUpdateInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResourceCreateArgs = {
  input: ResourceCreateInput;
};


export type MutationResourceDeleteArgs = {
  resourceID: Scalars['String']['input'];
};


export type MutationResourceUpdateArgs = {
  input: ResourceUpdateInput;
};


export type MutationRevenueReportAccessLogExportArgs = {
  input: RevenueReportAccessLogExportInput;
};


export type MutationRevenueReportApiKeyIssueArgs = {
  input: RevenueReportApiKeyIssueInput;
};


export type MutationRevenueReportApiKeyRevokeArgs = {
  revenueReportApiKeyID: Scalars['UUID']['input'];
};


export type MutationRevenueReportDetailCorrectArgs = {
  input: RevenueReportDetailCorrectInput;
};


export type MutationRevenueReportDetailExportArgs = {
  input: RevenueReportDetailExportInput;
};


export type MutationRevenueReportDetailVoidArgs = {
  input: RevenueReportDetailVoidInput;
};


export type MutationRevenueReportExportArgs = {
  input: RevenueReportExportInput;
};


export type MutationRevenueReportGenerateArgs = {
  input: RevenueReportGenerateInput;
};


export type MutationRevenueReportPartnerActivateArgs = {
  revenueReportPartnerID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerBranchActivateArgs = {
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerBranchCreateArgs = {
  input: RevenueReportPartnerBranchCreateInput;
};


export type MutationRevenueReportPartnerBranchCredentialClearArgs = {
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerBranchCredentialSetArgs = {
  input: RevenueReportPartnerBranchCredentialSetInput;
};


export type MutationRevenueReportPartnerBranchDeactivateArgs = {
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerBranchUpdateArgs = {
  input: RevenueReportPartnerBranchUpdateInput;
};


export type MutationRevenueReportPartnerCreateArgs = {
  input: RevenueReportPartnerCreateInput;
};


export type MutationRevenueReportPartnerCredentialSetArgs = {
  input: RevenueReportPartnerCredentialSetInput;
};


export type MutationRevenueReportPartnerDeactivateArgs = {
  revenueReportPartnerID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerEndpointUpdateArgs = {
  input: RevenueReportPartnerEndpointUpdateInput;
};


export type MutationRevenueReportPartnerUpdateArgs = {
  input: RevenueReportPartnerUpdateInput;
};


export type MutationRevenueReportResendArgs = {
  revenueReportID: Scalars['UUID']['input'];
};


export type MutationRevenueReportResyncArgs = {
  input: RevenueReportResyncInput;
};


export type MutationRevenueReportTemplateActivateArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type MutationRevenueReportTemplateCreateArgs = {
  input: RevenueReportTemplateCreateInput;
};


export type MutationRevenueReportTemplateDeactivateArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type MutationRevenueReportTemplateDeleteArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type MutationRevenueReportTemplateDuplicateArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type MutationRevenueReportTemplateFieldMapUpdateArgs = {
  input: RevenueReportTemplateFieldMapUpdateInput;
};


export type MutationRevenueReportTemplateUpdateArgs = {
  input: RevenueReportTemplateUpdateInput;
};


export type MutationRevenueReportUserActivateArgs = {
  revenueReportUserID: Scalars['UUID']['input'];
};


export type MutationRevenueReportUserCreateArgs = {
  input: RevenueReportUserCreateInput;
};


export type MutationRevenueReportUserDeactivateArgs = {
  revenueReportUserID: Scalars['UUID']['input'];
};


export type MutationRevenueReportUserUpdateArgs = {
  input: RevenueReportUserUpdateInput;
};


export type MutationRevenueSharingBranchCreateArgs = {
  input: RevenueSharingBranchCreateInput;
};


export type MutationRevenueSharingBranchDeleteArgs = {
  revenueSharingBranchID: Scalars['UUID']['input'];
};


export type MutationRevenueSharingBranchUpdateArgs = {
  input: RevenueSharingBranchUpdateInput;
};


export type MutationRevenueSharingCorrectItemArgs = {
  input: RevenueSharingCorrectItemInput;
};


export type MutationRevenueSharingExportArgs = {
  input: RevenueSharingExportInput;
};


export type MutationRevenueSharingGenerateArgs = {
  input: RevenueSharingGenerateInput;
};


export type MutationRevenueSharingReuploadDatesArgs = {
  revenueSharingID: Scalars['UUID']['input'];
};


export type MutationRevenueSharingUploadArgs = {
  revenueSharingID: Scalars['UUID']['input'];
};


export type MutationRevenueSharingVoidItemArgs = {
  revenueSharingDetailID: Scalars['UUID']['input'];
};


export type MutationRoleCreateArgs = {
  input: RoleCreateInput;
};


export type MutationRoleDeleteArgs = {
  roleID: Scalars['UUID']['input'];
};


export type MutationRoleUpdateArgs = {
  input: RoleUpdateInput;
};


export type MutationSalesChannelCampaignCancelArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCampaignCreateArgs = {
  input: SalesChannelCampaignCreateInput;
};


export type MutationSalesChannelCampaignDeleteArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCampaignPublishArgs = {
  input: SalesChannelCampaignPublishInput;
};


export type MutationSalesChannelCampaignPublishToStoresArgs = {
  input: SalesChannelCampaignPublishToStoresInput;
};


export type MutationSalesChannelCampaignSetCategoriesArgs = {
  input: SalesChannelCampaignSetCategoriesInput;
};


export type MutationSalesChannelCampaignSetChannelsArgs = {
  input: SalesChannelCampaignSetChannelsInput;
};


export type MutationSalesChannelCampaignSetProductsArgs = {
  input: SalesChannelCampaignSetProductsInput;
};


export type MutationSalesChannelCampaignStopArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCampaignUpdateArgs = {
  input: SalesChannelCampaignUpdateInput;
};


export type MutationSalesChannelCategoryCreateArgs = {
  input: SalesChannelCategoryCreateInput;
};


export type MutationSalesChannelCategoryDeleteArgs = {
  salesChannelCategoryID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCategoryGroupCreateArgs = {
  input: SalesChannelCategoryGroupCreateInput;
};


export type MutationSalesChannelCategoryGroupDeleteArgs = {
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCategoryGroupItemCreateArgs = {
  input: SalesChannelCategoryGroupItemCreateInput;
};


export type MutationSalesChannelCategoryGroupItemDeleteArgs = {
  salesChannelCategoryGroupItemID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCategoryGroupItemUpdateArgs = {
  input: SalesChannelCategoryGroupItemUpdateInput;
};


export type MutationSalesChannelCategoryGroupProductCreateArgs = {
  input: SalesChannelCategoryGroupProductCreateInput;
};


export type MutationSalesChannelCategoryGroupProductDeleteArgs = {
  salesChannelCategoryGroupProductID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCategoryGroupProductReorderArgs = {
  input: Array<ReorderSalesChannelCategoryGroupProductInput>;
};


export type MutationSalesChannelCategoryGroupProductUpdateArgs = {
  input: SalesChannelCategoryGroupProductUpdateInput;
};


export type MutationSalesChannelCategoryGroupUpdateArgs = {
  input: SalesChannelCategoryGroupUpdateInput;
};


export type MutationSalesChannelCategoryUpdateArgs = {
  input: SalesChannelCategoryUpdateInput;
};


export type MutationSalesChannelStockThresholdCreateArgs = {
  input: SalesChannelStockThresholdCreateInput;
};


export type MutationSalesChannelStockThresholdDeleteArgs = {
  salesChannelStockThresholdID: Scalars['UUID']['input'];
};


export type MutationSalesChannelStockThresholdUpdateArgs = {
  input: SalesChannelStockThresholdUpdateInput;
};


export type MutationSalesInvoiceInventoryBackfillArgs = {
  input: SalesInvoiceInventoryBackfillInput;
};


export type MutationSalesInvoiceReviewRefreshArgs = {
  salesInvoiceReviewID: Scalars['UUID']['input'];
};


export type MutationSalesInvoiceReviewResolveBulkArgs = {
  input: SalesInvoiceReviewResolveBulkInput;
};


export type MutationSalesPaymentMethodCreateArgs = {
  input: SalesPaymentMethodCreateInput;
};


export type MutationSalesPaymentMethodDeleteArgs = {
  salesPaymentMethodID: Scalars['UUID']['input'];
};


export type MutationSalesPaymentMethodTypeCreateArgs = {
  input: SalesPaymentMethodTypeCreateInput;
};


export type MutationSalesPaymentMethodTypeDeleteArgs = {
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
};


export type MutationSalesPaymentMethodTypeUpdateArgs = {
  input: SalesPaymentMethodTypeUpdateInput;
};


export type MutationSalesPaymentMethodUpdateArgs = {
  input: SalesPaymentMethodUpdateInput;
};


export type MutationSendConsignmentInvoiceEmailArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type MutationSendConsignmentInvoiceEmailsBulkArgs = {
  vendorConsignmentInvoiceIDs: Array<Scalars['UUID']['input']>;
};


export type MutationShiftSessionCloseArgs = {
  input: ShiftSessionCloseInput;
};


export type MutationShiftSessionCreateArgs = {
  input: ShiftSessionCreateInput;
};


export type MutationShiftSessionDeleteArgs = {
  shiftSessionID: Scalars['UUID']['input'];
};


export type MutationShiftSessionRecomputeArgs = {
  shiftSessionID: Scalars['UUID']['input'];
};


export type MutationShiftSessionResolveCashDiffArgs = {
  input: ShiftSessionResolveCashDiffInput;
};


export type MutationSimpleTransferOrderCancelArgs = {
  input: SimpleTransferOrderCancelInput;
};


export type MutationSimpleTransferOrderConfirmArgs = {
  input: SimpleTransferOrderConfirmInput;
};


export type MutationSimpleTransferOrderCreateArgs = {
  input: SimpleTransferOrderCreateInput;
};


export type MutationSimpleTransferOrderDeleteArgs = {
  transferOrderSimpleID: Scalars['UUID']['input'];
};


export type MutationSimpleTransferOrderReceivingCancelArgs = {
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationSimpleTransferOrderReceivingConfirmArgs = {
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationSimpleTransferOrderReceivingCreateArgs = {
  input: SimpleTransferOrderReceivingCreateInput;
};


export type MutationSimpleTransferOrderReceivingCreateAndConfirmArgs = {
  input: SimpleTransferOrderReceivingCreateAndConfirmInput;
};


export type MutationSimpleTransferOrderReceivingUpdateArgs = {
  input: SimpleTransferOrderReceivingUpdateInput;
};


export type MutationSimpleTransferOrderReceivingUpdateAndConfirmArgs = {
  input: SimpleTransferOrderReceivingUpdateAndConfirmInput;
};


export type MutationSimpleTransferOrderUpdateArgs = {
  input: SimpleTransferOrderUpdateInput;
};


export type MutationSubdistrictCreateArgs = {
  input: SubdistrictCreateInput;
};


export type MutationSubdistrictDeleteArgs = {
  subdistrictID: Scalars['String']['input'];
};


export type MutationSubdistrictUpdateArgs = {
  input: SubdistrictUpdateInput;
};


export type MutationSyncErpPurchaseOrderReceiveArgs = {
  input: SyncErpPurchaseOrderReceiveInput;
};


export type MutationSyncErpVendorArgs = {
  input: SyncErpVendorInput;
};


export type MutationTaxCreateArgs = {
  input: TaxCreateInput;
};


export type MutationTaxDeleteArgs = {
  taxID: Scalars['UUID']['input'];
};


export type MutationTaxUpdateArgs = {
  input: TaxUpdateInput;
};


export type MutationTransferOrderCancelArgs = {
  input: TransferOrderCancelInput;
};


export type MutationTransferOrderConfirmArgs = {
  input: TransferOrderConfirmInput;
};


export type MutationTransferOrderCreateArgs = {
  input: TransferOrderCreateInput;
};


export type MutationTransferOrderDeleteArgs = {
  transferOrderID: Scalars['UUID']['input'];
};


export type MutationTransferOrderImportArgs = {
  input: TransferOrderImportInput;
};


export type MutationTransferOrderImportValidateCodesArgs = {
  input: TransferOrderImportValidateCodesInput;
};


export type MutationTransferOrderMarkAsDoneArgs = {
  input: TransferOrderMarkAsDoneInput;
};


export type MutationTransferOrderReceivingCancelArgs = {
  transferOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationTransferOrderReceivingConfirmArgs = {
  transferOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationTransferOrderReceivingCreateArgs = {
  input: TransferOrderReceivingCreateInput;
};


export type MutationTransferOrderReceivingUpdateArgs = {
  input: TransferOrderReceivingUpdateInput;
};


export type MutationTransferOrderUpdateArgs = {
  input: TransferOrderUpdateInput;
};


export type MutationTransferRequestApproveArgs = {
  input: TransferRequestApproveInput;
};


export type MutationTransferRequestCancelArgs = {
  input: TransferRequestCancelInput;
};


export type MutationTransferRequestCreateArgs = {
  input: TransferRequestCreateInput;
};


export type MutationTransferRequestImportArgs = {
  input: TransferRequestImportInput;
};


export type MutationTransferRequestImportValidateCodesArgs = {
  input: TransferRequestImportValidateCodesInput;
};


export type MutationTransferRequestRejectArgs = {
  input: TransferRequestRejectInput;
};


export type MutationTransferRequestSubmitArgs = {
  input: TransferRequestSubmitInput;
};


export type MutationTransferRequestUpdateArgs = {
  input: TransferRequestUpdateInput;
};


export type MutationTriggerProductImageEmbeddingRunArgs = {
  input?: InputMaybe<TriggerIngestionInput>;
};


export type MutationUomCategoryCreateArgs = {
  input: UomCategoryCreateInput;
};


export type MutationUomCategoryDeleteArgs = {
  input: UomCategoryDeleteInput;
};


export type MutationUomCategoryUpdateArgs = {
  input: UomCategoryUpdateInput;
};


export type MutationUomCreateArgs = {
  input: UomCreateInput;
};


export type MutationUomDeleteArgs = {
  uomID: Scalars['UUID']['input'];
};


export type MutationUomUpdateArgs = {
  input: UomUpdateInput;
  uomID: Scalars['UUID']['input'];
};


export type MutationUpdateErpProductArgs = {
  input: UpdateErpProductInput;
  productID: Scalars['Int']['input'];
};


export type MutationUploadTemplateCreateArgs = {
  input: UploadTemplateCreateInput;
};


export type MutationUploadTemplateDeleteArgs = {
  uploadTemplateID: Scalars['UUID']['input'];
};


export type MutationUploadTemplateUpdateArgs = {
  input: UploadTemplateUpdateInput;
};


export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


export type MutationUserDeleteArgs = {
  userID: Scalars['UUID']['input'];
};


export type MutationUserRegeneratePinArgs = {
  userID: Scalars['UUID']['input'];
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationValidateBeforeIcFinishArgs = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
};


export type MutationValidateBeforeIcFinishConfirmArgs = {
  input: ValidateBeforeIcFinishConfirmInput;
};


export type MutationValidateSupervisorPinArgs = {
  input: ValidateSupervisorPinInput;
};


export type MutationVendorCategoryCreateArgs = {
  input: VendorCategoryCreateInput;
};


export type MutationVendorCategoryDeleteArgs = {
  vendorCategoryID: Scalars['UUID']['input'];
};


export type MutationVendorCategoryUpdateArgs = {
  input: VendorCategoryUpdateInput;
};


export type MutationVendorConsignmentBranchBulkDeleteArgs = {
  vendorConsignmentBranchIDs: Array<Scalars['UUID']['input']>;
};


export type MutationVendorConsignmentBranchCreateArgs = {
  input: VendorConsignmentBranchCreateInput;
};


export type MutationVendorConsignmentBranchDeleteArgs = {
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};


export type MutationVendorConsignmentBranchPeriodGrantArgs = {
  input: VendorConsignmentBranchPeriodGrantInput;
};


export type MutationVendorConsignmentBranchPeriodResumeArgs = {
  input: VendorConsignmentBranchPeriodResumeInput;
};


export type MutationVendorConsignmentBranchPeriodRevokeArgs = {
  input: VendorConsignmentBranchPeriodRevokeInput;
};


export type MutationVendorConsignmentBranchPeriodSuspendArgs = {
  input: VendorConsignmentBranchPeriodSuspendInput;
};


export type MutationVendorConsignmentBranchUpdateArgs = {
  input: VendorConsignmentBranchUpdateInput;
};


export type MutationVendorConsignmentInvoiceConfigCreateArgs = {
  input: VendorConsignmentInvoiceConfigCreateInput;
};


export type MutationVendorConsignmentInvoiceConfigImportArgs = {
  input: VendorConsignmentInvoiceConfigImportInput;
};


export type MutationVendorConsignmentInvoiceConfigImportValidateArgs = {
  input: VendorConsignmentInvoiceConfigImportInput;
};


export type MutationVendorConsignmentInvoiceConfigUpdateArgs = {
  input: VendorConsignmentInvoiceConfigUpdateInput;
};


export type MutationVendorConsignmentProductCreateArgs = {
  input: VendorConsignmentProductCreateInput;
};


export type MutationVendorConsignmentProductDeleteArgs = {
  vendorConsignmentProductID: Scalars['UUID']['input'];
};


export type MutationVendorConsignmentProductPriceBulkUpdateArgs = {
  input: VendorConsignmentProductPriceBulkUpdateInput;
};


export type MutationVendorConsignmentProductUpdateArgs = {
  input: VendorConsignmentProductUpdateInput;
};


export type MutationVendorConsignmentRentalPaymentApproveArgs = {
  input: VendorConsignmentRentalPaymentApproveInput;
};


export type MutationVendorConsignmentRentalPaymentCancelArgs = {
  input: VendorConsignmentRentalPaymentCancelInput;
};


export type MutationVendorConsignmentRentalPaymentCreateArgs = {
  input: VendorConsignmentRentalPaymentCreateInput;
};


export type MutationVendorConsignmentRentalPaymentRejectArgs = {
  input: VendorConsignmentRentalPaymentRejectInput;
};


export type MutationVendorConsignmentRentalPaymentSubmitArgs = {
  input: VendorConsignmentRentalPaymentSubmitInput;
};


export type MutationVendorConsignmentRentalPaymentUpdateArgs = {
  input: VendorConsignmentRentalPaymentUpdateInput;
};


export type MutationVendorCreateArgs = {
  input: VendorCreateInput;
};


export type MutationVendorCreateAccessArgs = {
  input: VendorCreateAccessInput;
};


export type MutationVendorDeleteArgs = {
  input: VendorDeleteInput;
};


export type MutationVendorPicContactCreateArgs = {
  input: VendorPicContactCreateInput;
};


export type MutationVendorPicContactDeleteArgs = {
  vendorPicContactID: Scalars['UUID']['input'];
};


export type MutationVendorPicContactUpdateArgs = {
  input: VendorPicContactUpdateInput;
};


export type MutationVendorSetPortalAccessActiveArgs = {
  input: VendorSetPortalAccessActiveInput;
};


export type MutationVendorUpdateArgs = {
  input: VendorUpdateInput;
};


export type MutationVendorUpdateAccessArgs = {
  input: VendorUpdateAccessInput;
};


export type MutationVillageCreateArgs = {
  input: VillageCreateInput;
};


export type MutationVillageDeleteArgs = {
  villageID: Scalars['String']['input'];
};


export type MutationVillageUpdateArgs = {
  input: VillageUpdateInput;
};


export type MutationVoucherCategoryCreateArgs = {
  input: VoucherCategoryCreateInput;
};


export type MutationVoucherCategoryDeleteArgs = {
  voucherCategoryID: Scalars['UUID']['input'];
};


export type MutationVoucherCategoryUpdateArgs = {
  input: VoucherCategoryUpdateInput;
};


export type MutationVoucherCreateArgs = {
  input: VoucherCreateInput;
};


export type MutationVoucherDeleteArgs = {
  voucherID: Scalars['UUID']['input'];
};


export type MutationVoucherItemGenerateArgs = {
  input: VoucherItemGenerateInput;
};


export type MutationVoucherItemImportArgs = {
  input: Array<VoucherItemImportInput>;
};


export type MutationVoucherItemVoidArgs = {
  voucherItemID: Scalars['UUID']['input'];
};


export type MutationVoucherRecountItemsArgs = {
  voucherID: Scalars['UUID']['input'];
};


export type MutationVoucherUpdateArgs = {
  input: VoucherUpdateInput;
};


export type MutationWarehouseCreateArgs = {
  input: WarehouseCreateInput;
};


export type MutationWarehouseDeleteArgs = {
  warehouseID: Scalars['UUID']['input'];
};


export type MutationWarehouseLocationCreateArgs = {
  input: WarehouseLocationCreateInput;
};


export type MutationWarehouseLocationCreateBulkArgs = {
  input: WarehouseLocationBulkCreateInput;
};


export type MutationWarehouseLocationDeleteArgs = {
  warehouseLocationID: Scalars['UUID']['input'];
};


export type MutationWarehouseLocationGroupCreateArgs = {
  input: WarehouseLocationGroupCreateInput;
};


export type MutationWarehouseLocationGroupDeleteArgs = {
  warehouseLocationGroupID: Scalars['UUID']['input'];
};


export type MutationWarehouseLocationGroupUpdateArgs = {
  input: WarehouseLocationGroupUpdateInput;
};


export type MutationWarehouseLocationRelationMapCreateArgs = {
  input: WarehouseLocationRelationMapCreateInput;
};


export type MutationWarehouseLocationRelationMapDeleteArgs = {
  input: WarehouseLocationRelationMapDeleteInput;
};


export type MutationWarehouseLocationRelationMapUpdateArgs = {
  input: WarehouseLocationRelationMapUpdateInput;
};


export type MutationWarehouseLocationUpdateArgs = {
  input: WarehouseLocationUpdateInput;
};


export type MutationWarehouseProductLocationMapCreateArgs = {
  input: WarehouseProductLocationMapCreateInput;
};


export type MutationWarehouseProductLocationMapDeleteArgs = {
  warehouseProductLocationMapID: Scalars['UUID']['input'];
};


export type MutationWarehouseProductLocationMapUpdateArgs = {
  input: WarehouseProductLocationMapUpdateInput;
};


export type MutationWarehouseReplenishmentTemplateCreateArgs = {
  input: WarehouseReplenishmentTemplateCreateInput;
};


export type MutationWarehouseReplenishmentTemplateCreateBulkArgs = {
  input: WarehouseReplenishmentTemplateCreateBulkInput;
};


export type MutationWarehouseReplenishmentTemplateDeleteArgs = {
  warehouseReplenishmentTemplateID: Scalars['UUID']['input'];
};


export type MutationWarehouseUpdateArgs = {
  input: WarehouseUpdateInput;
};

export enum OtpChannel {
  Email = 'EMAIL'
}

export enum OtpType {
  ResetPassword = 'RESET_PASSWORD'
}

export type OpenSealContainerInput = {
  outboundContainerID: Scalars['UUID']['input'];
};

export type OperatingHours = {
  __typename?: 'OperatingHours';
  fri: OperatingHoursDay;
  mon: OperatingHoursDay;
  sat: OperatingHoursDay;
  sun: OperatingHoursDay;
  thu: OperatingHoursDay;
  tue: OperatingHoursDay;
  wed: OperatingHoursDay;
};

export type OperatingHoursDay = {
  __typename?: 'OperatingHoursDay';
  isOpen: Scalars['Boolean']['output'];
  periods: Array<OperatingHoursPeriod>;
};

export type OperatingHoursDayInput = {
  isOpen: Scalars['Boolean']['input'];
  periods: Array<OperatingHoursPeriodInput>;
};

export type OperatingHoursInput = {
  fri: OperatingHoursDayInput;
  mon: OperatingHoursDayInput;
  sat: OperatingHoursDayInput;
  sun: OperatingHoursDayInput;
  thu: OperatingHoursDayInput;
  tue: OperatingHoursDayInput;
  wed: OperatingHoursDayInput;
};

export type OperatingHoursPeriod = {
  __typename?: 'OperatingHoursPeriod';
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type OperatingHoursPeriodInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

/**
 * Outbound container for shipping products.
 *
 * Status flags (isEmpty, isDo) are automatically set based on container data:
 * - isEmpty: Indicates if container has items (based on TotalItems count)
 * - isDo: Indicates if container is attached to a delivery order (based on DeliveryOrderID)
 */
export type OutboundContainer = {
  __typename?: 'OutboundContainer';
  containerNumber: Scalars['String']['output'];
  deliveryOrder?: Maybe<DeliveryOrder>;
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  draftDeliveryOrderBatchID?: Maybe<Scalars['UUID']['output']>;
  draftDeliveryOrderBatchNumber?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  fromBranchID: Scalars['UUID']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  gmt: Scalars['Int']['output'];
  /**
   * Indicates if the container is attached to a delivery order.
   *
   *   Automatically set based on DeliveryOrderID:
   *   - true: Container is attached to a delivery order (DeliveryOrderID is not null)
   *   - false: Container is not attached to a delivery order (DeliveryOrderID is null)
   *
   *   This flag is read-only and computed from the container's delivery order association.
   */
  isDo: Scalars['Boolean']['output'];
  /**
   * Indicates if the container is empty (has no items).
   *
   *   Automatically set based on TotalItems:
   *   - true: Container has no items (TotalItems = 0)
   *   - false: Container has items (TotalItems > 0)
   *
   *   This flag is read-only and computed from the container's item count.
   */
  isEmpty: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  isSealed: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  outboundContainerID: Scalars['UUID']['output'];
  packingTask?: Maybe<OutboundContainerPackingTaskInfo>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  toBranchID?: Maybe<Scalars['UUID']['output']>;
  toWarehouse?: Maybe<Warehouse>;
  toWarehouseID?: Maybe<Scalars['UUID']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQty: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
};

export type OutboundContainerCreateInput = {
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  fromBranchID: Scalars['UUID']['input'];
  fromWarehouseID: Scalars['UUID']['input'];
  gmt: Scalars['Int']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentNumber: Scalars['String']['input'];
  sourceDocumentType: Scalars['String']['input'];
  toBranchID?: InputMaybe<Scalars['UUID']['input']>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Item within an outbound container.
 *
 * Represents a product packed into a container with quantity and UOM information.
 */
export type OutboundContainerItem = {
  __typename?: 'OutboundContainerItem';
  baseUomQty: Scalars['Float']['output'];
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  outboundContainerID: Scalars['UUID']['output'];
  outboundContainerItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

/**
 * Outbound container items grouped by product.
 *
 * Represents aggregated quantities across multiple outbound containers for the same product.
 */
export type OutboundContainerItemGrouped = {
  __typename?: 'OutboundContainerItemGrouped';
  baseUomQty: Scalars['Float']['output'];
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type OutboundContainerItemGroupedPaged = {
  __typename?: 'OutboundContainerItemGroupedPaged';
  items?: Maybe<Array<OutboundContainerItemGrouped>>;
  pagination: PaginationResult;
};

export type OutboundContainerItemGroupedQopFilterInput = {
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
};

export type OutboundContainerItemGroupedQopInput = {
  filters?: InputMaybe<OutboundContainerItemGroupedQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

/**
 * Summary of item packing status within a container.
 *
 * Tracks existing quantities, newly packed quantities, and total quantities
 * for a product in a container during packing operations.
 */
export type OutboundContainerItemPackingSummary = {
  __typename?: 'OutboundContainerItemPackingSummary';
  baseUomQty: Scalars['Float']['output'];
  baseUomQtyExisting: Scalars['Float']['output'];
  baseUomQtyPacked: Scalars['Float']['output'];
  outboundContainerID: Scalars['UUID']['output'];
  outboundContainerItemID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  qtyExisting: Scalars['Float']['output'];
  qtyPacked: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type OutboundContainerItemPaged = {
  __typename?: 'OutboundContainerItemPaged';
  items?: Maybe<Array<OutboundContainerItem>>;
  pagination: PaginationResult;
};

export type OutboundContainerItemQopFilterInput = {
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  outboundContainerID?: InputMaybe<Scalars['UUID']['input']>;
  outboundContainerItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type OutboundContainerItemQopInput = {
  filters?: InputMaybe<OutboundContainerItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type OutboundContainerPackItemInput = {
  outboundContainerID: Scalars['UUID']['input'];
  packingTaskID: Scalars['UUID']['input'];
  packingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
  version: Scalars['UUID']['input'];
};

/** Packing task snapshot for an outbound container, resolved through packing_task_container. */
export type OutboundContainerPackingTaskInfo = {
  __typename?: 'OutboundContainerPackingTaskInfo';
  packingTaskID: Scalars['UUID']['output'];
  packingTaskNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OutboundContainerPaged = {
  __typename?: 'OutboundContainerPaged';
  items?: Maybe<Array<OutboundContainer>>;
  pagination: PaginationResult;
};

export type OutboundContainerQopFilterInput = {
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  excludeContainerNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromBranchID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  isDo?: InputMaybe<Scalars['Boolean']['input']>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSealed?: InputMaybe<Scalars['Boolean']['input']>;
  outboundContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  toBranchID?: InputMaybe<Scalars['UUID']['input']>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type OutboundContainerQopInput = {
  filters?: InputMaybe<OutboundContainerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type OutboundContainerUnpackItemInput = {
  outboundContainerID: Scalars['UUID']['input'];
  packingTaskID: Scalars['UUID']['input'];
  packingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
};

export type OutboundContainerUpdatePackItemInput = {
  outboundContainerID: Scalars['UUID']['input'];
  packingTaskID: Scalars['UUID']['input'];
  packingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
};

export type PackingTask = {
  __typename?: 'PackingTask';
  branch?: Maybe<Branch>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  cancelledAtUtc?: Maybe<Scalars['Time']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouse?: Maybe<Warehouse>;
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  packedUserID?: Maybe<Scalars['UUID']['output']>;
  packedUserName?: Maybe<Scalars['String']['output']>;
  packingTaskDatetime: Scalars['Time']['output'];
  packingTaskDatetimeUtc: Scalars['Time']['output'];
  packingTaskID: Scalars['UUID']['output'];
  packingTaskNumber: Scalars['String']['output'];
  pickedUserID: Scalars['UUID']['output'];
  pickedUserName: Scalars['String']['output'];
  pickingTask?: Maybe<PickingTask>;
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskNumber: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskDoneAt?: Maybe<Scalars['Time']['output']>;
  taskDoneAtUtc?: Maybe<Scalars['Time']['output']>;
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  taskStartAtUtc?: Maybe<Scalars['Time']['output']>;
  taskVerifiedAt?: Maybe<Scalars['Time']['output']>;
  taskVerifiedAtUtc?: Maybe<Scalars['Time']['output']>;
  toWarehouse?: Maybe<Warehouse>;
  toWarehouseCode?: Maybe<Scalars['String']['output']>;
  toWarehouseID?: Maybe<Scalars['UUID']['output']>;
  toWarehouseName?: Maybe<Scalars['String']['output']>;
  totalBaseUomQtyPacked: Scalars['Decimal']['output'];
  totalBaseUomQtyPicked: Scalars['Decimal']['output'];
  totalBaseUomQtyVerified: Scalars['Decimal']['output'];
  totalItems: Scalars['Int']['output'];
  totalItemsPacked: Scalars['Int']['output'];
  totalItemsVerified: Scalars['Int']['output'];
  totalPackings: Scalars['Int']['output'];
  totalQtyPacked: Scalars['Decimal']['output'];
  totalQtyPicked: Scalars['Decimal']['output'];
  totalQtyVerified: Scalars['Decimal']['output'];
  verifiedUserID?: Maybe<Scalars['UUID']['output']>;
  verifiedUserName?: Maybe<Scalars['String']['output']>;
};

export type PackingTaskCancelInput = {
  cancellationReason: Scalars['String']['input'];
  packingTaskID: Scalars['UUID']['input'];
};

export type PackingTaskContainer = {
  __typename?: 'PackingTaskContainer';
  entityAuditMetadata: EntityAuditMetadata;
  outboundContainer: OutboundContainer;
  outboundContainerID: Scalars['UUID']['output'];
  packingTaskContainerID: Scalars['UUID']['output'];
  packingTaskID: Scalars['UUID']['output'];
};

export type PackingTaskContainerItem = {
  __typename?: 'PackingTaskContainerItem';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  outboundContainer: OutboundContainer;
  outboundContainerID: Scalars['UUID']['output'];
  outboundContainerItemID: Scalars['UUID']['output'];
  packingTask: PackingTask;
  packingTaskContainer: PackingTaskContainer;
  packingTaskContainerID: Scalars['UUID']['output'];
  packingTaskContainerItemID: Scalars['UUID']['output'];
  packingTaskID: Scalars['UUID']['output'];
  packingTaskItem: PackingTaskItem;
  packingTaskItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
};

export type PackingTaskContainerItemPaged = {
  __typename?: 'PackingTaskContainerItemPaged';
  items: Array<PackingTaskContainerItem>;
  pagination: PaginationResult;
};

export type PackingTaskContainerItemQopFilterInput = {
  outboundContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PackingTaskContainerItemQopInput = {
  filters?: InputMaybe<PackingTaskContainerItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskContainerPaged = {
  __typename?: 'PackingTaskContainerPaged';
  items: Array<PackingTaskContainer>;
  pagination: PaginationResult;
};

export type PackingTaskContainerQopFilterInput = {
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  isDo?: InputMaybe<Scalars['Boolean']['input']>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSealed?: InputMaybe<Scalars['Boolean']['input']>;
  outboundContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
};

export type PackingTaskContainerQopInput = {
  filters?: InputMaybe<PackingTaskContainerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskExecution = {
  __typename?: 'PackingTaskExecution';
  baseUomQty: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  executedAtUtc: Scalars['Time']['output'];
  outboundContainerID?: Maybe<Scalars['UUID']['output']>;
  packingContainerID: Scalars['UUID']['output'];
  packingTaskExecutionID: Scalars['UUID']['output'];
  packingTaskID: Scalars['UUID']['output'];
  packingTaskItemID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Decimal']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type PackingTaskExecutionPaged = {
  __typename?: 'PackingTaskExecutionPaged';
  items: Array<PackingTaskExecution>;
  pagination: PaginationResult;
};

export type PackingTaskExecutionQopFilterInput = {
  executedAtEnd?: InputMaybe<Scalars['Time']['input']>;
  executedAtStart?: InputMaybe<Scalars['Time']['input']>;
  packingTaskExecutionID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PackingTaskExecutionQopInput = {
  filters?: InputMaybe<PackingTaskExecutionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskFinishInput = {
  finishAt?: InputMaybe<Scalars['Time']['input']>;
  packingTaskID: Scalars['UUID']['input'];
};

export type PackingTaskItem = {
  __typename?: 'PackingTaskItem';
  baseUomQtyDiff: Scalars['Decimal']['output'];
  baseUomQtyOutstanding: Scalars['Decimal']['output'];
  baseUomQtyPacked: Scalars['Decimal']['output'];
  baseUomQtyPicked: Scalars['Decimal']['output'];
  baseUomQtyVerified: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  packingTask?: Maybe<PackingTask>;
  packingTaskID: Scalars['UUID']['output'];
  packingTaskItemID: Scalars['UUID']['output'];
  pickingTaskExecution?: Maybe<PickingTaskExecution>;
  pickingTaskItem?: Maybe<PickingTaskItem>;
  pickingTaskItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyDiff: Scalars['Decimal']['output'];
  qtyDiffNote?: Maybe<Scalars['String']['output']>;
  qtyDiffReason?: Maybe<Scalars['String']['output']>;
  qtyOutstanding: Scalars['Decimal']['output'];
  qtyPacked: Scalars['Decimal']['output'];
  qtyPicked: Scalars['Decimal']['output'];
  qtyVerified: Scalars['Decimal']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  uom?: Maybe<Uom>;
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Decimal']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['Time']['output']>;
  verifiedAtUtc?: Maybe<Scalars['Time']['output']>;
  verifiedByUserID?: Maybe<Scalars['UUID']['output']>;
  verifiedByUserName?: Maybe<Scalars['String']['output']>;
};

export type PackingTaskItemPaged = {
  __typename?: 'PackingTaskItemPaged';
  items: Array<PackingTaskItem>;
  pagination: PaginationResult;
};

export type PackingTaskItemQopFilterInput = {
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PackingTaskItemQopInput = {
  filters?: InputMaybe<PackingTaskItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskPaged = {
  __typename?: 'PackingTaskPaged';
  items: Array<PackingTask>;
  pagination: PaginationResult;
};

export type PackingTaskQopFilterInput = {
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  packingTaskDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  packingTaskNumber?: InputMaybe<Scalars['String']['input']>;
  pickingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PackingTaskQopInput = {
  filters?: InputMaybe<PackingTaskQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskStartInput = {
  packingTaskID: Scalars['UUID']['input'];
  startAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PackingTaskVerifyInput = {
  items: Array<PackingTaskVerifyItemInput>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  packingTaskID: Scalars['UUID']['input'];
};

export type PackingTaskVerifyItemInput = {
  packingTaskItemID: Scalars['UUID']['input'];
  qtyVerified: Scalars['Decimal']['input'];
  reasonID?: InputMaybe<Scalars['UUID']['input']>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
};

export type Pagination = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  withCount?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaginationResult = {
  __typename?: 'PaginationResult';
  hasNext?: Maybe<Scalars['Boolean']['output']>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

export enum PauseDuration {
  Hours_24 = 'HOURS_24',
  Hour_1 = 'HOUR_1',
  Minutes_30 = 'MINUTES_30'
}

export type PauseDurationOption = {
  __typename?: 'PauseDurationOption';
  label: Scalars['String']['output'];
  value: PauseDuration;
};

export type PaymentInboundRequestLog = {
  __typename?: 'PaymentInboundRequestLog';
  clientKey: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorReason: Scalars['String']['output'];
  externalID: Scalars['String']['output'];
  headers: Scalars['String']['output'];
  httpMethod: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  partnerReferenceNo: Scalars['String']['output'];
  paymentInboundRequestLogID: Scalars['UUID']['output'];
  providerCode: Scalars['String']['output'];
  providerConfigID?: Maybe<Scalars['UUID']['output']>;
  receivedAt: Scalars['Time']['output'];
  requestBody: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  responseBody: Scalars['String']['output'];
  responseCode: Scalars['String']['output'];
  responseMessage: Scalars['String']['output'];
  responseStatus: Scalars['Int']['output'];
  signature: Scalars['String']['output'];
  timestampHeader: Scalars['String']['output'];
};

export type PaymentInboundRequestLogPaged = {
  __typename?: 'PaymentInboundRequestLogPaged';
  items?: Maybe<Array<PaymentInboundRequestLog>>;
  pagination: PaginationResult;
};

export type PaymentInboundRequestLogQopFilterInput = {
  clientKey?: InputMaybe<Scalars['String']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  partnerReferenceNo?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  receivedFrom?: InputMaybe<Scalars['Time']['input']>;
  receivedTo?: InputMaybe<Scalars['Time']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  responseStatus?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentInboundRequestLogQopInput = {
  filters?: InputMaybe<PaymentInboundRequestLogQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PaymentInquiryLog = {
  __typename?: 'PaymentInquiryLog';
  entityAuditMetadata: EntityAuditMetadata;
  httpStatus: Scalars['Int']['output'];
  inquiredAt: Scalars['Time']['output'];
  isSuccess: Scalars['Boolean']['output'];
  latestTransactionStatusCode: Scalars['String']['output'];
  partnerReferenceNo: Scalars['String']['output'];
  paymentInquiryLogID: Scalars['UUID']['output'];
  paymentTransactionID: Scalars['UUID']['output'];
  providerCode: Scalars['String']['output'];
  referenceNo: Scalars['String']['output'];
  requestPayload: Scalars['String']['output'];
  responseCode: Scalars['String']['output'];
  responseMessage: Scalars['String']['output'];
  responsePayload: Scalars['String']['output'];
  serviceCode: Scalars['String']['output'];
  triggeredBy: Scalars['String']['output'];
};

export type PaymentInquiryLogPaged = {
  __typename?: 'PaymentInquiryLogPaged';
  items?: Maybe<Array<PaymentInquiryLog>>;
  pagination: PaginationResult;
};

export type PaymentInquiryLogQopFilterInput = {
  inquiredFrom?: InputMaybe<Scalars['Time']['input']>;
  inquiredTo?: InputMaybe<Scalars['Time']['input']>;
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  latestTransactionStatusCode?: InputMaybe<Scalars['String']['input']>;
  partnerReferenceNo?: InputMaybe<Scalars['String']['input']>;
  paymentTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['String']['input']>;
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentInquiryLogQopInput = {
  filters?: InputMaybe<PaymentInquiryLogQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PaymentProviderConfig = {
  __typename?: 'PaymentProviderConfig';
  baseURL: Scalars['String']['output'];
  channelID: Scalars['String']['output'];
  clientID: Scalars['String']['output'];
  defaultValiditySeconds: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  environment: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  partnerID: Scalars['String']['output'];
  paymentProviderConfigID: Scalars['UUID']['output'];
  providerCode: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  webhookTimestampToleranceSeconds: Scalars['Int']['output'];
};

export type PaymentProviderConfigPaged = {
  __typename?: 'PaymentProviderConfigPaged';
  items?: Maybe<Array<PaymentProviderConfig>>;
  pagination: PaginationResult;
};

export type PaymentProviderConfigQopFilterInput = {
  environment?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentProviderConfigQopInput = {
  filters?: InputMaybe<PaymentProviderConfigQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PaymentProviderConfigUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  partnerID: Scalars['String']['input'];
  paymentProviderConfigID: Scalars['UUID']['input'];
};

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount: Scalars['Float']['output'];
  approvalCode: Scalars['String']['output'];
  branch?: Maybe<Branch>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancelReason: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  currency: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiredAt?: Maybe<Scalars['Time']['output']>;
  externalID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  issuerName: Scalars['String']['output'];
  latestTransactionStatusCode: Scalars['String']['output'];
  merchantID: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['Time']['output']>;
  partnerReferenceNo: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  paymentTransactionID: Scalars['UUID']['output'];
  paymentTransactionNumber: Scalars['String']['output'];
  paymentTransactionType: Scalars['String']['output'];
  providerCode: Scalars['String']['output'];
  qrContent: Scalars['String']['output'];
  qrImage: Scalars['String']['output'];
  referenceNo: Scalars['String']['output'];
  rrn: Scalars['String']['output'];
  sourceDocumentID?: Maybe<Scalars['UUID']['output']>;
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  terminalID: Scalars['String']['output'];
  transactionDatetime: Scalars['Time']['output'];
};

export type PaymentTransactionCancelInput = {
  paymentTransactionID: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentTransactionCheckStatusResult = {
  __typename?: 'PaymentTransactionCheckStatusResult';
  isPaid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  paymentTransaction?: Maybe<PaymentTransaction>;
  paymentTransactionID: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PaymentTransactionCreateDynamicQrisInput = {
  amount: Scalars['Float']['input'];
  branchID: Scalars['UUID']['input'];
  providerCode?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  validitySeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentTransactionPaged = {
  __typename?: 'PaymentTransactionPaged';
  items?: Maybe<Array<PaymentTransaction>>;
  pagination: PaginationResult;
};

export type PaymentTransactionQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdFrom?: InputMaybe<Scalars['Time']['input']>;
  createdTo?: InputMaybe<Scalars['Time']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  partnerReferenceNo?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentTransactionQopInput = {
  filters?: InputMaybe<PaymentTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PaymentWebhookEvent = {
  __typename?: 'PaymentWebhookEvent';
  channelID: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  eventType: Scalars['String']['output'];
  externalID: Scalars['String']['output'];
  headers: Scalars['String']['output'];
  httpMethod: Scalars['String']['output'];
  isDuplicate: Scalars['Boolean']['output'];
  isProcessed: Scalars['Boolean']['output'];
  isValidSignature: Scalars['Boolean']['output'];
  latestTransactionStatusCode: Scalars['String']['output'];
  partnerReferenceNo: Scalars['String']['output'];
  payload: Scalars['String']['output'];
  paymentTransactionID?: Maybe<Scalars['UUID']['output']>;
  paymentWebhookEventID: Scalars['UUID']['output'];
  providerCode: Scalars['String']['output'];
  receivedAt: Scalars['Time']['output'];
  referenceNo: Scalars['String']['output'];
  responseCode: Scalars['String']['output'];
  responseMessage: Scalars['String']['output'];
};

export type PaymentWebhookEventPaged = {
  __typename?: 'PaymentWebhookEventPaged';
  items?: Maybe<Array<PaymentWebhookEvent>>;
  pagination: PaginationResult;
};

export type PaymentWebhookEventQopFilterInput = {
  eventType?: InputMaybe<Scalars['String']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  isValidSignature?: InputMaybe<Scalars['Boolean']['input']>;
  partnerReferenceNo?: InputMaybe<Scalars['String']['input']>;
  paymentTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  receivedFrom?: InputMaybe<Scalars['Time']['input']>;
  receivedTo?: InputMaybe<Scalars['Time']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentWebhookEventQopInput = {
  filters?: InputMaybe<PaymentWebhookEventQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type Permission = {
  __typename?: 'Permission';
  apps?: Maybe<Array<App>>;
  entityAuditMetadata: EntityAuditMetadata;
  parentResourceID?: Maybe<Scalars['String']['output']>;
  parentResourceName?: Maybe<Scalars['String']['output']>;
  permissionID: Scalars['String']['output'];
  permissionName: Scalars['String']['output'];
  resourceID: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
};

export type PermissionCreateInput = {
  appIDs: Array<InputMaybe<Scalars['String']['input']>>;
  permissionID: Scalars['String']['input'];
  permissionName: Scalars['String']['input'];
  resourceID: Scalars['String']['input'];
};

export type PermissionPaged = {
  __typename?: 'PermissionPaged';
  items?: Maybe<Array<Permission>>;
  pagination: PaginationResult;
};

export type PermissionProfile = {
  __typename?: 'PermissionProfile';
  permissionID: Scalars['String']['output'];
  permissionName: Scalars['String']['output'];
};

export type PermissionQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  resourceID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PermissionQopInput = {
  filters?: InputMaybe<PermissionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PermissionUpdateInput = {
  appIDs: Array<InputMaybe<Scalars['String']['input']>>;
  permissionID: Scalars['String']['input'];
  permissionName: Scalars['String']['input'];
  resourceID: Scalars['String']['input'];
};

export type PettyCashAddFundTransaction = {
  __typename?: 'PettyCashAddFundTransaction';
  amount: Scalars['Float']['output'];
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankJournalAccountCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<PettyCashTransactionFile>>;
  gmt: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  pettyCashAddFundTransactionID: Scalars['UUID']['output'];
  pettyCashAddFundTransactionNumber: Scalars['String']['output'];
  pettyCashTransactionDatetime: Scalars['Time']['output'];
  pettyCashTransactionDatetimeUtc: Scalars['Time']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashAddFundTransactionCreateInput = {
  amount: Scalars['Float']['input'];
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashAddFundTransactionPaged = {
  __typename?: 'PettyCashAddFundTransactionPaged';
  items: Array<PettyCashAddFundTransaction>;
  pagination: PaginationResult;
};

export type PettyCashAddFundTransactionQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashAddFundTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PettyCashAddFundTransactionQopInput = {
  filters?: InputMaybe<PettyCashAddFundTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashAddFundTransactionUpdateInput = {
  amount: Scalars['Float']['input'];
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  pettyCashTransactionID: Scalars['UUID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['UUID']['input'];
};

export type PettyCashBalance = {
  __typename?: 'PettyCashBalance';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  currentBalance: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  lastPettyCashTransactionID: Scalars['UUID']['output'];
  lastPettyCashTransactionLedgerID?: Maybe<Scalars['UUID']['output']>;
  lastPettyCashTransactionNumber: Scalars['String']['output'];
  lastSourceDocumentID: Scalars['UUID']['output'];
  lastSourceDocumentNumber: Scalars['String']['output'];
  lastSourceDocumentType: Scalars['String']['output'];
  pettyCashBalanceID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashBalancePaged = {
  __typename?: 'PettyCashBalancePaged';
  items: Array<PettyCashBalance>;
  pagination: PaginationResult;
};

export type PettyCashBalanceQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
};

export type PettyCashBalanceQopInput = {
  filters?: InputMaybe<PettyCashBalanceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashExpenseTransaction = {
  __typename?: 'PettyCashExpenseTransaction';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<PettyCashTransactionFile>>;
  gmt: Scalars['Int']['output'];
  items?: Maybe<Array<PettyCashExpenseTransactionItem>>;
  note: Scalars['String']['output'];
  pettyCashExpenseTransactionDatetime: Scalars['Time']['output'];
  pettyCashExpenseTransactionDatetimeUtc: Scalars['Time']['output'];
  pettyCashExpenseTransactionID: Scalars['UUID']['output'];
  pettyCashExpenseTransactionNumber: Scalars['String']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashExpenseTransactionCreateInput = {
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  items: Array<PettyCashExpenseTransactionItemCreateInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashExpenseTransactionItem = {
  __typename?: 'PettyCashExpenseTransactionItem';
  amount: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expenseItemID: Scalars['UUID']['output'];
  expenseItemName: Scalars['String']['output'];
  journalAccountCode: Scalars['String']['output'];
  note: Scalars['String']['output'];
  pettyCashExpenseTransactionID: Scalars['UUID']['output'];
  pettyCashExpenseTransactionItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type PettyCashExpenseTransactionItemCreateInput = {
  expenseItemID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type PettyCashExpenseTransactionItemPaged = {
  __typename?: 'PettyCashExpenseTransactionItemPaged';
  items: Array<PettyCashExpenseTransactionItem>;
  pagination: PaginationResult;
};

export type PettyCashExpenseTransactionItemQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  expenseItemName?: InputMaybe<Scalars['String']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashExpenseTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  qty?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type PettyCashExpenseTransactionItemQopInput = {
  filters?: InputMaybe<PettyCashExpenseTransactionItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashExpenseTransactionItemUpdateInput = {
  expenseItemID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashExpenseTransactionItemID?: InputMaybe<Scalars['UUID']['input']>;
  qty: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type PettyCashExpenseTransactionPaged = {
  __typename?: 'PettyCashExpenseTransactionPaged';
  items: Array<PettyCashExpenseTransaction>;
  pagination: PaginationResult;
};

export type PettyCashExpenseTransactionQopFilterInput = {
  pettyCashExpenseTransactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  pettyCashExpenseTransactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  pettyCashExpenseTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashExpenseTransactionQopInput = {
  filters?: InputMaybe<PettyCashExpenseTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashExpenseTransactionUpdateInput = {
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  items: Array<PettyCashExpenseTransactionItemUpdateInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  pettyCashTransactionID: Scalars['UUID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['UUID']['input'];
};

export type PettyCashLedger = {
  __typename?: 'PettyCashLedger';
  amount: Scalars['Float']['output'];
  balanceAfter: Scalars['Float']['output'];
  balanceBefore: Scalars['Float']['output'];
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankJournalAccountCode?: Maybe<Scalars['String']['output']>;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  note: Scalars['String']['output'];
  pettyCashJournalAccountCode?: Maybe<Scalars['String']['output']>;
  pettyCashTransactionID: Scalars['UUID']['output'];
  pettyCashTransactionLedgerID: Scalars['UUID']['output'];
  pettyCashTransactionNumber: Scalars['String']['output'];
  signedAmount: Scalars['Float']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashLedgerPaged = {
  __typename?: 'PettyCashLedgerPaged';
  items: Array<PettyCashLedger>;
  pagination: PaginationResult;
};

export type PettyCashLedgerQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  balanceAfter?: InputMaybe<Scalars['Float']['input']>;
  balanceBefore?: InputMaybe<Scalars['Float']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  signedAmount?: InputMaybe<Scalars['Float']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashLedgerQopInput = {
  filters?: InputMaybe<PettyCashLedgerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashRefundTransaction = {
  __typename?: 'PettyCashRefundTransaction';
  amount: Scalars['Float']['output'];
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankJournalAccountCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<PettyCashTransactionFile>>;
  gmt: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  pettyCashRefundTransactionID: Scalars['UUID']['output'];
  pettyCashRefundTransactionNumber: Scalars['String']['output'];
  pettyCashTransactionDatetime: Scalars['Time']['output'];
  pettyCashTransactionDatetimeUtc: Scalars['Time']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashRefundTransactionCreateInput = {
  amount: Scalars['Float']['input'];
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashRefundTransactionPaged = {
  __typename?: 'PettyCashRefundTransactionPaged';
  items: Array<PettyCashRefundTransaction>;
  pagination: PaginationResult;
};

export type PettyCashRefundTransactionQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashRefundTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PettyCashRefundTransactionQopInput = {
  filters?: InputMaybe<PettyCashRefundTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashRefundTransactionUpdateInput = {
  amount: Scalars['Float']['input'];
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  pettyCashTransactionID: Scalars['UUID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['UUID']['input'];
};

export type PettyCashTransaction = {
  __typename?: 'PettyCashTransaction';
  addFundTransaction?: Maybe<PettyCashAddFundTransaction>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expenseTransaction?: Maybe<PettyCashExpenseTransaction>;
  files?: Maybe<Array<PettyCashTransactionFile>>;
  gmt: Scalars['Int']['output'];
  pettyCashJournalAccountCode?: Maybe<Scalars['String']['output']>;
  pettyCashTransactionDatetime: Scalars['Time']['output'];
  pettyCashTransactionDatetimeUtc: Scalars['Time']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  pettyCashTransactionNumber: Scalars['String']['output'];
  refundTransaction?: Maybe<PettyCashRefundTransaction>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashTransactionActionInput = {
  pettyCashTransactionID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type PettyCashTransactionFile = {
  __typename?: 'PettyCashTransactionFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  pettyCashTransactionFileID: Scalars['UUID']['output'];
  pettyCashTransactionFileType: Scalars['String']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashTransactionFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type PettyCashTransactionFilePaged = {
  __typename?: 'PettyCashTransactionFilePaged';
  items: Array<PettyCashTransactionFile>;
  pagination: PaginationResult;
};

export type PettyCashTransactionFileQopFilterInput = {
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashTransactionFileType?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PettyCashTransactionFileQopInput = {
  filters?: InputMaybe<PettyCashTransactionFileQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashTransactionPaged = {
  __typename?: 'PettyCashTransactionPaged';
  items: Array<PettyCashTransaction>;
  pagination: PaginationResult;
};

export type PettyCashTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashTransactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  pettyCashTransactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  pettyCashTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashTransactionQopInput = {
  filters?: InputMaybe<PettyCashTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PickingTask = {
  __typename?: 'PickingTask';
  assignedToUser?: Maybe<User>;
  assignedToUserID?: Maybe<Scalars['UUID']['output']>;
  assignedToUserName?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  completionPercentage: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  pickingTaskDatetime: Scalars['Time']['output'];
  pickingTaskDatetimeUtc: Scalars['Time']['output'];
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskNumber: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskDoneAt?: Maybe<Scalars['Time']['output']>;
  taskDoneAtUtc?: Maybe<Scalars['Time']['output']>;
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  taskStartAtUtc?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyAssigned: Scalars['Decimal']['output'];
  totalQtyExecuted: Scalars['Decimal']['output'];
  tranferOrder?: Maybe<TransferOrder>;
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type PickingTaskAssignInput = {
  assignedToUserID: Scalars['UUID']['input'];
  pickingTaskID: Scalars['UUID']['input'];
};

export type PickingTaskCancelInput = {
  pickingTaskID: Scalars['UUID']['input'];
};

export type PickingTaskExecuteInput = {
  pickingTaskID: Scalars['UUID']['input'];
  pickingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type PickingTaskExecution = {
  __typename?: 'PickingTaskExecution';
  baseUomQty: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  executedAtUtc: Scalars['Time']['output'];
  pickingTaskExecutionID: Scalars['UUID']['output'];
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskItemID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Decimal']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type PickingTaskExecutionPaged = {
  __typename?: 'PickingTaskExecutionPaged';
  items: Array<PickingTaskExecution>;
  pagination: PaginationResult;
};

export type PickingTaskExecutionQopFilterInput = {
  executedAtEnd?: InputMaybe<Scalars['Time']['input']>;
  executedAtStart?: InputMaybe<Scalars['Time']['input']>;
  pickingTaskExecutionID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskExecutionQopInput = {
  filters?: InputMaybe<PickingTaskExecutionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PickingTaskFinishInput = {
  forceFinish?: InputMaybe<Scalars['Boolean']['input']>;
  pickingTaskID: Scalars['UUID']['input'];
};

export type PickingTaskGenerateBulkInput = {
  tasks: Array<PickingTaskGenerateTaskInput>;
};

export type PickingTaskGenerateByZonePreviewGroup = {
  __typename?: 'PickingTaskGenerateByZonePreviewGroup';
  items: Array<PickingTaskGenerateByZonePreviewItem>;
  totalItems: Scalars['Int']['output'];
  totalQty: Scalars['Decimal']['output'];
  warehouseLocationGroupName?: Maybe<Scalars['String']['output']>;
  warehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
};

export type PickingTaskGenerateByZonePreviewInput = {
  sourceDocumentID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type PickingTaskGenerateByZonePreviewItem = {
  __typename?: 'PickingTaskGenerateByZonePreviewItem';
  baseUomQtyOutstanding: Scalars['Decimal']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyOutstanding: Scalars['Decimal']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
};

export type PickingTaskGenerateByZonePreviewResponse = {
  __typename?: 'PickingTaskGenerateByZonePreviewResponse';
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  groups: Array<PickingTaskGenerateByZonePreviewGroup>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
};

export type PickingTaskGenerateInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskDatetime: Scalars['Time']['input'];
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskGenerateItemInput = {
  baseUomQtyAssigned: Scalars['Decimal']['input'];
  productID: Scalars['UUID']['input'];
  qtyAssigned: Scalars['Decimal']['input'];
  sourceDocumentDetailID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskGenerateTaskInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  items: Array<PickingTaskGenerateItemInput>;
  pickingTaskDatetime: Scalars['Time']['input'];
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskItem = {
  __typename?: 'PickingTaskItem';
  baseUomQtyAssigned: Scalars['Decimal']['output'];
  baseUomQtyExecuted: Scalars['Decimal']['output'];
  baseUomQtyOutstanding: Scalars['Decimal']['output'];
  baseUomQtyUnfulfilled: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executions: Array<PickingTaskExecution>;
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyAssigned: Scalars['Decimal']['output'];
  qtyExecuted: Scalars['Decimal']['output'];
  qtyOutstanding: Scalars['Decimal']['output'];
  qtyUnfulfilled: Scalars['Decimal']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  unfulfilledReason?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Uom>;
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Decimal']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PickingTaskItemPaged = {
  __typename?: 'PickingTaskItemPaged';
  items: Array<PickingTaskItem>;
  pagination: PaginationResult;
};

export type PickingTaskItemQopFilterInput = {
  pickingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentDetailID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskItemQopInput = {
  filters?: InputMaybe<PickingTaskItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PickingTaskItemUnfulfilledReasonInput = {
  pickingTaskItemID: Scalars['UUID']['input'];
  unfulfilledReason: Scalars['String']['input'];
};

export type PickingTaskPaged = {
  __typename?: 'PickingTaskPaged';
  items: Array<PickingTask>;
  pagination: PaginationResult;
};

export type PickingTaskQopFilterInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  pickingTaskDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  pickingTaskNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskQopInput = {
  filters?: InputMaybe<PickingTaskQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PickingTaskStartInput = {
  pickingTaskID: Scalars['UUID']['input'];
};

export type PickingTaskUpdateUnfulfilledReasonsInput = {
  items: Array<PickingTaskItemUnfulfilledReasonInput>;
  pickingTaskID: Scalars['UUID']['input'];
};

export type PosBookmark = {
  __typename?: 'PosBookmark';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  posBookmarkID: Scalars['UUID']['output'];
  posBookmarkName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PosBookmarkCreateInput = {
  isActive?: Scalars['Boolean']['input'];
  posBookmarkName: Scalars['String']['input'];
};

export type PosBookmarkPaged = {
  __typename?: 'PosBookmarkPaged';
  items?: Maybe<Array<PosBookmark>>;
  pagination: PaginationResult;
};

export type PosBookmarkProduct = {
  __typename?: 'PosBookmarkProduct';
  entityAuditMetadata: EntityAuditMetadata;
  posBookmark?: Maybe<PosBookmark>;
  posBookmarkID: Scalars['UUID']['output'];
  posBookmarkName: Scalars['String']['output'];
  posBookmarkProductID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productID?: Maybe<Scalars['UUID']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type PosBookmarkProductCreateInput = {
  posBookmarkID: Scalars['UUID']['input'];
  posBookmarkName: Scalars['String']['input'];
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PosBookmarkProductPaged = {
  __typename?: 'PosBookmarkProductPaged';
  items?: Maybe<Array<PosBookmarkProduct>>;
  pagination: PaginationResult;
};

export type PosBookmarkProductQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  posBookmarkID?: InputMaybe<Scalars['UUID']['input']>;
  posBookmarkName?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PosBookmarkProductQopInput = {
  filters?: InputMaybe<PosBookmarkProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosBookmarkProductUpdateInput = {
  posBookmarkID: Scalars['UUID']['input'];
  posBookmarkName: Scalars['String']['input'];
  posBookmarkProductID: Scalars['UUID']['input'];
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PosBookmarkQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  posBookmarkName?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PosBookmarkQopInput = {
  filters?: InputMaybe<PosBookmarkQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosBookmarkUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  posBookmarkID: Scalars['UUID']['input'];
  posBookmarkName: Scalars['String']['input'];
};

/** PosBranch is retained as a deprecated alias of BranchLite for backwards compatibility. */
export type PosBranch = {
  __typename?: 'PosBranch';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  warehouseID?: Maybe<Scalars['UUID']['output']>;
};

export type PosSalesOrder = {
  __typename?: 'PosSalesOrder';
  adjustmentAmount: Scalars['Float']['output'];
  branchId: Scalars['UUID']['output'];
  cashPaymentAmount: Scalars['Float']['output'];
  createdTime: Scalars['Time']['output'];
  createdTimeUtc: Scalars['Time']['output'];
  createdUserId: Scalars['UUID']['output'];
  createdUserName: Scalars['String']['output'];
  customerId: Scalars['UUID']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastProcessAttemptTimeUtc?: Maybe<Scalars['Time']['output']>;
  memberTypeId: Scalars['UUID']['output'];
  nonCashPaymentAmount: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentChangeAmount: Scalars['Float']['output'];
  paymentReceivedAmount: Scalars['Float']['output'];
  posSalesOrderDatetime: Scalars['Time']['output'];
  posSalesOrderId: Scalars['UUID']['output'];
  posSalesOrderNumber: Scalars['String']['output'];
  processRemark?: Maybe<Scalars['String']['output']>;
  processStatus?: Maybe<Scalars['String']['output']>;
  processedTimeUtc?: Maybe<Scalars['Time']['output']>;
  retryCount: Scalars['Int']['output'];
  salesChannelId: Scalars['String']['output'];
  shiftSessionId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  syncError?: Maybe<Scalars['String']['output']>;
  taxAmount: Scalars['Float']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  updatedTime: Scalars['Time']['output'];
  updatedUserId: Scalars['UUID']['output'];
  updatedUserName: Scalars['String']['output'];
};

export type PosSalesOrderCreateInput = {
  adjustmentAmount: Scalars['Float']['input'];
  branchId: Scalars['UUID']['input'];
  cashPaymentAmount: Scalars['Float']['input'];
  createdTime: Scalars['Time']['input'];
  createdUserId: Scalars['UUID']['input'];
  createdUserName: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  items: Array<PosSalesOrderItemInput>;
  marketplace?: InputMaybe<PosSalesOrderMarketplaceInput>;
  memberTypeId?: InputMaybe<Scalars['UUID']['input']>;
  nonCashPaymentAmount: Scalars['Float']['input'];
  noteInternal: Scalars['String']['input'];
  paymentAmount: Scalars['Float']['input'];
  paymentChangeAmount: Scalars['Float']['input'];
  paymentReceivedAmount: Scalars['Float']['input'];
  payments: Array<PosSalesOrderPaymentInput>;
  posSalesOrderDatetime: Scalars['Time']['input'];
  posSalesOrderId: Scalars['UUID']['input'];
  posSalesOrderNumber: Scalars['String']['input'];
  salesChannelId?: InputMaybe<Scalars['String']['input']>;
  shiftSessionId: Scalars['String']['input'];
  status: Scalars['String']['input'];
  subtotal: Scalars['Float']['input'];
  subtotalAfterDiscount: Scalars['Float']['input'];
  taxAmount: Scalars['Float']['input'];
  taxIncluded: Scalars['Boolean']['input'];
  taxItems: Scalars['String']['input'];
  taxableAmount: Scalars['Float']['input'];
  total: Scalars['Float']['input'];
  totalItemQty: Scalars['Float']['input'];
  updatedTime: Scalars['Time']['input'];
  updatedUserId: Scalars['UUID']['input'];
  updatedUserName: Scalars['String']['input'];
  voucherAmount: Scalars['Float']['input'];
  vouchers?: InputMaybe<Array<PosSalesOrderVoucherInput>>;
};

export type PosSalesOrderItemInput = {
  additionalDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  additionalDiscountPerc?: InputMaybe<Scalars['Float']['input']>;
  addonComponents?: InputMaybe<Scalars['String']['input']>;
  baseUomQty?: InputMaybe<Scalars['Float']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  commissionAmount?: InputMaybe<Scalars['Float']['input']>;
  consignmentCommissionFeePerc?: InputMaybe<Scalars['Float']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  createdTime: Scalars['Time']['input'];
  createdUserId: Scalars['UUID']['input'];
  createdUserName: Scalars['String']['input'];
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountPerc?: InputMaybe<Scalars['Float']['input']>;
  discountPercPlus?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  effectiveTaxRate?: InputMaybe<Scalars['Float']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  isPromoItem?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  posSalesOrderID: Scalars['UUID']['input'];
  posSalesOrderItemID: Scalars['UUID']['input'];
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoParentItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoParentProductID?: InputMaybe<Scalars['UUID']['input']>;
  promoRowType?: InputMaybe<Scalars['String']['input']>;
  promoType?: InputMaybe<Scalars['String']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtotalBeforeDiscount?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  taxItems?: InputMaybe<Scalars['String']['input']>;
  taxableAmount?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  totalCalculatedDiscount?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomConvertionDecimal?: InputMaybe<Scalars['Int']['input']>;
  uomConvertionRate?: InputMaybe<Scalars['Float']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  updatedTime: Scalars['Time']['input'];
  updatedUserId: Scalars['UUID']['input'];
  updatedUserName: Scalars['String']['input'];
  vendorShareAmount?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Jejak order marketplace di balik sebuah sales order POS. Null untuk order
 * reguler. Isinya adalah POTRET saat POS menandai order siap, bukan sumber
 * kebenaran: sumber kebenarannya tetap tabel marketplace_order, yang dijangkau
 * lewat marketplaceOrderId.
 */
export type PosSalesOrderMarketplaceInput = {
  acceptedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  deliveryFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  externalOrderId: Scalars['String']['input'];
  isEdited?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceOrderId?: InputMaybe<Scalars['UUID']['input']>;
  /** JSON: rincian yang tidak pernah jadi predikat query. */
  metadata?: InputMaybe<Scalars['String']['input']>;
  orderDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  readyMarkedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  shortOrderNumber?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type PosSalesOrderPaged = {
  __typename?: 'PosSalesOrderPaged';
  items?: Maybe<Array<PosSalesOrder>>;
  pagination: PaginationResult;
};

export type PosSalesOrderPaymentInput = {
  authCode?: InputMaybe<Scalars['String']['input']>;
  bankReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  branchQrisMerchantID?: InputMaybe<Scalars['UUID']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  createdTime: Scalars['Time']['input'];
  createdUserId: Scalars['UUID']['input'];
  createdUserName: Scalars['String']['input'];
  edcTerminalID?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentMethodID?: InputMaybe<Scalars['UUID']['input']>;
  paymentMethodTypeID?: InputMaybe<Scalars['UUID']['input']>;
  paymentTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  posSalesOrderID: Scalars['UUID']['input'];
  posSalesOrderPaymentID: Scalars['UUID']['input'];
  updatedTime: Scalars['Time']['input'];
  updatedUserId: Scalars['UUID']['input'];
  updatedUserName: Scalars['String']['input'];
};

export type PosSalesOrderQopFilterInput = {
  branchId?: InputMaybe<Scalars['UUID']['input']>;
  createdTimeUtc?: InputMaybe<Scalars['Time']['input']>;
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  posSalesOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  posSalesOrderNumber?: InputMaybe<Scalars['String']['input']>;
  processStatus?: InputMaybe<Scalars['String']['input']>;
  salesChannelId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PosSalesOrderQopInput = {
  filters?: InputMaybe<PosSalesOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosSalesOrderUpdateInput = {
  id: Scalars['UUID']['input'];
};

export type PosSalesOrderVoucherInput = {
  createdTime: Scalars['Time']['input'];
  createdUserId: Scalars['UUID']['input'];
  createdUserName: Scalars['String']['input'];
  isDeleted: Scalars['Boolean']['input'];
  posSalesOrderID: Scalars['UUID']['input'];
  posSalesOrderVoucherID: Scalars['UUID']['input'];
  status: Scalars['String']['input'];
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedTime: Scalars['Time']['input'];
  updatedUserId: Scalars['UUID']['input'];
  updatedUserName: Scalars['String']['input'];
  validationReason?: InputMaybe<Scalars['String']['input']>;
  validationStatus: Scalars['String']['input'];
  voucherAmount: Scalars['Float']['input'];
  voucherCode: Scalars['String']['input'];
  voucherID?: InputMaybe<Scalars['UUID']['input']>;
  voucherItemCode: Scalars['String']['input'];
  voucherItemID?: InputMaybe<Scalars['UUID']['input']>;
  voucherName?: InputMaybe<Scalars['String']['input']>;
  voucherValue: Scalars['Float']['input'];
};

/** A poster program: a named, scheduled, branch-targeted set of images. */
export type Poster = {
  __typename?: 'Poster';
  /** Ignored while isDefault, but kept. See the isAllBranches description. */
  branches?: Maybe<Array<PosterBranchRef>>;
  /** Paired with startAt. See the startAt description. */
  endAt?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  /** The images in this program, already in read order. A program always has at least one. */
  images: Array<PosterImage>;
  /** The only run/stop signal. A cron switches this off once endAt passes, so an expired program is an inactive one; a program whose startAt is still ahead stays active and simply is not eligible yet. */
  isActive: Scalars['Boolean']['output'];
  /** Ignored while isDefault, but kept: it applies again if the main-poster flag moves elsewhere. */
  isAllBranches: Scalars['Boolean']['output'];
  /** The main poster: always shown, in every branch, at any time. Ignores branches and the schedule while set. */
  isDefault: Scalars['Boolean']['output'];
  posterID: Scalars['UUID']['output'];
  posterName: Scalars['String']['output'];
  /** Orders programs for POS, 1-5; lower runs first. Unique among active programs whose branches and schedule overlap; the main poster counts as all-branches with no schedule. */
  priority: Scalars['Int']['output'];
  /** Paired with endAt: both empty means the program is always shown. */
  startAt?: Maybe<Scalars['Time']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type PosterBranchRef = {
  __typename?: 'PosterBranchRef';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  branchName?: Maybe<Scalars['String']['output']>;
};

export type PosterBranchRefInput = {
  branchID: Scalars['UUID']['input'];
};

export type PosterCreateInput = {
  branches?: InputMaybe<Array<PosterBranchRefInput>>;
  endAt?: InputMaybe<Scalars['Time']['input']>;
  /** At least one image is required: a program can never be empty. */
  images: Array<PosterImageInput>;
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  posterName: Scalars['String']['input'];
  /** 1-5, lower runs first. Must be free among active programs whose branches and schedule overlap. */
  priority: Scalars['Int']['input'];
  /** Leave startAt and endAt both empty for a program that is always shown; filling one requires the other. */
  startAt?: InputMaybe<Scalars['Time']['input']>;
};

/** One image inside a poster program. Synced to POS as its own stream and joined locally on posterID. */
export type PosterImage = {
  __typename?: 'PosterImage';
  displayDurationSeconds: Scalars['Int']['output'];
  /** Sort hint within the program; deliberately not unique. Ties break on createdAt then posterImageID. */
  displayOrder: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  file?: Maybe<File>;
  fileID: Scalars['UUID']['output'];
  /** Optional admin label. The uploaded filename lives on the file and is resolved on read. */
  imageLabel?: Maybe<Scalars['String']['output']>;
  /** Signed imgproxy URL rendered at poster size (1920x2160). Built on read. */
  imageURL: Scalars['String']['output'];
  posterID: Scalars['UUID']['output'];
  posterImageID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PosterImageInput = {
  /** 3-60 seconds. Defaults to 10 when omitted. */
  displayDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  displayOrder: Scalars['Int']['input'];
  fileID: Scalars['UUID']['input'];
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Omit to add a new image. Supply an existing id to keep that row's identity across the edit. */
  posterImageID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PosterImagePaged = {
  __typename?: 'PosterImagePaged';
  items: Array<PosterImage>;
  pagination: PaginationResult;
};

export type PosterImageQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  posterID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PosterImageQopInput = {
  filters?: InputMaybe<PosterImageQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosterPaged = {
  __typename?: 'PosterPaged';
  items: Array<Poster>;
  pagination: PaginationResult;
};

export type PosterQopFilterInput = {
  /** Matches posters targeting this branch, all-branch posters included. Resolved in the repository via jsonb containment. */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  posterName?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PosterQopInput = {
  filters?: InputMaybe<PosterQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosterUpdateInput = {
  branches?: InputMaybe<Array<PosterBranchRefInput>>;
  endAt?: InputMaybe<Scalars['Time']['input']>;
  /** Omit to leave the images untouched. When supplied it replaces the set and must not be empty. */
  images?: InputMaybe<Array<PosterImageInput>>;
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  posterID: Scalars['UUID']['input'];
  posterName: Scalars['String']['input'];
  /** 1-5, lower runs first. Must be free among active programs whose branches and schedule overlap. */
  priority: Scalars['Int']['input'];
  /** Leave startAt and endAt both empty for a program that is always shown; filling one requires the other. */
  startAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PriceTagItem = {
  __typename?: 'PriceTagItem';
  barcode: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPercent: Scalars['Float']['output'];
  finalPrice: Scalars['Float']['output'];
  found: Scalars['Boolean']['output'];
  isConsignment: Scalars['Boolean']['output'];
  nominalPrice: Scalars['Float']['output'];
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  promoName: Scalars['String']['output'];
  promoTypeName: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
};

export type Pricelist = {
  __typename?: 'Pricelist';
  channelMarkups: Array<PricelistChannelMarkup>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  pricelistCode: Scalars['String']['output'];
  pricelistId: Scalars['UUID']['output'];
  pricelistName: Scalars['String']['output'];
  pricelistPeriods: Array<PricelistPeriod>;
  uniqueKey: Scalars['String']['output'];
};

export type PricelistChannelMarkup = {
  __typename?: 'PricelistChannelMarkup';
  markupPerc: Scalars['Float']['output'];
  markupSource: Scalars['String']['output'];
  pricelistSalesChannel?: Maybe<PricelistSalesChannel>;
  salesChannel: SalesChannel;
  salesChannelID: Scalars['String']['output'];
};

export type PricelistCreateInput = {
  isActive: Scalars['Boolean']['input'];
  pricelistCode: Scalars['String']['input'];
  pricelistName: Scalars['String']['input'];
  pricelistPeriods: Array<PricelistPeriodCreateFromPricelistInput>;
};

export type PricelistDeleteInput = {
  pricelistId: Scalars['UUID']['input'];
};

export type PricelistPaged = {
  __typename?: 'PricelistPaged';
  items: Array<Pricelist>;
  pagination: PaginationResult;
};

export type PricelistPeriod = {
  __typename?: 'PricelistPeriod';
  effectiveEndDate: Scalars['Time']['output'];
  effectiveEndHour?: Maybe<Scalars['Int']['output']>;
  effectiveEndMinute?: Maybe<Scalars['Int']['output']>;
  effectiveStartDate: Scalars['Time']['output'];
  effectiveStartHour?: Maybe<Scalars['Int']['output']>;
  effectiveStartMinute?: Maybe<Scalars['Int']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  pricelist: Pricelist;
  pricelistID: Scalars['UUID']['output'];
  pricelistPeriodID: Scalars['UUID']['output'];
  pricelistPeriodName: Scalars['String']['output'];
  pricelistProducts: Array<PricelistProduct>;
  priority: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
  useTime: Scalars['Boolean']['output'];
};

export type PricelistPeriodCreateFromPricelistInput = {
  effectiveEndDate: Scalars['Time']['input'];
  effectiveEndHour?: InputMaybe<Scalars['Int']['input']>;
  effectiveEndMinute?: InputMaybe<Scalars['Int']['input']>;
  effectiveStartDate: Scalars['Time']['input'];
  effectiveStartHour?: InputMaybe<Scalars['Int']['input']>;
  effectiveStartMinute?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistPeriodName: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  useTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricelistPeriodCreateInput = {
  effectiveEndDate: Scalars['Time']['input'];
  effectiveEndHour: Scalars['Int']['input'];
  effectiveEndMinute: Scalars['Int']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  effectiveStartHour: Scalars['Int']['input'];
  effectiveStartMinute: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodName: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  useTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricelistPeriodPaged = {
  __typename?: 'PricelistPeriodPaged';
  items?: Maybe<Array<PricelistPeriod>>;
  pagination: PaginationResult;
};

export type PricelistPeriodQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistPeriodName?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  useTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricelistPeriodQopInput = {
  filters?: InputMaybe<PricelistPeriodQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistPeriodUpdateInput = {
  effectiveEndDate: Scalars['Time']['input'];
  effectiveEndHour: Scalars['Int']['input'];
  effectiveEndMinute: Scalars['Int']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  effectiveStartHour: Scalars['Int']['input'];
  effectiveStartMinute: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  pricelistPeriodName: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  useTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricelistProduct = {
  __typename?: 'PricelistProduct';
  entityAuditMetadata: EntityAuditMetadata;
  pricelist: Pricelist;
  pricelistID: Scalars['UUID']['output'];
  pricelistPeriod: PricelistPeriod;
  pricelistPeriodID: Scalars['UUID']['output'];
  pricelistProductID: Scalars['UUID']['output'];
  pricelistProductSalesChannels: Array<PricelistProductSalesChannel>;
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  salesChannelPrice?: Maybe<Scalars['String']['output']>;
  salesChannelPrices: Array<PricelistProductChannelPrice>;
  sellingPrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PricelistProductBulkCreateInput = {
  items: Array<PricelistProductCreateInput>;
};

export type PricelistProductChannelPrice = {
  __typename?: 'PricelistProductChannelPrice';
  autoSellingPrice: Scalars['Float']['output'];
  effectiveSellingPrice: Scalars['Float']['output'];
  priceSource: Scalars['String']['output'];
  pricelistProductSalesChannel?: Maybe<PricelistProductSalesChannel>;
  salesChannel: SalesChannel;
  salesChannelID: Scalars['String']['output'];
};

export type PricelistProductCreateInput = {
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  productID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelPrice?: InputMaybe<Scalars['String']['input']>;
  sellingPrice: Scalars['Float']['input'];
};

export type PricelistProductDeleteInput = {
  pricelistProductID: Scalars['UUID']['input'];
};

export type PricelistProductImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PricelistProductImportFileMappingInput = {
  columns: Array<PricelistProductImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type PricelistProductImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: PricelistProductImportFileMappingInput;
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
};

export type PricelistProductImportResult = {
  __typename?: 'PricelistProductImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type PricelistProductImportRowReport = {
  __typename?: 'PricelistProductImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<PricelistProductImportRowViolation>;
};

export type PricelistProductImportRowViolation = {
  __typename?: 'PricelistProductImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PricelistProductImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: PricelistProductImportFileMappingInput;
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
};

export type PricelistProductImportValidateResult = {
  __typename?: 'PricelistProductImportValidateResult';
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: PricelistProductImportRowReport;
};

export type PricelistProductPaged = {
  __typename?: 'PricelistProductPaged';
  items: Array<PricelistProduct>;
  pagination: PaginationResult;
};

export type PricelistProductQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtBefore?: InputMaybe<Scalars['Time']['input']>;
  createdByUserID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistPeriodID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistProductID?: InputMaybe<Scalars['UUID']['input']>;
  productBrandID?: InputMaybe<Scalars['UUID']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productSourceID?: InputMaybe<Scalars['UUID']['input']>;
  productSubCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productSubDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  searchKeyFull?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtBefore?: InputMaybe<Scalars['Time']['input']>;
  updatedByUserID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PricelistProductQopInput = {
  filters?: InputMaybe<PricelistProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistProductSalesChannel = {
  __typename?: 'PricelistProductSalesChannel';
  customSellingPrice: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  pricelist?: Maybe<Pricelist>;
  pricelistID: Scalars['UUID']['output'];
  pricelistPeriodID: Scalars['UUID']['output'];
  pricelistProduct?: Maybe<PricelistProduct>;
  pricelistProductID: Scalars['UUID']['output'];
  pricelistProductSalesChannelID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  salesChannel?: Maybe<SalesChannel>;
  salesChannelID: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PricelistProductSalesChannelCreateInput = {
  customSellingPrice: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  pricelistProductID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type PricelistProductSalesChannelPaged = {
  __typename?: 'PricelistProductSalesChannelPaged';
  items?: Maybe<Array<PricelistProductSalesChannel>>;
  pagination: PaginationResult;
};

export type PricelistProductSalesChannelQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customSellingPrice?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistPeriodID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistProductID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCode?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PricelistProductSalesChannelQopInput = {
  filters?: InputMaybe<PricelistProductSalesChannelQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistProductSalesChannelUpdateInput = {
  customSellingPrice: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  pricelistProductID: Scalars['UUID']['input'];
  pricelistProductSalesChannelID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type PricelistProductSalesChannelUpsertInput = {
  customSellingPrice: Scalars['Float']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistProductID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type PricelistProductUpdateInput = {
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  pricelistProductID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  salesChannelPrice?: InputMaybe<Scalars['String']['input']>;
  sellingPrice: Scalars['Float']['input'];
};

export type PricelistQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistCode?: InputMaybe<Scalars['String']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistName?: InputMaybe<Scalars['String']['input']>;
  pricelistPeriodID?: InputMaybe<Scalars['UUID']['input']>;
  productBrandID?: InputMaybe<Scalars['UUID']['input']>;
  productCategory?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productSourceID?: InputMaybe<Scalars['UUID']['input']>;
  productSubCategory?: InputMaybe<Scalars['String']['input']>;
  productSubDepartment?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PricelistQopInput = {
  filters?: InputMaybe<PricelistQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistSalesChannel = {
  __typename?: 'PricelistSalesChannel';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  priceMarkupPerc: Scalars['Float']['output'];
  pricelistID: Scalars['UUID']['output'];
  pricelistSalesChannelID: Scalars['UUID']['output'];
  salesChannel?: Maybe<SalesChannel>;
  salesChannelID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PricelistSalesChannelPaged = {
  __typename?: 'PricelistSalesChannelPaged';
  items?: Maybe<Array<PricelistSalesChannel>>;
  pagination: PaginationResult;
};

export type PricelistSalesChannelQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  priceMarkupPerc?: InputMaybe<Scalars['Float']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PricelistSalesChannelQopInput = {
  filters?: InputMaybe<PricelistSalesChannelQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistSalesChannelUpsertInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  priceMarkupPerc: Scalars['Float']['input'];
  pricelistID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type PricelistTagPricesInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistPeriodID?: InputMaybe<Scalars['UUID']['input']>;
  skus: Array<Scalars['String']['input']>;
};

export type PricelistUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  pricelistCode: Scalars['String']['input'];
  pricelistId: Scalars['UUID']['input'];
  pricelistName: Scalars['String']['input'];
  pricelistPeriods?: InputMaybe<Array<PricelistPeriodCreateFromPricelistInput>>;
};

export type Product = {
  __typename?: 'Product';
  addonGroup?: Maybe<ProductAddonGroup>;
  addonGroupID?: Maybe<Scalars['UUID']['output']>;
  altBarcode1?: Maybe<Scalars['String']['output']>;
  altBarcode2?: Maybe<Scalars['String']['output']>;
  barcode: Scalars['String']['output'];
  baseUom?: Maybe<Uom>;
  baseUomID: Scalars['UUID']['output'];
  baseUomPurchaseCost?: Maybe<Scalars['Float']['output']>;
  canBePurchased: Scalars['Boolean']['output'];
  canBeSold: Scalars['Boolean']['output'];
  consignmentVendor?: Maybe<Vendor>;
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  country?: Maybe<Country>;
  countryID?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  hasAddon: Scalars['Boolean']['output'];
  inventoryTrackingType: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isConsignment: Scalars['Boolean']['output'];
  isProduced: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  mainImageFile: File;
  mainImageFileID?: Maybe<Scalars['UUID']['output']>;
  mainImageFileLargePathURL?: Maybe<Scalars['String']['output']>;
  mainImageFileMediumPathURL?: Maybe<Scalars['String']['output']>;
  mainImageFileSmallPathURL?: Maybe<Scalars['String']['output']>;
  minimumOrder: Scalars['Float']['output'];
  pricelistProducts: Array<PricelistProduct>;
  productAIImages: Array<ProductAiImage>;
  productAccountingCategory?: Maybe<ProductAccountingCategory>;
  productAccountingCategoryErpRefID?: Maybe<Scalars['String']['output']>;
  productAccountingCategoryErpRefName?: Maybe<Scalars['String']['output']>;
  productAccountingCategoryID?: Maybe<Scalars['UUID']['output']>;
  productAvailabilityTemplateItems: Array<ProductAvailabilityTemplateItem>;
  productBarcodeMaps: Array<ProductBarcodeMap>;
  productBrand?: Maybe<ProductBrand>;
  productBrandID: Scalars['UUID']['output'];
  productBundleComponents: Array<ProductBundleComponent>;
  productCategory?: Maybe<ProductCategory>;
  productCategoryID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productFiles: Array<ProductFile>;
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productNameAlias: Scalars['String']['output'];
  productSource?: Maybe<ProductSource>;
  productSourceID: Scalars['UUID']['output'];
  productSubCategory?: Maybe<ProductSubCategory>;
  productSubCategoryID: Scalars['UUID']['output'];
  productTagProducts: Array<ProductTagProduct>;
  productType: Scalars['String']['output'];
  productVendors: Array<ProductVendor>;
  purchaseCost?: Maybe<Scalars['Float']['output']>;
  purchaseTax?: Maybe<Tax>;
  purchaseTaxID?: Maybe<Scalars['UUID']['output']>;
  purchaseUom?: Maybe<Uom>;
  purchaseUomID?: Maybe<Scalars['UUID']['output']>;
  salesScanType?: Maybe<Scalars['String']['output']>;
  salesTax?: Maybe<Tax>;
  salesTaxID?: Maybe<Scalars['UUID']['output']>;
  salesUom?: Maybe<Uom>;
  salesUomID?: Maybe<Scalars['UUID']['output']>;
  sellingPrice?: Maybe<Scalars['Float']['output']>;
  trackExpiredDate: Scalars['Boolean']['output'];
  trackStock: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  volumeHeight: Scalars['Float']['output'];
  volumeLength: Scalars['Float']['output'];
  volumeWidth: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type ProductAiImage = {
  __typename?: 'ProductAIImage';
  aiImageType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  productAIImageID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAiImageCreateInput = {
  aiImageType: Scalars['String']['input'];
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL: Scalars['String']['input'];
  imageFileMediumPathURL: Scalars['String']['input'];
  imageFileSmallPathURL: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductAiImageInput = {
  aiImageType: Scalars['String']['input'];
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL?: InputMaybe<Scalars['String']['input']>;
  imageFileMediumPathURL?: InputMaybe<Scalars['String']['input']>;
  imageFileSmallPathURL?: InputMaybe<Scalars['String']['input']>;
  productAIImageID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductAiImagePaged = {
  __typename?: 'ProductAIImagePaged';
  items?: Maybe<Array<ProductAiImage>>;
  pagination: PaginationResult;
};

export type ProductAiImageQopFilterInput = {
  aiImageType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAiImageQopInput = {
  filters?: InputMaybe<ProductAiImageQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAiImageUpdateInput = {
  aiImageType: Scalars['String']['input'];
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL: Scalars['String']['input'];
  imageFileMediumPathURL: Scalars['String']['input'];
  imageFileSmallPathURL: Scalars['String']['input'];
  productAIImageID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductAccountingCategory = {
  __typename?: 'ProductAccountingCategory';
  entityAuditMetadata: EntityAuditMetadata;
  erpRefID?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  productAccountingCategoryID: Scalars['UUID']['output'];
  productAccountingCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAccountingCategoryCreateInput = {
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  productAccountingCategoryName: Scalars['String']['input'];
};

export type ProductAccountingCategoryPaged = {
  __typename?: 'ProductAccountingCategoryPaged';
  items?: Maybe<Array<ProductAccountingCategory>>;
  pagination: PaginationResult;
};

export type ProductAccountingCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productAccountingCategoryName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAccountingCategoryQopInput = {
  filters?: InputMaybe<ProductAccountingCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAccountingCategoryUpdateInput = {
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  productAccountingCategoryID: Scalars['UUID']['input'];
  productAccountingCategoryName: Scalars['String']['input'];
};

export type ProductAddon = {
  __typename?: 'ProductAddon';
  components?: Maybe<Array<ProductAddonComponent>>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isMultiple: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  maxQty?: Maybe<Scalars['Int']['output']>;
  minQty?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  productAddonID: Scalars['UUID']['output'];
  showQty: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAddonComponent = {
  __typename?: 'ProductAddonComponent';
  baseUomQty: Scalars['Float']['output'];
  customSellingPrice: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  priceType: Scalars['String']['output'];
  product?: Maybe<Product>;
  productAddonComponentID: Scalars['UUID']['output'];
  productAddonID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ProductAddonComponentCreateInput = {
  baseUomQty: Scalars['Float']['input'];
  customSellingPrice: Scalars['Float']['input'];
  priceType: Scalars['String']['input'];
  productAddonID: Scalars['UUID']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomConversionDecimal: Scalars['Int']['input'];
  uomConvertionRate: Scalars['Float']['input'];
  uomDecimal: Scalars['Int']['input'];
  uomID: Scalars['UUID']['input'];
  uomName: Scalars['String']['input'];
};

export type ProductAddonComponentInAddonInput = {
  customSellingPrice: Scalars['Float']['input'];
  priceType: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomConversionDecimal: Scalars['Int']['input'];
  uomConvertionRate: Scalars['Float']['input'];
  uomDecimal: Scalars['Int']['input'];
  uomID: Scalars['UUID']['input'];
  uomName: Scalars['String']['input'];
};

export type ProductAddonComponentPaged = {
  __typename?: 'ProductAddonComponentPaged';
  items: Array<ProductAddonComponent>;
  pagination: PaginationResult;
};

export type ProductAddonComponentQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  priceType?: InputMaybe<Scalars['String']['input']>;
  productAddonID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAddonComponentQopInput = {
  filters?: InputMaybe<ProductAddonComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAddonComponentUpdateInput = {
  baseUomQty: Scalars['Float']['input'];
  customSellingPrice: Scalars['Float']['input'];
  priceType: Scalars['String']['input'];
  productAddonComponentID: Scalars['UUID']['input'];
  productAddonID: Scalars['UUID']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomConversionDecimal: Scalars['Int']['input'];
  uomConvertionRate: Scalars['Float']['input'];
  uomDecimal: Scalars['Int']['input'];
  uomID: Scalars['UUID']['input'];
  uomName: Scalars['String']['input'];
};

export type ProductAddonCreateInput = {
  components?: InputMaybe<Array<ProductAddonComponentInAddonInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMultiple: Scalars['Boolean']['input'];
  isRequired: Scalars['Boolean']['input'];
  maxQty?: InputMaybe<Scalars['Int']['input']>;
  minQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  showQty: Scalars['Boolean']['input'];
};

export type ProductAddonGroup = {
  __typename?: 'ProductAddonGroup';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productAddonGroupID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAddonGroupCreateInput = {
  addons?: InputMaybe<Array<ProductAddonGroupItemCreateInGroupInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ProductAddonGroupItem = {
  __typename?: 'ProductAddonGroupItem';
  entityAuditMetadata: EntityAuditMetadata;
  productAddon: ProductAddon;
  productAddonGroupID: Scalars['UUID']['output'];
  productAddonGroupItemID: Scalars['UUID']['output'];
  productAddonID: Scalars['UUID']['output'];
  sequence: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAddonGroupItemCreateInGroupInput = {
  productAddonID: Scalars['UUID']['input'];
};

export type ProductAddonGroupItemCreateInput = {
  productAddonGroupID: Scalars['UUID']['input'];
  productAddonID: Scalars['UUID']['input'];
  sequence: Scalars['Int']['input'];
};

export type ProductAddonGroupItemPaged = {
  __typename?: 'ProductAddonGroupItemPaged';
  items?: Maybe<Array<ProductAddonGroupItem>>;
  pagination: PaginationResult;
};

export type ProductAddonGroupItemQopFilterInput = {
  productAddonGroupID?: InputMaybe<Scalars['UUID']['input']>;
  productAddonID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductAddonGroupItemQopInput = {
  filters?: InputMaybe<ProductAddonGroupItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAddonGroupItemUpdateInput = {
  productAddonGroupID: Scalars['UUID']['input'];
  productAddonGroupItemID: Scalars['UUID']['input'];
  productAddonID: Scalars['UUID']['input'];
  sequence: Scalars['Int']['input'];
};

export type ProductAddonGroupPaged = {
  __typename?: 'ProductAddonGroupPaged';
  items?: Maybe<Array<ProductAddonGroup>>;
  pagination: PaginationResult;
};

export type ProductAddonGroupQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAddonGroupQopInput = {
  filters?: InputMaybe<ProductAddonGroupQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAddonGroupUpdateInput = {
  addons?: InputMaybe<Array<ProductAddonGroupItemCreateInGroupInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productAddonGroupID: Scalars['UUID']['input'];
};

export type ProductAddonPaged = {
  __typename?: 'ProductAddonPaged';
  items?: Maybe<Array<ProductAddon>>;
  pagination: PaginationResult;
};

export type ProductAddonQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAddonQopInput = {
  filters?: InputMaybe<ProductAddonQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAddonUpdateInput = {
  components?: InputMaybe<Array<ProductAddonComponentInAddonInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMultiple: Scalars['Boolean']['input'];
  isRequired: Scalars['Boolean']['input'];
  maxQty?: InputMaybe<Scalars['Int']['input']>;
  minQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  productAddonID: Scalars['UUID']['input'];
  showQty: Scalars['Boolean']['input'];
};

export type ProductAvailabilityTemplate = {
  __typename?: 'ProductAvailabilityTemplate';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productAvailabilityTemplateID: Scalars['UUID']['output'];
  productAvailabilityTemplateName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAvailabilityTemplateCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productAvailabilityTemplateName: Scalars['String']['input'];
};

export type ProductAvailabilityTemplateItem = {
  __typename?: 'ProductAvailabilityTemplateItem';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product: Product;
  productAvailabilityTemplate?: Maybe<ProductAvailabilityTemplate>;
  productAvailabilityTemplateID: Scalars['UUID']['output'];
  productAvailabilityTemplateItemID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  salesChannelIDs: Array<Scalars['String']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type ProductAvailabilityTemplateItemCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productAvailabilityTemplateID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplateItemExportResult = {
  __typename?: 'ProductAvailabilityTemplateItemExportResult';
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type ProductAvailabilityTemplateItemImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProductAvailabilityTemplateItemImportFileMappingInput = {
  columns: Array<ProductAvailabilityTemplateItemImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductAvailabilityTemplateItemImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductAvailabilityTemplateItemImportFileMappingInput;
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplateItemImportResult = {
  __typename?: 'ProductAvailabilityTemplateItemImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type ProductAvailabilityTemplateItemImportRowReport = {
  __typename?: 'ProductAvailabilityTemplateItemImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<ProductAvailabilityTemplateItemImportRowViolation>;
};

export type ProductAvailabilityTemplateItemImportRowViolation = {
  __typename?: 'ProductAvailabilityTemplateItemImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductAvailabilityTemplateItemImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductAvailabilityTemplateItemImportFileMappingInput;
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplateItemImportValidateResult = {
  __typename?: 'ProductAvailabilityTemplateItemImportValidateResult';
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: ProductAvailabilityTemplateItemImportRowReport;
};

export type ProductAvailabilityTemplateItemInput = {
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplateItemPaged = {
  __typename?: 'ProductAvailabilityTemplateItemPaged';
  items?: Maybe<Array<ProductAvailabilityTemplateItem>>;
  pagination: PaginationResult;
};

export type ProductAvailabilityTemplateItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productAvailabilityTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAvailabilityTemplateItemQopInput = {
  filters?: InputMaybe<ProductAvailabilityTemplateItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAvailabilityTemplateItemSetChannelsInput = {
  productAvailabilityTemplateItemID: Scalars['UUID']['input'];
  salesChannelIDs: Array<Scalars['String']['input']>;
};

export type ProductAvailabilityTemplateItemUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productAvailabilityTemplateID: Scalars['UUID']['input'];
  productAvailabilityTemplateItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplatePaged = {
  __typename?: 'ProductAvailabilityTemplatePaged';
  items?: Maybe<Array<ProductAvailabilityTemplate>>;
  pagination: PaginationResult;
};

export type ProductAvailabilityTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productAvailabilityTemplateName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAvailabilityTemplateQopInput = {
  filters?: InputMaybe<ProductAvailabilityTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAvailabilityTemplateUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productAvailabilityTemplateID: Scalars['UUID']['input'];
  productAvailabilityTemplateName: Scalars['String']['input'];
};

export type ProductBarcodeMap = {
  __typename?: 'ProductBarcodeMap';
  barcode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product: Product;
  productBarcodeMapID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductBarcodeMapCreateInput = {
  barcode: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductBarcodeMapPaged = {
  __typename?: 'ProductBarcodeMapPaged';
  items?: Maybe<Array<ProductBarcodeMap>>;
  pagination: PaginationResult;
};

export type ProductBarcodeMapQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBarcodeMapQopInput = {
  filters?: InputMaybe<ProductBarcodeMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBarcodeMapUpdateInput = {
  barcode: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productBarcodeMapID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductBookmark = {
  __typename?: 'ProductBookmark';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productBookmarkID: Scalars['UUID']['output'];
  productBookmarkName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductBookmarkCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productBookmarkName: Scalars['String']['input'];
};

export type ProductBookmarkPaged = {
  __typename?: 'ProductBookmarkPaged';
  items?: Maybe<Array<ProductBookmark>>;
  pagination: PaginationResult;
};

export type ProductBookmarkProduct = {
  __typename?: 'ProductBookmarkProduct';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productBookmark?: Maybe<ProductBookmark>;
  productBookmarkID: Scalars['UUID']['output'];
  productBookmarkName: Scalars['String']['output'];
  productBookmarkProductID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductBookmarkProductCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productBookmarkID: Scalars['UUID']['input'];
  productBookmarkName: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
};

export type ProductBookmarkProductPaged = {
  __typename?: 'ProductBookmarkProductPaged';
  items?: Maybe<Array<ProductBookmarkProduct>>;
  pagination: PaginationResult;
};

export type ProductBookmarkProductQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productBookmarkID?: InputMaybe<Scalars['UUID']['input']>;
  productBookmarkName?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBookmarkProductQopInput = {
  filters?: InputMaybe<ProductBookmarkProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBookmarkProductUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productBookmarkID: Scalars['UUID']['input'];
  productBookmarkName: Scalars['String']['input'];
  productBookmarkProductID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
};

export type ProductBookmarkQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productBookmarkName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBookmarkQopInput = {
  filters?: InputMaybe<ProductBookmarkQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBookmarkUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productBookmarkID: Scalars['UUID']['input'];
  productBookmarkName: Scalars['String']['input'];
};

export type ProductBrand = {
  __typename?: 'ProductBrand';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productBrandID: Scalars['UUID']['output'];
  productBrandName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductBrandCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productBrandName: Scalars['String']['input'];
};

export type ProductBrandPaged = {
  __typename?: 'ProductBrandPaged';
  items?: Maybe<Array<ProductBrand>>;
  pagination: PaginationResult;
};

export type ProductBrandQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productBrandName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBrandQopInput = {
  filters?: InputMaybe<ProductBrandQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBrandUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productBrandID: Scalars['UUID']['input'];
  productBrandName: Scalars['String']['input'];
};

export type ProductBundleComponent = {
  __typename?: 'ProductBundleComponent';
  componentProduct?: Maybe<Product>;
  componentProductID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productBundleComponentID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  uom: Uom;
  uomCategory: UomCategory;
  uomCategoryID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
};

export type ProductBundleComponentCreateInput = {
  componentProductID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductBundleComponentInput = {
  componentProductID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productBundleComponentID?: InputMaybe<Scalars['UUID']['input']>;
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductBundleComponentPaged = {
  __typename?: 'ProductBundleComponentPaged';
  items?: Maybe<Array<ProductBundleComponent>>;
  pagination: PaginationResult;
};

export type ProductBundleComponentQopFilterInput = {
  componentProductID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBundleComponentQopInput = {
  filters?: InputMaybe<ProductBundleComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBundleComponentUpdateInput = {
  componentProductID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productBundleComponentID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productCategoryFullName: Scalars['String']['output'];
  productCategoryID: Scalars['UUID']['output'];
  productCategoryName: Scalars['String']['output'];
  productDepartment?: Maybe<ProductDepartment>;
  productDepartmentID: Scalars['UUID']['output'];
  productDepartmentName: Scalars['String']['output'];
  productDivision?: Maybe<ProductDivision>;
  productDivisionID: Scalars['UUID']['output'];
  productDivisionName: Scalars['String']['output'];
  productSubDepartment?: Maybe<ProductSubDepartment>;
  productSubDepartmentID: Scalars['UUID']['output'];
  productSubDepartmentName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductCategoryCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productCategoryName: Scalars['String']['input'];
  productSubDepartmentID: Scalars['UUID']['input'];
};

export type ProductCategoryPaged = {
  __typename?: 'ProductCategoryPaged';
  items?: Maybe<Array<ProductCategory>>;
  pagination: PaginationResult;
};

export type ProductCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productDivisionID?: InputMaybe<Scalars['UUID']['input']>;
  productSubDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductCategoryQopInput = {
  filters?: InputMaybe<ProductCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductCategorySalesChannelMap = {
  __typename?: 'ProductCategorySalesChannelMap';
  entityAuditMetadata: EntityAuditMetadata;
  externalCategoryID: Scalars['String']['output'];
  externalCategoryName: Scalars['String']['output'];
  externalParentCategoryID: Scalars['String']['output'];
  externalParentCategoryName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  productCategory?: Maybe<ProductCategory>;
  productCategoryID: Scalars['UUID']['output'];
  productCategorySalesChannelMapID: Scalars['UUID']['output'];
  salesChannel?: Maybe<SalesChannel>;
  salesChannelID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductCategorySalesChannelMapCreateInput = {
  externalCategoryID: Scalars['String']['input'];
  externalCategoryName: Scalars['String']['input'];
  externalParentCategoryID: Scalars['String']['input'];
  externalParentCategoryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type ProductCategorySalesChannelMapExportResult = {
  __typename?: 'ProductCategorySalesChannelMapExportResult';
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type ProductCategorySalesChannelMapImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategorySalesChannelMapImportFileMappingInput = {
  columns: Array<ProductCategorySalesChannelMapImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategorySalesChannelMapImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductCategorySalesChannelMapImportFileMappingInput;
  salesChannelID: Scalars['String']['input'];
};

export type ProductCategorySalesChannelMapImportResult = {
  __typename?: 'ProductCategorySalesChannelMapImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type ProductCategorySalesChannelMapImportRowReport = {
  __typename?: 'ProductCategorySalesChannelMapImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<ProductCategorySalesChannelMapImportRowViolation>;
};

export type ProductCategorySalesChannelMapImportRowViolation = {
  __typename?: 'ProductCategorySalesChannelMapImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductCategorySalesChannelMapImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductCategorySalesChannelMapImportFileMappingInput;
  salesChannelID: Scalars['String']['input'];
};

export type ProductCategorySalesChannelMapImportValidateResult = {
  __typename?: 'ProductCategorySalesChannelMapImportValidateResult';
  missingProductCategoryCodes: Array<Scalars['String']['output']>;
  rowReport: ProductCategorySalesChannelMapImportRowReport;
};

export type ProductCategorySalesChannelMapPaged = {
  __typename?: 'ProductCategorySalesChannelMapPaged';
  items: Array<ProductCategorySalesChannelMap>;
  pagination: PaginationResult;
};

export type ProductCategorySalesChannelMapQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalCategoryID?: InputMaybe<Scalars['String']['input']>;
  externalParentCategoryID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductCategorySalesChannelMapQopInput = {
  filters?: InputMaybe<ProductCategorySalesChannelMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductCategorySalesChannelMapUpdateInput = {
  externalCategoryID: Scalars['String']['input'];
  externalCategoryName: Scalars['String']['input'];
  externalParentCategoryID: Scalars['String']['input'];
  externalParentCategoryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  productCategorySalesChannelMapID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type ProductCategoryUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  productCategoryName: Scalars['String']['input'];
  productSubDepartmentID: Scalars['UUID']['input'];
};

export type ProductCreateInput = {
  addonGroupID?: InputMaybe<Scalars['UUID']['input']>;
  altBarcode1?: InputMaybe<Scalars['String']['input']>;
  altBarcode2?: InputMaybe<Scalars['String']['input']>;
  barcode: Scalars['String']['input'];
  baseUomID: Scalars['UUID']['input'];
  canBePurchased: Scalars['Boolean']['input'];
  canBeSold: Scalars['Boolean']['input'];
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasAddon: Scalars['Boolean']['input'];
  inventoryTrackingType?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isConsignment: Scalars['Boolean']['input'];
  isProduced: Scalars['Boolean']['input'];
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  pricelistProducts?: InputMaybe<Array<PricelistProductCreateInput>>;
  productAIImages?: InputMaybe<Array<ProductAiImageInput>>;
  productAccountingCategoryErpRefID?: InputMaybe<Scalars['String']['input']>;
  productAccountingCategoryErpRefName?: InputMaybe<Scalars['String']['input']>;
  productAccountingCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateItems?: InputMaybe<Array<ProductAvailabilityTemplateItemInput>>;
  productBrandID: Scalars['UUID']['input'];
  productBundleComponents?: InputMaybe<Array<ProductBundleComponentInput>>;
  productCategoryID: Scalars['UUID']['input'];
  productCode: Scalars['String']['input'];
  productFiles: Array<ProductFileInput>;
  productName: Scalars['String']['input'];
  productNameAlias?: InputMaybe<Scalars['String']['input']>;
  productSourceID: Scalars['UUID']['input'];
  productSubCategoryID: Scalars['UUID']['input'];
  productTags?: InputMaybe<Array<ProductTagInput>>;
  productType: Scalars['String']['input'];
  productVendors?: InputMaybe<Array<ProductVendorInput>>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseUomID?: InputMaybe<Scalars['UUID']['input']>;
  salesScanType?: InputMaybe<Scalars['String']['input']>;
  salesTaxID?: InputMaybe<Scalars['UUID']['input']>;
  salesUomID?: InputMaybe<Scalars['UUID']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate: Scalars['Boolean']['input'];
  trackStock?: InputMaybe<Scalars['Boolean']['input']>;
  uomCategoryID: Scalars['UUID']['input'];
  vendorConsignmentProductPrices?: InputMaybe<Array<VendorConsignmentProductPriceInput>>;
  volumeHeight?: InputMaybe<Scalars['Float']['input']>;
  volumeLength?: InputMaybe<Scalars['Float']['input']>;
  volumeWidth?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductDepartment = {
  __typename?: 'ProductDepartment';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productDepartmentID: Scalars['UUID']['output'];
  productDepartmentName: Scalars['String']['output'];
  productDivision: ProductDivision;
  productDivisionID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductDepartmentCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productDepartmentName: Scalars['String']['input'];
  productDivisionID: Scalars['UUID']['input'];
};

export type ProductDepartmentPaged = {
  __typename?: 'ProductDepartmentPaged';
  items?: Maybe<Array<ProductDepartment>>;
  pagination: PaginationResult;
};

export type ProductDepartmentQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productDepartmentName?: InputMaybe<Scalars['String']['input']>;
  productDivisionID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductDepartmentQopInput = {
  filters?: InputMaybe<ProductDepartmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductDepartmentUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productDepartmentID: Scalars['UUID']['input'];
  productDepartmentName: Scalars['String']['input'];
  productDivisionID: Scalars['UUID']['input'];
};

export type ProductDivision = {
  __typename?: 'ProductDivision';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productDepartments: Array<ProductDepartment>;
  productDivisionID: Scalars['UUID']['output'];
  productDivisionName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductDivisionCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productDivisionName: Scalars['String']['input'];
};

export type ProductDivisionPaged = {
  __typename?: 'ProductDivisionPaged';
  items?: Maybe<Array<ProductDivision>>;
  pagination: PaginationResult;
};

export type ProductDivisionQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productDivisionName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductDivisionQopInput = {
  filters?: InputMaybe<ProductDivisionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductDivisionUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productDivisionID: Scalars['UUID']['input'];
  productDivisionName: Scalars['String']['input'];
};

export type ProductFile = {
  __typename?: 'ProductFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  productFileID: Scalars['UUID']['output'];
  productFileType: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductFileCreateInput = {
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL: Scalars['String']['input'];
  imageFileMediumPathURL: Scalars['String']['input'];
  imageFileSmallPathURL: Scalars['String']['input'];
  productFileType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductFileInput = {
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL?: InputMaybe<Scalars['String']['input']>;
  imageFileMediumPathURL?: InputMaybe<Scalars['String']['input']>;
  imageFileSmallPathURL?: InputMaybe<Scalars['String']['input']>;
  productFileID?: InputMaybe<Scalars['UUID']['input']>;
  productFileType: Scalars['String']['input'];
};

export type ProductFilePaged = {
  __typename?: 'ProductFilePaged';
  items?: Maybe<Array<ProductFile>>;
  pagination: PaginationResult;
};

export type ProductFileQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  productFileType?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductFileQopInput = {
  filters?: InputMaybe<ProductFileQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductFileUpdateInput = {
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL: Scalars['String']['input'];
  imageFileMediumPathURL: Scalars['String']['input'];
  imageFileSmallPathURL: Scalars['String']['input'];
  productFileID: Scalars['UUID']['input'];
  productFileType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
};

export enum ProductImageEmbeddingChangeOp {
  Delete = 'DELETE',
  Upsert = 'UPSERT'
}

export type ProductImageEmbeddingSyncHead = {
  __typename?: 'ProductImageEmbeddingSyncHead';
  lancedbCount: Scalars['Int']['output'];
  latestSeq: Scalars['Int']['output'];
};

export type ProductImportColumnInput = {
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
};

export type ProductImportFileMappingInput = {
  columns: Array<ProductImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductImportFileMappingInput;
};

export type ProductImportMissing = {
  __typename?: 'ProductImportMissing';
  accountingCategories: Array<Scalars['String']['output']>;
  brands: Array<Scalars['String']['output']>;
  categories: Array<Scalars['String']['output']>;
  countries: Array<Scalars['String']['output']>;
  sources: Array<Scalars['String']['output']>;
  subCategories: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  taxes: Array<Scalars['String']['output']>;
  uomCategories: Array<Scalars['String']['output']>;
  uoms: Array<Scalars['String']['output']>;
  vendors: Array<Scalars['String']['output']>;
};

export type ProductImportPreviewRow = {
  __typename?: 'ProductImportPreviewRow';
  action: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type ProductImportResult = {
  __typename?: 'ProductImportResult';
  backgroundJobID: Scalars['UUID']['output'];
};

export type ProductImportRowIssue = {
  __typename?: 'ProductImportRowIssue';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductImportRowReport = {
  __typename?: 'ProductImportRowReport';
  createRowCount: Scalars['Int']['output'];
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  updateRowCount: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<ProductImportRowIssue>;
  warningRowCount: Scalars['Int']['output'];
  warningSample: Array<ProductImportRowIssue>;
};

export type ProductImportValidateResult = {
  __typename?: 'ProductImportValidateResult';
  missing: ProductImportMissing;
  rowReport: ProductImportRowReport;
  status: Scalars['String']['output'];
  updatedRows: Array<ProductImportPreviewRow>;
};

export type ProductPaged = {
  __typename?: 'ProductPaged';
  items?: Maybe<Array<Product>>;
  pagination: PaginationResult;
};

export type ProductQopFilterInput = {
  altBarcode1?: InputMaybe<Scalars['String']['input']>;
  altBarcode2?: InputMaybe<Scalars['String']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  baseUomID?: InputMaybe<Scalars['UUID']['input']>;
  baseUomPurchaseCost?: InputMaybe<Scalars['Float']['input']>;
  canBePurchased?: InputMaybe<Scalars['Boolean']['input']>;
  canBeSold?: InputMaybe<Scalars['Boolean']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  excludeProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  inventoryTrackingType?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isProduced?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  mainImageFileID?: InputMaybe<Scalars['UUID']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  productAccountingCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productBrandID?: InputMaybe<Scalars['UUID']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productDivisionID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productNameAlias?: InputMaybe<Scalars['String']['input']>;
  productSourceID?: InputMaybe<Scalars['UUID']['input']>;
  productSubCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productSubDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  productTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseUomID?: InputMaybe<Scalars['UUID']['input']>;
  purchasingVendorID?: InputMaybe<Scalars['UUID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  salesScanType?: InputMaybe<Scalars['String']['input']>;
  salesTaxID?: InputMaybe<Scalars['UUID']['input']>;
  salesUomID?: InputMaybe<Scalars['UUID']['input']>;
  searchKeyFull?: InputMaybe<Scalars['String']['input']>;
  searchKeyScan?: InputMaybe<Scalars['String']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate?: InputMaybe<Scalars['Boolean']['input']>;
  trackStock?: InputMaybe<Scalars['Boolean']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductQopInput = {
  filters?: InputMaybe<ProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSalesChannelItemMap = {
  __typename?: 'ProductSalesChannelItemMap';
  barcode: Scalars['String']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalItemID: Scalars['String']['output'];
  externalItemName: Scalars['String']['output'];
  externalVariantID: Scalars['String']['output'];
  externalVariantName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productSalesChannelItemMapID: Scalars['UUID']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductSalesChannelItemMapCreateInput = {
  barcode: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  externalItemID: Scalars['String']['input'];
  externalItemName: Scalars['String']['input'];
  externalVariantID: Scalars['String']['input'];
  externalVariantName: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName: Scalars['String']['input'];
};

export type ProductSalesChannelItemMapPaged = {
  __typename?: 'ProductSalesChannelItemMapPaged';
  items: Array<ProductSalesChannelItemMap>;
  pagination: PaginationResult;
};

export type ProductSalesChannelItemMapQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalItemID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductSalesChannelItemMapQopInput = {
  filters?: InputMaybe<ProductSalesChannelItemMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSalesChannelItemMapUpdateInput = {
  barcode: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  externalItemID: Scalars['String']['input'];
  externalItemName: Scalars['String']['input'];
  externalVariantID: Scalars['String']['input'];
  externalVariantName: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  productSalesChannelItemMapID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName: Scalars['String']['input'];
};

export type ProductSource = {
  __typename?: 'ProductSource';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productSourceCode: Scalars['String']['output'];
  productSourceID: Scalars['UUID']['output'];
  productSourceName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductSourceCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productSourceCode: Scalars['String']['input'];
  productSourceName: Scalars['String']['input'];
};

export type ProductSourcePaged = {
  __typename?: 'ProductSourcePaged';
  items?: Maybe<Array<ProductSource>>;
  pagination: PaginationResult;
};

export type ProductSourceQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productSourceCode?: InputMaybe<Scalars['String']['input']>;
  productSourceName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductSourceQopInput = {
  filters?: InputMaybe<ProductSourceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSourceUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productSourceCode: Scalars['String']['input'];
  productSourceID: Scalars['UUID']['input'];
  productSourceName: Scalars['String']['input'];
};

export type ProductSubCategory = {
  __typename?: 'ProductSubCategory';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productCategory?: Maybe<ProductCategory>;
  productCategoryID: Scalars['UUID']['output'];
  productSubCategoryID: Scalars['UUID']['output'];
  productSubCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductSubCategoryCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  productSubCategoryName: Scalars['String']['input'];
};

export type ProductSubCategoryPaged = {
  __typename?: 'ProductSubCategoryPaged';
  items?: Maybe<Array<ProductSubCategory>>;
  pagination: PaginationResult;
};

export type ProductSubCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productSubCategoryName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductSubCategoryQopInput = {
  filters?: InputMaybe<ProductSubCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSubCategoryUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  productSubCategoryID: Scalars['UUID']['input'];
  productSubCategoryName: Scalars['String']['input'];
};

export type ProductSubDepartment = {
  __typename?: 'ProductSubDepartment';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productDepartment: ProductDepartment;
  productDepartmentID: Scalars['UUID']['output'];
  productSubDepartmentID: Scalars['UUID']['output'];
  productSubDepartmentName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductSubDepartmentCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productDepartmentID: Scalars['UUID']['input'];
  productSubDepartmentName: Scalars['String']['input'];
};

export type ProductSubDepartmentPaged = {
  __typename?: 'ProductSubDepartmentPaged';
  items?: Maybe<Array<ProductSubDepartment>>;
  pagination: PaginationResult;
};

export type ProductSubDepartmentQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productSubDepartmentName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductSubDepartmentQopInput = {
  filters?: InputMaybe<ProductSubDepartmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSubDepartmentUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productDepartmentID: Scalars['UUID']['input'];
  productSubDepartmentID: Scalars['UUID']['input'];
  productSubDepartmentName: Scalars['String']['input'];
};

export type ProductTag = {
  __typename?: 'ProductTag';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productTagID: Scalars['UUID']['output'];
  productTagName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductTagCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productTagName: Scalars['String']['input'];
};

export type ProductTagInput = {
  productTagID: Scalars['UUID']['input'];
};

export type ProductTagPaged = {
  __typename?: 'ProductTagPaged';
  items?: Maybe<Array<ProductTag>>;
  pagination: PaginationResult;
};

export type ProductTagProduct = {
  __typename?: 'ProductTagProduct';
  entityAuditMetadata: EntityAuditMetadata;
  productID: Scalars['UUID']['output'];
  productTag: ProductTag;
  productTagID: Scalars['UUID']['output'];
  productTagProductID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductTagProductCreateInput = {
  productID: Scalars['UUID']['input'];
  productTagID: Scalars['UUID']['input'];
};

export type ProductTagProductPaged = {
  __typename?: 'ProductTagProductPaged';
  items?: Maybe<Array<ProductTagProduct>>;
  pagination: PaginationResult;
};

export type ProductTagProductQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productTagID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductTagProductQopInput = {
  filters?: InputMaybe<ProductTagProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductTagProductUpdateInput = {
  productID: Scalars['UUID']['input'];
  productTagID: Scalars['UUID']['input'];
  productTagProductID: Scalars['UUID']['input'];
};

export type ProductTagQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productTagName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductTagQopInput = {
  filters?: InputMaybe<ProductTagQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductTagUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productTagID: Scalars['UUID']['input'];
  productTagName: Scalars['String']['input'];
};

export type ProductUpdateInput = {
  addonGroupID?: InputMaybe<Scalars['UUID']['input']>;
  altBarcode1?: InputMaybe<Scalars['String']['input']>;
  altBarcode2?: InputMaybe<Scalars['String']['input']>;
  barcode: Scalars['String']['input'];
  baseUomID: Scalars['UUID']['input'];
  canBePurchased: Scalars['Boolean']['input'];
  canBeSold: Scalars['Boolean']['input'];
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasAddon: Scalars['Boolean']['input'];
  inventoryTrackingType?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isConsignment: Scalars['Boolean']['input'];
  isProduced: Scalars['Boolean']['input'];
  isSystem: Scalars['Boolean']['input'];
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  productAIImages?: InputMaybe<Array<ProductAiImageInput>>;
  productAccountingCategoryErpRefID?: InputMaybe<Scalars['String']['input']>;
  productAccountingCategoryErpRefName?: InputMaybe<Scalars['String']['input']>;
  productAccountingCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateItems?: InputMaybe<Array<ProductAvailabilityTemplateItemInput>>;
  productBrandID: Scalars['UUID']['input'];
  productBundleComponents?: InputMaybe<Array<ProductBundleComponentInput>>;
  productCategoryID: Scalars['UUID']['input'];
  productCode: Scalars['String']['input'];
  productFiles: Array<ProductFileInput>;
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  productNameAlias?: InputMaybe<Scalars['String']['input']>;
  productSourceID: Scalars['UUID']['input'];
  productSubCategoryID: Scalars['UUID']['input'];
  productTags?: InputMaybe<Array<ProductTagInput>>;
  productType: Scalars['String']['input'];
  productVendors?: InputMaybe<Array<ProductVendorInput>>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseUomID?: InputMaybe<Scalars['UUID']['input']>;
  salesScanType?: InputMaybe<Scalars['String']['input']>;
  salesTaxID?: InputMaybe<Scalars['UUID']['input']>;
  salesUomID?: InputMaybe<Scalars['UUID']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate: Scalars['Boolean']['input'];
  trackStock: Scalars['Boolean']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  vendorConsignmentProductPrices?: InputMaybe<Array<VendorConsignmentProductPriceInput>>;
  volumeHeight?: InputMaybe<Scalars['Float']['input']>;
  volumeLength?: InputMaybe<Scalars['Float']['input']>;
  volumeWidth?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductValidationResult = {
  __typename?: 'ProductValidationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productID?: Maybe<Scalars['UUID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  putawayTaskItemID?: Maybe<Scalars['UUID']['output']>;
  qtyOutstanding?: Maybe<Scalars['Float']['output']>;
  uomConversionDecimal?: Maybe<Scalars['Int']['output']>;
  uomConvertionRate?: Maybe<Scalars['Float']['output']>;
  uomDecimal?: Maybe<Scalars['Int']['output']>;
  uomID?: Maybe<Scalars['UUID']['output']>;
  uomName?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type ProductVendor = {
  __typename?: 'ProductVendor';
  canBeReturned: Scalars['Boolean']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  minimumOrder: Scalars['Float']['output'];
  product: Product;
  productId: Scalars['UUID']['output'];
  productVendorID: Scalars['UUID']['output'];
  purchasePrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  vendor: Vendor;
  vendorId: Scalars['UUID']['output'];
};

export type ProductVendorCreateInput = {
  canBeReturned: Scalars['Boolean']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrder: Scalars['Float']['input'];
  productID: Scalars['UUID']['input'];
  purchasePrice: Scalars['Float']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type ProductVendorInput = {
  canBeReturned: Scalars['Boolean']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  productVendorID?: InputMaybe<Scalars['UUID']['input']>;
  purchasePrice: Scalars['Float']['input'];
  vendorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductVendorPaged = {
  __typename?: 'ProductVendorPaged';
  items?: Maybe<Array<ProductVendor>>;
  pagination: PaginationResult;
};

export type ProductVendorQopFilterInput = {
  canBeReturned?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductVendorQopInput = {
  filters?: InputMaybe<ProductVendorQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductVendorUpdateInput = {
  canBeReturned: Scalars['Boolean']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrder: Scalars['Float']['input'];
  productID: Scalars['UUID']['input'];
  productVendorID: Scalars['UUID']['input'];
  purchasePrice: Scalars['Float']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type ProductionOrder = {
  __typename?: 'ProductionOrder';
  baseUomQty: Scalars['Float']['output'];
  billOfMaterial: BillOfMaterial;
  billOfMaterialID: Scalars['UUID']['output'];
  bomBaseUomQty: Scalars['Float']['output'];
  bomQty: Scalars['Float']['output'];
  bomUomConversionDecimal: Scalars['Int']['output'];
  bomUomConvertionRate: Scalars['Float']['output'];
  bomUomID: Scalars['UUID']['output'];
  branchID: Scalars['UUID']['output'];
  components: Array<ProductionOrderComponent>;
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  gmt: Scalars['Int']['output'];
  lotNo: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productionOrderDatetime: Scalars['Time']['output'];
  productionOrderDatetimeUTC?: Maybe<Scalars['Time']['output']>;
  productionOrderID: Scalars['UUID']['output'];
  productionOrderNumber: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
  waste?: Maybe<Scalars['Float']['output']>;
  wastePerc?: Maybe<Scalars['Float']['output']>;
};

export type ProductionOrderComponent = {
  __typename?: 'ProductionOrderComponent';
  baseUomQty: Scalars['Float']['output'];
  bomBaseQtyDiff?: Maybe<Scalars['Float']['output']>;
  bomBaseUomQty?: Maybe<Scalars['Float']['output']>;
  bomQty?: Maybe<Scalars['Float']['output']>;
  bomUomConversionDecimal?: Maybe<Scalars['Int']['output']>;
  bomUomConvertionRate?: Maybe<Scalars['Float']['output']>;
  bomUomID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isManual: Scalars['Boolean']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productionOrderComponentID: Scalars['UUID']['output'];
  productionOrderID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ProductionOrderComponentCreateInput = {
  bomBaseQtyDiff: Scalars['Float']['input'];
  bomQty?: InputMaybe<Scalars['Float']['input']>;
  bomUomID?: InputMaybe<Scalars['UUID']['input']>;
  isManual: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductionOrderComponentPaged = {
  __typename?: 'ProductionOrderComponentPaged';
  items: Array<ProductionOrderComponent>;
  pagination: PaginationResult;
};

export type ProductionOrderComponentQopFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productionOrderID?: InputMaybe<Scalars['UUID']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
};

export type ProductionOrderComponentQopInput = {
  filters?: InputMaybe<ProductionOrderComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductionOrderComponentUpdateInput = {
  bomBaseQtyDiff: Scalars['Float']['input'];
  bomQty?: InputMaybe<Scalars['Float']['input']>;
  bomUomID?: InputMaybe<Scalars['UUID']['input']>;
  isManual: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  productionOrderComponentID?: InputMaybe<Scalars['UUID']['input']>;
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductionOrderCreateInput = {
  billOfMaterialID: Scalars['UUID']['input'];
  bomQty?: InputMaybe<Scalars['Float']['input']>;
  bomUomID?: InputMaybe<Scalars['UUID']['input']>;
  branchID: Scalars['UUID']['input'];
  components: Array<ProductionOrderComponentCreateInput>;
  expiryDate: Scalars['Time']['input'];
  gmt: Scalars['Int']['input'];
  lotNo?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  productionOrderDatetime: Scalars['Time']['input'];
  productionOrderNumber?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
  status: Scalars['String']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
  waste?: InputMaybe<Scalars['Float']['input']>;
  wastePerc?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductionOrderPaged = {
  __typename?: 'ProductionOrderPaged';
  items: Array<ProductionOrder>;
  pagination: PaginationResult;
};

export type ProductionOrderQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productionOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  productionOrderDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  productionOrderDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  productionOrderNumber?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductionOrderQopInput = {
  filters?: InputMaybe<ProductionOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductionOrderUpdateInput = {
  billOfMaterialID: Scalars['UUID']['input'];
  bomQty?: InputMaybe<Scalars['Float']['input']>;
  bomUomID?: InputMaybe<Scalars['UUID']['input']>;
  branchID: Scalars['UUID']['input'];
  components: Array<ProductionOrderComponentUpdateInput>;
  expiryDate: Scalars['Time']['input'];
  gmt: Scalars['Int']['input'];
  lotNo?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  productionOrderDatetime: Scalars['Time']['input'];
  productionOrderID: Scalars['UUID']['input'];
  productionOrderNumber?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
  status: Scalars['String']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
  waste?: InputMaybe<Scalars['Float']['input']>;
  wastePerc?: InputMaybe<Scalars['Float']['input']>;
};

export type Promo = {
  __typename?: 'Promo';
  branches?: Maybe<Array<PromoBranchRef>>;
  description: Scalars['String']['output'];
  effectiveEndDate: Scalars['Time']['output'];
  effectiveStartDate: Scalars['Time']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expenseAccountCode?: Maybe<Scalars['String']['output']>;
  expenseAccountErpRefID?: Maybe<Scalars['String']['output']>;
  expenseAccountErpRefName?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAllBranches: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  promoID: Scalars['UUID']['output'];
  promoName: Scalars['String']['output'];
  /** Extensible promo rules object (availability, min_basket, max_usage, payment_method, etc.) */
  promoRules?: Maybe<PromoRules>;
};

export type PromoAvailabilityRule = {
  __typename?: 'PromoAvailabilityRule';
  allDay: Scalars['Boolean']['output'];
  days: Array<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  useTime: Scalars['Boolean']['output'];
};

export type PromoAvailabilityRuleInput = {
  allDay: Scalars['Boolean']['input'];
  days: Array<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  useTime: Scalars['Boolean']['input'];
};

export type PromoBranchRef = {
  __typename?: 'PromoBranchRef';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  branchName?: Maybe<Scalars['String']['output']>;
};

export type PromoBranchRefInput = {
  branchID: Scalars['UUID']['input'];
};

/**
 * Promo Cat1: Buy Product X Get Discount % per Product.
 * Example: selected SKUs get 10% discount.
 *
 * Each element in PromoBulkCat1RuleInput represents a single promo row (CAT1)
 * that will share the same branches and availabilityRules (TnC) defined in the
 * PromoBulkCreateInput header.
 *
 * Quota: Per-product quota - each product has its own usage limit per branch.
 */
export type PromoBulkCat1RuleInput = {
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  productQuotas?: InputMaybe<Array<PromoProductQuotaInput>>;
  products: Array<PromoProductInput>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat1UpdateRuleInput = {
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  productQuotas?: InputMaybe<Array<PromoProductQuotaInput>>;
  products: Array<PromoProductInput>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/**
 * Promo Cat2: Buy Product X Get Product Y (free product pool).
 * Example: buy 2 of product A, get 1 free from a pool of products B/C.
 *
 * Each element in PromoBulkCat2RuleInput represents a single promo row (CAT2)
 * that will share the same branches and availabilityRules (TnC) defined in the
 * PromoBulkCreateInput header.
 *
 * Quota: Per-promo quota - single quota applies to entire promo (all products share).
 */
export type PromoBulkCat2RuleInput = {
  buyProducts: Array<PromoProductInput>;
  description: Scalars['String']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  freeQty: Scalars['Int']['input'];
  getFreeProducts: Array<PromoProductInput>;
  isMultiple: Scalars['Boolean']['input'];
  minQty: Scalars['Int']['input'];
  promoTypeID: Scalars['UUID']['input'];
  quota?: InputMaybe<PromoQuotaInput>;
};

export type PromoBulkCat2UpdateRuleInput = {
  buyProducts: Array<PromoProductInput>;
  description: Scalars['String']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  freeQty: Scalars['Int']['input'];
  getFreeProducts: Array<PromoProductInput>;
  isMultiple: Scalars['Boolean']['input'];
  minQty: Scalars['Int']['input'];
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
  quota?: InputMaybe<PromoQuotaInput>;
};

/**
 * Promo Cat3: Buy Product x Get Discount (amount).
 * Example: buy selected SKUs, get RpX off.
 *
 * Quota: Per-product quota - each product has its own usage limit per branch.
 */
export type PromoBulkCat3RuleInput = {
  description: Scalars['String']['input'];
  discountAmount: Scalars['Float']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  productQuotas?: InputMaybe<Array<PromoProductQuotaInput>>;
  products: Array<PromoProductInput>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat3UpdateRuleInput = {
  description: Scalars['String']['input'];
  discountAmount: Scalars['Float']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  productQuotas?: InputMaybe<Array<PromoProductQuotaInput>>;
  products: Array<PromoProductInput>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/** Promo Cat4: Discount All Products by Percentage (basket-level). */
export type PromoBulkCat4RuleInput = {
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat4UpdateRuleInput = {
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/** Promo Cat5: Discount All Products by Nominal amount (basket-level). */
export type PromoBulkCat5RuleInput = {
  description: Scalars['String']['input'];
  discountAmount: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat5UpdateRuleInput = {
  description: Scalars['String']['input'];
  discountAmount: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/**
 * Promo Cat6: Discount Product Category by Percentage.
 * Example: discount 10% for all products in selected categories.
 */
export type PromoBulkCat6RuleInput = {
  categories: Array<PromoCategoryInput>;
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat6UpdateRuleInput = {
  categories: Array<PromoCategoryInput>;
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/**
 * Bulk create promo API.
 *
 * Branches and availabilityRules (TnC) are defined once at the header level and
 * will be applied to every generated promo row from cat1Rules..cat6Rules.
 * Each rule element corresponds to a single promo row in the promo table.
 */
export type PromoBulkCreateInput = {
  branches?: InputMaybe<Array<PromoBranchRefInput>>;
  cat1Rules?: InputMaybe<Array<PromoBulkCat1RuleInput>>;
  cat2Rules?: InputMaybe<Array<PromoBulkCat2RuleInput>>;
  cat3Rules?: InputMaybe<Array<PromoBulkCat3RuleInput>>;
  cat4Rules?: InputMaybe<Array<PromoBulkCat4RuleInput>>;
  cat5Rules?: InputMaybe<Array<PromoBulkCat5RuleInput>>;
  cat6Rules?: InputMaybe<Array<PromoBulkCat6RuleInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate: Scalars['Time']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  expenseAccountCode?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  promoName: Scalars['String']['input'];
  /** Extensible promo rules object (availability, min_basket, max_usage, payment_method, etc.) */
  promoRules?: InputMaybe<PromoRulesInput>;
};

export type PromoBulkUpdateInput = {
  branches?: InputMaybe<Array<PromoBranchRefInput>>;
  cat1Rules?: InputMaybe<Array<PromoBulkCat1UpdateRuleInput>>;
  cat2Rules?: InputMaybe<Array<PromoBulkCat2UpdateRuleInput>>;
  cat3Rules?: InputMaybe<Array<PromoBulkCat3UpdateRuleInput>>;
  cat4Rules?: InputMaybe<Array<PromoBulkCat4UpdateRuleInput>>;
  cat5Rules?: InputMaybe<Array<PromoBulkCat5UpdateRuleInput>>;
  cat6Rules?: InputMaybe<Array<PromoBulkCat6UpdateRuleInput>>;
  componentSyncMode?: InputMaybe<PromoComponentSyncMode>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate: Scalars['Time']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  expenseAccountCode?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  promoID: Scalars['UUID']['input'];
  promoName: Scalars['String']['input'];
  /** Extensible promo rules object (availability, min_basket, max_usage, payment_method, etc.) */
  promoRules?: InputMaybe<PromoRulesInput>;
};

export type PromoCat1Detail = {
  __typename?: 'PromoCAT1Detail';
  configCat1: PromoConfigCat1;
  promo: Promo;
};

export type PromoCat2Detail = {
  __typename?: 'PromoCAT2Detail';
  configCat2: PromoConfigCat2;
  promo: Promo;
};

export type PromoCat3Detail = {
  __typename?: 'PromoCAT3Detail';
  configCat3: PromoConfigCat3;
  promo: Promo;
};

export type PromoCat4Detail = {
  __typename?: 'PromoCAT4Detail';
  configCat4: PromoConfigCat4;
  promo: Promo;
};

export type PromoCat5Detail = {
  __typename?: 'PromoCAT5Detail';
  configCat5: PromoConfigCat5;
  promo: Promo;
};

export type PromoCat6Detail = {
  __typename?: 'PromoCAT6Detail';
  configCat6: PromoConfigCat6;
  promo: Promo;
};

export type PromoCategory = {
  __typename?: 'PromoCategory';
  productCategory: ProductCategory;
  productCategoryID: Scalars['UUID']['output'];
  productCategoryName?: Maybe<Scalars['String']['output']>;
};

/** Reference to a product category (used by CAT6). */
export type PromoCategoryInput = {
  productCategoryID: Scalars['UUID']['input'];
};

export type PromoComponent = {
  __typename?: 'PromoComponent';
  config: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  promo: Promo;
  promoComponentID: Scalars['UUID']['output'];
  promoID: Scalars['UUID']['output'];
  promoType: PromoType;
  promoTypeID: Scalars['UUID']['output'];
};

export type PromoComponentCat1Detail = {
  __typename?: 'PromoComponentCAT1Detail';
  config: PromoConfigCat1;
  promoComponent: PromoComponent;
};

export type PromoComponentCat2Detail = {
  __typename?: 'PromoComponentCAT2Detail';
  config: PromoConfigCat2;
  promoComponent: PromoComponent;
};

export type PromoComponentCat3Detail = {
  __typename?: 'PromoComponentCAT3Detail';
  config: PromoConfigCat3;
  promoComponent: PromoComponent;
};

export type PromoComponentCat4Detail = {
  __typename?: 'PromoComponentCAT4Detail';
  config: PromoConfigCat4;
  promoComponent: PromoComponent;
};

export type PromoComponentCat5Detail = {
  __typename?: 'PromoComponentCAT5Detail';
  config: PromoConfigCat5;
  promoComponent: PromoComponent;
};

export type PromoComponentCat6Detail = {
  __typename?: 'PromoComponentCAT6Detail';
  config: PromoConfigCat6;
  promoComponent: PromoComponent;
};

export type PromoComponentImportColumnInput = {
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
};

export type PromoComponentImportComponent = {
  __typename?: 'PromoComponentImportComponent';
  description: Scalars['String']['output'];
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  enableQuota: Scalars['Boolean']['output'];
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  freeQty?: Maybe<Scalars['Int']['output']>;
  getFreeProducts: Array<PromoImportedItem>;
  isMultiple?: Maybe<Scalars['Boolean']['output']>;
  minQty?: Maybe<Scalars['Int']['output']>;
  products: Array<PromoImportedItem>;
  promoComponentID?: Maybe<Scalars['UUID']['output']>;
  promoTypeID: Scalars['UUID']['output'];
  quotaMaxQty?: Maybe<Scalars['Int']['output']>;
};

export type PromoComponentImportFileMappingInput = {
  columns: Array<PromoComponentImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoComponentImportRowReport = {
  __typename?: 'PromoComponentImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<PromoComponentImportRowViolation>;
};

export type PromoComponentImportRowViolation = {
  __typename?: 'PromoComponentImportRowViolation';
  componentName: Scalars['String']['output'];
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PromoComponentImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: PromoComponentImportFileMappingInput;
  promoID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoComponentImportValidateResult = {
  __typename?: 'PromoComponentImportValidateResult';
  components: Array<PromoComponentImportComponent>;
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: PromoComponentImportRowReport;
};

export type PromoComponentPaged = {
  __typename?: 'PromoComponentPaged';
  items?: Maybe<Array<PromoComponent>>;
  pagination: PaginationResult;
};

export type PromoComponentQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  promoID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PromoComponentQopInput = {
  filters?: InputMaybe<PromoComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PromoComponentQuota = {
  __typename?: 'PromoComponentQuota';
  maxQty: Scalars['Int']['output'];
};

/**
 * How the components in this payload relate to the ones the promo already has.
 * SNAPSHOT, the default, is the historical behaviour: the payload is the complete
 * list and any component missing from it is deleted. MERGE adds and updates only
 * what is sent and leaves the rest alone, which is what an import of a promo with
 * more components than the form can load needs.
 */
export enum PromoComponentSyncMode {
  Merge = 'MERGE',
  Snapshot = 'SNAPSHOT'
}

export type PromoConfigCat1 = {
  __typename?: 'PromoConfigCAT1';
  branches: Array<PromoBranchRef>;
  discountPercent: Scalars['Float']['output'];
  enableQuota: Scalars['Boolean']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  productQuotas?: Maybe<Array<PromoProductQuota>>;
  products: Array<PromoProduct>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoConfigCat2 = {
  __typename?: 'PromoConfigCAT2';
  branches: Array<PromoBranchRef>;
  buyProducts: Array<PromoProduct>;
  enableQuota: Scalars['Boolean']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  freeQty: Scalars['Int']['output'];
  getFreeProducts: Array<PromoProduct>;
  isMultiple: Scalars['Boolean']['output'];
  minQty: Scalars['Int']['output'];
  promoRules?: Maybe<PromoRules>;
  quota?: Maybe<PromoComponentQuota>;
};

export type PromoConfigCat3 = {
  __typename?: 'PromoConfigCAT3';
  branches: Array<PromoBranchRef>;
  discountAmount: Scalars['Float']['output'];
  enableQuota: Scalars['Boolean']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  productQuotas?: Maybe<Array<PromoProductQuota>>;
  products: Array<PromoProduct>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoConfigCat4 = {
  __typename?: 'PromoConfigCAT4';
  branches: Array<PromoBranchRef>;
  discountPercent: Scalars['Float']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoConfigCat5 = {
  __typename?: 'PromoConfigCAT5';
  branches: Array<PromoBranchRef>;
  discountAmount: Scalars['Float']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoConfigCat6 = {
  __typename?: 'PromoConfigCAT6';
  branches: Array<PromoBranchRef>;
  categories: Array<PromoCategory>;
  discountPercent: Scalars['Float']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoImportedItem = {
  __typename?: 'PromoImportedItem';
  barcode: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  quotaMaxQty?: Maybe<Scalars['Int']['output']>;
};

export type PromoPaged = {
  __typename?: 'PromoPaged';
  items?: Maybe<Array<Promo>>;
  pagination: PaginationResult;
};

export type PromoProduct = {
  __typename?: 'PromoProduct';
  product: Product;
  productCode?: Maybe<Scalars['String']['output']>;
  productID: Scalars['UUID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
};

export type PromoProductInput = {
  productID: Scalars['UUID']['input'];
};

export type PromoProductQuota = {
  __typename?: 'PromoProductQuota';
  maxQty: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
};

/**
 * Quota configuration for per-product promos (CAT1, CAT3).
 * Each product can have its own quota limit per branch.
 */
export type PromoProductQuotaInput = {
  maxQty: Scalars['Int']['input'];
  productID: Scalars['UUID']['input'];
};

export type PromoQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  promoName?: InputMaybe<Scalars['String']['input']>;
  promoTypeID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PromoQopInput = {
  filters?: InputMaybe<PromoQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PromoQuota = {
  __typename?: 'PromoQuota';
  category?: Maybe<ProductCategory>;
  data?: Maybe<PromoQuotaData>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  maxQty: Scalars['Int']['output'];
  product?: Maybe<Product>;
  promo?: Maybe<Promo>;
  promoComponent?: Maybe<PromoComponent>;
  promoComponentID: Scalars['UUID']['output'];
  promoID: Scalars['UUID']['output'];
  promoQuotaID: Scalars['UUID']['output'];
  quotaType: Scalars['String']['output'];
  remainingQty: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
  usedQty: Scalars['Int']['output'];
};

export type PromoQuotaBranchUsage = {
  __typename?: 'PromoQuotaBranchUsage';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  maxQty: Scalars['Int']['output'];
  promoQuota: PromoQuota;
  promoQuotaBranchUsageID: Scalars['UUID']['output'];
  promoQuotaID: Scalars['UUID']['output'];
  remainingQty: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
  usedQty: Scalars['Int']['output'];
};

export type PromoQuotaBranchUsageFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  promoQuotaID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PromoQuotaBranchUsagePagedResult = {
  __typename?: 'PromoQuotaBranchUsagePagedResult';
  items: Array<PromoQuotaBranchUsage>;
  pagination: PaginationResult;
};

export type PromoQuotaBranchUsageQopInput = {
  filters?: InputMaybe<PromoQuotaBranchUsageFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type PromoQuotaCheckInput = {
  branchID: Scalars['UUID']['input'];
  data?: InputMaybe<PromoQuotaDataInput>;
  promoComponentID: Scalars['UUID']['input'];
};

export type PromoQuotaCreateInput = {
  data?: InputMaybe<PromoQuotaDataInput>;
  isActive?: Scalars['Boolean']['input'];
  maxQty: Scalars['Int']['input'];
  promoComponentID: Scalars['UUID']['input'];
  promoID: Scalars['UUID']['input'];
  quotaType?: Scalars['String']['input'];
};

export type PromoQuotaData = {
  __typename?: 'PromoQuotaData';
  categoryID?: Maybe<Scalars['UUID']['output']>;
  departmentID?: Maybe<Scalars['UUID']['output']>;
  productID?: Maybe<Scalars['UUID']['output']>;
};

export type PromoQuotaDataInput = {
  categoryID?: InputMaybe<Scalars['UUID']['input']>;
  departmentID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PromoQuotaFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoID?: InputMaybe<Scalars['UUID']['input']>;
  quotaType?: InputMaybe<Scalars['String']['input']>;
};

export type PromoQuotaIncrementUsageInput = {
  branchID: Scalars['UUID']['input'];
  incrementQty?: Scalars['Int']['input'];
  promoQuotaID: Scalars['UUID']['input'];
};

/**
 * Quota configuration for per-promo promos (CAT2).
 * Single quota applies to entire promo (all products share).
 */
export type PromoQuotaInput = {
  maxQty: Scalars['Int']['input'];
};

export type PromoQuotaPagedResult = {
  __typename?: 'PromoQuotaPagedResult';
  items: Array<PromoQuota>;
  pagination: PaginationResult;
};

export type PromoQuotaQopInput = {
  filters?: InputMaybe<PromoQuotaFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type PromoQuotaResetUsageInput = {
  branchID: Scalars['UUID']['input'];
  promoQuotaID: Scalars['UUID']['input'];
};

export type PromoQuotaUpdateInput = {
  data?: InputMaybe<PromoQuotaDataInput>;
  isActive: Scalars['Boolean']['input'];
  maxQty: Scalars['Int']['input'];
  promoComponentID: Scalars['UUID']['input'];
  promoID: Scalars['UUID']['input'];
  promoQuotaID: Scalars['UUID']['input'];
  quotaType?: Scalars['String']['input'];
};

export type PromoQuotaUsageCheck = {
  __typename?: 'PromoQuotaUsageCheck';
  canUse: Scalars['Boolean']['output'];
  isGlobalFallback: Scalars['Boolean']['output'];
  maxQty: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  promoQuotaID?: Maybe<Scalars['UUID']['output']>;
  quotaType?: Maybe<Scalars['String']['output']>;
  remaining: Scalars['Int']['output'];
  usedQty: Scalars['Int']['output'];
};

export type PromoRules = {
  __typename?: 'PromoRules';
  availability?: Maybe<Array<PromoAvailabilityRule>>;
  /** Indicates if this promo has quota enabled (auto-computed from promo components) */
  enableQuota?: Maybe<Scalars['Boolean']['output']>;
};

export type PromoRulesInput = {
  availability?: InputMaybe<Array<PromoAvailabilityRuleInput>>;
};

export type PromoType = {
  __typename?: 'PromoType';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  promoTypeID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PromoTypeCreateInput = {
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type PromoTypePaged = {
  __typename?: 'PromoTypePaged';
  items?: Maybe<Array<PromoType>>;
  pagination: PaginationResult;
};

export type PromoTypeQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PromoTypeQopInput = {
  filters?: InputMaybe<PromoTypeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PromoTypeUpdateInput = {
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  promoTypeID: Scalars['UUID']['input'];
};

export type Province = {
  __typename?: 'Province';
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProvinceCreateInput = {
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
};

export type ProvincePaged = {
  __typename?: 'ProvincePaged';
  items: Array<Province>;
  pagination: PaginationResult;
};

export type ProvinceQop = {
  filters?: InputMaybe<ProvinceQopFilter>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type ProvinceQopFilter = {
  countryID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  provinceName?: InputMaybe<Scalars['String']['input']>;
};

export type ProvinceUpdateInput = {
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
};

export type PurchaseArea = {
  __typename?: 'PurchaseArea';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  purchaseAreaID: Scalars['UUID']['output'];
  purchaseAreaName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PurchaseAreaCreateInput = {
  isActive: Scalars['Boolean']['input'];
  purchaseAreaName: Scalars['String']['input'];
};

export type PurchaseAreaPaged = {
  __typename?: 'PurchaseAreaPaged';
  items?: Maybe<Array<PurchaseArea>>;
  pagination: PaginationResult;
};

export type PurchaseAreaQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseAreaName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PurchaseAreaQopInput = {
  filters?: InputMaybe<PurchaseAreaQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseAreaUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  purchaseAreaID: Scalars['UUID']['input'];
  purchaseAreaName: Scalars['String']['input'];
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  adjustmentAmount: Scalars['Float']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  cancelledType?: Maybe<Scalars['String']['output']>;
  deadlineDate: Scalars['Time']['output'];
  deliveryDate: Scalars['Time']['output'];
  destinationWarehouseAddress?: Maybe<BaseModelAddress>;
  destinationWarehouseCode: Scalars['String']['output'];
  destinationWarehouseID: Scalars['UUID']['output'];
  destinationWarehouseName: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  isAlreadyForceClosePO?: Maybe<Scalars['Boolean']['output']>;
  isCannotRevise?: Maybe<Scalars['Boolean']['output']>;
  itemUomSummaries: Array<PurchaseOrderItemUomSummary>;
  landedCost: Scalars['Float']['output'];
  landedCostPerUnit: Scalars['Float']['output'];
  noteForVendor: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  purchaseAreaID: Scalars['UUID']['output'];
  purchaseAreaName: Scalars['String']['output'];
  purchaseOrderDatetime: Scalars['Time']['output'];
  purchaseOrderDatetimeUtc: Scalars['Time']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  receivingStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<PurchaseOrderTax>;
  total: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItems: Scalars['Int']['output'];
  vendorAddress?: Maybe<BaseModelAddress>;
  vendorCode: Scalars['String']['output'];
  vendorEmail: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
  vendorNpwp: Scalars['String']['output'];
  vendorNpwpCompanyName: Scalars['String']['output'];
  vendorPhoneNumber: Scalars['String']['output'];
  vendorRefNo: Scalars['String']['output'];
};

export type PurchaseOrderBackfillTotalsInput = {
  purchaseOrderIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type PurchaseOrderBackfillTotalsResult = {
  __typename?: 'PurchaseOrderBackfillTotalsResult';
  totalPurchaseOrderUpdated: Scalars['Int']['output'];
};

export type PurchaseOrderCloseInput = {
  purchaseOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type PurchaseOrderCreateInput = {
  adjustmentAmount: Scalars['Float']['input'];
  branchID: Scalars['UUID']['input'];
  deadlineDate: Scalars['Time']['input'];
  deliveryDate: Scalars['Time']['input'];
  destinationWarehouseID: Scalars['UUID']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  items: Array<PurchaseOrderItemCreateInput>;
  landedCost: Scalars['Float']['input'];
  noteForVendor: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseAreaID: Scalars['UUID']['input'];
  purchaseOrderDatetime: Scalars['Time']['input'];
  purchaseOrderDatetimeUtc: Scalars['Time']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
  taxIncluded: Scalars['Boolean']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorRefNo: Scalars['String']['input'];
};

export type PurchaseOrderForceCloseInput = {
  purchaseOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type PurchaseOrderImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderImportFileMappingInput = {
  columns: Array<PurchaseOrderImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  rowFilters?: InputMaybe<Array<PurchaseOrderImportRowFilterInput>>;
};

export type PurchaseOrderImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: PurchaseOrderImportFileMappingInput;
};

export type PurchaseOrderImportMissingProductUom = {
  __typename?: 'PurchaseOrderImportMissingProductUom';
  productCode: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderImportRowFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
};

export type PurchaseOrderImportRowReport = {
  __typename?: 'PurchaseOrderImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<PurchaseOrderImportRowViolation>;
};

export type PurchaseOrderImportRowViolation = {
  __typename?: 'PurchaseOrderImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PurchaseOrderImportValidateCodesInput = {
  branchCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  fileMapping?: InputMaybe<PurchaseOrderImportFileMappingInput>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseAreaNames?: InputMaybe<Array<Scalars['String']['input']>>;
  taxCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PurchaseOrderImportValidateCodesResult = {
  __typename?: 'PurchaseOrderImportValidateCodesResult';
  consignmentProductCodes: Array<Scalars['String']['output']>;
  consignmentVendorCodes: Array<Scalars['String']['output']>;
  duplicateProductCodes: Array<Scalars['String']['output']>;
  missingBranchCodes: Array<Scalars['String']['output']>;
  missingProductCodes: Array<Scalars['String']['output']>;
  missingProductUoms: Array<PurchaseOrderImportMissingProductUom>;
  missingPurchaseAreaNames: Array<Scalars['String']['output']>;
  missingTaxCodes: Array<Scalars['String']['output']>;
  missingVendorCodes: Array<Scalars['String']['output']>;
  missingWarehouseCodes: Array<Scalars['String']['output']>;
  rowReport?: Maybe<PurchaseOrderImportRowReport>;
};

export type PurchaseOrderItem = {
  __typename?: 'PurchaseOrderItem';
  additionalDiscountAmount: Scalars['Float']['output'];
  additionalDiscountPerc: Scalars['Float']['output'];
  additionalLandedCost: Scalars['Float']['output'];
  baseUomQty: Scalars['Float']['output'];
  baseUomUnitCost: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  sequenceNo: Scalars['Int']['output'];
  taxAmount: Scalars['Float']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<PurchaseOrderItemTax>;
  total: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderItemCreateInput = {
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  taxes: Array<PurchaseOrderItemTaxCreateInput>;
  unitPrice: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderItemPaged = {
  __typename?: 'PurchaseOrderItemPaged';
  items: Array<PurchaseOrderItem>;
  pagination: PaginationResult;
};

export type PurchaseOrderItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PurchaseOrderItemQopInput = {
  filters?: InputMaybe<PurchaseOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseOrderItemReviseInput = {
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  taxes: Array<PurchaseOrderItemTaxCreateInput>;
  unitPrice: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderItemTax = {
  __typename?: 'PurchaseOrderItemTax';
  entityAuditMetadata: EntityAuditMetadata;
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderItemID: Scalars['UUID']['output'];
  purchaseOrderItemTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type PurchaseOrderItemTaxCreateInput = {
  taxCode: Scalars['String']['input'];
  taxID: Scalars['UUID']['input'];
  taxRate: Scalars['Float']['input'];
};

export type PurchaseOrderItemTaxUpdateInput = {
  purchaseOrderItemTaxID?: InputMaybe<Scalars['UUID']['input']>;
  taxCode: Scalars['String']['input'];
  taxID: Scalars['UUID']['input'];
  taxRate: Scalars['Float']['input'];
};

export type PurchaseOrderItemUomSummary = {
  __typename?: 'PurchaseOrderItemUomSummary';
  qty: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderItemUpdateInput = {
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  purchaseOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  qty: Scalars['Float']['input'];
  taxes: Array<PurchaseOrderItemTaxUpdateInput>;
  unitPrice: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderPaged = {
  __typename?: 'PurchaseOrderPaged';
  items: Array<PurchaseOrder>;
  pagination: PaginationResult;
};

export type PurchaseOrderQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  destinationWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseOrderDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  purchaseOrderDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNo?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderQopInput = {
  filters?: InputMaybe<PurchaseOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseOrderReceiving = {
  __typename?: 'PurchaseOrderReceiving';
  adjustmentAmount: Scalars['Float']['output'];
  branchID: Scalars['UUID']['output'];
  closePO?: Maybe<Scalars['Boolean']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountType: Scalars['String']['output'];
  driverName: Scalars['String']['output'];
  driverPhoneNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files: Array<PurchaseOrderReceivingFile>;
  gmt: Scalars['Int']['output'];
  landedCost: Scalars['Float']['output'];
  landedCostPerUnit: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  purchaseOrderReceivingDatetime: Scalars['Time']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxIncluded?: Maybe<Scalars['Boolean']['output']>;
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<PurchaseOrderReceivingTax>;
  total: Scalars['Float']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  vehiclePlateNumber: Scalars['String']['output'];
  vendor: Vendor;
  vendorID: Scalars['UUID']['output'];
  vendorRefNo: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type PurchaseOrderReceivingCreateInput = {
  closePO: Scalars['Boolean']['input'];
  driverName: Scalars['String']['input'];
  driverPhoneNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<PurchaseOrderReceivingFileInput>>;
  items: Array<PurchaseOrderReceivingItemCreateInput>;
  landedCost: Scalars['Float']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseOrderID: Scalars['UUID']['input'];
  purchaseOrderReceivingDatetime: Scalars['Time']['input'];
  vehiclePlateNumber: Scalars['String']['input'];
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNo: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type PurchaseOrderReceivingFile = {
  __typename?: 'PurchaseOrderReceivingFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  purchaseOrderReceivingFileID: Scalars['UUID']['output'];
  purchaseOrderReceivingFileType: Scalars['String']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
};

export type PurchaseOrderReceivingFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderReceivingItem = {
  __typename?: 'PurchaseOrderReceivingItem';
  additionalDiscountAmount: Scalars['Float']['output'];
  additionalDiscountPerc: Scalars['Float']['output'];
  additionalLandedCost: Scalars['Float']['output'];
  baseUomQty: Scalars['Float']['output'];
  baseUomUnitCost: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  itemDetails: Array<PurchaseOrderReceivingItemDetail>;
  poQty: Scalars['Float']['output'];
  poQtyOutstanding: Scalars['Float']['output'];
  poQtyReceived: Scalars['Float']['output'];
  poUomConversionRate: Scalars['Float']['output'];
  poUomID: Scalars['UUID']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderItemID: Scalars['UUID']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemID: Scalars['UUID']['output'];
  qtyReceived: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<PurchaseOrderReceivingItemTax>;
  total: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderReceivingItemCreateInput = {
  itemDetails?: InputMaybe<Array<PurchaseOrderReceivingItemDetailCreateInput>>;
  purchaseOrderItemID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderReceivingItemDetail = {
  __typename?: 'PurchaseOrderReceivingItemDetail';
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  lotNo: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemDetailID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderReceivingItemDetailCreateInput = {
  expiryDate: Scalars['Time']['input'];
  lotNo?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
};

export type PurchaseOrderReceivingItemDetailUpdateInput = {
  expiryDate: Scalars['Time']['input'];
  lotNo?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
};

export type PurchaseOrderReceivingItemPaged = {
  __typename?: 'PurchaseOrderReceivingItemPaged';
  items: Array<PurchaseOrderReceivingItem>;
  pagination: PaginationResult;
};

export type PurchaseOrderReceivingItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseOrderReceivingID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PurchaseOrderReceivingItemQopInput = {
  filters?: InputMaybe<PurchaseOrderReceivingItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseOrderReceivingItemTax = {
  __typename?: 'PurchaseOrderReceivingItemTax';
  entityAuditMetadata: EntityAuditMetadata;
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type PurchaseOrderReceivingItemUpdateInput = {
  itemDetails?: InputMaybe<Array<PurchaseOrderReceivingItemDetailUpdateInput>>;
  purchaseOrderItemID: Scalars['UUID']['input'];
  purchaseOrderReceivingItemID?: InputMaybe<Scalars['UUID']['input']>;
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderReceivingPaged = {
  __typename?: 'PurchaseOrderReceivingPaged';
  items: Array<PurchaseOrderReceiving>;
  pagination: PaginationResult;
};

export type PurchaseOrderReceivingQopFilterInput = {
  purchaseOrderID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderReceivingDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  purchaseOrderReceivingDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  purchaseOrderReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PurchaseOrderReceivingQopInput = {
  filters?: InputMaybe<PurchaseOrderReceivingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseOrderReceivingTax = {
  __typename?: 'PurchaseOrderReceivingTax';
  entityAuditMetadata: EntityAuditMetadata;
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type PurchaseOrderReceivingUpdateInput = {
  closePO: Scalars['Boolean']['input'];
  driverName: Scalars['String']['input'];
  driverPhoneNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<PurchaseOrderReceivingFileInput>>;
  items: Array<PurchaseOrderReceivingItemUpdateInput>;
  landedCost: Scalars['Float']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseOrderReceivingDatetime: Scalars['Time']['input'];
  purchaseOrderReceivingID: Scalars['UUID']['input'];
  vehiclePlateNumber: Scalars['String']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type PurchaseOrderReviseInput = {
  deadlineDate: Scalars['Time']['input'];
  deliveryDate: Scalars['Time']['input'];
  destinationWarehouseID: Scalars['UUID']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  items: Array<PurchaseOrderItemReviseInput>;
  noteForVendor: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseAreaID: Scalars['UUID']['input'];
  purchaseOrderDatetime: Scalars['Time']['input'];
  purchaseOrderDatetimeUtc: Scalars['Time']['input'];
  purchaseOrderID: Scalars['UUID']['input'];
  taxIncluded: Scalars['Boolean']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorRefNo: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
};

export type PurchaseOrderTax = {
  __typename?: 'PurchaseOrderTax';
  entityAuditMetadata: EntityAuditMetadata;
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type PurchaseOrderUpdateInput = {
  adjustmentAmount: Scalars['Float']['input'];
  branchID: Scalars['UUID']['input'];
  deadlineDate: Scalars['Time']['input'];
  deliveryDate: Scalars['Time']['input'];
  destinationWarehouseID: Scalars['UUID']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  items: Array<PurchaseOrderItemUpdateInput>;
  landedCost: Scalars['Float']['input'];
  noteForVendor: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseAreaID: Scalars['UUID']['input'];
  purchaseOrderDatetime: Scalars['Time']['input'];
  purchaseOrderDatetimeUtc: Scalars['Time']['input'];
  purchaseOrderID: Scalars['UUID']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
  taxIncluded: Scalars['Boolean']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorRefNo: Scalars['String']['input'];
};

export type PutawayTask = {
  __typename?: 'PutawayTask';
  assignedToUser?: Maybe<User>;
  assignedToUserID?: Maybe<Scalars['UUID']['output']>;
  assignedToUserName?: Maybe<Scalars['String']['output']>;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseLocation?: Maybe<WarehouseLocation>;
  fromWarehouseLocationCode: Scalars['String']['output'];
  fromWarehouseLocationID: Scalars['UUID']['output'];
  fromWarehouseLocationName: Scalars['String']['output'];
  inboundReceiving?: Maybe<InboundReceiving>;
  items: Array<PutawayTaskItem>;
  noteInternal: Scalars['String']['output'];
  progressPercent: Scalars['Float']['output'];
  putawayTaskDatetime: Scalars['Time']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskNumber: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskDoneAt?: Maybe<Scalars['Time']['output']>;
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyAssigned: Scalars['Float']['output'];
  totalQtyExecuted: Scalars['Float']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type PutawayTaskExecution = {
  __typename?: 'PutawayTaskExecution';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  putawayTaskExecutionID: Scalars['UUID']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation?: Maybe<WarehouseLocation>;
  warehouseLocationCode: Scalars['String']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
};

export type PutawayTaskExecutionPaged = {
  __typename?: 'PutawayTaskExecutionPaged';
  items: Array<PutawayTaskExecution>;
  pagination: PaginationResult;
};

export type PutawayTaskExecutionQopFilterInput = {
  putawayTaskExecutionID?: InputMaybe<Scalars['UUID']['input']>;
  putawayTaskID?: InputMaybe<Scalars['UUID']['input']>;
  putawayTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PutawayTaskExecutionQopInput = {
  filters?: InputMaybe<PutawayTaskExecutionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PutawayTaskItem = {
  __typename?: 'PutawayTaskItem';
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskItemID: Scalars['UUID']['output'];
  qtyAssigned: Scalars['Float']['output'];
  qtyExecuted: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  suggestionWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  suggestionWarehouseLocationName?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Uom>;
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PutawayTaskItemPaged = {
  __typename?: 'PutawayTaskItemPaged';
  items: Array<PutawayTaskItem>;
  pagination: PaginationResult;
};

export type PutawayTaskItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  putawayTaskID?: InputMaybe<Scalars['UUID']['input']>;
  putawayTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentDetailID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PutawayTaskItemQopInput = {
  filters?: InputMaybe<PutawayTaskItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PutawayTaskItemUpdateInput = {
  putawayTaskItemID: Scalars['UUID']['input'];
  qtyAssigned: Scalars['Float']['input'];
};

export type PutawayTaskPaged = {
  __typename?: 'PutawayTaskPaged';
  items: Array<PutawayTask>;
  pagination: PaginationResult;
};

export type PutawayTaskQopFilterInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  putawayTaskNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskDatetimeFrom?: InputMaybe<Scalars['Time']['input']>;
  taskDatetimeTo?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PutawayTaskQopInput = {
  filters?: InputMaybe<PutawayTaskQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PutawayTaskUpdateInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  items?: InputMaybe<Array<PutawayTaskItemUpdateInput>>;
  putawayTaskDatetime?: InputMaybe<Scalars['Time']['input']>;
  putawayTaskID: Scalars['UUID']['input'];
  putawayTaskNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  activeShiftSessionByUserID?: Maybe<ShiftSession>;
  aiAppClients: Array<AiAppClient>;
  aiChatMessages: AiChatMessagePaged;
  aiChatSession?: Maybe<AiChatSession>;
  aiChatSessions: AiChatSessionPaged;
  aiGuardrailsConfig: AiGuardrailsConfig;
  aiScopeConfig: AiScopeConfig;
  app?: Maybe<App>;
  apps: AppPaged;
  backgroundJob?: Maybe<BackgroundJob>;
  backgroundJobs: BackgroundJobPaged;
  bank: Bank;
  bankAccount: BankAccount;
  bankAccounts: BankAccountPaged;
  bankReconciliation?: Maybe<BankReconciliation>;
  bankReconciliationFiles: Array<BankReconciliationFile>;
  bankReconciliationItems: BankReconciliationItemPaged;
  bankReconciliationPoolFiles: Array<BankReconciliationFile>;
  bankReconciliationPoolRows: BankDataRowPaged;
  bankReconciliations: BankReconciliationPaged;
  banks: BankPaged;
  biKnowledge?: Maybe<BiKnowledge>;
  biKnowledgeList: BiKnowledgePaged;
  biMonitorSummary: BiMonitorSummary;
  biRole?: Maybe<BiRole>;
  biRoles: BiRolePaged;
  biScopeTable?: Maybe<BiScopeTable>;
  biScopeTableCategories: Array<Scalars['String']['output']>;
  biScopeTables: BiScopeTablePaged;
  biUser?: Maybe<BiUser>;
  biUsers: BiUserPaged;
  billOfMaterial: BillOfMaterial;
  billOfMaterialComponent: BillOfMaterialComponent;
  billOfMaterialComponents: BillOfMaterialComponentPaged;
  billOfMaterials: BillOfMaterialPaged;
  branch?: Maybe<Branch>;
  branchBankAccount: BranchBankAccount;
  branchBankAccounts: BranchBankAccountPaged;
  branchCategories: BranchCategoryPaged;
  branchCategory?: Maybe<BranchCategory>;
  branchPosBookmark: BranchPosBookmark;
  branchPosBookmarks: BranchPosBookmarkPaged;
  branchProductSalesChannelItems: BranchProductSalesChannelItemPaged;
  branchQrisMerchant: BranchQrisMerchant;
  branchQrisMerchants: BranchQrisMerchantPaged;
  branchSalesChannelCategoryGroup: BranchSalesChannelCategoryGroup;
  branchSalesChannelCategoryGroups: BranchSalesChannelCategoryGroupPaged;
  branchSalesChannelMerchantMap: BranchSalesChannelMerchantMap;
  branchSalesChannelMerchantMaps: BranchSalesChannelMerchantMapPaged;
  branchSalesChannelMerchantMapsByBranch: Array<BranchSalesChannelMerchantMap>;
  branchSalesChannelPauseDurations: Array<PauseDurationOption>;
  branchSalesPaymentMethod: BranchSalesPaymentMethod;
  branchSalesPaymentMethods: BranchSalesPaymentMethodPaged;
  branchStoreSupervisor?: Maybe<BranchStoreSupervisor>;
  branchStoreSupervisors: BranchStoreSupervisorPaged;
  branchStoreSupervisorsByBranchID: Array<BranchStoreSupervisor>;
  branches: BranchPaged;
  /**
   * Lightweight branch list for dropdown pickers and POS first-run setup.
   *   Returns active, store-type branches only.
   */
  branchesLite: Array<BranchLite>;
  checkOTP: CheckOtpResponse;
  /** Check if quota is available for usage */
  checkPromoQuota: PromoQuotaUsageCheck;
  cities?: Maybe<CityPaged>;
  city?: Maybe<City>;
  consignmentSettlementBranches: Array<ConsignmentSettlementBranchRow>;
  consignmentSettlementExport: ConsignmentSettlementExportResult;
  consignmentSettlementHistory: Array<ConsignmentSettlementHistory>;
  consignmentSettlementListExport: ConsignmentSettlementExportResult;
  consignmentSettlementPeriods: Array<ConsignmentSettlementPeriod>;
  consignmentSettlementPivot: Array<ConsignmentSettlementPivotRow>;
  consignmentStockIn?: Maybe<ConsignmentStockIn>;
  consignmentStockInItem?: Maybe<ConsignmentStockInItem>;
  consignmentStockInItems: ConsignmentStockInItemPaged;
  consignmentStockInRequest?: Maybe<ConsignmentStockInRequest>;
  consignmentStockInRequestFiles: ConsignmentStockInRequestFilePaged;
  consignmentStockInRequestItems: ConsignmentStockInRequestItemPaged;
  consignmentStockInRequestLabels: Array<ConsignmentStockInRequestLabel>;
  consignmentStockInRequestSummary: ConsignmentStockInRequestSummary;
  consignmentStockInRequests: ConsignmentStockInRequestPaged;
  consignmentStockIns: ConsignmentStockInPaged;
  consignmentStockOut?: Maybe<ConsignmentStockOut>;
  consignmentStockOutItem?: Maybe<ConsignmentStockOutItem>;
  consignmentStockOutItems: ConsignmentStockOutItemPaged;
  consignmentStockOuts: ConsignmentStockOutPaged;
  consignmentTagPrices: Array<ConsignmentTagItem>;
  conversationTurns: ConversationTurnPaged;
  countries?: Maybe<CountryPaged>;
  country?: Maybe<Country>;
  customer: Customer;
  customerAddressByID?: Maybe<CustomerAddress>;
  customerAddressList: CustomerAddressPaged;
  customerAddressesByCustomerID: Array<CustomerAddress>;
  customerByPhoneNumber?: Maybe<Customer>;
  customerPointTransaction?: Maybe<CustomerPointTransaction>;
  customerPointTransactions: CustomerPointTransactionPaged;
  customerVoucherTransaction?: Maybe<CustomerVoucherTransaction>;
  customerVoucherTransactions: CustomerVoucherTransactionPaged;
  customers: CustomerPaged;
  deliveryOrder: DeliveryOrder;
  deliveryOrderBatch?: Maybe<DeliveryOrderBatch>;
  deliveryOrderBatchDestinationSummary: DeliveryOrderBatchDestinationSummary;
  deliveryOrderBatchDraft?: Maybe<DeliveryOrderBatch>;
  deliveryOrderBatches: DeliveryOrderBatchPaged;
  deliveryOrderItemSummaries: DeliveryOrderItemSummaryPaged;
  deliveryOrderItemSummariesByDeliveryOrderID: Array<DeliveryOrderItemSummary>;
  deliveryOrderItemSummary?: Maybe<DeliveryOrderItemSummary>;
  deliveryOrderItems: DeliveryOrderItemPaged;
  deliveryOrders: DeliveryOrderPaged;
  edcTerminal: EdcTerminal;
  edcTerminals: EdcTerminalPaged;
  employee?: Maybe<Employee>;
  employees: EmployeePaged;
  erpAccountJournal: AccountJournal;
  erpAccountJournals: AccountJournalPaged;
  erpBranch: ErpBranch;
  erpBranches: ErpBranchPaged;
  erpEmployee: ErpEmployee;
  erpEmployees: ErpEmployeePaged;
  erpProduct: ErpProduct;
  erpProductCategories: ErpProductCategoryPaged;
  erpProductCategory: ErpProductCategory;
  erpProducts: ErpProductPaged;
  erpPurchaseOrderReceive?: Maybe<ErpPurchaseOrderReceive>;
  erpPurchaseOrderReceives: ErpPurchaseOrderReceivePaged;
  erpSyncFullRun?: Maybe<ErpSyncFullRun>;
  erpSyncFullRuns: ErpSyncFullRunPaged;
  erpTax: ErpTax;
  erpTaxes: ErpTaxPaged;
  erpUom: ErpUom;
  erpUomCategories: ErpUomCategoryPaged;
  erpUomCategory: ErpUomCategory;
  erpUoms: ErpUomPaged;
  erpVendor: ErpVendor;
  erpVendors: ErpVendorPaged;
  erpWarehouse: ErpWarehouse;
  erpWarehouses: ErpWarehousePaged;
  expenseItem: ExpenseItem;
  expenseItems: ExpenseItemPaged;
  file: File;
  files: FilePaged;
  health?: Maybe<Scalars['Boolean']['output']>;
  inboundReceiving?: Maybe<InboundReceiving>;
  inboundReceivings: InboundReceivingPaged;
  internalTransfer?: Maybe<InternalTransfer>;
  internalTransferExecution: InternalTransferExecution;
  internalTransferExecutions: InternalTransferExecutionPaged;
  internalTransferItem: InternalTransferItem;
  internalTransferItems: InternalTransferItemPaged;
  internalTransfers: InternalTransferPaged;
  inventoryAdjustment: InventoryAdjustment;
  inventoryAdjustmentItem?: Maybe<InventoryAdjustmentItem>;
  inventoryAdjustmentItems: InventoryAdjustmentItemPaged;
  inventoryAdjustmentTypes: Array<InventoryAdjustmentType>;
  inventoryAdjustments: InventoryAdjustmentPaged;
  inventoryCountItemTemplate: InventoryCountItemTemplate;
  inventoryCountItemTemplateItem: InventoryCountItemTemplateItem;
  inventoryCountItemTemplateItems: InventoryCountItemTemplateItemPaged;
  inventoryCountItemTemplates: InventoryCountItemTemplatePaged;
  inventoryCountTask?: Maybe<InventoryCountTask>;
  inventoryCountTaskAssignee?: Maybe<InventoryCountTaskAssignee>;
  inventoryCountTaskAssignees: InventoryCountTaskAssigneePaged;
  inventoryCountTaskExecutionItem?: Maybe<InventoryCountTaskExecutionItem>;
  inventoryCountTaskExecutionItemDetail?: Maybe<InventoryCountTaskExecutionItemDetail>;
  inventoryCountTaskExecutionItemDetails: InventoryCountTaskExecutionItemDetailPaged;
  inventoryCountTaskExecutionItemSummaries: InventoryCountTaskExecutionItemSummaryPaged;
  inventoryCountTaskExecutionItemSummary?: Maybe<InventoryCountTaskExecutionItemSummary>;
  inventoryCountTaskExecutionItems: InventoryCountTaskExecutionItemPaged;
  inventoryCountTaskExecutionItemsInLocations: InventoryCountTaskExecutionItemPaged;
  inventoryCountTaskRecountItem?: Maybe<InventoryCountTaskRecountItem>;
  inventoryCountTaskRecountItems: InventoryCountTaskRecountItemPaged;
  inventoryCountTasks: InventoryCountTaskPaged;
  inventoryCountTransaction?: Maybe<InventoryCountTransaction>;
  inventoryCountTransactionItem?: Maybe<InventoryCountTransactionItem>;
  inventoryCountTransactionItems: InventoryCountTransactionItemPaged;
  inventoryCountTransactionLocation?: Maybe<InventoryCountTransactionLocation>;
  inventoryCountTransactionLocationDetail?: Maybe<InventoryCountTransactionLocationDetail>;
  inventoryCountTransactionLocationDetails: InventoryCountTransactionLocationDetailPaged;
  inventoryCountTransactionLocations: InventoryCountTransactionLocationPaged;
  inventoryCountTransactionResultItem?: Maybe<InventoryCountTransactionResultItem>;
  inventoryCountTransactionResultItemDetail?: Maybe<InventoryCountTransactionResultItemDetail>;
  inventoryCountTransactionResultItemDetails: InventoryCountTransactionResultItemDetailPaged;
  inventoryCountTransactionResultItems: InventoryCountTransactionResultItemPaged;
  inventoryCountTransactions: InventoryCountTransactionPaged;
  inventoryDailyMovement: InventoryDailyMovement;
  inventoryDailyMovements: InventoryDailyMovementPaged;
  inventoryLocation: InventoryLocation;
  inventoryLocations: InventoryLocationPaged;
  inventoryMovementSummary: InventoryMovementSummaryPaged;
  inventoryPosition: InventoryPosition;
  inventoryPositionSnapshot?: Maybe<InventoryPositionSnapshot>;
  inventoryPositions: InventoryPositionPaged;
  inventoryPositionsByIds: Array<InventoryPosition>;
  inventorySummaries: InventorySummaryPaged;
  inventorySummary: InventorySummary;
  inventoryTransaction: InventoryTransaction;
  inventoryTransactionItem: InventoryTransactionLineItem;
  inventoryTransactionItems: InventoryTransactionLineItemPaged;
  inventoryTransactionLine: InventoryTransactionLine;
  inventoryTransactionLineUnit: InventoryTransactionLineUnit;
  inventoryTransactionLineUnits: InventoryTransactionLineUnitPaged;
  inventoryTransactionLines: InventoryTransactionLinePaged;
  inventoryTransactions: InventoryTransactionPaged;
  latestProductImageEmbeddingRun?: Maybe<IngestionRunInfo>;
  marketplaceBackgroundJob?: Maybe<MarketplaceBackgroundJob>;
  marketplaceBackgroundJobs: MarketplaceBackgroundJobPaged;
  marketplaceCampaign?: Maybe<MarketplaceCampaign>;
  marketplaceCampaignProducts: MarketplaceCampaignProductPaged;
  marketplaceCampaigns: MarketplaceCampaignPaged;
  marketplaceChannelAPILog?: Maybe<MarketplaceChannelApiLog>;
  marketplaceChannelAPILogs: MarketplaceChannelApiLogPaged;
  marketplaceChannelTaxonomy: Array<ChannelTaxonomyNode>;
  marketplaceCronSettings: MarketplaceCronSettingPaged;
  marketplaceInboundOrder?: Maybe<MarketplaceInboundOrder>;
  marketplaceInboundOrders: MarketplaceInboundOrderPaged;
  marketplaceMenuSyncStatus?: Maybe<MarketplaceMenuSyncStatus>;
  marketplaceOrder?: Maybe<MarketplaceOrder>;
  marketplaceOrderCheckCancelable: MarketplaceOrderCancelableResult;
  marketplaceOrderExport: MarketplaceOrderExportFile;
  marketplaceOrderItem?: Maybe<MarketplaceOrderItem>;
  marketplaceOrderItems: MarketplaceOrderItemPaged;
  marketplaceOrders: MarketplaceOrderPaged;
  marketplacePromoForPublish?: Maybe<MarketplacePromoForPublish>;
  marketplaceProviderCampaigns: Array<MarketplaceProviderCampaign>;
  marketplacePublishablePromos: Array<MarketplaceProvisionablePromo>;
  marketplaceStoreStatus?: Maybe<MarketplaceStoreStatus>;
  marketplaceSyncHealth: Array<MarketplaceChannelSyncHealth>;
  masterdataBackgroundJob?: Maybe<MasterdataBackgroundJob>;
  memberType: MemberType;
  memberTypes: MemberTypePaged;
  mobilePickingTask: MobilePickingTask;
  mobilePutawayTask: MobilePutawayTask;
  myInventoryCountTaskHistories: InventoryCountTaskPaged;
  myInventoryCountTasks: InventoryCountTaskPaged;
  myPickingTasks: PickingTaskPaged;
  myPutawayTasks?: Maybe<PutawayTaskPaged>;
  nonMainUoms: UomPaged;
  outboundContainer?: Maybe<OutboundContainer>;
  outboundContainerItems: OutboundContainerItemPaged;
  outboundContainerItemsSummary: OutboundContainerItemGroupedPaged;
  outboundContainers: OutboundContainerPaged;
  packingTask: PackingTask;
  packingTaskContainer?: Maybe<PackingTaskContainer>;
  packingTaskContainerItem?: Maybe<PackingTaskContainerItem>;
  packingTaskContainerItems: PackingTaskContainerItemPaged;
  packingTaskContainers: PackingTaskContainerPaged;
  packingTaskExecution: PackingTaskExecution;
  packingTaskExecutions: PackingTaskExecutionPaged;
  packingTaskItem?: Maybe<PackingTaskItem>;
  packingTaskItems: PackingTaskItemPaged;
  packingTasks: PackingTaskPaged;
  paymentInboundRequests: PaymentInboundRequestLogPaged;
  paymentInquiryLogs: PaymentInquiryLogPaged;
  paymentProviderConfig?: Maybe<PaymentProviderConfig>;
  paymentProviderConfigs: PaymentProviderConfigPaged;
  paymentTransaction: PaymentTransaction;
  paymentTransactions: PaymentTransactionPaged;
  paymentWebhookEvents: PaymentWebhookEventPaged;
  permission?: Maybe<Permission>;
  permissions: PermissionPaged;
  pettyCashAddFundTransaction?: Maybe<PettyCashAddFundTransaction>;
  pettyCashAddFundTransactions: PettyCashAddFundTransactionPaged;
  pettyCashBalance?: Maybe<PettyCashBalance>;
  pettyCashBalances: PettyCashBalancePaged;
  pettyCashExpenseTransaction?: Maybe<PettyCashExpenseTransaction>;
  pettyCashExpenseTransactionItem?: Maybe<PettyCashExpenseTransactionItem>;
  pettyCashExpenseTransactionItems: PettyCashExpenseTransactionItemPaged;
  pettyCashExpenseTransactions: PettyCashExpenseTransactionPaged;
  pettyCashLedger?: Maybe<PettyCashLedger>;
  pettyCashLedgers: PettyCashLedgerPaged;
  pettyCashRefundTransaction?: Maybe<PettyCashRefundTransaction>;
  pettyCashRefundTransactions: PettyCashRefundTransactionPaged;
  pettyCashTransaction?: Maybe<PettyCashTransaction>;
  pettyCashTransactionFiles: PettyCashTransactionFilePaged;
  pettyCashTransactions: PettyCashTransactionPaged;
  pickingTask?: Maybe<PickingTask>;
  pickingTaskExecution?: Maybe<PickingTaskExecution>;
  pickingTaskExecutions: PickingTaskExecutionPaged;
  pickingTaskGenerateByZonePreview: PickingTaskGenerateByZonePreviewResponse;
  pickingTaskItem?: Maybe<PickingTaskItem>;
  pickingTaskItems: PickingTaskItemPaged;
  pickingTasks: PickingTaskPaged;
  posBookmark: PosBookmark;
  posBookmarkProduct: PosBookmarkProduct;
  posBookmarkProducts: PosBookmarkProductPaged;
  posBookmarks: PosBookmarkPaged;
  /**
   * Deprecated alias: use branchesLite instead.
   * @deprecated Use branchesLite instead
   */
  posBranches: Array<PosBranch>;
  posSalesOrder: PosSalesOrder;
  posSalesOrders: PosSalesOrderPaged;
  poster: Poster;
  /** Full poster-image stream for POS cursor sync. Cursor mode cannot be combined with filters, so POS pulls everything and joins on posterID locally. */
  posterImages: PosterImagePaged;
  posters: PosterPaged;
  pricelist: Pricelist;
  pricelistPeriod?: Maybe<PricelistPeriod>;
  pricelistPeriods: PricelistPeriodPaged;
  pricelistProduct: PricelistProduct;
  pricelistProductSalesChannel: PricelistProductSalesChannel;
  pricelistProductSalesChannelByCompositeKey?: Maybe<PricelistProductSalesChannel>;
  pricelistProductSalesChannels: PricelistProductSalesChannelPaged;
  pricelistProducts: PricelistProductPaged;
  pricelistSalesChannel?: Maybe<PricelistSalesChannel>;
  pricelistSalesChannels: PricelistSalesChannelPaged;
  pricelistTagPrices: Array<PriceTagItem>;
  pricelists: PricelistPaged;
  product: Product;
  productAIImage: ProductAiImage;
  productAIImages: ProductAiImagePaged;
  productAccountingCategories: ProductAccountingCategoryPaged;
  productAccountingCategory?: Maybe<ProductAccountingCategory>;
  productAddon: ProductAddon;
  productAddonComponent?: Maybe<ProductAddonComponent>;
  productAddonComponents: ProductAddonComponentPaged;
  productAddonComponentsByProductAddonID: Array<ProductAddonComponent>;
  productAddonGroup: ProductAddonGroup;
  productAddonGroupItem: ProductAddonGroupItem;
  productAddonGroupItems: ProductAddonGroupItemPaged;
  productAddonGroupItemsByGroupID: Array<ProductAddonGroupItem>;
  productAddonGroups: ProductAddonGroupPaged;
  productAddons: ProductAddonPaged;
  productAvailabilityTemplate: ProductAvailabilityTemplate;
  productAvailabilityTemplateItem: ProductAvailabilityTemplateItem;
  productAvailabilityTemplateItems: ProductAvailabilityTemplateItemPaged;
  productAvailabilityTemplates: ProductAvailabilityTemplatePaged;
  productBarcodeConflicts: Array<BarcodeConflictOwner>;
  productBarcodeMap: ProductBarcodeMap;
  productBarcodeMaps: ProductBarcodeMapPaged;
  productBookmark: ProductBookmark;
  productBookmarkProduct: ProductBookmarkProduct;
  productBookmarkProducts: ProductBookmarkProductPaged;
  productBookmarks: ProductBookmarkPaged;
  productBrand?: Maybe<ProductBrand>;
  productBrands: ProductBrandPaged;
  productBundleComponent?: Maybe<ProductBundleComponent>;
  productBundleComponents: ProductBundleComponentPaged;
  productBundleComponentsByProductID: Array<ProductBundleComponent>;
  productCategories: ProductCategoryPaged;
  productCategory?: Maybe<ProductCategory>;
  productCategorySalesChannelMap: ProductCategorySalesChannelMap;
  productCategorySalesChannelMaps: ProductCategorySalesChannelMapPaged;
  productDepartment?: Maybe<ProductDepartment>;
  productDepartments: ProductDepartmentPaged;
  productDivision: ProductDivision;
  productDivisions: ProductDivisionPaged;
  productFile: ProductFile;
  productFiles: ProductFilePaged;
  productImageEmbeddingChanges: Array<DeltaItem>;
  productImageEmbeddingDelta: DeltaPage;
  productImageEmbeddingSnapshot: SnapshotPage;
  productImageEmbeddingSyncHead: ProductImageEmbeddingSyncHead;
  productSalesChannelItemMap: ProductSalesChannelItemMap;
  productSalesChannelItemMaps: ProductSalesChannelItemMapPaged;
  productSource?: Maybe<ProductSource>;
  productSources: ProductSourcePaged;
  productSubCategories: ProductSubCategoryPaged;
  productSubCategory?: Maybe<ProductSubCategory>;
  productSubDepartment?: Maybe<ProductSubDepartment>;
  productSubDepartments: ProductSubDepartmentPaged;
  productTag?: Maybe<ProductTag>;
  productTagProduct: ProductTagProduct;
  productTagProducts: ProductTagProductPaged;
  productTags: ProductTagPaged;
  productVendor: ProductVendor;
  productVendors: ProductVendorPaged;
  productionOrder?: Maybe<ProductionOrder>;
  productionOrderComponent?: Maybe<ProductionOrderComponent>;
  productionOrderComponents: ProductionOrderComponentPaged;
  productionOrders: ProductionOrderPaged;
  products: ProductPaged;
  promo: Promo;
  promoCat1: PromoCat1Detail;
  promoCat2: PromoCat2Detail;
  promoCat3: PromoCat3Detail;
  promoCat4: PromoCat4Detail;
  promoCat5: PromoCat5Detail;
  promoCat6: PromoCat6Detail;
  promoComponent: PromoComponent;
  promoComponentCat1: PromoComponentCat1Detail;
  promoComponentCat2: PromoComponentCat2Detail;
  promoComponentCat3: PromoComponentCat3Detail;
  promoComponentCat4: PromoComponentCat4Detail;
  promoComponentCat5: PromoComponentCat5Detail;
  promoComponentCat6: PromoComponentCat6Detail;
  promoComponents: PromoComponentPaged;
  /** Get promo quota config by ID */
  promoQuota?: Maybe<PromoQuota>;
  /** Get branch usage for a specific quota and branch */
  promoQuotaBranchUsage?: Maybe<PromoQuotaBranchUsage>;
  /** Get all branch usages for a quota */
  promoQuotaBranchUsages: PromoQuotaBranchUsagePagedResult;
  /** Get paginated list of promo quota configs */
  promoQuotas: PromoQuotaPagedResult;
  promoType: PromoType;
  promoTypes: PromoTypePaged;
  promos: PromoPaged;
  province?: Maybe<Province>;
  provinces?: Maybe<ProvincePaged>;
  purchaseArea?: Maybe<PurchaseArea>;
  purchaseAreas: PurchaseAreaPaged;
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderItem?: Maybe<PurchaseOrderItem>;
  purchaseOrderItems: PurchaseOrderItemPaged;
  purchaseOrderReceiving?: Maybe<PurchaseOrderReceiving>;
  purchaseOrderReceivingItem?: Maybe<PurchaseOrderReceivingItem>;
  purchaseOrderReceivingItems: PurchaseOrderReceivingItemPaged;
  purchaseOrderReceivings: PurchaseOrderReceivingPaged;
  purchaseOrders: PurchaseOrderPaged;
  putawayTask: PutawayTask;
  putawayTaskByNumber: PutawayTask;
  putawayTaskExecution: PutawayTaskExecution;
  putawayTaskExecutions: PutawayTaskExecutionPaged;
  putawayTaskItem: PutawayTaskItem;
  putawayTaskItems: PutawayTaskItemPaged;
  putawayTasks: PutawayTaskPaged;
  reason: Reason;
  reasonInventoryAdjustment: ReasonInventoryAdjustment;
  reasonInventoryAdjustments: ReasonInventoryAdjustmentPaged;
  reasons: ReasonPaged;
  replenishment: Replenishment;
  replenishmentItem: ReplenishmentItem;
  replenishmentItems: ReplenishmentItemPaged;
  replenishmentTemplate: ReplenishmentTemplate;
  replenishmentTemplateCategories: ReplenishmentTemplateCategoryPaged;
  replenishmentTemplateCategory: ReplenishmentTemplateCategory;
  replenishmentTemplateItem: ReplenishmentTemplateItem;
  replenishmentTemplateItems: ReplenishmentTemplateItemPaged;
  replenishmentTemplates: ReplenishmentTemplatePaged;
  replenishments: ReplenishmentPaged;
  resource?: Maybe<Resource>;
  resources: ResourcePaged;
  revenueReport?: Maybe<RevenueReport>;
  revenueReportAccessLogSummary: RevenueReportAccessLogSummary;
  revenueReportAccessLogs: RevenueReportAccessLogPaged;
  revenueReportApiKeys: RevenueReportApiKeyPaged;
  revenueReportDetails: RevenueReportDetailPaged;
  revenueReportPartner?: Maybe<RevenueReportPartner>;
  revenueReportPartnerBranch?: Maybe<RevenueReportPartnerBranch>;
  revenueReportPartnerBranches: RevenueReportPartnerBranchPaged;
  revenueReportPartners: RevenueReportPartnerPaged;
  revenueReportSummary: RevenueReportSummary;
  revenueReportTemplate?: Maybe<RevenueReportTemplate>;
  revenueReportTemplatePreview: Scalars['String']['output'];
  revenueReportTemplates: RevenueReportTemplatePaged;
  revenueReportUploadBatches: RevenueReportUploadBatchPaged;
  revenueReportUser?: Maybe<RevenueReportUser>;
  revenueReportUsers: RevenueReportUserPaged;
  revenueReports: RevenueReportPaged;
  revenueSharing?: Maybe<RevenueSharing>;
  revenueSharingBranch?: Maybe<RevenueSharingBranch>;
  revenueSharingBranches: RevenueSharingBranchPaged;
  revenueSharingDetail?: Maybe<RevenueSharingDetail>;
  revenueSharingDetailLippoLive: Array<RevenueSharingLippoLiveRow>;
  revenueSharingDetails: RevenueSharingDetailPaged;
  revenueSharingUploadBatches: Array<RevenueSharingUploadBatch>;
  revenueSharings: RevenueSharingPaged;
  role?: Maybe<RoleDetail>;
  roles: RolePaged;
  salesChannel?: Maybe<SalesChannel>;
  salesChannelCampaign: SalesChannelCampaign;
  salesChannelCampaignChannels: Array<SalesChannelCampaignChannel>;
  salesChannelCampaignProducts: SalesChannelCampaignProductPaged;
  salesChannelCampaignResults: SalesChannelCampaignResultPaged;
  salesChannelCampaigns: SalesChannelCampaignPaged;
  salesChannelCategories: SalesChannelCategoryPaged;
  salesChannelCategory: SalesChannelCategory;
  salesChannelCategoryGroup: SalesChannelCategoryGroup;
  salesChannelCategoryGroupItem: SalesChannelCategoryGroupItem;
  salesChannelCategoryGroupItems: SalesChannelCategoryGroupItemPaged;
  salesChannelCategoryGroupProduct: SalesChannelCategoryGroupProduct;
  salesChannelCategoryGroupProducts: SalesChannelCategoryGroupProductPaged;
  salesChannelCategoryGroups: SalesChannelCategoryGroupPaged;
  salesChannelMenuBuild: SalesChannelBuiltMenu;
  salesChannelStockThresholds: SalesChannelStockThresholdPaged;
  salesChannels: SalesChannelPaged;
  salesConsignmentInvoice?: Maybe<SalesConsignmentInvoice>;
  salesConsignmentInvoiceItem?: Maybe<SalesConsignmentInvoiceItem>;
  salesConsignmentInvoiceItems: SalesConsignmentInvoiceItemPaged;
  salesConsignmentInvoices: SalesConsignmentInvoicePaged;
  salesDashboard: SalesDashboard;
  salesInvoice?: Maybe<SalesInvoice>;
  salesInvoiceItem?: Maybe<SalesInvoiceItem>;
  salesInvoiceItems: SalesInvoiceItemPaged;
  salesInvoicePayments: SalesInvoicePaymentPaged;
  salesInvoiceReview?: Maybe<SalesInvoiceReview>;
  salesInvoiceReviews: SalesInvoiceReviewPaged;
  salesInvoices: SalesInvoicePaged;
  salesPaymentMethod: SalesPaymentMethod;
  salesPaymentMethodType: SalesPaymentMethodType;
  salesPaymentMethodTypes: SalesPaymentMethodTypePaged;
  salesPaymentMethods: SalesPaymentMethodPaged;
  shiftSession: ShiftSession;
  shiftSessions: ShiftSessionPaged;
  simpleTransferOrder?: Maybe<SimpleTransferOrder>;
  simpleTransferOrderItem?: Maybe<SimpleTransferOrderItem>;
  simpleTransferOrderItemLocations: SimpleTransferOrderItemLocationPaged;
  simpleTransferOrderItems: SimpleTransferOrderItemPaged;
  simpleTransferOrderReceiving?: Maybe<SimpleTransferOrderReceiving>;
  simpleTransferOrderReceivingItem?: Maybe<SimpleTransferOrderReceivingItem>;
  simpleTransferOrderReceivingItems: SimpleTransferOrderReceivingItemPaged;
  simpleTransferOrderReceivings: SimpleTransferOrderReceivingPaged;
  simpleTransferOrders: SimpleTransferOrderPaged;
  subdistrict?: Maybe<Subdistrict>;
  subdistricts?: Maybe<SubdistrictPaged>;
  tax: Tax;
  taxes: TaxPaged;
  transferOrder?: Maybe<TransferOrder>;
  transferOrderItem?: Maybe<TransferOrderItem>;
  transferOrderItems: TransferOrderItemPaged;
  transferOrderReceiving?: Maybe<TransferOrderReceiving>;
  transferOrderReceivingItem?: Maybe<TransferOrderReceivingItem>;
  transferOrderReceivingItems: TransferOrderReceivingItemPaged;
  transferOrderReceivings: TransferOrderReceivingPaged;
  transferOrders: TransferOrderPaged;
  transferRequest?: Maybe<TransferRequest>;
  transferRequestItem?: Maybe<TransferRequestItem>;
  transferRequestItems: TransferRequestItemPaged;
  transferRequests: TransferRequestPaged;
  unassignedPickingTasks: PickingTaskPaged;
  unassignedPutawayTasks?: Maybe<PutawayTaskPaged>;
  uom: Uom;
  uomCategories: UomCategoryPaged;
  uomCategory: UomCategory;
  uoms: UomPaged;
  uploadTemplate: UploadTemplate;
  uploadTemplates: UploadTemplatePaged;
  user?: Maybe<UserDetail>;
  userProfile: UserProfile;
  userTokenByCode?: Maybe<UserToken>;
  users: UserPaged;
  usersLite: UserLitePaged;
  vendor: Vendor;
  vendorCategories: VendorCategoryPaged;
  vendorCategory: VendorCategory;
  vendorConsignmentBranch: VendorConsignmentBranch;
  vendorConsignmentBranchPeriod?: Maybe<VendorConsignmentBranchPeriod>;
  vendorConsignmentBranchPeriodByBranch?: Maybe<VendorConsignmentBranchPeriod>;
  vendorConsignmentBranchPeriods: VendorConsignmentBranchPeriodPaged;
  vendorConsignmentBranches: VendorConsignmentBranchPaged;
  vendorConsignmentDashboard: VendorConsignmentDashboard;
  vendorConsignmentInvoice?: Maybe<VendorConsignmentInvoice>;
  vendorConsignmentInvoiceConfig?: Maybe<VendorConsignmentInvoiceConfig>;
  vendorConsignmentInvoiceConfigs: VendorConsignmentInvoiceConfigPaged;
  vendorConsignmentInvoiceEmailPreview: Scalars['String']['output'];
  vendorConsignmentInvoiceSummary: VendorConsignmentInvoiceSummary;
  vendorConsignmentInvoices: VendorConsignmentInvoicePaged;
  vendorConsignmentPaymentChargeConfigs: VendorConsignmentPaymentChargeConfigPaged;
  vendorConsignmentProduct: VendorConsignmentProduct;
  vendorConsignmentProducts: VendorConsignmentProductAggregatedPaged;
  vendorConsignmentProductsByBranch: VendorConsignmentImportItemPaged;
  vendorConsignmentRentalPayment?: Maybe<VendorConsignmentRentalPayment>;
  vendorConsignmentRentalPayments: VendorConsignmentRentalPaymentPaged;
  vendorConsignmentSalesExport: VendorConsignmentSalesExportResult;
  /**
   * A vendor's consignment stock aggregated per cabang (branch), storage warehouses
   *   only. Pagination is applied after aggregation so totals reflect cabang count.
   */
  vendorConsignmentStockByBranch: VendorConsignmentStockByBranchPaged;
  /** The same rows as the table, as .xlsx, honouring the same search and result filters. */
  vendorInventoryCountExport: VendorInventoryCountExportResult;
  /**
   * Opnames the vendor can open, newest first. Only counts whose stock adjustment has
   *   posted: an in-progress or unposted one would show numbers that still change.
   *
   *   Capped at 200 — a picker is a dropdown, and a vendor with a longer history should
   *   narrow the period rather than pull every count they ever appeared in.
   */
  vendorInventoryCountList: Array<VendorInventoryCountListItem>;
  /** Cards plus the paged item table for one opname. */
  vendorInventoryCountReport: VendorInventoryCountReport;
  vendorPicContact: VendorPicContact;
  vendorPicContacts: VendorPicContactPaged;
  vendorStockExport: VendorStockExportResult;
  /** Stock movement breakdown behind one product on the vendor stock opname detail page. */
  vendorStockReconciliation: VendorStockReconciliation;
  vendors: VendorPaged;
  village: Village;
  villages: VillagePaged;
  voucher?: Maybe<Voucher>;
  voucherCategories: VoucherCategoryPaged;
  voucherCategory?: Maybe<VoucherCategory>;
  voucherItem?: Maybe<VoucherItem>;
  voucherItemByCode?: Maybe<VoucherItem>;
  voucherItems: VoucherItemPaged;
  vouchers: VoucherPaged;
  warehouse?: Maybe<Warehouse>;
  warehouseLocation?: Maybe<WarehouseLocation>;
  warehouseLocationGroup?: Maybe<WarehouseLocationGroup>;
  warehouseLocationGroups: WarehouseLocationGroupPaged;
  warehouseLocationRelationMap: WarehouseLocationRelationMap;
  warehouseLocationRelationMaps: WarehouseLocationRelationMapPaged;
  warehouseLocationSortableFields: Array<Scalars['String']['output']>;
  warehouseLocations: WarehouseLocationPaged;
  warehouseProductLocationMap?: Maybe<WarehouseProductLocationMap>;
  warehouseProductLocationMaps: WarehouseProductLocationMapPaged;
  warehouseReplenishmentTemplate?: Maybe<WarehouseReplenishmentTemplate>;
  warehouseReplenishmentTemplates: WarehouseReplenishmentTemplatePaged;
  warehouses: WarehousePaged;
};


export type QueryActiveShiftSessionByUserIdArgs = {
  userID: Scalars['UUID']['input'];
};


export type QueryAiChatMessagesArgs = {
  input: AiChatMessageQopInput;
};


export type QueryAiChatSessionArgs = {
  sessionID: Scalars['String']['input'];
};


export type QueryAiChatSessionsArgs = {
  input?: InputMaybe<AiChatSessionQopInput>;
};


export type QueryAppArgs = {
  appID: Scalars['String']['input'];
};


export type QueryAppsArgs = {
  qop?: InputMaybe<AppQopInput>;
};


export type QueryBackgroundJobArgs = {
  backgroundJobID: Scalars['UUID']['input'];
};


export type QueryBackgroundJobsArgs = {
  qop?: InputMaybe<BackgroundJobQopInput>;
};


export type QueryBankArgs = {
  bankID: Scalars['UUID']['input'];
};


export type QueryBankAccountArgs = {
  bankAccountID: Scalars['UUID']['input'];
};


export type QueryBankAccountsArgs = {
  qop?: InputMaybe<BankAccountQopInput>;
};


export type QueryBankReconciliationArgs = {
  bankReconciliationID: Scalars['UUID']['input'];
};


export type QueryBankReconciliationFilesArgs = {
  bankReconciliationID: Scalars['UUID']['input'];
};


export type QueryBankReconciliationItemsArgs = {
  qop?: InputMaybe<BankReconciliationItemQopInput>;
};


export type QueryBankReconciliationPoolFilesArgs = {
  bankID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryBankReconciliationPoolRowsArgs = {
  qop?: InputMaybe<BankDataRowQopInput>;
};


export type QueryBankReconciliationsArgs = {
  qop?: InputMaybe<BankReconciliationQopInput>;
};


export type QueryBanksArgs = {
  qop?: InputMaybe<BankQopInput>;
};


export type QueryBiKnowledgeArgs = {
  biKnowledgeID: Scalars['UUID']['input'];
};


export type QueryBiKnowledgeListArgs = {
  qop?: InputMaybe<BiKnowledgeQopInput>;
};


export type QueryBiRoleArgs = {
  role: Scalars['String']['input'];
};


export type QueryBiRolesArgs = {
  qop?: InputMaybe<BiRoleQopInput>;
};


export type QueryBiScopeTableArgs = {
  tableName: Scalars['String']['input'];
};


export type QueryBiScopeTablesArgs = {
  qop?: InputMaybe<BiScopeTableQopInput>;
};


export type QueryBiUserArgs = {
  biUserID: Scalars['UUID']['input'];
};


export type QueryBiUsersArgs = {
  qop?: InputMaybe<BiUserQopInput>;
};


export type QueryBillOfMaterialArgs = {
  billOfMaterialID: Scalars['UUID']['input'];
};


export type QueryBillOfMaterialComponentArgs = {
  billOfMaterialComponentID: Scalars['UUID']['input'];
};


export type QueryBillOfMaterialComponentsArgs = {
  qop?: InputMaybe<BillOfMaterialComponentQopInput>;
};


export type QueryBillOfMaterialsArgs = {
  qop?: InputMaybe<BillOfMaterialQopInput>;
};


export type QueryBranchArgs = {
  branchID: Scalars['UUID']['input'];
};


export type QueryBranchBankAccountArgs = {
  branchBankAccountID: Scalars['UUID']['input'];
};


export type QueryBranchBankAccountsArgs = {
  qop?: InputMaybe<BranchBankAccountQopInput>;
};


export type QueryBranchCategoriesArgs = {
  qop?: InputMaybe<BranchCategoryQopInput>;
};


export type QueryBranchCategoryArgs = {
  branchCategoryID: Scalars['UUID']['input'];
};


export type QueryBranchPosBookmarkArgs = {
  branchPosBookmarkID: Scalars['UUID']['input'];
};


export type QueryBranchPosBookmarksArgs = {
  qop?: InputMaybe<BranchPosBookmarkQopInput>;
};


export type QueryBranchProductSalesChannelItemsArgs = {
  qop?: InputMaybe<BranchProductSalesChannelItemQopInput>;
};


export type QueryBranchQrisMerchantArgs = {
  branchQrisMerchantID: Scalars['UUID']['input'];
};


export type QueryBranchQrisMerchantsArgs = {
  qop?: InputMaybe<BranchQrisMerchantQopInput>;
};


export type QueryBranchSalesChannelCategoryGroupArgs = {
  branchSalesChannelCategoryGroupID: Scalars['UUID']['input'];
};


export type QueryBranchSalesChannelCategoryGroupsArgs = {
  qop?: InputMaybe<BranchSalesChannelCategoryGroupQopInput>;
};


export type QueryBranchSalesChannelMerchantMapArgs = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
};


export type QueryBranchSalesChannelMerchantMapsArgs = {
  qop?: InputMaybe<BranchSalesChannelMerchantMapQopInput>;
};


export type QueryBranchSalesChannelMerchantMapsByBranchArgs = {
  branchID: Scalars['UUID']['input'];
};


export type QueryBranchSalesChannelPauseDurationsArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type QueryBranchSalesPaymentMethodArgs = {
  branchSalesPaymentMethodID: Scalars['UUID']['input'];
};


export type QueryBranchSalesPaymentMethodsArgs = {
  qop?: InputMaybe<BranchSalesPaymentMethodQopInput>;
};


export type QueryBranchStoreSupervisorArgs = {
  branchStoreSupervisorID: Scalars['UUID']['input'];
};


export type QueryBranchStoreSupervisorsArgs = {
  qop?: InputMaybe<BranchStoreSupervisorQopInput>;
};


export type QueryBranchStoreSupervisorsByBranchIdArgs = {
  branchID: Scalars['UUID']['input'];
};


export type QueryBranchesArgs = {
  qop?: InputMaybe<BranchQopInput>;
};


export type QueryCheckOtpArgs = {
  input: CheckOtpRequest;
};


export type QueryCheckPromoQuotaArgs = {
  input: PromoQuotaCheckInput;
};


export type QueryCitiesArgs = {
  qop?: InputMaybe<CityQop>;
};


export type QueryCityArgs = {
  id: Scalars['String']['input'];
};


export type QueryConsignmentSettlementBranchesArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryConsignmentSettlementExportArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryConsignmentSettlementHistoryArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryConsignmentSettlementListExportArgs = {
  filter: ConsignmentSettlementListExportFilterInput;
};


export type QueryConsignmentSettlementPivotArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInArgs = {
  consignmentStockInID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInItemArgs = {
  consignmentStockInItemID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInItemsArgs = {
  qop?: InputMaybe<ConsignmentStockInItemQopInput>;
};


export type QueryConsignmentStockInRequestArgs = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInRequestFilesArgs = {
  qop?: InputMaybe<ConsignmentStockInRequestFileQopInput>;
};


export type QueryConsignmentStockInRequestItemsArgs = {
  qop?: InputMaybe<ConsignmentStockInRequestItemQopInput>;
};


export type QueryConsignmentStockInRequestLabelsArgs = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInRequestSummaryArgs = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryConsignmentStockInRequestsArgs = {
  qop?: InputMaybe<ConsignmentStockInRequestQopInput>;
};


export type QueryConsignmentStockInsArgs = {
  qop?: InputMaybe<ConsignmentStockInQopInput>;
};


export type QueryConsignmentStockOutArgs = {
  consignmentStockOutID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockOutItemArgs = {
  consignmentStockOutItemID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockOutItemsArgs = {
  qop?: InputMaybe<ConsignmentStockOutItemQopInput>;
};


export type QueryConsignmentStockOutsArgs = {
  qop?: InputMaybe<ConsignmentStockOutQopInput>;
};


export type QueryConsignmentTagPricesArgs = {
  input: ConsignmentTagPricesInput;
};


export type QueryConversationTurnsArgs = {
  qop?: InputMaybe<ConversationTurnQopInput>;
};


export type QueryCountriesArgs = {
  qop?: InputMaybe<CountryQop>;
};


export type QueryCountryArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerArgs = {
  customerID: Scalars['UUID']['input'];
};


export type QueryCustomerAddressByIdArgs = {
  customerAddressID: Scalars['UUID']['input'];
};


export type QueryCustomerAddressListArgs = {
  qop?: InputMaybe<CustomerAddressQopInput>;
};


export type QueryCustomerAddressesByCustomerIdArgs = {
  customerID: Scalars['UUID']['input'];
};


export type QueryCustomerByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryCustomerPointTransactionArgs = {
  customerPointTransactionID: Scalars['UUID']['input'];
};


export type QueryCustomerPointTransactionsArgs = {
  qop?: InputMaybe<CustomerPointTransactionQopInput>;
};


export type QueryCustomerVoucherTransactionArgs = {
  customerVoucherTransactionID: Scalars['UUID']['input'];
};


export type QueryCustomerVoucherTransactionsArgs = {
  qop?: InputMaybe<CustomerVoucherTransactionQopInput>;
};


export type QueryCustomersArgs = {
  qop?: InputMaybe<CustomerQopInput>;
};


export type QueryDeliveryOrderArgs = {
  deliveryOrderID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderBatchArgs = {
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderBatchDestinationSummaryArgs = {
  destinationWarehouseID: Scalars['UUID']['input'];
  originWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryDeliveryOrderBatchDraftArgs = {
  destinationWarehouseID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderBatchesArgs = {
  qop?: InputMaybe<DeliveryOrderBatchQopInput>;
};


export type QueryDeliveryOrderItemSummariesArgs = {
  qop?: InputMaybe<DeliveryOrderItemSummaryQopInput>;
};


export type QueryDeliveryOrderItemSummariesByDeliveryOrderIdArgs = {
  deliveryOrderID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderItemSummaryArgs = {
  deliveryOrderItemSummaryID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderItemsArgs = {
  qop?: InputMaybe<DeliveryOrderItemQopInput>;
};


export type QueryDeliveryOrdersArgs = {
  qop?: InputMaybe<DeliveryOrderQopInput>;
};


export type QueryEdcTerminalArgs = {
  edcTerminalID: Scalars['UUID']['input'];
};


export type QueryEdcTerminalsArgs = {
  qop?: InputMaybe<EdcTerminalQopInput>;
};


export type QueryEmployeeArgs = {
  employeeID: Scalars['UUID']['input'];
};


export type QueryEmployeesArgs = {
  qop?: InputMaybe<EmployeeQopInput>;
};


export type QueryErpAccountJournalArgs = {
  accountJournalID: Scalars['Int']['input'];
};


export type QueryErpAccountJournalsArgs = {
  qop?: InputMaybe<AccountJournalQopInput>;
};


export type QueryErpBranchArgs = {
  branchID: Scalars['Int']['input'];
};


export type QueryErpBranchesArgs = {
  qop?: InputMaybe<ErpBranchQopInput>;
};


export type QueryErpEmployeeArgs = {
  employeeID: Scalars['Int64']['input'];
};


export type QueryErpEmployeesArgs = {
  qop?: InputMaybe<ErpEmployeeQopInput>;
};


export type QueryErpProductArgs = {
  productID: Scalars['Int']['input'];
};


export type QueryErpProductCategoriesArgs = {
  qop?: InputMaybe<ErpProductCategoryQopInput>;
};


export type QueryErpProductCategoryArgs = {
  productCategoryID: Scalars['Int']['input'];
};


export type QueryErpProductsArgs = {
  qop?: InputMaybe<ErpProductQopInput>;
};


export type QueryErpPurchaseOrderReceiveArgs = {
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};


export type QueryErpPurchaseOrderReceivesArgs = {
  qop?: InputMaybe<ErpPurchaseOrderReceiveQopInput>;
};


export type QueryErpSyncFullRunArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryErpSyncFullRunsArgs = {
  qop?: InputMaybe<ErpSyncFullRunQopInput>;
};


export type QueryErpTaxArgs = {
  taxID: Scalars['Int']['input'];
};


export type QueryErpTaxesArgs = {
  qop?: InputMaybe<ErpTaxQopInput>;
};


export type QueryErpUomArgs = {
  uomID: Scalars['Int']['input'];
};


export type QueryErpUomCategoriesArgs = {
  qop?: InputMaybe<ErpUomCategoryQopInput>;
};


export type QueryErpUomCategoryArgs = {
  uomCategoryID: Scalars['Int']['input'];
};


export type QueryErpUomsArgs = {
  qop?: InputMaybe<ErpUomQopInput>;
};


export type QueryErpVendorArgs = {
  vendorID: Scalars['Int']['input'];
};


export type QueryErpVendorsArgs = {
  qop?: InputMaybe<ErpVendorQopInput>;
};


export type QueryErpWarehouseArgs = {
  warehouseID: Scalars['Int']['input'];
};


export type QueryErpWarehousesArgs = {
  qop?: InputMaybe<ErpWarehouseQopInput>;
};


export type QueryExpenseItemArgs = {
  expenseItemID: Scalars['UUID']['input'];
};


export type QueryExpenseItemsArgs = {
  qop?: InputMaybe<ExpenseItemQopInput>;
};


export type QueryFileArgs = {
  fileID: Scalars['UUID']['input'];
};


export type QueryFilesArgs = {
  qop?: InputMaybe<FileQopInput>;
};


export type QueryInboundReceivingArgs = {
  inboundReceivingID: Scalars['UUID']['input'];
};


export type QueryInboundReceivingsArgs = {
  qop?: InputMaybe<InboundReceivingQopInput>;
};


export type QueryInternalTransferArgs = {
  internalTransferID: Scalars['UUID']['input'];
};


export type QueryInternalTransferExecutionArgs = {
  internalTransferExecutionID: Scalars['UUID']['input'];
};


export type QueryInternalTransferExecutionsArgs = {
  qop?: InputMaybe<InternalTransferExecutionQopInput>;
};


export type QueryInternalTransferItemArgs = {
  internalTransferItemID: Scalars['UUID']['input'];
};


export type QueryInternalTransferItemsArgs = {
  qop?: InputMaybe<InternalTransferItemQopInput>;
};


export type QueryInternalTransfersArgs = {
  qop?: InputMaybe<InternalTransferQopInput>;
};


export type QueryInventoryAdjustmentArgs = {
  inventoryAdjustmentID: Scalars['UUID']['input'];
};


export type QueryInventoryAdjustmentItemArgs = {
  inventoryAdjustmentItemID: Scalars['UUID']['input'];
};


export type QueryInventoryAdjustmentItemsArgs = {
  qop?: InputMaybe<InventoryAdjustmentItemQopInput>;
};


export type QueryInventoryAdjustmentTypesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInventoryAdjustmentsArgs = {
  qop?: InputMaybe<InventoryAdjustmentQopInput>;
};


export type QueryInventoryCountItemTemplateArgs = {
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
};


export type QueryInventoryCountItemTemplateItemArgs = {
  inventoryCountItemTemplateItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountItemTemplateItemsArgs = {
  qop?: InputMaybe<InventoryCountItemTemplateItemQopInput>;
};


export type QueryInventoryCountItemTemplatesArgs = {
  qop?: InputMaybe<InventoryCountItemTemplateQopInput>;
};


export type QueryInventoryCountTaskArgs = {
  inventoryCountTaskID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskAssigneeArgs = {
  inventoryCountTaskAssigneeID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskAssigneesArgs = {
  qop?: InputMaybe<InventoryCountTaskAssigneeQopInput>;
};


export type QueryInventoryCountTaskExecutionItemArgs = {
  inventoryCountTaskExecutionItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskExecutionItemDetailArgs = {
  inventoryCountTaskExecutionItemDetailID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskExecutionItemDetailsArgs = {
  qop?: InputMaybe<InventoryCountTaskExecutionItemDetailQopInput>;
};


export type QueryInventoryCountTaskExecutionItemSummariesArgs = {
  qop?: InputMaybe<InventoryCountTaskExecutionItemSummaryQopInput>;
};


export type QueryInventoryCountTaskExecutionItemSummaryArgs = {
  inventoryCountTaskExecutionItemSummaryID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskExecutionItemsArgs = {
  qop?: InputMaybe<InventoryCountTaskExecutionItemQopInput>;
};


export type QueryInventoryCountTaskExecutionItemsInLocationsArgs = {
  qop?: InputMaybe<InventoryCountTaskExecutionItemQopInput>;
};


export type QueryInventoryCountTaskRecountItemArgs = {
  inventoryCountTaskRecountItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskRecountItemsArgs = {
  qop?: InputMaybe<InventoryCountTaskRecountItemQopInput>;
};


export type QueryInventoryCountTasksArgs = {
  qop?: InputMaybe<InventoryCountTaskQopInput>;
};


export type QueryInventoryCountTransactionArgs = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionItemArgs = {
  inventoryCountTransactionItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionItemsArgs = {
  qop?: InputMaybe<InventoryCountTransactionItemQopInput>;
};


export type QueryInventoryCountTransactionLocationArgs = {
  inventoryCountTransactionLocationID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionLocationDetailArgs = {
  inventoryCountTransactionLocationDetailID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionLocationDetailsArgs = {
  qop?: InputMaybe<InventoryCountTransactionLocationDetailQopInput>;
};


export type QueryInventoryCountTransactionLocationsArgs = {
  qop?: InputMaybe<InventoryCountTransactionLocationQopInput>;
};


export type QueryInventoryCountTransactionResultItemArgs = {
  inventoryCountTransactionResultItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionResultItemDetailArgs = {
  inventoryCountTransactionResultItemDetailID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionResultItemDetailsArgs = {
  qop?: InputMaybe<InventoryCountTransactionResultItemDetailQopInput>;
};


export type QueryInventoryCountTransactionResultItemsArgs = {
  qop?: InputMaybe<InventoryCountTransactionResultItemQopInput>;
};


export type QueryInventoryCountTransactionsArgs = {
  qop?: InputMaybe<InventoryCountTransactionQopInput>;
};


export type QueryInventoryDailyMovementArgs = {
  inventoryDailyMovementID: Scalars['UUID']['input'];
};


export type QueryInventoryDailyMovementsArgs = {
  qop?: InputMaybe<InventoryDailyMovementQopInput>;
};


export type QueryInventoryLocationArgs = {
  inventoryLocationID: Scalars['UUID']['input'];
};


export type QueryInventoryLocationsArgs = {
  qop?: InputMaybe<InventoryLocationQopInput>;
};


export type QueryInventoryMovementSummaryArgs = {
  qop: InventoryMovementSummaryQopInput;
};


export type QueryInventoryPositionArgs = {
  inventoryPositionID: Scalars['UUID']['input'];
};


export type QueryInventoryPositionSnapshotArgs = {
  qop?: InputMaybe<InventoryPositionSnapshotQopInput>;
};


export type QueryInventoryPositionsArgs = {
  qop?: InputMaybe<InventoryPositionQopInput>;
};


export type QueryInventoryPositionsByIdsArgs = {
  inventoryPositionIds: Array<Scalars['UUID']['input']>;
};


export type QueryInventorySummariesArgs = {
  qop?: InputMaybe<InventorySummaryQopInput>;
};


export type QueryInventorySummaryArgs = {
  inventorySummaryID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionArgs = {
  inventoryTransactionID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionItemArgs = {
  inventoryTransactionItemID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionItemsArgs = {
  qop?: InputMaybe<InventoryTransactionItemQopInput>;
};


export type QueryInventoryTransactionLineArgs = {
  inventoryTransactionLineID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionLineUnitArgs = {
  inventoryTransactionLineUnitID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionLineUnitsArgs = {
  qop?: InputMaybe<InventoryTransactionLineUnitQopInput>;
};


export type QueryInventoryTransactionLinesArgs = {
  qop?: InputMaybe<InventoryTransactionLineQopInput>;
};


export type QueryInventoryTransactionsArgs = {
  qop?: InputMaybe<InventoryTransactionQopInput>;
};


export type QueryMarketplaceBackgroundJobArgs = {
  marketplaceBackgroundJobID: Scalars['UUID']['input'];
};


export type QueryMarketplaceBackgroundJobsArgs = {
  qop?: InputMaybe<MarketplaceBackgroundJobQopInput>;
};


export type QueryMarketplaceCampaignArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type QueryMarketplaceCampaignProductsArgs = {
  qop?: InputMaybe<MarketplaceCampaignProductQopInput>;
};


export type QueryMarketplaceCampaignsArgs = {
  qop?: InputMaybe<MarketplaceCampaignQopInput>;
};


export type QueryMarketplaceChannelApiLogArgs = {
  marketplaceChannelAPILogID: Scalars['UUID']['input'];
};


export type QueryMarketplaceChannelApiLogsArgs = {
  qop?: InputMaybe<MarketplaceChannelApiLogQopInput>;
};


export type QueryMarketplaceChannelTaxonomyArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceCronSettingsArgs = {
  qop?: InputMaybe<MarketplaceCronSettingQopInput>;
};


export type QueryMarketplaceInboundOrderArgs = {
  marketplaceInboundOrderID: Scalars['UUID']['input'];
};


export type QueryMarketplaceInboundOrdersArgs = {
  qop?: InputMaybe<MarketplaceInboundOrderQopInput>;
};


export type QueryMarketplaceMenuSyncStatusArgs = {
  externalMerchantID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceOrderArgs = {
  marketplaceOrderID: Scalars['UUID']['input'];
};


export type QueryMarketplaceOrderCheckCancelableArgs = {
  externalOrderID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceOrderExportArgs = {
  qop?: InputMaybe<MarketplaceOrderQopInput>;
};


export type QueryMarketplaceOrderItemArgs = {
  marketplaceOrderItemID: Scalars['UUID']['input'];
};


export type QueryMarketplaceOrderItemsArgs = {
  qop?: InputMaybe<MarketplaceOrderItemQopInput>;
};


export type QueryMarketplaceOrdersArgs = {
  qop?: InputMaybe<MarketplaceOrderQopInput>;
};


export type QueryMarketplacePromoForPublishArgs = {
  promoID: Scalars['UUID']['input'];
};


export type QueryMarketplaceProviderCampaignsArgs = {
  externalMerchantID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplacePublishablePromosArgs = {
  externalMerchantID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceStoreStatusArgs = {
  externalMerchantID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceSyncHealthArgs = {
  salesChannelIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryMasterdataBackgroundJobArgs = {
  backgroundJobID: Scalars['UUID']['input'];
};


export type QueryMemberTypeArgs = {
  memberTypeID: Scalars['UUID']['input'];
};


export type QueryMemberTypesArgs = {
  qop?: InputMaybe<MemberTypeQopInput>;
};


export type QueryMobilePickingTaskArgs = {
  pickingTaskID: Scalars['UUID']['input'];
};


export type QueryMobilePutawayTaskArgs = {
  putawayTaskID: Scalars['UUID']['input'];
};


export type QueryMyInventoryCountTaskHistoriesArgs = {
  qop?: InputMaybe<InventoryCountTaskQopInput>;
};


export type QueryMyInventoryCountTasksArgs = {
  qop?: InputMaybe<InventoryCountTaskQopInput>;
};


export type QueryMyPickingTasksArgs = {
  qop?: InputMaybe<PickingTaskQopInput>;
};


export type QueryMyPutawayTasksArgs = {
  qop?: InputMaybe<PutawayTaskQopInput>;
};


export type QueryNonMainUomsArgs = {
  qop?: InputMaybe<UomQopInput>;
};


export type QueryOutboundContainerArgs = {
  outboundContainerID: Scalars['UUID']['input'];
};


export type QueryOutboundContainerItemsArgs = {
  qop?: InputMaybe<OutboundContainerItemQopInput>;
};


export type QueryOutboundContainerItemsSummaryArgs = {
  qop?: InputMaybe<OutboundContainerItemGroupedQopInput>;
};


export type QueryOutboundContainersArgs = {
  qop?: InputMaybe<OutboundContainerQopInput>;
};


export type QueryPackingTaskArgs = {
  packingTaskID: Scalars['UUID']['input'];
};


export type QueryPackingTaskContainerArgs = {
  packingTaskContainerID: Scalars['UUID']['input'];
};


export type QueryPackingTaskContainerItemArgs = {
  packingTaskContainerItemID: Scalars['UUID']['input'];
};


export type QueryPackingTaskContainerItemsArgs = {
  qop?: InputMaybe<PackingTaskContainerItemQopInput>;
};


export type QueryPackingTaskContainersArgs = {
  qop?: InputMaybe<PackingTaskContainerQopInput>;
};


export type QueryPackingTaskExecutionArgs = {
  packingTaskExecutionID: Scalars['UUID']['input'];
};


export type QueryPackingTaskExecutionsArgs = {
  qop?: InputMaybe<PackingTaskExecutionQopInput>;
};


export type QueryPackingTaskItemArgs = {
  packingTaskItemID: Scalars['UUID']['input'];
};


export type QueryPackingTaskItemsArgs = {
  qop?: InputMaybe<PackingTaskItemQopInput>;
};


export type QueryPackingTasksArgs = {
  qop?: InputMaybe<PackingTaskQopInput>;
};


export type QueryPaymentInboundRequestsArgs = {
  qop?: InputMaybe<PaymentInboundRequestLogQopInput>;
};


export type QueryPaymentInquiryLogsArgs = {
  qop?: InputMaybe<PaymentInquiryLogQopInput>;
};


export type QueryPaymentProviderConfigArgs = {
  paymentProviderConfigID: Scalars['UUID']['input'];
};


export type QueryPaymentProviderConfigsArgs = {
  qop?: InputMaybe<PaymentProviderConfigQopInput>;
};


export type QueryPaymentTransactionArgs = {
  paymentTransactionID: Scalars['UUID']['input'];
};


export type QueryPaymentTransactionsArgs = {
  qop?: InputMaybe<PaymentTransactionQopInput>;
};


export type QueryPaymentWebhookEventsArgs = {
  qop?: InputMaybe<PaymentWebhookEventQopInput>;
};


export type QueryPermissionArgs = {
  permissionID: Scalars['String']['input'];
};


export type QueryPermissionsArgs = {
  qop?: InputMaybe<PermissionQopInput>;
};


export type QueryPettyCashAddFundTransactionArgs = {
  pettyCashTransactionID: Scalars['UUID']['input'];
};


export type QueryPettyCashAddFundTransactionsArgs = {
  qop?: InputMaybe<PettyCashAddFundTransactionQopInput>;
};


export type QueryPettyCashBalanceArgs = {
  pettyCashBalanceID: Scalars['UUID']['input'];
};


export type QueryPettyCashBalancesArgs = {
  qop?: InputMaybe<PettyCashBalanceQopInput>;
};


export type QueryPettyCashExpenseTransactionArgs = {
  pettyCashTransactionID: Scalars['UUID']['input'];
};


export type QueryPettyCashExpenseTransactionItemArgs = {
  pettyCashExpenseTransactionItemID: Scalars['UUID']['input'];
};


export type QueryPettyCashExpenseTransactionItemsArgs = {
  qop?: InputMaybe<PettyCashExpenseTransactionItemQopInput>;
};


export type QueryPettyCashExpenseTransactionsArgs = {
  qop?: InputMaybe<PettyCashExpenseTransactionQopInput>;
};


export type QueryPettyCashLedgerArgs = {
  pettyCashTransactionLedgerID: Scalars['UUID']['input'];
};


export type QueryPettyCashLedgersArgs = {
  qop?: InputMaybe<PettyCashLedgerQopInput>;
};


export type QueryPettyCashRefundTransactionArgs = {
  pettyCashTransactionID: Scalars['UUID']['input'];
};


export type QueryPettyCashRefundTransactionsArgs = {
  qop?: InputMaybe<PettyCashRefundTransactionQopInput>;
};


export type QueryPettyCashTransactionArgs = {
  pettyCashTransactionID: Scalars['UUID']['input'];
};


export type QueryPettyCashTransactionFilesArgs = {
  qop?: InputMaybe<PettyCashTransactionFileQopInput>;
};


export type QueryPettyCashTransactionsArgs = {
  qop?: InputMaybe<PettyCashTransactionQopInput>;
};


export type QueryPickingTaskArgs = {
  pickingTaskID: Scalars['UUID']['input'];
};


export type QueryPickingTaskExecutionArgs = {
  pickingTaskExecutionID: Scalars['UUID']['input'];
};


export type QueryPickingTaskExecutionsArgs = {
  qop?: InputMaybe<PickingTaskExecutionQopInput>;
};


export type QueryPickingTaskGenerateByZonePreviewArgs = {
  input: PickingTaskGenerateByZonePreviewInput;
};


export type QueryPickingTaskItemArgs = {
  pickingTaskItemID: Scalars['UUID']['input'];
};


export type QueryPickingTaskItemsArgs = {
  qop?: InputMaybe<PickingTaskItemQopInput>;
};


export type QueryPickingTasksArgs = {
  qop?: InputMaybe<PickingTaskQopInput>;
};


export type QueryPosBookmarkArgs = {
  posBookmarkID: Scalars['UUID']['input'];
};


export type QueryPosBookmarkProductArgs = {
  posBookmarkProductID: Scalars['UUID']['input'];
};


export type QueryPosBookmarkProductsArgs = {
  qop?: InputMaybe<PosBookmarkProductQopInput>;
};


export type QueryPosBookmarksArgs = {
  qop?: InputMaybe<PosBookmarkQopInput>;
};


export type QueryPosSalesOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPosSalesOrdersArgs = {
  qop?: InputMaybe<PosSalesOrderQopInput>;
};


export type QueryPosterArgs = {
  posterID: Scalars['UUID']['input'];
};


export type QueryPosterImagesArgs = {
  qop?: InputMaybe<PosterImageQopInput>;
};


export type QueryPostersArgs = {
  qop?: InputMaybe<PosterQopInput>;
};


export type QueryPricelistArgs = {
  pricelistID: Scalars['UUID']['input'];
};


export type QueryPricelistPeriodArgs = {
  pricelistPeriodID: Scalars['UUID']['input'];
};


export type QueryPricelistPeriodsArgs = {
  qop?: InputMaybe<PricelistPeriodQopInput>;
};


export type QueryPricelistProductArgs = {
  pricelistProductID: Scalars['UUID']['input'];
};


export type QueryPricelistProductSalesChannelArgs = {
  pricelistProductSalesChannelID: Scalars['UUID']['input'];
};


export type QueryPricelistProductSalesChannelByCompositeKeyArgs = {
  pricelistProductID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryPricelistProductSalesChannelsArgs = {
  qop?: InputMaybe<PricelistProductSalesChannelQopInput>;
};


export type QueryPricelistProductsArgs = {
  qop?: InputMaybe<PricelistProductQopInput>;
};


export type QueryPricelistSalesChannelArgs = {
  pricelistSalesChannelID: Scalars['UUID']['input'];
};


export type QueryPricelistSalesChannelsArgs = {
  qop?: InputMaybe<PricelistSalesChannelQopInput>;
};


export type QueryPricelistTagPricesArgs = {
  input: PricelistTagPricesInput;
};


export type QueryPricelistsArgs = {
  qop?: InputMaybe<PricelistQopInput>;
};


export type QueryProductArgs = {
  productID: Scalars['UUID']['input'];
};


export type QueryProductAiImageArgs = {
  productAIImageID: Scalars['UUID']['input'];
};


export type QueryProductAiImagesArgs = {
  qop?: InputMaybe<ProductAiImageQopInput>;
};


export type QueryProductAccountingCategoriesArgs = {
  qop?: InputMaybe<ProductAccountingCategoryQopInput>;
};


export type QueryProductAccountingCategoryArgs = {
  productAccountingCategoryID: Scalars['UUID']['input'];
};


export type QueryProductAddonArgs = {
  productAddonID: Scalars['UUID']['input'];
};


export type QueryProductAddonComponentArgs = {
  productAddonComponentID: Scalars['UUID']['input'];
};


export type QueryProductAddonComponentsArgs = {
  qop?: InputMaybe<ProductAddonComponentQopInput>;
};


export type QueryProductAddonComponentsByProductAddonIdArgs = {
  productAddonID: Scalars['UUID']['input'];
};


export type QueryProductAddonGroupArgs = {
  productAddonGroupID: Scalars['UUID']['input'];
};


export type QueryProductAddonGroupItemArgs = {
  productAddonGroupItemID: Scalars['UUID']['input'];
};


export type QueryProductAddonGroupItemsArgs = {
  qop?: InputMaybe<ProductAddonGroupItemQopInput>;
};


export type QueryProductAddonGroupItemsByGroupIdArgs = {
  productAddonGroupID: Scalars['UUID']['input'];
};


export type QueryProductAddonGroupsArgs = {
  qop?: InputMaybe<ProductAddonGroupQopInput>;
};


export type QueryProductAddonsArgs = {
  qop?: InputMaybe<ProductAddonQopInput>;
};


export type QueryProductAvailabilityTemplateArgs = {
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};


export type QueryProductAvailabilityTemplateItemArgs = {
  productAvailabilityTemplateItemID: Scalars['UUID']['input'];
};


export type QueryProductAvailabilityTemplateItemsArgs = {
  qop?: InputMaybe<ProductAvailabilityTemplateItemQopInput>;
};


export type QueryProductAvailabilityTemplatesArgs = {
  qop?: InputMaybe<ProductAvailabilityTemplateQopInput>;
};


export type QueryProductBarcodeConflictsArgs = {
  barcodes: Array<Scalars['String']['input']>;
  excludeProductID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryProductBarcodeMapArgs = {
  productBarcodeMapID: Scalars['UUID']['input'];
};


export type QueryProductBarcodeMapsArgs = {
  qop?: InputMaybe<ProductBarcodeMapQopInput>;
};


export type QueryProductBookmarkArgs = {
  productBookmarkID: Scalars['UUID']['input'];
};


export type QueryProductBookmarkProductArgs = {
  productBookmarkProductID: Scalars['UUID']['input'];
};


export type QueryProductBookmarkProductsArgs = {
  qop?: InputMaybe<ProductBookmarkProductQopInput>;
};


export type QueryProductBookmarksArgs = {
  qop?: InputMaybe<ProductBookmarkQopInput>;
};


export type QueryProductBrandArgs = {
  productBrandID: Scalars['UUID']['input'];
};


export type QueryProductBrandsArgs = {
  qop?: InputMaybe<ProductBrandQopInput>;
};


export type QueryProductBundleComponentArgs = {
  productBundleComponentID: Scalars['UUID']['input'];
};


export type QueryProductBundleComponentsArgs = {
  qop?: InputMaybe<ProductBundleComponentQopInput>;
};


export type QueryProductBundleComponentsByProductIdArgs = {
  productID: Scalars['UUID']['input'];
};


export type QueryProductCategoriesArgs = {
  qop?: InputMaybe<ProductCategoryQopInput>;
};


export type QueryProductCategoryArgs = {
  productCategoryID: Scalars['UUID']['input'];
};


export type QueryProductCategorySalesChannelMapArgs = {
  productCategorySalesChannelMapID: Scalars['UUID']['input'];
};


export type QueryProductCategorySalesChannelMapsArgs = {
  qop?: InputMaybe<ProductCategorySalesChannelMapQopInput>;
};


export type QueryProductDepartmentArgs = {
  productDepartmentID: Scalars['UUID']['input'];
};


export type QueryProductDepartmentsArgs = {
  qop?: InputMaybe<ProductDepartmentQopInput>;
};


export type QueryProductDivisionArgs = {
  productDivisionID: Scalars['UUID']['input'];
};


export type QueryProductDivisionsArgs = {
  qop?: InputMaybe<ProductDivisionQopInput>;
};


export type QueryProductFileArgs = {
  productFileID: Scalars['UUID']['input'];
};


export type QueryProductFilesArgs = {
  qop?: InputMaybe<ProductFileQopInput>;
};


export type QueryProductImageEmbeddingChangesArgs = {
  afterSeq?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductImageEmbeddingDeltaArgs = {
  afterSeq?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductImageEmbeddingSnapshotArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductSalesChannelItemMapArgs = {
  productSalesChannelItemMapID: Scalars['UUID']['input'];
};


export type QueryProductSalesChannelItemMapsArgs = {
  qop?: InputMaybe<ProductSalesChannelItemMapQopInput>;
};


export type QueryProductSourceArgs = {
  productSourceID: Scalars['UUID']['input'];
};


export type QueryProductSourcesArgs = {
  qop?: InputMaybe<ProductSourceQopInput>;
};


export type QueryProductSubCategoriesArgs = {
  qop?: InputMaybe<ProductSubCategoryQopInput>;
};


export type QueryProductSubCategoryArgs = {
  productSubCategoryID: Scalars['UUID']['input'];
};


export type QueryProductSubDepartmentArgs = {
  productSubDepartmentID: Scalars['UUID']['input'];
};


export type QueryProductSubDepartmentsArgs = {
  qop?: InputMaybe<ProductSubDepartmentQopInput>;
};


export type QueryProductTagArgs = {
  productTagID: Scalars['UUID']['input'];
};


export type QueryProductTagProductArgs = {
  productTagProductID: Scalars['UUID']['input'];
};


export type QueryProductTagProductsArgs = {
  qop?: InputMaybe<ProductTagProductQopInput>;
};


export type QueryProductTagsArgs = {
  qop?: InputMaybe<ProductTagQopInput>;
};


export type QueryProductVendorArgs = {
  productVendorID: Scalars['UUID']['input'];
};


export type QueryProductVendorsArgs = {
  qop?: InputMaybe<ProductVendorQopInput>;
};


export type QueryProductionOrderArgs = {
  productionOrderID: Scalars['UUID']['input'];
};


export type QueryProductionOrderComponentArgs = {
  productionOrderComponentID: Scalars['UUID']['input'];
};


export type QueryProductionOrderComponentsArgs = {
  qop?: InputMaybe<ProductionOrderComponentQopInput>;
};


export type QueryProductionOrdersArgs = {
  qop?: InputMaybe<ProductionOrderQopInput>;
};


export type QueryProductsArgs = {
  qop?: InputMaybe<ProductQopInput>;
};


export type QueryPromoArgs = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat1Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat2Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat3Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat4Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat5Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat6Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoComponentArgs = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat1Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat2Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat3Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat4Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat5Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat6Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentsArgs = {
  qop?: InputMaybe<PromoComponentQopInput>;
};


export type QueryPromoQuotaArgs = {
  promoQuotaID: Scalars['UUID']['input'];
};


export type QueryPromoQuotaBranchUsageArgs = {
  branchID: Scalars['UUID']['input'];
  promoQuotaID: Scalars['UUID']['input'];
};


export type QueryPromoQuotaBranchUsagesArgs = {
  input: PromoQuotaBranchUsageQopInput;
};


export type QueryPromoQuotasArgs = {
  input: PromoQuotaQopInput;
};


export type QueryPromoTypeArgs = {
  promoTypeID: Scalars['UUID']['input'];
};


export type QueryPromoTypesArgs = {
  qop?: InputMaybe<PromoTypeQopInput>;
};


export type QueryPromosArgs = {
  qop?: InputMaybe<PromoQopInput>;
};


export type QueryProvinceArgs = {
  id: Scalars['String']['input'];
};


export type QueryProvincesArgs = {
  qop?: InputMaybe<ProvinceQop>;
};


export type QueryPurchaseAreaArgs = {
  purchaseAreaID: Scalars['UUID']['input'];
};


export type QueryPurchaseAreasArgs = {
  qop?: InputMaybe<PurchaseAreaQopInput>;
};


export type QueryPurchaseOrderArgs = {
  purchaseOrderID: Scalars['UUID']['input'];
};


export type QueryPurchaseOrderItemArgs = {
  purchaseOrderItemID: Scalars['UUID']['input'];
};


export type QueryPurchaseOrderItemsArgs = {
  qop?: InputMaybe<PurchaseOrderItemQopInput>;
};


export type QueryPurchaseOrderReceivingArgs = {
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};


export type QueryPurchaseOrderReceivingItemArgs = {
  purchaseOrderReceivingItemID: Scalars['UUID']['input'];
};


export type QueryPurchaseOrderReceivingItemsArgs = {
  qop?: InputMaybe<PurchaseOrderReceivingItemQopInput>;
};


export type QueryPurchaseOrderReceivingsArgs = {
  qop?: InputMaybe<PurchaseOrderReceivingQopInput>;
};


export type QueryPurchaseOrdersArgs = {
  qop?: InputMaybe<PurchaseOrderQopInput>;
};


export type QueryPutawayTaskArgs = {
  putawayTaskID: Scalars['UUID']['input'];
};


export type QueryPutawayTaskByNumberArgs = {
  putawayTaskNumber: Scalars['String']['input'];
};


export type QueryPutawayTaskExecutionArgs = {
  putawayTaskExecutionID: Scalars['UUID']['input'];
};


export type QueryPutawayTaskExecutionsArgs = {
  qop?: InputMaybe<PutawayTaskExecutionQopInput>;
};


export type QueryPutawayTaskItemArgs = {
  putawayTaskItemID: Scalars['UUID']['input'];
};


export type QueryPutawayTaskItemsArgs = {
  qop?: InputMaybe<PutawayTaskItemQopInput>;
};


export type QueryPutawayTasksArgs = {
  qop?: InputMaybe<PutawayTaskQopInput>;
};


export type QueryReasonArgs = {
  reasonID: Scalars['UUID']['input'];
};


export type QueryReasonInventoryAdjustmentArgs = {
  reasonInventoryAdjustmentID: Scalars['UUID']['input'];
};


export type QueryReasonInventoryAdjustmentsArgs = {
  qop?: InputMaybe<ReasonInventoryAdjustmentQopInput>;
};


export type QueryReasonsArgs = {
  qop?: InputMaybe<ReasonQopInput>;
};


export type QueryReplenishmentArgs = {
  replenishmentID: Scalars['UUID']['input'];
};


export type QueryReplenishmentItemArgs = {
  replenishmentItemID: Scalars['UUID']['input'];
};


export type QueryReplenishmentItemsArgs = {
  qop?: InputMaybe<ReplenishmentItemQopInput>;
};


export type QueryReplenishmentTemplateArgs = {
  replenishmentTemplateID: Scalars['UUID']['input'];
};


export type QueryReplenishmentTemplateCategoriesArgs = {
  qop?: InputMaybe<ReplenishmentTemplateCategoryQopInput>;
};


export type QueryReplenishmentTemplateCategoryArgs = {
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
};


export type QueryReplenishmentTemplateItemArgs = {
  replenishmentTemplateItemID: Scalars['UUID']['input'];
};


export type QueryReplenishmentTemplateItemsArgs = {
  qop?: InputMaybe<ReplenishmentTemplateItemQopInput>;
};


export type QueryReplenishmentTemplatesArgs = {
  qop?: InputMaybe<ReplenishmentTemplateQopInput>;
};


export type QueryReplenishmentsArgs = {
  qop?: InputMaybe<ReplenishmentQopInput>;
};


export type QueryResourceArgs = {
  resourceID: Scalars['String']['input'];
};


export type QueryResourcesArgs = {
  qop?: InputMaybe<ResourceQopInput>;
};


export type QueryRevenueReportArgs = {
  revenueReportID: Scalars['UUID']['input'];
};


export type QueryRevenueReportAccessLogSummaryArgs = {
  qop?: InputMaybe<RevenueReportAccessLogQopInput>;
};


export type QueryRevenueReportAccessLogsArgs = {
  qop?: InputMaybe<RevenueReportAccessLogQopInput>;
};


export type QueryRevenueReportApiKeysArgs = {
  qop?: InputMaybe<RevenueReportApiKeyQopInput>;
};


export type QueryRevenueReportDetailsArgs = {
  qop?: InputMaybe<RevenueReportDetailQopInput>;
};


export type QueryRevenueReportPartnerArgs = {
  revenueReportPartnerID: Scalars['UUID']['input'];
};


export type QueryRevenueReportPartnerBranchArgs = {
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};


export type QueryRevenueReportPartnerBranchesArgs = {
  qop?: InputMaybe<RevenueReportPartnerBranchQopInput>;
};


export type QueryRevenueReportPartnersArgs = {
  qop?: InputMaybe<RevenueReportPartnerQopInput>;
};


export type QueryRevenueReportSummaryArgs = {
  qop?: InputMaybe<RevenueReportQopInput>;
};


export type QueryRevenueReportTemplateArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type QueryRevenueReportTemplatePreviewArgs = {
  deliveryMode: Scalars['String']['input'];
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type QueryRevenueReportTemplatesArgs = {
  qop?: InputMaybe<RevenueReportTemplateQopInput>;
};


export type QueryRevenueReportUploadBatchesArgs = {
  qop?: InputMaybe<RevenueReportUploadBatchQopInput>;
};


export type QueryRevenueReportUserArgs = {
  revenueReportUserID: Scalars['UUID']['input'];
};


export type QueryRevenueReportUsersArgs = {
  qop?: InputMaybe<RevenueReportUserQopInput>;
};


export type QueryRevenueReportsArgs = {
  qop?: InputMaybe<RevenueReportQopInput>;
};


export type QueryRevenueSharingArgs = {
  revenueSharingID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingBranchArgs = {
  revenueSharingBranchID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingBranchesArgs = {
  qop?: InputMaybe<RevenueSharingBranchQopInput>;
};


export type QueryRevenueSharingDetailArgs = {
  revenueSharingDetailID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingDetailLippoLiveArgs = {
  revenueSharingDetailID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingDetailsArgs = {
  qop?: InputMaybe<RevenueSharingDetailQopInput>;
};


export type QueryRevenueSharingUploadBatchesArgs = {
  revenueSharingID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingsArgs = {
  qop?: InputMaybe<RevenueSharingQopInput>;
};


export type QueryRoleArgs = {
  roleID: Scalars['UUID']['input'];
};


export type QueryRolesArgs = {
  qop?: InputMaybe<RoleQopInput>;
};


export type QuerySalesChannelArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type QuerySalesChannelCampaignArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCampaignChannelsArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCampaignProductsArgs = {
  qop?: InputMaybe<SalesChannelCampaignProductQopInput>;
};


export type QuerySalesChannelCampaignResultsArgs = {
  qop?: InputMaybe<SalesChannelCampaignResultQopInput>;
};


export type QuerySalesChannelCampaignsArgs = {
  qop?: InputMaybe<SalesChannelCampaignQopInput>;
};


export type QuerySalesChannelCategoriesArgs = {
  qop?: InputMaybe<SalesChannelCategoryQopInput>;
};


export type QuerySalesChannelCategoryArgs = {
  salesChannelCategoryID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCategoryGroupArgs = {
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCategoryGroupItemArgs = {
  salesChannelCategoryGroupItemID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCategoryGroupItemsArgs = {
  qop?: InputMaybe<SalesChannelCategoryGroupItemQopInput>;
};


export type QuerySalesChannelCategoryGroupProductArgs = {
  salesChannelCategoryGroupProductID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCategoryGroupProductsArgs = {
  qop?: InputMaybe<SalesChannelCategoryGroupProductQopInput>;
};


export type QuerySalesChannelCategoryGroupsArgs = {
  qop?: InputMaybe<SalesChannelCategoryGroupQopInput>;
};


export type QuerySalesChannelMenuBuildArgs = {
  branchID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QuerySalesChannelStockThresholdsArgs = {
  qop?: InputMaybe<SalesChannelStockThresholdQopInput>;
};


export type QuerySalesChannelsArgs = {
  qop?: InputMaybe<SalesChannelQopInput>;
};


export type QuerySalesConsignmentInvoiceArgs = {
  salesConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QuerySalesConsignmentInvoiceItemArgs = {
  salesConsignmentInvoiceItemID: Scalars['UUID']['input'];
};


export type QuerySalesConsignmentInvoiceItemsArgs = {
  qop?: InputMaybe<SalesConsignmentInvoiceItemQopInput>;
};


export type QuerySalesConsignmentInvoicesArgs = {
  qop?: InputMaybe<SalesConsignmentInvoiceQopInput>;
};


export type QuerySalesDashboardArgs = {
  filter?: InputMaybe<SalesDashboardFilterInput>;
};


export type QuerySalesInvoiceArgs = {
  salesInvoiceID: Scalars['UUID']['input'];
};


export type QuerySalesInvoiceItemArgs = {
  salesInvoiceItemID: Scalars['UUID']['input'];
};


export type QuerySalesInvoiceItemsArgs = {
  qop?: InputMaybe<SalesInvoiceItemQopInput>;
};


export type QuerySalesInvoicePaymentsArgs = {
  qop?: InputMaybe<SalesInvoicePaymentQopInput>;
};


export type QuerySalesInvoiceReviewArgs = {
  salesInvoiceReviewID: Scalars['UUID']['input'];
};


export type QuerySalesInvoiceReviewsArgs = {
  qop?: InputMaybe<SalesInvoiceReviewQopInput>;
};


export type QuerySalesInvoicesArgs = {
  qop?: InputMaybe<SalesInvoiceQopInput>;
};


export type QuerySalesPaymentMethodArgs = {
  salesPaymentMethodID: Scalars['UUID']['input'];
};


export type QuerySalesPaymentMethodTypeArgs = {
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
};


export type QuerySalesPaymentMethodTypesArgs = {
  qop?: InputMaybe<SalesPaymentMethodTypeQopInput>;
};


export type QuerySalesPaymentMethodsArgs = {
  qop?: InputMaybe<SalesPaymentMethodQopInput>;
};


export type QueryShiftSessionArgs = {
  shiftSessionID: Scalars['UUID']['input'];
};


export type QueryShiftSessionsArgs = {
  qop?: InputMaybe<ShiftSessionQopInput>;
};


export type QuerySimpleTransferOrderArgs = {
  transferOrderSimpleID: Scalars['UUID']['input'];
};


export type QuerySimpleTransferOrderItemArgs = {
  transferOrderSimpleItemID: Scalars['UUID']['input'];
};


export type QuerySimpleTransferOrderItemLocationsArgs = {
  qop?: InputMaybe<SimpleTransferOrderItemLocationQopInput>;
};


export type QuerySimpleTransferOrderItemsArgs = {
  qop?: InputMaybe<SimpleTransferOrderItemQopInput>;
};


export type QuerySimpleTransferOrderReceivingArgs = {
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
};


export type QuerySimpleTransferOrderReceivingItemArgs = {
  simpleTransferOrderReceivingItemID: Scalars['UUID']['input'];
};


export type QuerySimpleTransferOrderReceivingItemsArgs = {
  qop?: InputMaybe<SimpleTransferOrderReceivingItemQopInput>;
};


export type QuerySimpleTransferOrderReceivingsArgs = {
  qop?: InputMaybe<SimpleTransferOrderReceivingQopInput>;
};


export type QuerySimpleTransferOrdersArgs = {
  qop?: InputMaybe<SimpleTransferOrderQopInput>;
};


export type QuerySubdistrictArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubdistrictsArgs = {
  qop?: InputMaybe<SubdistrictQop>;
};


export type QueryTaxArgs = {
  taxID: Scalars['UUID']['input'];
};


export type QueryTaxesArgs = {
  qop?: InputMaybe<TaxQopInput>;
};


export type QueryTransferOrderArgs = {
  transferOrderID: Scalars['UUID']['input'];
};


export type QueryTransferOrderItemArgs = {
  transferOrderItemID: Scalars['UUID']['input'];
};


export type QueryTransferOrderItemsArgs = {
  qop?: InputMaybe<TransferOrderItemQopInput>;
};


export type QueryTransferOrderReceivingArgs = {
  transferOrderReceivingID: Scalars['UUID']['input'];
};


export type QueryTransferOrderReceivingItemArgs = {
  transferOrderReceivingItemID: Scalars['UUID']['input'];
};


export type QueryTransferOrderReceivingItemsArgs = {
  qop?: InputMaybe<TransferOrderReceivingItemQopInput>;
};


export type QueryTransferOrderReceivingsArgs = {
  qop?: InputMaybe<TransferOrderReceivingQopInput>;
};


export type QueryTransferOrdersArgs = {
  qop?: InputMaybe<TransferOrderQopInput>;
};


export type QueryTransferRequestArgs = {
  transferRequestID: Scalars['UUID']['input'];
};


export type QueryTransferRequestItemArgs = {
  transferRequestItemID: Scalars['UUID']['input'];
};


export type QueryTransferRequestItemsArgs = {
  qop?: InputMaybe<TransferRequestItemQopInput>;
};


export type QueryTransferRequestsArgs = {
  qop?: InputMaybe<TransferRequestQopInput>;
};


export type QueryUnassignedPickingTasksArgs = {
  qop?: InputMaybe<PickingTaskQopInput>;
};


export type QueryUnassignedPutawayTasksArgs = {
  qop?: InputMaybe<PutawayTaskQopInput>;
};


export type QueryUomArgs = {
  uomID: Scalars['UUID']['input'];
};


export type QueryUomCategoriesArgs = {
  qop?: InputMaybe<UomCategoryQopInput>;
};


export type QueryUomCategoryArgs = {
  uomCategoryID: Scalars['UUID']['input'];
};


export type QueryUomsArgs = {
  qop?: InputMaybe<UomQopInput>;
};


export type QueryUploadTemplateArgs = {
  uploadTemplateID: Scalars['UUID']['input'];
};


export type QueryUploadTemplatesArgs = {
  qop?: InputMaybe<UploadTemplateQopInput>;
};


export type QueryUserArgs = {
  userID: Scalars['UUID']['input'];
};


export type QueryUserTokenByCodeArgs = {
  tokenCode: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  qop?: InputMaybe<UserQopInput>;
};


export type QueryUsersLiteArgs = {
  qop?: InputMaybe<UserLiteQopInput>;
};


export type QueryVendorArgs = {
  vendorID: Scalars['UUID']['input'];
};


export type QueryVendorCategoriesArgs = {
  qop?: InputMaybe<VendorCategoryQopInput>;
};


export type QueryVendorCategoryArgs = {
  vendorCategoryID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentBranchArgs = {
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentBranchPeriodArgs = {
  vendorConsignmentBranchPeriodID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentBranchPeriodByBranchArgs = {
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentBranchPeriodsArgs = {
  qop?: InputMaybe<VendorConsignmentBranchPeriodQopInput>;
};


export type QueryVendorConsignmentBranchesArgs = {
  qop?: InputMaybe<VendorConsignmentBranchQopInput>;
};


export type QueryVendorConsignmentDashboardArgs = {
  filter: VendorConsignmentDashboardFilterInput;
};


export type QueryVendorConsignmentInvoiceArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentInvoiceConfigArgs = {
  vendorConsignmentInvoiceConfigID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentInvoiceConfigsArgs = {
  qop?: InputMaybe<VendorConsignmentInvoiceConfigQopInput>;
};


export type QueryVendorConsignmentInvoiceEmailPreviewArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentInvoiceSummaryArgs = {
  qop?: InputMaybe<VendorConsignmentInvoiceQopInput>;
};


export type QueryVendorConsignmentInvoicesArgs = {
  qop?: InputMaybe<VendorConsignmentInvoiceQopInput>;
};


export type QueryVendorConsignmentPaymentChargeConfigsArgs = {
  qop?: InputMaybe<VendorConsignmentPaymentChargeConfigQopInput>;
};


export type QueryVendorConsignmentProductArgs = {
  vendorConsignmentProductID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentProductsArgs = {
  qop?: InputMaybe<VendorConsignmentProductQopInput>;
};


export type QueryVendorConsignmentProductsByBranchArgs = {
  branchID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentRentalPaymentArgs = {
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentRentalPaymentsArgs = {
  qop?: InputMaybe<VendorConsignmentRentalPaymentQopInput>;
};


export type QueryVendorConsignmentSalesExportArgs = {
  filter: VendorConsignmentSalesExportFilterInput;
};


export type QueryVendorConsignmentStockByBranchArgs = {
  qop: VendorConsignmentStockByBranchQopInput;
};


export type QueryVendorInventoryCountExportArgs = {
  filter: VendorInventoryCountReportFilterInput;
};


export type QueryVendorInventoryCountListArgs = {
  filter: VendorInventoryCountListFilterInput;
};


export type QueryVendorInventoryCountReportArgs = {
  qop: VendorInventoryCountReportQopInput;
};


export type QueryVendorPicContactArgs = {
  vendorPicContactID: Scalars['UUID']['input'];
};


export type QueryVendorPicContactsArgs = {
  qop?: InputMaybe<VendorPicContactQopInput>;
};


export type QueryVendorStockExportArgs = {
  filter: VendorStockExportFilterInput;
};


export type QueryVendorStockReconciliationArgs = {
  filter: VendorStockReconciliationFilterInput;
};


export type QueryVendorsArgs = {
  qop?: InputMaybe<VendorQopInput>;
};


export type QueryVillageArgs = {
  villageID: Scalars['String']['input'];
};


export type QueryVillagesArgs = {
  qop?: InputMaybe<VillageQopInput>;
};


export type QueryVoucherArgs = {
  voucherID: Scalars['UUID']['input'];
};


export type QueryVoucherCategoriesArgs = {
  qop?: InputMaybe<VoucherCategoryQopInput>;
};


export type QueryVoucherCategoryArgs = {
  voucherCategoryID: Scalars['UUID']['input'];
};


export type QueryVoucherItemArgs = {
  voucherItemID: Scalars['UUID']['input'];
};


export type QueryVoucherItemByCodeArgs = {
  voucherItemCode: Scalars['String']['input'];
};


export type QueryVoucherItemsArgs = {
  qop?: InputMaybe<VoucherItemQopInput>;
};


export type QueryVouchersArgs = {
  qop?: InputMaybe<VoucherQopInput>;
};


export type QueryWarehouseArgs = {
  warehouseID: Scalars['UUID']['input'];
};


export type QueryWarehouseLocationArgs = {
  warehouseLocationID: Scalars['UUID']['input'];
};


export type QueryWarehouseLocationGroupArgs = {
  warehouseLocationGroupID: Scalars['UUID']['input'];
};


export type QueryWarehouseLocationGroupsArgs = {
  qop?: InputMaybe<WarehouseLocationGroupQopInput>;
};


export type QueryWarehouseLocationRelationMapArgs = {
  warehouseLocationChildID: Scalars['UUID']['input'];
  warehouseLocationParentID: Scalars['UUID']['input'];
};


export type QueryWarehouseLocationRelationMapsArgs = {
  qop?: InputMaybe<WarehouseLocationRelationMapQopInput>;
};


export type QueryWarehouseLocationsArgs = {
  qop?: InputMaybe<WarehouseLocationQopInput>;
};


export type QueryWarehouseProductLocationMapArgs = {
  warehouseProductLocationMapID: Scalars['UUID']['input'];
};


export type QueryWarehouseProductLocationMapsArgs = {
  qop?: InputMaybe<WarehouseProductLocationMapQopInput>;
};


export type QueryWarehouseReplenishmentTemplateArgs = {
  warehouseReplenishmentTemplateID: Scalars['UUID']['input'];
};


export type QueryWarehouseReplenishmentTemplatesArgs = {
  qop?: InputMaybe<WarehouseReplenishmentTemplateQopInput>;
};


export type QueryWarehousesArgs = {
  qop?: InputMaybe<WarehouseQopInput>;
};

export type Reason = {
  __typename?: 'Reason';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  reasonCategory: Scalars['String']['output'];
  reasonCode: Scalars['String']['output'];
  reasonID: Scalars['UUID']['output'];
  reasonName: Scalars['String']['output'];
  reasonScope: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ReasonCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  reasonCategory: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
  reasonName: Scalars['String']['input'];
  reasonScope: Scalars['String']['input'];
};

export type ReasonInventoryAdjustment = {
  __typename?: 'ReasonInventoryAdjustment';
  adjustmentTypes: Array<ReasonInventoryAdjustmentType>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  journalAccountCode: Scalars['String']['output'];
  journalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  journalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  reasonInventoryAdjustmentID: Scalars['UUID']['output'];
  reasonName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ReasonInventoryAdjustmentCreateInput = {
  adjustmentTypes: Array<ReasonInventoryAdjustmentType>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  reasonName: Scalars['String']['input'];
};

export type ReasonInventoryAdjustmentPaged = {
  __typename?: 'ReasonInventoryAdjustmentPaged';
  items?: Maybe<Array<ReasonInventoryAdjustment>>;
  pagination: PaginationResult;
};

export type ReasonInventoryAdjustmentQopFilterInput = {
  adjustmentTypes?: InputMaybe<Array<ReasonInventoryAdjustmentType>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  reasonName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReasonInventoryAdjustmentQopInput = {
  filters?: InputMaybe<ReasonInventoryAdjustmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export enum ReasonInventoryAdjustmentType {
  InventoryCount = 'inventory_count',
  Standard = 'standard',
  Waste = 'waste'
}

export type ReasonInventoryAdjustmentUpdateInput = {
  adjustmentTypes: Array<ReasonInventoryAdjustmentType>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  reasonInventoryAdjustmentID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
};

export type ReasonPaged = {
  __typename?: 'ReasonPaged';
  items?: Maybe<Array<Reason>>;
  pagination: PaginationResult;
};

export type ReasonQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  reasonName?: InputMaybe<Scalars['String']['input']>;
  reasonScope?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReasonQopInput = {
  filters?: InputMaybe<ReasonQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReasonUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  reasonCategory: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  reasonScope: Scalars['String']['input'];
};

export type RecordExecutionInput = {
  productID: Scalars['UUID']['input'];
  putawayTaskID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type RemoveContainerInput = {
  outboundContainerID: Scalars['UUID']['input'];
};

export type ReorderSalesChannelCategoryGroupProductInput = {
  displayOrder: Scalars['Int']['input'];
  salesChannelCategoryGroupProductID: Scalars['UUID']['input'];
};

export type Replenishment = {
  __typename?: 'Replenishment';
  avgUsageDays: Scalars['Int']['output'];
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  branchType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  reorderItemCount: Scalars['Int']['output'];
  replenishmentDate: Scalars['Time']['output'];
  replenishmentDateUTC: Scalars['Time']['output'];
  replenishmentID: Scalars['UUID']['output'];
  replenishmentNumber: Scalars['String']['output'];
  replenishmentTemplate?: Maybe<ReplenishmentTemplate>;
  replenishmentTemplateID: Scalars['UUID']['output'];
  sourceWarehouse: Warehouse;
  sourceWarehouseID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type ReplenishmentCreateInput = {
  avgUsageDays: Scalars['Int']['input'];
  branchID: Scalars['UUID']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  replenishmentTemplateID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type ReplenishmentItem = {
  __typename?: 'ReplenishmentItem';
  avgUsage: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  leadTime: Scalars['Int']['output'];
  minStock: Scalars['Decimal']['output'];
  mpkm: Scalars['Decimal']['output'];
  mpkmFromAvgUsage: Scalars['Decimal']['output'];
  orderMultiplier: Scalars['Decimal']['output'];
  pkm: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qtyAvailable: Scalars['Decimal']['output'];
  qtyCommitted: Scalars['Decimal']['output'];
  qtyIncoming: Scalars['Decimal']['output'];
  qtyOnHand: Scalars['Decimal']['output'];
  reorderQty: Scalars['Decimal']['output'];
  replenishmentID: Scalars['UUID']['output'];
  replenishmentItemID: Scalars['UUID']['output'];
  safetyDays: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ReplenishmentItemPaged = {
  __typename?: 'ReplenishmentItemPaged';
  items?: Maybe<Array<ReplenishmentItem>>;
  pagination: PaginationResult;
};

export type ReplenishmentItemQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReplenishmentItemQopInput = {
  filters?: InputMaybe<ReplenishmentItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentPaged = {
  __typename?: 'ReplenishmentPaged';
  items?: Maybe<Array<Replenishment>>;
  pagination: PaginationResult;
};

export type ReplenishmentQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentDateGte?: InputMaybe<Scalars['Time']['input']>;
  replenishmentDateLte?: InputMaybe<Scalars['Time']['input']>;
  replenishmentID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentNumber?: InputMaybe<Scalars['String']['input']>;
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  sourceWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReplenishmentQopInput = {
  filters?: InputMaybe<ReplenishmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentTemplate = {
  __typename?: 'ReplenishmentTemplate';
  defaultLeadtimeDays: Scalars['Int']['output'];
  defaultSafetyDays: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  items: Array<ReplenishmentTemplateItem>;
  replenishmentTemplateCategory?: Maybe<ReplenishmentTemplateCategory>;
  replenishmentTemplateCategoryID: Scalars['UUID']['output'];
  replenishmentTemplateID: Scalars['UUID']['output'];
  replenishmentTemplateName?: Maybe<Scalars['String']['output']>;
  sourceDocumentType: Scalars['String']['output'];
  sourceWarehouse?: Maybe<Warehouse>;
  sourceWarehouseCode: Scalars['String']['output'];
  sourceWarehouseID: Scalars['UUID']['output'];
  sourceWarehouseName: Scalars['String']['output'];
};

export type ReplenishmentTemplateCategory = {
  __typename?: 'ReplenishmentTemplateCategory';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  replenishmentTemplateCategoryID: Scalars['UUID']['output'];
  replenishmentTemplateCategoryName: Scalars['String']['output'];
};

export type ReplenishmentTemplateCategoryCreateInput = {
  isActive: Scalars['Boolean']['input'];
  replenishmentTemplateCategoryName: Scalars['String']['input'];
};

export type ReplenishmentTemplateCategoryPaged = {
  __typename?: 'ReplenishmentTemplateCategoryPaged';
  items?: Maybe<Array<ReplenishmentTemplateCategory>>;
  pagination: PaginationResult;
};

export type ReplenishmentTemplateCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  replenishmentTemplateCategoryName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReplenishmentTemplateCategoryQopInput = {
  filters?: InputMaybe<ReplenishmentTemplateCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentTemplateCategoryUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
  replenishmentTemplateCategoryName: Scalars['String']['input'];
};

export type ReplenishmentTemplateCreateInput = {
  defaultLeadtimeDays: Scalars['Int']['input'];
  defaultSafetyDays: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  items?: InputMaybe<Array<ReplenishmentTemplateItemCreateInput>>;
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
  replenishmentTemplateName: Scalars['String']['input'];
  sourceDocumentType: Scalars['String']['input'];
  sourceWarehouseCode: Scalars['String']['input'];
  sourceWarehouseID: Scalars['UUID']['input'];
  sourceWarehouseName: Scalars['String']['input'];
};

export type ReplenishmentTemplateItem = {
  __typename?: 'ReplenishmentTemplateItem';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  leadtimeDays: Scalars['Int']['output'];
  minStock: Scalars['Float']['output'];
  orderMultiplier: Scalars['Float']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  replenishmentTemplateID: Scalars['UUID']['output'];
  replenishmentTemplateItemID: Scalars['UUID']['output'];
  safetyDays: Scalars['Int']['output'];
};

export type ReplenishmentTemplateItemCreateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  leadtimeDays: Scalars['Int']['input'];
  minStock: Scalars['Float']['input'];
  orderMultiplier: Scalars['Float']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentTemplateItemID?: InputMaybe<Scalars['UUID']['input']>;
  safetyDays: Scalars['Int']['input'];
};

export type ReplenishmentTemplateItemImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ReplenishmentTemplateItemImportFileMappingInput = {
  columns: Array<ReplenishmentTemplateItemImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type ReplenishmentTemplateItemImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ReplenishmentTemplateItemImportFileMappingInput;
  replenishmentTemplateID: Scalars['UUID']['input'];
};

export type ReplenishmentTemplateItemImportResult = {
  __typename?: 'ReplenishmentTemplateItemImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type ReplenishmentTemplateItemImportRowReport = {
  __typename?: 'ReplenishmentTemplateItemImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  newRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  updateRowCount: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<ReplenishmentTemplateItemImportRowViolation>;
};

export type ReplenishmentTemplateItemImportRowViolation = {
  __typename?: 'ReplenishmentTemplateItemImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReplenishmentTemplateItemImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ReplenishmentTemplateItemImportFileMappingInput;
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReplenishmentTemplateItemImportValidateResult = {
  __typename?: 'ReplenishmentTemplateItemImportValidateResult';
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: ReplenishmentTemplateItemImportRowReport;
};

export type ReplenishmentTemplateItemPaged = {
  __typename?: 'ReplenishmentTemplateItemPaged';
  items?: Maybe<Array<ReplenishmentTemplateItem>>;
  pagination: PaginationResult;
};

export type ReplenishmentTemplateItemQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReplenishmentTemplateItemQopInput = {
  filters?: InputMaybe<ReplenishmentTemplateItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentTemplateItemUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  leadtimeDays: Scalars['Int']['input'];
  minStock: Scalars['Float']['input'];
  orderMultiplier: Scalars['Float']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  replenishmentTemplateItemID: Scalars['UUID']['input'];
  safetyDays: Scalars['Int']['input'];
};

export type ReplenishmentTemplatePaged = {
  __typename?: 'ReplenishmentTemplatePaged';
  items?: Maybe<Array<ReplenishmentTemplate>>;
  pagination: PaginationResult;
};

export type ReplenishmentTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  replenishmentTemplateCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentTemplateName?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  sourceWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReplenishmentTemplateQopInput = {
  filters?: InputMaybe<ReplenishmentTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentTemplateUpdateInput = {
  defaultLeadtimeDays: Scalars['Int']['input'];
  defaultSafetyDays: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  items?: InputMaybe<Array<ReplenishmentTemplateItemCreateInput>>;
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
  replenishmentTemplateID: Scalars['UUID']['input'];
  replenishmentTemplateName: Scalars['String']['input'];
  sourceDocumentType: Scalars['String']['input'];
  sourceWarehouseCode: Scalars['String']['input'];
  sourceWarehouseID: Scalars['UUID']['input'];
  sourceWarehouseName: Scalars['String']['input'];
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  tokenCode: Scalars['String']['input'];
};

export type Resource = {
  __typename?: 'Resource';
  apps?: Maybe<Array<App>>;
  entityAuditMetadata: EntityAuditMetadata;
  parentResourceID?: Maybe<Scalars['String']['output']>;
  parentresourceName?: Maybe<Scalars['String']['output']>;
  resourceID: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
};

export type ResourceCreateInput = {
  parentResourceID?: InputMaybe<Scalars['String']['input']>;
  resourceID: Scalars['String']['input'];
  resourceName: Scalars['String']['input'];
};

export type ResourcePaged = {
  __typename?: 'ResourcePaged';
  items?: Maybe<Array<Resource>>;
  pagination: PaginationResult;
};

export type ResourceQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  parentResourceID?: InputMaybe<Scalars['String']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ResourceQopInput = {
  filters?: InputMaybe<ResourceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ResourceUpdateInput = {
  parentResourceID?: InputMaybe<Scalars['String']['input']>;
  resourceID: Scalars['String']['input'];
  resourceName: Scalars['String']['input'];
};

export type RevenueReport = {
  __typename?: 'RevenueReport';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  deliveryMode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  itemCount: Scalars['Int']['output'];
  lastPulledAt?: Maybe<Scalars['Time']['output']>;
  lastUploadError: Scalars['String']['output'];
  partnerName: Scalars['String']['output'];
  revenueReportID: Scalars['UUID']['output'];
  revenueReportPartnerID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  transactionDate: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uploadAttemptCount: Scalars['Int']['output'];
  uploadStatus: Scalars['String']['output'];
  uploaded: Scalars['Boolean']['output'];
  uploadedDatetime?: Maybe<Scalars['Time']['output']>;
};

export type RevenueReportAccessLog = {
  __typename?: 'RevenueReportAccessLog';
  accessedDatetime: Scalars['Time']['output'];
  accessedDatetimeUtc: Scalars['Time']['output'];
  clientName: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  httpStatus: Scalars['Int']['output'];
  keyPrefix: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  partnerName: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  resultClass: Scalars['String']['output'];
  revenueReportAccessLogID: Scalars['UUID']['output'];
  revenueReportApiKeyID?: Maybe<Scalars['UUID']['output']>;
  revenueReportPartnerID?: Maybe<Scalars['UUID']['output']>;
  revenueReportTemplateID?: Maybe<Scalars['UUID']['output']>;
  revenueReportUserID?: Maybe<Scalars['UUID']['output']>;
  rowCount: Scalars['Int']['output'];
  sourceIp: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type RevenueReportAccessLogExport = {
  __typename?: 'RevenueReportAccessLogExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type RevenueReportAccessLogExportInput = {
  filters?: InputMaybe<RevenueReportAccessLogQopFilterInput>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportAccessLogPaged = {
  __typename?: 'RevenueReportAccessLogPaged';
  items?: Maybe<Array<RevenueReportAccessLog>>;
  pagination: PaginationResult;
};

export type RevenueReportAccessLogQopFilterInput = {
  accessedDatetimeUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  accessedDatetimeUtcStart?: InputMaybe<Scalars['Time']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  keyPrefix?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  resultClass?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  revenueReportUserID?: InputMaybe<Scalars['UUID']['input']>;
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  windowEndDateFrom?: InputMaybe<Scalars['String']['input']>;
  windowStartDateTo?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportAccessLogQopInput = {
  filters?: InputMaybe<RevenueReportAccessLogQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportAccessLogSummary = {
  __typename?: 'RevenueReportAccessLogSummary';
  distinctIpCount: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
  requestCount: Scalars['Int']['output'];
  rowsServed: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
};

export type RevenueReportApiKey = {
  __typename?: 'RevenueReportApiKey';
  entityAuditMetadata: EntityAuditMetadata;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  keyPrefix: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['Time']['output']>;
  lastUsedIp: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  revenueReportApiKeyID: Scalars['UUID']['output'];
  revenueReportUserID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
};

export type RevenueReportApiKeyIssueInput = {
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  revenueReportUserID: Scalars['UUID']['input'];
};

export type RevenueReportApiKeyIssued = {
  __typename?: 'RevenueReportApiKeyIssued';
  expiresAt?: Maybe<Scalars['Time']['output']>;
  keyPrefix: Scalars['String']['output'];
  plaintextApiKey: Scalars['String']['output'];
  revenueReportApiKeyID: Scalars['UUID']['output'];
  revenueReportUserID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
};

export type RevenueReportApiKeyPaged = {
  __typename?: 'RevenueReportApiKeyPaged';
  items?: Maybe<Array<RevenueReportApiKey>>;
  pagination: PaginationResult;
};

export type RevenueReportApiKeyQopFilterInput = {
  keyPrefix?: InputMaybe<Scalars['String']['input']>;
  revenueReportUserID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportApiKeyQopInput = {
  filters?: InputMaybe<RevenueReportApiKeyQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportDetail = {
  __typename?: 'RevenueReportDetail';
  barcode: Scalars['String']['output'];
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  correctedDatetime?: Maybe<Scalars['Time']['output']>;
  correctedUserID?: Maybe<Scalars['UUID']['output']>;
  correctedUserName: Scalars['String']['output'];
  correctionReason: Scalars['String']['output'];
  correctionType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isConsignment: Scalars['Boolean']['output'];
  originalTaxAmount?: Maybe<Scalars['Float']['output']>;
  originalTotalAmount?: Maybe<Scalars['Float']['output']>;
  productAccountingCategoryName: Scalars['String']['output'];
  productCategoryFullName: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID?: Maybe<Scalars['UUID']['output']>;
  productName: Scalars['String']['output'];
  productSalesTaxCode: Scalars['String']['output'];
  productSalesTaxID?: Maybe<Scalars['UUID']['output']>;
  productType: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  revenueReportDetailID: Scalars['UUID']['output'];
  revenueReportID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  sourceStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  transactionDatetime: Scalars['Time']['output'];
  transactionDatetimeUtc: Scalars['Time']['output'];
  uomName: Scalars['String']['output'];
  uploaded: Scalars['Boolean']['output'];
};

export type RevenueReportDetailCorrectInput = {
  correctionReason: Scalars['String']['input'];
  revenueReportDetailID: Scalars['UUID']['input'];
  totalAmount: Scalars['Float']['input'];
};

export type RevenueReportDetailExport = {
  __typename?: 'RevenueReportDetailExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type RevenueReportDetailExportInput = {
  filters?: InputMaybe<RevenueReportDetailQopFilterInput>;
  revenueReportID: Scalars['UUID']['input'];
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportDetailPaged = {
  __typename?: 'RevenueReportDetailPaged';
  items?: Maybe<Array<RevenueReportDetail>>;
  pagination: PaginationResult;
};

export type RevenueReportDetailQopFilterInput = {
  correctionType?: InputMaybe<Scalars['String']['input']>;
  revenueReportID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportDetailQopInput = {
  filters?: InputMaybe<RevenueReportDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportDetailVoidInput = {
  correctionReason: Scalars['String']['input'];
  revenueReportDetailID: Scalars['UUID']['input'];
};

export type RevenueReportExport = {
  __typename?: 'RevenueReportExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type RevenueReportExportInput = {
  filters?: InputMaybe<RevenueReportQopFilterInput>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportGenerateInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  endDate: Scalars['String']['input'];
  rebuildDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  startDate: Scalars['String']['input'];
};

export type RevenueReportPaged = {
  __typename?: 'RevenueReportPaged';
  items?: Maybe<Array<RevenueReport>>;
  pagination: PaginationResult;
};

export type RevenueReportPartner = {
  __typename?: 'RevenueReportPartner';
  apiClientCount: Scalars['Int']['output'];
  apiKeyPrefix: Scalars['String']['output'];
  authType: Scalars['String']['output'];
  branchCount: Scalars['Int']['output'];
  credentialState: Scalars['String']['output'];
  credentialUpdatedAt?: Maybe<Scalars['Time']['output']>;
  deliveryMode: Scalars['String']['output'];
  endpointURL: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  hasApiSecret: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isNpwpdRequired: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  partnerName: Scalars['String']['output'];
  revenueReportPartnerID: Scalars['UUID']['output'];
  revenueReportPartnerType: Scalars['String']['output'];
  revenueReportTemplateID: Scalars['UUID']['output'];
  templateName: Scalars['String']['output'];
};

export type RevenueReportPartnerBranch = {
  __typename?: 'RevenueReportPartnerBranch';
  apiKeyPrefix: Scalars['String']['output'];
  authType: Scalars['String']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  credentialSource: Scalars['String']['output'];
  credentialState: Scalars['String']['output'];
  credentialUpdatedAt?: Maybe<Scalars['Time']['output']>;
  deliveryMode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  npwpd: Scalars['String']['output'];
  partnerName: Scalars['String']['output'];
  revenueReportPartnerBranchID: Scalars['UUID']['output'];
  revenueReportPartnerID: Scalars['UUID']['output'];
  revenueReportTemplateID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

export type RevenueReportPartnerBranchCreateInput = {
  branchID: Scalars['UUID']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  npwpd?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerBranchCredentialSetInput = {
  apiKey: Scalars['String']['input'];
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerBranchPaged = {
  __typename?: 'RevenueReportPartnerBranchPaged';
  items?: Maybe<Array<RevenueReportPartnerBranch>>;
  pagination: PaginationResult;
};

export type RevenueReportPartnerBranchQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerBranchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportPartnerBranchQopInput = {
  filters?: InputMaybe<RevenueReportPartnerBranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportPartnerBranchUpdateInput = {
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  npwpd?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerCreateInput = {
  authType?: InputMaybe<Scalars['String']['input']>;
  deliveryMode: Scalars['String']['input'];
  endpointURL?: InputMaybe<Scalars['String']['input']>;
  isNpwpdRequired?: InputMaybe<Scalars['Boolean']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  partnerName: Scalars['String']['input'];
  revenueReportTemplateID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerCredentialSetInput = {
  apiKey: Scalars['String']['input'];
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerEndpointUpdateInput = {
  authType: Scalars['String']['input'];
  endpointURL: Scalars['String']['input'];
  revenueReportPartnerID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerPaged = {
  __typename?: 'RevenueReportPartnerPaged';
  items?: Maybe<Array<RevenueReportPartner>>;
  pagination: PaginationResult;
};

export type RevenueReportPartnerQopFilterInput = {
  authType?: InputMaybe<Scalars['String']['input']>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  revenueReportPartnerType?: InputMaybe<Scalars['String']['input']>;
  revenueReportTemplateID?: InputMaybe<Scalars['UUID']['input']>;
};

export type RevenueReportPartnerQopInput = {
  filters?: InputMaybe<RevenueReportPartnerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportPartnerUpdateInput = {
  isNpwpdRequired?: InputMaybe<Scalars['Boolean']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  partnerName: Scalars['String']['input'];
  revenueReportPartnerID: Scalars['UUID']['input'];
  revenueReportTemplateID: Scalars['UUID']['input'];
};

export type RevenueReportQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  revenueReportIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  transactionDateEnd?: InputMaybe<Scalars['Time']['input']>;
  transactionDateStart?: InputMaybe<Scalars['Time']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uploadStatus?: InputMaybe<Scalars['String']['input']>;
  uploadStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RevenueReportQopInput = {
  filters?: InputMaybe<RevenueReportQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportResyncInput = {
  revenueReportID: Scalars['UUID']['input'];
};

export type RevenueReportSummary = {
  __typename?: 'RevenueReportSummary';
  itemCount: Scalars['Int']['output'];
  revenueReportCount: Scalars['Int']['output'];
  taxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type RevenueReportTemplate = {
  __typename?: 'RevenueReportTemplate';
  entityAuditMetadata: EntityAuditMetadata;
  envelope: Scalars['String']['output'];
  fieldMap: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  partnerCount: Scalars['Int']['output'];
  partnerNames: Array<Scalars['String']['output']>;
  resultKey: Scalars['String']['output'];
  revenueReportTemplateID: Scalars['UUID']['output'];
  revenueReportTemplateType: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  wrapperMap?: Maybe<Scalars['String']['output']>;
};

export type RevenueReportTemplateCreateInput = {
  envelope: Scalars['String']['input'];
  fieldMap: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  resultKey?: InputMaybe<Scalars['String']['input']>;
  revenueReportTemplateType: Scalars['String']['input'];
  templateName: Scalars['String']['input'];
  wrapperMap?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportTemplateFieldMapUpdateInput = {
  fieldMap: Scalars['String']['input'];
  revenueReportTemplateID: Scalars['UUID']['input'];
};

export type RevenueReportTemplatePaged = {
  __typename?: 'RevenueReportTemplatePaged';
  items?: Maybe<Array<RevenueReportTemplate>>;
  pagination: PaginationResult;
};

export type RevenueReportTemplateQopFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  revenueReportTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  revenueReportTemplateType?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportTemplateQopInput = {
  filters?: InputMaybe<RevenueReportTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportTemplateUpdateInput = {
  envelope: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  resultKey?: InputMaybe<Scalars['String']['input']>;
  revenueReportTemplateID: Scalars['UUID']['input'];
  templateName: Scalars['String']['input'];
  wrapperMap?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportUploadBatch = {
  __typename?: 'RevenueReportUploadBatch';
  entityAuditMetadata: EntityAuditMetadata;
  errorCount: Scalars['Int']['output'];
  errorSummary: Scalars['String']['output'];
  httpStatus: Scalars['Int']['output'];
  requestPayload: Scalars['String']['output'];
  responseBody: Scalars['String']['output'];
  revenueReportID: Scalars['UUID']['output'];
  revenueReportUploadBatchID: Scalars['UUID']['output'];
  sentCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  uploadedDatetime?: Maybe<Scalars['Time']['output']>;
  uploadedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
};

export type RevenueReportUploadBatchPaged = {
  __typename?: 'RevenueReportUploadBatchPaged';
  items?: Maybe<Array<RevenueReportUploadBatch>>;
  pagination: PaginationResult;
};

export type RevenueReportUploadBatchQopFilterInput = {
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  revenueReportID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportUploadBatchQopInput = {
  filters?: InputMaybe<RevenueReportUploadBatchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportUser = {
  __typename?: 'RevenueReportUser';
  activeApiKeyCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fullName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['Time']['output']>;
  partnerName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  revenueReportPartnerID: Scalars['UUID']['output'];
  revenueReportUserID: Scalars['UUID']['output'];
  userType: Scalars['String']['output'];
};

export type RevenueReportUserCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID: Scalars['UUID']['input'];
};

export type RevenueReportUserPaged = {
  __typename?: 'RevenueReportUserPaged';
  items?: Maybe<Array<RevenueReportUser>>;
  pagination: PaginationResult;
};

export type RevenueReportUserQopFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  revenueReportUserIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type RevenueReportUserQopInput = {
  filters?: InputMaybe<RevenueReportUserQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportUserUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  revenueReportUserID: Scalars['UUID']['input'];
};

export type RevenueSharing = {
  __typename?: 'RevenueSharing';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  lastUploadError: Scalars['String']['output'];
  lastUploadPayload: Scalars['String']['output'];
  lastUploadResponse: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  providerCode: Scalars['String']['output'];
  revenueBatchId?: Maybe<Scalars['Int']['output']>;
  revenueSharingID: Scalars['UUID']['output'];
  totalActiveCount: Scalars['Int']['output'];
  totalAmountDpp: Scalars['Float']['output'];
  totalCancelledCount: Scalars['Int']['output'];
  totalDeductionAmount: Scalars['Float']['output'];
  totalNetAmount: Scalars['Float']['output'];
  totalVoucherAmount: Scalars['Float']['output'];
  transactionDate: Scalars['Time']['output'];
  uploadAttemptCount: Scalars['Int']['output'];
  uploaded: Scalars['Boolean']['output'];
  uploadedDatetime?: Maybe<Scalars['Time']['output']>;
  uploadedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
};

export type RevenueSharingBranch = {
  __typename?: 'RevenueSharingBranch';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  deductionType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  password: Scalars['String']['output'];
  providerCode: Scalars['String']['output'];
  revenueSharingBranchID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type RevenueSharingBranchCreateInput = {
  branchID: Scalars['UUID']['input'];
  deductionType: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  status: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type RevenueSharingBranchPaged = {
  __typename?: 'RevenueSharingBranchPaged';
  items?: Maybe<Array<RevenueSharingBranch>>;
  pagination: PaginationResult;
};

export type RevenueSharingBranchQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  revenueSharingBranchIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueSharingBranchQopInput = {
  filters?: InputMaybe<RevenueSharingBranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueSharingBranchUpdateInput = {
  branchID: Scalars['UUID']['input'];
  deductionType: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  revenueSharingBranchID: Scalars['UUID']['input'];
  status: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type RevenueSharingCorrectItemInput = {
  correctedAmountDpp: Scalars['Float']['input'];
  revenueSharingDetailID: Scalars['UUID']['input'];
};

export type RevenueSharingDetail = {
  __typename?: 'RevenueSharingDetail';
  deductionAmount: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalTransactionID?: Maybe<Scalars['Int64']['output']>;
  netAmount: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  revenueSharingDetailID: Scalars['UUID']['output'];
  revenueSharingID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  sourceStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionDatetime: Scalars['Time']['output'];
  transactionDatetimeUtc: Scalars['Time']['output'];
  uploadAmountDpp: Scalars['Float']['output'];
  uploaded: Scalars['Boolean']['output'];
  voucherAmount: Scalars['Float']['output'];
};

export type RevenueSharingDetailPaged = {
  __typename?: 'RevenueSharingDetailPaged';
  items?: Maybe<Array<RevenueSharingDetail>>;
  pagination: PaginationResult;
};

export type RevenueSharingDetailQopFilterInput = {
  revenueSharingDetailIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  revenueSharingID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueSharingDetailQopInput = {
  filters?: InputMaybe<RevenueSharingDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueSharingExport = {
  __typename?: 'RevenueSharingExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type RevenueSharingExportInput = {
  endDate: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type RevenueSharingGenerateInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type RevenueSharingLippoLiveRow = {
  __typename?: 'RevenueSharingLippoLiveRow';
  amount: Scalars['Float']['output'];
  transactionDate: Scalars['String']['output'];
  transactionNumber: Scalars['String']['output'];
};

export type RevenueSharingPaged = {
  __typename?: 'RevenueSharingPaged';
  items?: Maybe<Array<RevenueSharing>>;
  pagination: PaginationResult;
};

export type RevenueSharingQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  revenueSharingIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionDateEnd?: InputMaybe<Scalars['Time']['input']>;
  transactionDateStart?: InputMaybe<Scalars['Time']['input']>;
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RevenueSharingQopInput = {
  filters?: InputMaybe<RevenueSharingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueSharingReuploadResult = {
  __typename?: 'RevenueSharingReuploadResult';
  alreadyCorrect: Scalars['Int']['output'];
  fixed: Scalars['Int']['output'];
  needManual: Scalars['Int']['output'];
};

export type RevenueSharingUploadBatch = {
  __typename?: 'RevenueSharingUploadBatch';
  chunkIndex: Scalars['Int']['output'];
  duplicateCount: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  errorSummary: Scalars['String']['output'];
  httpStatus: Scalars['Int']['output'];
  lippoCode: Scalars['Int']['output'];
  lippoMessage: Scalars['String']['output'];
  requestPayload: Scalars['String']['output'];
  responseBody: Scalars['String']['output'];
  revenueBatchID?: Maybe<Scalars['Int64']['output']>;
  revenueSharingID: Scalars['UUID']['output'];
  revenueSharingUploadBatchID: Scalars['UUID']['output'];
  sentCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  uploadedDatetime?: Maybe<Scalars['Time']['output']>;
  uploadedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
};

export enum Role {
  Authenticated = 'AUTHENTICATED',
  Cap = 'CAP',
  Spr = 'SPR',
  Spvcap = 'SPVCAP'
}

export type RoleCreateInput = {
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  permissionIDs: Array<InputMaybe<Scalars['String']['input']>>;
  roleName: Scalars['String']['input'];
};

export type RoleDetail = {
  __typename?: 'RoleDetail';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  roleID: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
  rolePermissions: Array<RolePermission>;
};

export type RolePaged = {
  __typename?: 'RolePaged';
  items?: Maybe<Array<Roles>>;
  pagination: PaginationResult;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  appID: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  parentResourceID: Scalars['String']['output'];
  parentResourceName: Scalars['String']['output'];
  permissionID: Scalars['String']['output'];
  permissionName: Scalars['String']['output'];
  resourceID: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
  roleID: Scalars['UUID']['output'];
};

export type RoleProfile = {
  __typename?: 'RoleProfile';
  permissions?: Maybe<Array<PermissionProfile>>;
  resourceID: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
};

export type RoleQopFilterInput = {
  appID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  policyType?: InputMaybe<Scalars['String']['input']>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type RoleQopInput = {
  filters?: InputMaybe<RoleQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RoleUpdateInput = {
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  permissionIDs: Array<InputMaybe<Scalars['String']['input']>>;
  roleID: Scalars['UUID']['input'];
  roleName: Scalars['String']['input'];
};

export type Roles = {
  __typename?: 'Roles';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  roleID: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
};

export type SalesChannel = {
  __typename?: 'SalesChannel';
  additionalCharge: Scalars['Float']['output'];
  commisionPerc: Scalars['Float']['output'];
  defaultMenuImageURL?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
  salesChannelType: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  useCategoryMap: Scalars['Boolean']['output'];
};

export type SalesChannelBuiltMenu = {
  __typename?: 'SalesChannelBuiltMenu';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['String']['output'];
  branchName: Scalars['String']['output'];
  categories: Array<SalesChannelMenuCategory>;
  salesChannelID: Scalars['String']['output'];
};

export type SalesChannelCampaign = {
  __typename?: 'SalesChannelCampaign';
  branch?: Maybe<Branch>;
  branchCode: Scalars['String']['output'];
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName: Scalars['String']['output'];
  categories: Array<SalesChannelCampaignCategory>;
  customTag: Scalars['String']['output'];
  discountCap?: Maybe<Scalars['Float']['output']>;
  discountType: Scalars['String']['output'];
  discountValue?: Maybe<Scalars['Float']['output']>;
  eaterType: Scalars['String']['output'];
  endAt: Scalars['Time']['output'];
  endAtUtc: Scalars['Time']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  externalCampaignID: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  externalStoreID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isAllBranches: Scalars['Boolean']['output'];
  minBasketAmount?: Maybe<Scalars['Float']['output']>;
  objectIDs?: Maybe<Scalars['String']['output']>;
  parentSalesChannelCampaignID?: Maybe<Scalars['UUID']['output']>;
  quotaPerUser?: Maybe<Scalars['Int64']['output']>;
  quotaTotal?: Maybe<Scalars['Int64']['output']>;
  salesChannel?: Maybe<SalesChannel>;
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelCampaignName: Scalars['String']['output'];
  salesChannelCategoryGroupID?: Maybe<Scalars['UUID']['output']>;
  salesChannelCategoryGroupName?: Maybe<Scalars['String']['output']>;
  salesChannelID?: Maybe<Scalars['String']['output']>;
  scopeType: Scalars['String']['output'];
  sourcePromoComponentID?: Maybe<Scalars['UUID']['output']>;
  sourcePromoID?: Maybe<Scalars['UUID']['output']>;
  startAt: Scalars['Time']['output'];
  startAtUtc: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  workingHours?: Maybe<Scalars['String']['output']>;
};

export type SalesChannelCampaignCategory = {
  __typename?: 'SalesChannelCampaignCategory';
  entityAuditMetadata: EntityAuditMetadata;
  salesChannelCampaignCategoryID: Scalars['UUID']['output'];
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelCategoryID: Scalars['UUID']['output'];
  salesChannelCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCampaignChannel = {
  __typename?: 'SalesChannelCampaignChannel';
  entityAuditMetadata: EntityAuditMetadata;
  salesChannelCampaignChannelID: Scalars['UUID']['output'];
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCampaignCreateInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountType: Scalars['String']['input'];
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['Time']['input'];
  isAllBranches?: InputMaybe<Scalars['Boolean']['input']>;
  isPublishNow?: InputMaybe<Scalars['Boolean']['input']>;
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  objectIDs?: InputMaybe<Scalars['String']['input']>;
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  quotaPerUser?: InputMaybe<Scalars['Int64']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int64']['input']>;
  salesChannelCampaignName: Scalars['String']['input'];
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  salesChannelIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  sourcePromoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  sourcePromoID?: InputMaybe<Scalars['UUID']['input']>;
  startAt: Scalars['Time']['input'];
  workingHours?: InputMaybe<Scalars['String']['input']>;
};

export type SalesChannelCampaignPaged = {
  __typename?: 'SalesChannelCampaignPaged';
  items?: Maybe<Array<SalesChannelCampaign>>;
  pagination: PaginationResult;
};

export type SalesChannelCampaignProduct = {
  __typename?: 'SalesChannelCampaignProduct';
  barcode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelCampaignProductID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCampaignProductPaged = {
  __typename?: 'SalesChannelCampaignProductPaged';
  items?: Maybe<Array<SalesChannelCampaignProduct>>;
  pagination: PaginationResult;
};

export type SalesChannelCampaignProductQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCampaignID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesChannelCampaignProductQopInput = {
  filters?: InputMaybe<SalesChannelCampaignProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCampaignPublishInput = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};

export type SalesChannelCampaignPublishStoreResult = {
  __typename?: 'SalesChannelCampaignPublishStoreResult';
  branchID: Scalars['UUID']['output'];
  child?: Maybe<SalesChannelCampaign>;
  note: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  salesChannelID: Scalars['String']['output'];
  skippedProductCodes: Array<Scalars['String']['output']>;
  skippedProductIDs: Array<Scalars['UUID']['output']>;
};

export type SalesChannelCampaignPublishToStoresInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  salesChannelCampaignID: Scalars['UUID']['input'];
};

export type SalesChannelCampaignQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  endAtFrom?: InputMaybe<Scalars['Time']['input']>;
  endAtTo?: InputMaybe<Scalars['Time']['input']>;
  parentSalesChannelCampaignID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  startAtFrom?: InputMaybe<Scalars['Time']['input']>;
  startAtTo?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCampaignQopInput = {
  filters?: InputMaybe<SalesChannelCampaignQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCampaignResult = {
  __typename?: 'SalesChannelCampaignResult';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  externalCampaignID: Scalars['String']['output'];
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelCampaignResultID: Scalars['UUID']['output'];
  salesChannelID: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCampaignResultPaged = {
  __typename?: 'SalesChannelCampaignResultPaged';
  items?: Maybe<Array<SalesChannelCampaignResult>>;
  pagination: PaginationResult;
};

export type SalesChannelCampaignResultQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCampaignID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SalesChannelCampaignResultQopInput = {
  filters?: InputMaybe<SalesChannelCampaignResultQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCampaignSetCategoriesInput = {
  salesChannelCampaignID: Scalars['UUID']['input'];
  salesChannelCategoryIDs: Array<Scalars['UUID']['input']>;
};

export type SalesChannelCampaignSetChannelsInput = {
  salesChannelCampaignID: Scalars['UUID']['input'];
  salesChannelIDs: Array<Scalars['String']['input']>;
};

export type SalesChannelCampaignSetProductsInput = {
  productIDs: Array<Scalars['UUID']['input']>;
  salesChannelCampaignID: Scalars['UUID']['input'];
};

export type SalesChannelCampaignUpdateInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountType: Scalars['String']['input'];
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['Time']['input'];
  isAllBranches?: InputMaybe<Scalars['Boolean']['input']>;
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  objectIDs?: InputMaybe<Scalars['String']['input']>;
  quotaPerUser?: InputMaybe<Scalars['Int64']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int64']['input']>;
  salesChannelCampaignID: Scalars['UUID']['input'];
  salesChannelCampaignName: Scalars['String']['input'];
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['Time']['input'];
  workingHours?: InputMaybe<Scalars['String']['input']>;
};

export type SalesChannelCategory = {
  __typename?: 'SalesChannelCategory';
  displayOrder: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isInMenu: Scalars['Boolean']['output'];
  parentSalesChannelCategoryID?: Maybe<Scalars['UUID']['output']>;
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryID: Scalars['UUID']['output'];
  salesChannelCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCategoryCreateInput = {
  displayOrder?: Scalars['Int']['input'];
  isActive?: Scalars['Boolean']['input'];
  isInMenu?: Scalars['Boolean']['input'];
  parentSalesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryName: Scalars['String']['input'];
};

export type SalesChannelCategoryGroup = {
  __typename?: 'SalesChannelCategoryGroup';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isUseMasterdataAvailability: Scalars['Boolean']['output'];
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryGroupName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCategoryGroupCreateInput = {
  isActive?: Scalars['Boolean']['input'];
  isUseMasterdataAvailability?: Scalars['Boolean']['input'];
  salesChannelCategoryGroupName: Scalars['String']['input'];
};

export type SalesChannelCategoryGroupItem = {
  __typename?: 'SalesChannelCategoryGroupItem';
  displayOrder: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isInMenu: Scalars['Boolean']['output'];
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryGroupItemID: Scalars['UUID']['output'];
  salesChannelCategoryID: Scalars['UUID']['output'];
  salesChannelCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCategoryGroupItemCreateInput = {
  displayOrder?: Scalars['Int']['input'];
  isInMenu?: Scalars['Boolean']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
  salesChannelCategoryName: Scalars['String']['input'];
};

export type SalesChannelCategoryGroupItemPaged = {
  __typename?: 'SalesChannelCategoryGroupItemPaged';
  items?: Maybe<Array<SalesChannelCategoryGroupItem>>;
  pagination: PaginationResult;
};

export type SalesChannelCategoryGroupItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCategoryGroupItemQopInput = {
  filters?: InputMaybe<SalesChannelCategoryGroupItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCategoryGroupItemUpdateInput = {
  displayOrder?: Scalars['Int']['input'];
  isInMenu: Scalars['Boolean']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupItemID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
  salesChannelCategoryName: Scalars['String']['input'];
};

export type SalesChannelCategoryGroupPaged = {
  __typename?: 'SalesChannelCategoryGroupPaged';
  items?: Maybe<Array<SalesChannelCategoryGroup>>;
  pagination: PaginationResult;
};

export type SalesChannelCategoryGroupProduct = {
  __typename?: 'SalesChannelCategoryGroupProduct';
  barcode: Scalars['String']['output'];
  customPrice: Scalars['Float']['output'];
  displayOrder: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalImageURL: Scalars['String']['output'];
  imageType: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isNoPrice: Scalars['Boolean']['output'];
  isOutOfStock: Scalars['Boolean']['output'];
  priceType: Scalars['String']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty?: Maybe<Scalars['Float']['output']>;
  salesChannelCategory?: Maybe<SalesChannelCategory>;
  salesChannelCategoryGroup?: Maybe<SalesChannelCategoryGroup>;
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryGroupProductID: Scalars['UUID']['output'];
  salesChannelCategoryID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCategoryGroupProductCreateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  customPrice?: InputMaybe<Scalars['Float']['input']>;
  displayOrder?: Scalars['Int']['input'];
  externalImageURL?: InputMaybe<Scalars['String']['input']>;
  imageType?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  priceType?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
};

export type SalesChannelCategoryGroupProductPaged = {
  __typename?: 'SalesChannelCategoryGroupProductPaged';
  items?: Maybe<Array<SalesChannelCategoryGroupProduct>>;
  pagination: PaginationResult;
};

export type SalesChannelCategoryGroupProductQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCategoryGroupProductQopInput = {
  filters?: InputMaybe<SalesChannelCategoryGroupProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCategoryGroupProductUpdateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  customPrice?: InputMaybe<Scalars['Float']['input']>;
  displayOrder?: Scalars['Int']['input'];
  externalImageURL?: InputMaybe<Scalars['String']['input']>;
  imageType?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  priceType?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupProductID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
};

export type SalesChannelCategoryGroupQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelCategoryGroupName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCategoryGroupQopInput = {
  filters?: InputMaybe<SalesChannelCategoryGroupQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCategoryGroupUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  isUseMasterdataAvailability: Scalars['Boolean']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupName: Scalars['String']['input'];
};

export type SalesChannelCategoryPaged = {
  __typename?: 'SalesChannelCategoryPaged';
  items?: Maybe<Array<SalesChannelCategory>>;
  pagination: PaginationResult;
};

export type SalesChannelCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  parentSalesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryName?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCategoryQopInput = {
  filters?: InputMaybe<SalesChannelCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCategoryUpdateInput = {
  displayOrder?: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  isInMenu: Scalars['Boolean']['input'];
  parentSalesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
  salesChannelCategoryName: Scalars['String']['input'];
};

export type SalesChannelCreateInput = {
  additionalCharge: Scalars['Float']['input'];
  commisionPerc: Scalars['Float']['input'];
  defaultMenuImageURL?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName: Scalars['String']['input'];
  salesChannelType: Scalars['String']['input'];
  useCategoryMap?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SalesChannelDeleteInput = {
  salesChannelID: Scalars['String']['input'];
};

export type SalesChannelMenuCategory = {
  __typename?: 'SalesChannelMenuCategory';
  categoryID: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  items: Array<SalesChannelMenuItem>;
};

export type SalesChannelMenuItem = {
  __typename?: 'SalesChannelMenuItem';
  barcode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  externalCategoryID: Scalars['String']['output'];
  externalCategoryName: Scalars['String']['output'];
  externalItemID: Scalars['String']['output'];
  externalParentCategoryID: Scalars['String']['output'];
  externalParentCategoryName: Scalars['String']['output'];
  imageURL: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  itemName: Scalars['String']['output'];
  modifierGroups: Array<SalesChannelMenuModifierGroup>;
  sellingPrice: Scalars['Float']['output'];
  sequence: Scalars['Int']['output'];
};

export type SalesChannelMenuModifier = {
  __typename?: 'SalesChannelMenuModifier';
  isAvailable: Scalars['Boolean']['output'];
  modifierID: Scalars['String']['output'];
  modifierName: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  productID: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
};

export type SalesChannelMenuModifierGroup = {
  __typename?: 'SalesChannelMenuModifierGroup';
  isAvailable: Scalars['Boolean']['output'];
  maxSelect: Scalars['Int']['output'];
  minSelect: Scalars['Int']['output'];
  modifierGroupID: Scalars['String']['output'];
  modifierGroupName: Scalars['String']['output'];
  modifiers: Array<SalesChannelMenuModifier>;
  sequence: Scalars['Int']['output'];
};

export type SalesChannelPaged = {
  __typename?: 'SalesChannelPaged';
  items: Array<SalesChannel>;
  pagination: PaginationResult;
};

export type SalesChannelQopFilterInput = {
  additionalCharge?: InputMaybe<Scalars['Float']['input']>;
  commisionPerc?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesChannelName?: InputMaybe<Scalars['String']['input']>;
  salesChannelType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelQopInput = {
  filters?: InputMaybe<SalesChannelQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelStockThreshold = {
  __typename?: 'SalesChannelStockThreshold';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelStockThresholdID: Scalars['UUID']['output'];
  thresholdType: Scalars['String']['output'];
  thresholdValue: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelStockThresholdCreateInput = {
  isActive: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  salesChannelID: Scalars['String']['input'];
  thresholdType?: InputMaybe<Scalars['String']['input']>;
  thresholdValue: Scalars['Float']['input'];
};

export type SalesChannelStockThresholdPaged = {
  __typename?: 'SalesChannelStockThresholdPaged';
  items?: Maybe<Array<SalesChannelStockThreshold>>;
  pagination: PaginationResult;
};

export type SalesChannelStockThresholdQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  thresholdType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelStockThresholdQopInput = {
  filters?: InputMaybe<SalesChannelStockThresholdQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelStockThresholdUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  salesChannelID: Scalars['String']['input'];
  salesChannelStockThresholdID: Scalars['UUID']['input'];
  thresholdType?: InputMaybe<Scalars['String']['input']>;
  thresholdValue: Scalars['Float']['input'];
};

export type SalesChannelUpdateInput = {
  additionalCharge: Scalars['Float']['input'];
  commisionPerc: Scalars['Float']['input'];
  defaultMenuImageURL?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName: Scalars['String']['input'];
  salesChannelType: Scalars['String']['input'];
  useCategoryMap?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SalesConsignmentInvoice = {
  __typename?: 'SalesConsignmentInvoice';
  branchID: Scalars['UUID']['output'];
  commissionAmount: Scalars['Float']['output'];
  consignmentCommissionFeePerc?: Maybe<Scalars['Float']['output']>;
  consignmentPartnershipType?: Maybe<Scalars['String']['output']>;
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  consignmentVendorTotal: Scalars['Float']['output'];
  customerID?: Maybe<Scalars['UUID']['output']>;
  discountAmount: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  memberTypeID?: Maybe<Scalars['UUID']['output']>;
  memberTypeName?: Maybe<Scalars['String']['output']>;
  noteInternal: Scalars['String']['output'];
  salesChannelCommisionPerc?: Maybe<Scalars['Float']['output']>;
  salesChannelID?: Maybe<Scalars['String']['output']>;
  salesChannelName?: Maybe<Scalars['String']['output']>;
  salesChannelReferenceID?: Maybe<Scalars['String']['output']>;
  salesChannelType?: Maybe<Scalars['String']['output']>;
  salesConsignmentInvoiceDatetime: Scalars['Time']['output'];
  salesConsignmentInvoiceDatetimeUtc: Scalars['Time']['output'];
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceNumber: Scalars['String']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<SalesConsignmentInvoiceTax>;
  total: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  vendorConsignmentInvoiceID?: Maybe<Scalars['UUID']['output']>;
  warehouseID?: Maybe<Scalars['UUID']['output']>;
};

export type SalesConsignmentInvoiceItem = {
  __typename?: 'SalesConsignmentInvoiceItem';
  additionalDiscountAmount?: Maybe<Scalars['Float']['output']>;
  additionalDiscountPerc?: Maybe<Scalars['Float']['output']>;
  barcode: Scalars['String']['output'];
  baseUomQty: Scalars['Float']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  commissionAmount?: Maybe<Scalars['Float']['output']>;
  /** Gross commission shown to the vendor: net commissionAmount + taxAmount (PPN). commissionAmount and taxAmount are kept separate; this is the display/rollup value. */
  commissionInclTaxAmount?: Maybe<Scalars['Float']['output']>;
  consignmentCommissionFeePerc?: Maybe<Scalars['Float']['output']>;
  consignmentPartnershipType?: Maybe<Scalars['String']['output']>;
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  consignmentVendorPrice?: Maybe<Scalars['Float']['output']>;
  consignmentVendorTotal: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  productCategoryFullName: Scalars['String']['output'];
  productCategoryID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productNameAlias: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  salesConsignmentInvoice: SalesConsignmentInvoice;
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceItemID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceItem: SalesInvoiceItem;
  salesInvoiceItemID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  salesOrderID: Scalars['UUID']['output'];
  salesOrderItemID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  taxAmount: Scalars['Float']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<SalesConsignmentInvoiceItemTax>;
  total: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  vendorConsignmentInvoiceID?: Maybe<Scalars['UUID']['output']>;
};

export type SalesConsignmentInvoiceItemPaged = {
  __typename?: 'SalesConsignmentInvoiceItemPaged';
  items: Array<SalesConsignmentInvoiceItem>;
  pagination: PaginationResult;
};

export type SalesConsignmentInvoiceItemQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesConsignmentInvoiceDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  salesOrderID?: InputMaybe<Scalars['UUID']['input']>;
  vendorConsignmentInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesConsignmentInvoiceItemQopInput = {
  filters?: InputMaybe<SalesConsignmentInvoiceItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesConsignmentInvoiceItemTax = {
  __typename?: 'SalesConsignmentInvoiceItemTax';
  consignmentVendorID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceItemID: Scalars['UUID']['output'];
  salesConsignmentInvoiceItemTaxID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceItemID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type SalesConsignmentInvoicePaged = {
  __typename?: 'SalesConsignmentInvoicePaged';
  items: Array<SalesConsignmentInvoice>;
  pagination: PaginationResult;
};

export type SalesConsignmentInvoiceQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesConsignmentInvoiceDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  salesConsignmentInvoiceType?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesConsignmentInvoiceQopInput = {
  filters?: InputMaybe<SalesConsignmentInvoiceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesConsignmentInvoiceTax = {
  __typename?: 'SalesConsignmentInvoiceTax';
  consignmentVendorID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceTaxID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type SalesDashboard = {
  __typename?: 'SalesDashboard';
  salesByDay: Array<SalesDashboardDayPoint>;
  salesByHour: Array<SalesDashboardHourPoint>;
  summary: SalesDashboardSummary;
  topProducts: Array<SalesDashboardProductPoint>;
  topProductsByRevenue: Array<SalesDashboardProductPoint>;
};

export type SalesDashboardDayPoint = {
  __typename?: 'SalesDashboardDayPoint';
  date: Scalars['String']['output'];
  invoiceCount: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type SalesDashboardFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SalesDashboardHourPoint = {
  __typename?: 'SalesDashboardHourPoint';
  bucket: Scalars['String']['output'];
  invoiceCount: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type SalesDashboardProductPoint = {
  __typename?: 'SalesDashboardProductPoint';
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type SalesDashboardSummary = {
  __typename?: 'SalesDashboardSummary';
  avgBasket: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  totalDiscount: Scalars['Float']['output'];
  totalItemBundle: Scalars['Float']['output'];
  totalItemConsignment: Scalars['Float']['output'];
  totalItemProduct: Scalars['Float']['output'];
  totalItems: Scalars['Float']['output'];
  totalSales: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
};

export type SalesInvoice = {
  __typename?: 'SalesInvoice';
  adjustmentAmount: Scalars['Float']['output'];
  branchID: Scalars['UUID']['output'];
  cashPaymentAmount: Scalars['Float']['output'];
  customerID?: Maybe<Scalars['UUID']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  memberTypeID?: Maybe<Scalars['UUID']['output']>;
  memberTypeName?: Maybe<Scalars['String']['output']>;
  nonCashPaymentAmount: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentChangeAmount: Scalars['Float']['output'];
  paymentReceivedAmount: Scalars['Float']['output'];
  paymentVoucherAmount: Scalars['Float']['output'];
  payments: Array<SalesInvoicePayment>;
  salesChannelAdditionalCharge?: Maybe<Scalars['Float']['output']>;
  salesChannelCommisionPerc?: Maybe<Scalars['Float']['output']>;
  salesChannelID?: Maybe<Scalars['String']['output']>;
  salesChannelName?: Maybe<Scalars['String']['output']>;
  salesChannelReferenceID?: Maybe<Scalars['String']['output']>;
  salesChannelType?: Maybe<Scalars['String']['output']>;
  salesInvoiceDatetime: Scalars['Time']['output'];
  salesInvoiceDatetimeUtc: Scalars['Time']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  salesInvoiceType: Scalars['String']['output'];
  salesOrderID: Scalars['UUID']['output'];
  salesOrderNumber: Scalars['String']['output'];
  shiftSession?: Maybe<ShiftSession>;
  shiftSessionID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<SalesInvoiceTax>;
  total: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  warehouseID?: Maybe<Scalars['UUID']['output']>;
};

export type SalesInvoiceBranchDateInput = {
  branchId: Scalars['String']['input'];
  date: Scalars['String']['input'];
};

export type SalesInvoiceConsignmentVendor = {
  __typename?: 'SalesInvoiceConsignmentVendor';
  consignmentCommissionFeePerc?: Maybe<Scalars['Float']['output']>;
  isPKP?: Maybe<Scalars['Boolean']['output']>;
  vendorCode: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
};

export type SalesInvoiceInventoryBackfillInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  salesInvoiceIDs: Array<Scalars['UUID']['input']>;
};

export type SalesInvoiceInventoryBackfillItem = {
  __typename?: 'SalesInvoiceInventoryBackfillItem';
  error: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  skipReason: Scalars['String']['output'];
};

export type SalesInvoiceInventoryBackfillResult = {
  __typename?: 'SalesInvoiceInventoryBackfillResult';
  dryRun: Scalars['Boolean']['output'];
  failed: Scalars['Int']['output'];
  published: Scalars['Int']['output'];
  results: Array<SalesInvoiceInventoryBackfillItem>;
  skipped: Scalars['Int']['output'];
  totalRequested: Scalars['Int']['output'];
};

export type SalesInvoiceItem = {
  __typename?: 'SalesInvoiceItem';
  additionalDiscountAmount: Scalars['Float']['output'];
  additionalDiscountPerc: Scalars['Float']['output'];
  addonComponents: Array<SalesInvoiceItemAddonComponent>;
  barcode: Scalars['String']['output'];
  baseUomQty: Scalars['Float']['output'];
  cancellationReason: Scalars['String']['output'];
  commissionAmount: Scalars['Float']['output'];
  consignmentCommissionFeePerc?: Maybe<Scalars['Float']['output']>;
  consignmentVendor?: Maybe<SalesInvoiceConsignmentVendor>;
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isConsignment: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productCategoryFullName: Scalars['String']['output'];
  productCategoryID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productNameAlias: Scalars['String']['output'];
  promoComponentID?: Maybe<Scalars['UUID']['output']>;
  promoParentProductID?: Maybe<Scalars['UUID']['output']>;
  promoType?: Maybe<Scalars['String']['output']>;
  qty: Scalars['Float']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceItemID: Scalars['UUID']['output'];
  salesOrderItemID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  taxAmount: Scalars['Float']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<SalesInvoiceItemTax>;
  total: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type SalesInvoiceItemAddonComponent = {
  __typename?: 'SalesInvoiceItemAddonComponent';
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
};

export type SalesInvoiceItemPaged = {
  __typename?: 'SalesInvoiceItemPaged';
  items: Array<SalesInvoiceItem>;
  pagination: PaginationResult;
};

export type SalesInvoiceItemQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesInvoiceItemQopInput = {
  filters?: InputMaybe<SalesInvoiceItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesInvoiceItemTax = {
  __typename?: 'SalesInvoiceItemTax';
  entityAuditMetadata: EntityAuditMetadata;
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceItemID: Scalars['UUID']['output'];
  salesInvoiceItemTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type SalesInvoicePaged = {
  __typename?: 'SalesInvoicePaged';
  items: Array<SalesInvoice>;
  pagination: PaginationResult;
};

export type SalesInvoicePayment = {
  __typename?: 'SalesInvoicePayment';
  authCode?: Maybe<Scalars['String']['output']>;
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankReconciliationItemID?: Maybe<Scalars['UUID']['output']>;
  bankReferenceNumber?: Maybe<Scalars['String']['output']>;
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  branchQrisMerchantID?: Maybe<Scalars['UUID']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  edcTerminalID?: Maybe<Scalars['UUID']['output']>;
  edcTerminalName?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isReconciliation: Scalars['Boolean']['output'];
  journalAccountCode?: Maybe<Scalars['String']['output']>;
  paymentAmount: Scalars['Float']['output'];
  paymentMethodID: Scalars['UUID']['output'];
  paymentMethodName: Scalars['String']['output'];
  paymentMethodTypeCode: Scalars['String']['output'];
  paymentMethodTypeID: Scalars['UUID']['output'];
  paymentMethodTypeIsCard: Scalars['Boolean']['output'];
  paymentMethodTypeIsCash: Scalars['Boolean']['output'];
  paymentMethodTypeIsSalesChannel: Scalars['Boolean']['output'];
  paymentMethodTypeName: Scalars['String']['output'];
  paymentMethodTypeUseUdc: Scalars['Boolean']['output'];
  paymentTransactionID?: Maybe<Scalars['UUID']['output']>;
  reconciledAt?: Maybe<Scalars['Time']['output']>;
  reconciledAtUtc?: Maybe<Scalars['Time']['output']>;
  reconciliationStatus: Scalars['String']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoicePaymentID: Scalars['UUID']['output'];
  salesOrderPaymentID: Scalars['UUID']['output'];
};

export type SalesInvoicePaymentPaged = {
  __typename?: 'SalesInvoicePaymentPaged';
  items: Array<SalesInvoicePayment>;
  pagination: PaginationResult;
};

export type SalesInvoicePaymentQopFilterInput = {
  authCode?: InputMaybe<Scalars['String']['input']>;
  bankAccountID?: InputMaybe<Scalars['UUID']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  isReconciliation?: InputMaybe<Scalars['Boolean']['input']>;
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentMethodTypeCode?: InputMaybe<Scalars['String']['input']>;
  paymentMethodTypeIsCash?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  reconciliationStatus?: InputMaybe<Scalars['String']['input']>;
};

export type SalesInvoicePaymentQopInput = {
  filters?: InputMaybe<SalesInvoicePaymentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesInvoiceQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  salesInvoiceDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceType?: InputMaybe<Scalars['String']['input']>;
  salesOrderID?: InputMaybe<Scalars['UUID']['input']>;
  shiftSessionID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesInvoiceQopInput = {
  filters?: InputMaybe<SalesInvoiceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesInvoiceReview = {
  __typename?: 'SalesInvoiceReview';
  actualSettlementAmount: Scalars['Float']['output'];
  amountDifference: Scalars['Float']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cashierUserID: Scalars['UUID']['output'];
  cashierUserName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expectedSettlementAmount: Scalars['Float']['output'];
  gmt: Scalars['Int']['output'];
  isNoteInternal: Scalars['Boolean']['output'];
  isResolved: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentTransactions: Array<PaymentTransaction>;
  payments: Array<SalesInvoicePayment>;
  resolutionNote: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Time']['output']>;
  resolvedAtUtc?: Maybe<Scalars['Time']['output']>;
  resolvedByUserID?: Maybe<Scalars['UUID']['output']>;
  resolvedByUserName: Scalars['String']['output'];
  reviewType: Scalars['String']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
  salesInvoiceDatetime: Scalars['Time']['output'];
  salesInvoiceDatetimeUtc: Scalars['Time']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  salesInvoiceReviewID: Scalars['UUID']['output'];
  salesInvoiceStatus: Scalars['String']['output'];
  salesInvoiceType: Scalars['String']['output'];
  salesOrderID: Scalars['UUID']['output'];
  salesOrderNumber: Scalars['String']['output'];
  settlementItems: Array<SalesInvoiceReviewSettlement>;
  shiftSessionID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type SalesInvoiceReviewPaged = {
  __typename?: 'SalesInvoiceReviewPaged';
  items: Array<SalesInvoiceReview>;
  pagination: PaginationResult;
};

export type SalesInvoiceReviewQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  cashierUserID?: InputMaybe<Scalars['UUID']['input']>;
  isNoteInternal?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  reviewType?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  salesInvoiceDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceStatus?: InputMaybe<Scalars['String']['input']>;
  salesOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shiftSessionID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalEnd?: InputMaybe<Scalars['Float']['input']>;
  totalStart?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesInvoiceReviewQopInput = {
  filters?: InputMaybe<SalesInvoiceReviewQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesInvoiceReviewResolveBulkInput = {
  filters?: InputMaybe<SalesInvoiceReviewQopFilterInput>;
  resolutionNote: Scalars['String']['input'];
  salesInvoiceReviewIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type SalesInvoiceReviewResolveResult = {
  __typename?: 'SalesInvoiceReviewResolveResult';
  error: Scalars['String']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  salesInvoiceReviewID: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type SalesInvoiceReviewSettlement = {
  __typename?: 'SalesInvoiceReviewSettlement';
  amount: Scalars['Float']['output'];
  reference: Scalars['String']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SalesInvoiceTax = {
  __typename?: 'SalesInvoiceTax';
  entityAuditMetadata: EntityAuditMetadata;
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type SalesPaymentMethod = {
  __typename?: 'SalesPaymentMethod';
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  journalAccountCode: Scalars['String']['output'];
  salesPaymentMethodID: Scalars['UUID']['output'];
  salesPaymentMethodName: Scalars['String']['output'];
  salesPaymentMethodType: SalesPaymentMethodType;
  salesPaymentMethodTypeCode: Scalars['String']['output'];
  salesPaymentMethodTypeID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesPaymentMethodCreateInput = {
  bankAccountID: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodName: Scalars['String']['input'];
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
};

export type SalesPaymentMethodPaged = {
  __typename?: 'SalesPaymentMethodPaged';
  items: Array<SalesPaymentMethod>;
  pagination: PaginationResult;
};

export type SalesPaymentMethodQopFilterInput = {
  bankAccountID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodName?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodTypeCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodTypeID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesPaymentMethodQopInput = {
  filters?: InputMaybe<SalesPaymentMethodQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesPaymentMethodType = {
  __typename?: 'SalesPaymentMethodType';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isCard: Scalars['Boolean']['output'];
  isCash: Scalars['Boolean']['output'];
  isHandledBySystem: Scalars['Boolean']['output'];
  isSalesChannel: Scalars['Boolean']['output'];
  isSystemAutoPaid: Scalars['Boolean']['output'];
  salesChannelID: Scalars['String']['output'];
  salesPaymentMethodTypeCode: Scalars['String']['output'];
  salesPaymentMethodTypeID: Scalars['UUID']['output'];
  salesPaymentMethodTypeName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  useEdc: Scalars['Boolean']['output'];
};

export type SalesPaymentMethodTypeCreateInput = {
  isActive: Scalars['Boolean']['input'];
  isCard: Scalars['Boolean']['input'];
  isCash: Scalars['Boolean']['input'];
  isHandledBySystem: Scalars['Boolean']['input'];
  isSalesChannel: Scalars['Boolean']['input'];
  isSystemAutoPaid: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeName: Scalars['String']['input'];
  useEdc: Scalars['Boolean']['input'];
};

export type SalesPaymentMethodTypePaged = {
  __typename?: 'SalesPaymentMethodTypePaged';
  items?: Maybe<Array<SalesPaymentMethodType>>;
  pagination: PaginationResult;
};

export type SalesPaymentMethodTypeQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCard?: InputMaybe<Scalars['Boolean']['input']>;
  isCash?: InputMaybe<Scalars['Boolean']['input']>;
  isHandledBySystem?: InputMaybe<Scalars['Boolean']['input']>;
  isSalesChannel?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodTypeCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodTypeName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  useEdc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SalesPaymentMethodTypeQopInput = {
  filters?: InputMaybe<SalesPaymentMethodTypeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesPaymentMethodTypeUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  isCard: Scalars['Boolean']['input'];
  isCash: Scalars['Boolean']['input'];
  isHandledBySystem: Scalars['Boolean']['input'];
  isSalesChannel: Scalars['Boolean']['input'];
  isSystemAutoPaid: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
  salesPaymentMethodTypeName: Scalars['String']['input'];
  useEdc: Scalars['Boolean']['input'];
};

export type SalesPaymentMethodUpdateInput = {
  bankAccountID: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodID: Scalars['UUID']['input'];
  salesPaymentMethodName: Scalars['String']['input'];
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
};

export type ScanLocationInput = {
  locationBarcode: Scalars['String']['input'];
  putawayTaskID: Scalars['UUID']['input'];
};

export type ScanProductInput = {
  productBarcode: Scalars['String']['input'];
  putawayTaskID: Scalars['UUID']['input'];
};

export type SetDefaultBranchInput = {
  branchID: Scalars['UUID']['input'];
};

export type ShiftSession = {
  __typename?: 'ShiftSession';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cashBalanceDiff: Scalars['Float']['output'];
  cashTransactionAmount: Scalars['Float']['output'];
  employeeID: Scalars['UUID']['output'];
  employeeName: Scalars['String']['output'];
  endingCashBalance?: Maybe<Scalars['Float']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  isCashBalanceDiff: Scalars['Boolean']['output'];
  isResolved: Scalars['Boolean']['output'];
  nonCashTransactionAmount: Scalars['Float']['output'];
  openingCashBalance: Scalars['Float']['output'];
  resolutionNote: Scalars['String']['output'];
  resolutionStatus: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Time']['output']>;
  resolvedAtUtc?: Maybe<Scalars['Time']['output']>;
  resolvedByUserID?: Maybe<Scalars['UUID']['output']>;
  resolvedByUserName: Scalars['String']['output'];
  sessionCloseTime?: Maybe<Scalars['Time']['output']>;
  sessionCloseTimeUtc?: Maybe<Scalars['Time']['output']>;
  sessionDuration: Scalars['Int']['output'];
  sessionOpenTime: Scalars['Time']['output'];
  sessionOpenTimeUtc: Scalars['Time']['output'];
  shiftSessionID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  totalTransactionAmount: Scalars['Float']['output'];
  userID: Scalars['UUID']['output'];
  userName: Scalars['String']['output'];
  voucherTransactionAmount: Scalars['Float']['output'];
  voucherTransactionCount: Scalars['Int']['output'];
};

export type ShiftSessionCloseInput = {
  cashTransactionAmount: Scalars['Float']['input'];
  endingCashBalance: Scalars['Float']['input'];
  sessionCloseTime: Scalars['Time']['input'];
  sessionCloseTimeUtc: Scalars['Time']['input'];
  shiftSessionID: Scalars['UUID']['input'];
};

export type ShiftSessionCloseResult = {
  __typename?: 'ShiftSessionCloseResult';
  shiftSession: ShiftSession;
  unsyncedOrders: ShiftSessionUnsyncedOrders;
};

export type ShiftSessionCreateInput = {
  branchID: Scalars['UUID']['input'];
  openingCashBalance: Scalars['Float']['input'];
  sessionOpenTime: Scalars['Time']['input'];
  sessionOpenTimeUtc: Scalars['Time']['input'];
};

export type ShiftSessionDeadOrder = {
  __typename?: 'ShiftSessionDeadOrder';
  lastAttemptTimeUtc: Scalars['String']['output'];
  posSalesOrderID: Scalars['String']['output'];
  posSalesOrderNumber: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  syncError: Scalars['String']['output'];
};

export type ShiftSessionPaged = {
  __typename?: 'ShiftSessionPaged';
  items?: Maybe<Array<ShiftSession>>;
  pagination: PaginationResult;
};

export type ShiftSessionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  employeeID?: InputMaybe<Scalars['UUID']['input']>;
  isCashBalanceDiff?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  sessionOpenTimeGte?: InputMaybe<Scalars['Time']['input']>;
  sessionOpenTimeLte?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['UUID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type ShiftSessionQopInput = {
  filters?: InputMaybe<ShiftSessionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ShiftSessionResolveCashDiffInput = {
  resolutionNote: Scalars['String']['input'];
  resolutionStatus: Scalars['String']['input'];
  shiftSessionID: Scalars['UUID']['input'];
};

export type ShiftSessionUnsyncedOrders = {
  __typename?: 'ShiftSessionUnsyncedOrders';
  deadOrders: Array<ShiftSessionDeadOrder>;
  hasUnsynced: Scalars['Boolean']['output'];
  pendingCount: Scalars['Int']['output'];
};

export type SimpleTransferOrder = {
  __typename?: 'SimpleTransferOrder';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  confirmByUserID?: Maybe<Scalars['UUID']['output']>;
  confirmByUserName?: Maybe<Scalars['String']['output']>;
  confirmDatetime?: Maybe<Scalars['Time']['output']>;
  confirmDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  deliveredDatetime?: Maybe<Scalars['Time']['output']>;
  deliveredDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouse: Warehouse;
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  noteForReceiver: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  scheduledDeliveryDate: Scalars['Time']['output'];
  simpleTransferOrderDatetime: Scalars['Time']['output'];
  simpleTransferOrderDatetimeUtc: Scalars['Time']['output'];
  simpleTransferOrderID: Scalars['UUID']['output'];
  simpleTransferOrderNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toWarehouse: Warehouse;
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItemQtyReadyToShip: Scalars['Float']['output'];
  totalItemQtyShipped: Scalars['Float']['output'];
  totalItemQtyUnfulfilled: Scalars['Float']['output'];
  totalItemWeight: Scalars['Float']['output'];
};

export type SimpleTransferOrderCancelInput = {
  cancellationReason: Scalars['String']['input'];
  transferOrderSimpleID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderConfirmInput = {
  deliveryOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderNumber?: InputMaybe<Scalars['String']['input']>;
  transferOrderSimpleID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderCreateInput = {
  branchID: Scalars['UUID']['input'];
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  deliveryOrderNumber?: InputMaybe<Scalars['String']['input']>;
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<SimpleTransferOrderItemCreateInput>;
  noteForReceiver: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
  toWarehouseID: Scalars['UUID']['input'];
  transferOrderSimpleDatetime: Scalars['Time']['input'];
  transferOrderSimpleNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SimpleTransferOrderItem = {
  __typename?: 'SimpleTransferOrderItem';
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isMultiple: Scalars['Boolean']['output'];
  locations: Array<SimpleTransferOrderItemLocation>;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  qtyReadyToShip: Scalars['Float']['output'];
  qtyShipped: Scalars['Float']['output'];
  qtyUnfulfilled: Scalars['Float']['output'];
  simpleTransferOrderID: Scalars['UUID']['output'];
  simpleTransferOrderItemID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type SimpleTransferOrderItemCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<SimpleTransferOrderItemLocationCreateInput>>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderItemLocation = {
  __typename?: 'SimpleTransferOrderItemLocation';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseLocation: WarehouseLocation;
  fromWarehouseLocationID: Scalars['UUID']['output'];
  fromWarehouseLocationName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  simpleTransferOrderItem: SimpleTransferOrderItem;
  simpleTransferOrderItemID: Scalars['UUID']['output'];
  simpleTransferOrderItemLocationID: Scalars['UUID']['output'];
};

export type SimpleTransferOrderItemLocationCreateInput = {
  fromWarehouseLocationID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
};

export type SimpleTransferOrderItemLocationPaged = {
  __typename?: 'SimpleTransferOrderItemLocationPaged';
  items: Array<SimpleTransferOrderItemLocation>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderItemLocationQopFilterInput = {
  fromWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseLocationName?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  simpleTransferOrderItemLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderItemLocationQopInput = {
  filters?: InputMaybe<SimpleTransferOrderItemLocationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderItemLocationUpdateInput = {
  fromWarehouseLocationID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  transferOrderSimpleItemLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderItemPaged = {
  __typename?: 'SimpleTransferOrderItemPaged';
  items: Array<SimpleTransferOrderItem>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderID?: InputMaybe<Scalars['UUID']['input']>;
  simpleTransferOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderItemQopInput = {
  filters?: InputMaybe<SimpleTransferOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderItemUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<SimpleTransferOrderItemLocationUpdateInput>>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  transferOrderSimpleItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderPaged = {
  __typename?: 'SimpleTransferOrderPaged';
  items: Array<SimpleTransferOrder>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  scheduledDeliveryDate?: InputMaybe<Scalars['Time']['input']>;
  scheduledDeliveryDateEnd?: InputMaybe<Scalars['Time']['input']>;
  scheduledDeliveryDateStart?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  simpleTransferOrderNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderQopInput = {
  filters?: InputMaybe<SimpleTransferOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderReceiving = {
  __typename?: 'SimpleTransferOrderReceiving';
  /** How the receiving reached confirmed: save_and_confirm | edit_and_confirm | submit_confirm. Null while still a draft. */
  actionType?: Maybe<Scalars['String']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  closeSto: Scalars['Boolean']['output'];
  deliveryBy: Scalars['String']['output'];
  deliveryOrder: DeliveryOrder;
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderNumber: Scalars['String']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhoneNumber?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<SimpleTransferOrderReceivingFile>>;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  originWarehouse: Warehouse;
  originWarehouseID: Scalars['UUID']['output'];
  simpleTransferOrderID: Scalars['UUID']['output'];
  simpleTransferOrderNumber: Scalars['String']['output'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['output'];
  simpleTransferOrderReceivingID: Scalars['UUID']['output'];
  simpleTransferOrderReceivingNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItemWeightReceived: Scalars['Float']['output'];
  vehiclePlateNumber?: Maybe<Scalars['String']['output']>;
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
  vendorRefNumber?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type SimpleTransferOrderReceivingCreateAndConfirmInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  deliveryOrderID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<SimpleTransferOrderReceivingFileInput>>;
  items: Array<SimpleTransferOrderReceivingItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingCreateInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  deliveryOrderID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<SimpleTransferOrderReceivingFileInput>>;
  items: Array<SimpleTransferOrderReceivingItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderReceivingFile = {
  __typename?: 'SimpleTransferOrderReceivingFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  simpleTransferOrderReceivingFileID: Scalars['UUID']['output'];
  simpleTransferOrderReceivingFileType: Scalars['String']['output'];
  simpleTransferOrderReceivingID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SimpleTransferOrderReceivingFileInput = {
  fileID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingItem = {
  __typename?: 'SimpleTransferOrderReceivingItem';
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  doQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  note?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  simpleTransferOrderID: Scalars['UUID']['output'];
  simpleTransferOrderItemID: Scalars['UUID']['output'];
  simpleTransferOrderReceivingID: Scalars['UUID']['output'];
  simpleTransferOrderReceivingItemID: Scalars['UUID']['output'];
  toQty: Scalars['Float']['output'];
  toQtyOutstanding: Scalars['Float']['output'];
  toQtyReceived: Scalars['Float']['output'];
  toUomConversionDecimal: Scalars['Int']['output'];
  toUomConversionRate: Scalars['Float']['output'];
  toUomID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type SimpleTransferOrderReceivingItemCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingItemPaged = {
  __typename?: 'SimpleTransferOrderReceivingItemPaged';
  items: Array<SimpleTransferOrderReceivingItem>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderReceivingItemQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  simpleTransferOrderID?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderReceivingID?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderReceivingItemID?: InputMaybe<Scalars['String']['input']>;
};

export type SimpleTransferOrderReceivingItemQopInput = {
  filters?: InputMaybe<SimpleTransferOrderReceivingItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderReceivingItemUpdateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  simpleTransferOrderReceivingItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingPaged = {
  __typename?: 'SimpleTransferOrderReceivingPaged';
  items: Array<SimpleTransferOrderReceiving>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderReceivingQopFilterInput = {
  simpleTransferOrderNumber?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderReceivingDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderReceivingDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderReceivingQopInput = {
  filters?: InputMaybe<SimpleTransferOrderReceivingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderReceivingUpdateAndConfirmInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  files?: InputMaybe<Array<SimpleTransferOrderReceivingFileInput>>;
  items: Array<SimpleTransferOrderReceivingItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['input'];
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingUpdateInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  files?: InputMaybe<Array<SimpleTransferOrderReceivingFileInput>>;
  items: Array<SimpleTransferOrderReceivingItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['input'];
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderUpdateInput = {
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<SimpleTransferOrderItemUpdateInput>;
  noteForReceiver: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
  toWarehouseID: Scalars['UUID']['input'];
  transferOrderSimpleID: Scalars['UUID']['input'];
};

export type SnapshotItem = {
  __typename?: 'SnapshotItem';
  id: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  vector: Array<Scalars['Float']['output']>;
};

export type SnapshotPage = {
  __typename?: 'SnapshotPage';
  items: Array<SnapshotItem>;
  limit: Scalars['Int']['output'];
  nextOffset?: Maybe<Scalars['Int']['output']>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Sort = {
  direction: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

export type StartTaskInput = {
  putawayTaskID: Scalars['UUID']['input'];
};

export type Subdistrict = {
  __typename?: 'Subdistrict';
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  villages?: Maybe<Array<Maybe<Village>>>;
};

export type SubdistrictCreateInput = {
  cityID: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type SubdistrictPaged = {
  __typename?: 'SubdistrictPaged';
  items: Array<Subdistrict>;
  pagination: PaginationResult;
};

export type SubdistrictQop = {
  filters?: InputMaybe<SubdistrictQopFilter>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type SubdistrictQopFilter = {
  cityID?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
  subdistrictName?: InputMaybe<Scalars['String']['input']>;
};

export type SubdistrictUpdateInput = {
  cityID: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type SupervisorPinValidationResult = {
  __typename?: 'SupervisorPinValidationResult';
  branchID?: Maybe<Scalars['UUID']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  userID?: Maybe<Scalars['UUID']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type SyncAllResult = {
  __typename?: 'SyncAllResult';
  failedIDs: Array<Scalars['String']['output']>;
  successIDs: Array<Scalars['String']['output']>;
  totalFailed: Scalars['Int']['output'];
  totalSuccess: Scalars['Int']['output'];
};

export type SyncErpPurchaseOrderReceiveInput = {
  action: Scalars['String']['input'];
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};

export type SyncErpVendorInput = {
  action: Scalars['String']['input'];
  vendorCode: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type TaskAllocationInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  items: Array<TaskItemAllocationInput>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
};

export type TaskItemAllocationInput = {
  qtyAssigned: Scalars['Float']['input'];
  sourceDocumentDetailID: Scalars['UUID']['input'];
};

export type Tax = {
  __typename?: 'Tax';
  entityAuditMetadata: EntityAuditMetadata;
  erpRefID?: Maybe<Scalars['String']['output']>;
  erpRefName?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxName: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  taxType: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type TaxCreateInput = {
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  taxCode: Scalars['String']['input'];
  taxName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
  taxType: Scalars['String']['input'];
};

export type TaxPaged = {
  __typename?: 'TaxPaged';
  items?: Maybe<Array<Tax>>;
  pagination: PaginationResult;
};

export type TaxQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  taxName?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  taxType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type TaxQopInput = {
  filters?: InputMaybe<TaxQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TaxUpdateInput = {
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  taxCode: Scalars['String']['input'];
  taxID: Scalars['UUID']['input'];
  taxName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
  taxType: Scalars['String']['input'];
};

export enum TokenType {
  EmailVerification = 'EMAIL_VERIFICATION',
  PhoneVerification = 'PHONE_VERIFICATION',
  ResetPassword = 'RESET_PASSWORD'
}

export enum TransactionSyncEntityType {
  ConsignmentStockIn = 'CONSIGNMENT_STOCK_IN',
  ConsignmentStockOut = 'CONSIGNMENT_STOCK_OUT',
  DeliveryOrder = 'DELIVERY_ORDER',
  InventoryAdjustment = 'INVENTORY_ADJUSTMENT',
  PettyCashTransaction = 'PETTY_CASH_TRANSACTION',
  ProductionOrder = 'PRODUCTION_ORDER',
  PurchaseOrder = 'PURCHASE_ORDER',
  PurchaseOrderReceive = 'PURCHASE_ORDER_RECEIVE',
  SalesInvoice = 'SALES_INVOICE',
  SimpleTransferOrderReceive = 'SIMPLE_TRANSFER_ORDER_RECEIVE',
  TransferOrderReceive = 'TRANSFER_ORDER_RECEIVE'
}

export type TransferOrder = {
  __typename?: 'TransferOrder';
  branch: Branch;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  confirmByUserID?: Maybe<Scalars['UUID']['output']>;
  confirmByUserName?: Maybe<Scalars['String']['output']>;
  confirmDatetime?: Maybe<Scalars['Time']['output']>;
  confirmDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  doneByUserID?: Maybe<Scalars['UUID']['output']>;
  doneByUserName?: Maybe<Scalars['String']['output']>;
  doneDatetime?: Maybe<Scalars['Time']['output']>;
  doneDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  doneReason?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouse: Warehouse;
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isPickingTaskComplated: Scalars['Boolean']['output'];
  isReadyGenerateDeliveryOrder: Scalars['Boolean']['output'];
  noteForReceiver: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  reasonNotReadyGenerateDeliveryOrder?: Maybe<Scalars['String']['output']>;
  scheduledDeliveryDate: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  toWarehouse: Warehouse;
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItemQtyReadyToPack: Scalars['Float']['output'];
  totalItemQtyReadyToPick: Scalars['Float']['output'];
  totalItemQtyReadyToShip: Scalars['Float']['output'];
  totalItemQtyShipped: Scalars['Float']['output'];
  totalItemQtyUnfulfilled: Scalars['Float']['output'];
  totalItemWeight: Scalars['Float']['output'];
  transferOrderDatetime: Scalars['Time']['output'];
  transferOrderDatetimeUtc: Scalars['Time']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderNumber: Scalars['String']['output'];
  transferRequest?: Maybe<TransferRequest>;
};

export type TransferOrderCancelInput = {
  cancellationReason: Scalars['String']['input'];
  transferOrderID: Scalars['UUID']['input'];
};

export type TransferOrderConfirmInput = {
  transferOrderID: Scalars['UUID']['input'];
};

export type TransferOrderCreateInput = {
  branchID: Scalars['UUID']['input'];
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<TransferOrderItemCreateInput>;
  noteForReceiver: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
  toWarehouseID: Scalars['UUID']['input'];
  transferOrderDatetime: Scalars['Time']['input'];
  transferOrderNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TransferOrderImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TransferOrderImportFileMappingInput = {
  columns: Array<TransferOrderImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  rowFilters?: InputMaybe<Array<TransferOrderImportRowFilterInput>>;
};

export type TransferOrderImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: TransferOrderImportFileMappingInput;
};

export type TransferOrderImportMissingProductUom = {
  __typename?: 'TransferOrderImportMissingProductUom';
  productCode: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  uomName: Scalars['String']['output'];
};

export type TransferOrderImportRowFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
};

export type TransferOrderImportRowReport = {
  __typename?: 'TransferOrderImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<TransferOrderImportRowViolation>;
};

export type TransferOrderImportRowViolation = {
  __typename?: 'TransferOrderImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TransferOrderImportValidateCodesInput = {
  branchCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  fileMapping?: InputMaybe<TransferOrderImportFileMappingInput>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransferOrderImportValidateCodesResult = {
  __typename?: 'TransferOrderImportValidateCodesResult';
  consignmentProductCodes: Array<Scalars['String']['output']>;
  duplicateProductCodes: Array<Scalars['String']['output']>;
  missingBranchCodes: Array<Scalars['String']['output']>;
  missingProductCodes: Array<Scalars['String']['output']>;
  missingProductUoms: Array<TransferOrderImportMissingProductUom>;
  missingWarehouseCodes: Array<Scalars['String']['output']>;
  rowReport?: Maybe<TransferOrderImportRowReport>;
};

export type TransferOrderItem = {
  __typename?: 'TransferOrderItem';
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  qtyReadyToPack: Scalars['Float']['output'];
  qtyReadyToPick: Scalars['Float']['output'];
  qtyReadyToShip: Scalars['Float']['output'];
  qtyShipped: Scalars['Float']['output'];
  qtyUnfulfilled: Scalars['Float']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderItemID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type TransferOrderItemCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type TransferOrderItemPaged = {
  __typename?: 'TransferOrderItemPaged';
  items: Array<TransferOrderItem>;
  pagination: PaginationResult;
};

export type TransferOrderItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  transferOrderID?: InputMaybe<Scalars['UUID']['input']>;
  transferOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type TransferOrderItemQopInput = {
  filters?: InputMaybe<TransferOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferOrderItemUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  transferOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type TransferOrderMarkAsDoneInput = {
  reason: Scalars['String']['input'];
  transferOrderID: Scalars['UUID']['input'];
};

export type TransferOrderPaged = {
  __typename?: 'TransferOrderPaged';
  items: Array<TransferOrder>;
  pagination: PaginationResult;
};

export type TransferOrderQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  scheduledDeliveryDate?: InputMaybe<Scalars['Time']['input']>;
  scheduledDeliveryDateEnd?: InputMaybe<Scalars['Time']['input']>;
  scheduledDeliveryDateStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  transferOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  transferOrderDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transferOrderDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  transferOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transferOrderNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TransferOrderQopInput = {
  filters?: InputMaybe<TransferOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferOrderReceiving = {
  __typename?: 'TransferOrderReceiving';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  closeTO: Scalars['Boolean']['output'];
  deliveryBy: Scalars['String']['output'];
  deliveryOrder: DeliveryOrder;
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderNumber: Scalars['String']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhoneNumber?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<TransferOrderReceivingFile>>;
  gmt: Scalars['Int']['output'];
  items: Array<TransferOrderReceivingItem>;
  landedCost: Scalars['Float']['output'];
  landedCostPerUnit: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  originWarehouse: Warehouse;
  originWarehouseID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItemWeightReceived: Scalars['Float']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderNumber: Scalars['String']['output'];
  transferOrderReceivingDatetime: Scalars['Time']['output'];
  transferOrderReceivingID: Scalars['UUID']['output'];
  transferOrderReceivingNumber: Scalars['String']['output'];
  vehiclePlateNumber?: Maybe<Scalars['String']['output']>;
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
  vendorRefNumber?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type TransferOrderReceivingCreateInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  deliveryOrderID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<TransferOrderReceivingFileInput>>;
  items: Array<TransferOrderReceivingItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  transferOrderReceivingDatetime: Scalars['Time']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type TransferOrderReceivingFile = {
  __typename?: 'TransferOrderReceivingFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  transferOrderReceivingFileID: Scalars['UUID']['output'];
  transferOrderReceivingFileType: Scalars['String']['output'];
  transferOrderReceivingID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type TransferOrderReceivingFileInput = {
  fileID: Scalars['UUID']['input'];
};

export type TransferOrderReceivingItem = {
  __typename?: 'TransferOrderReceivingItem';
  additionalLandedCost: Scalars['Float']['output'];
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  doQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  note?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  toQty: Scalars['Float']['output'];
  toQtyOutstanding: Scalars['Float']['output'];
  toQtyReceived: Scalars['Float']['output'];
  toUomConversionDecimal: Scalars['Int']['output'];
  toUomConversionRate: Scalars['Float']['output'];
  toUomID: Scalars['UUID']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderItemID: Scalars['UUID']['output'];
  transferOrderReceivingID: Scalars['UUID']['output'];
  transferOrderReceivingItemID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type TransferOrderReceivingItemCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type TransferOrderReceivingItemPaged = {
  __typename?: 'TransferOrderReceivingItemPaged';
  items: Array<TransferOrderReceivingItem>;
  pagination: PaginationResult;
};

export type TransferOrderReceivingItemQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  transferOrderID?: InputMaybe<Scalars['String']['input']>;
  transferOrderReceivingID?: InputMaybe<Scalars['String']['input']>;
  transferOrderReceivingItemID?: InputMaybe<Scalars['String']['input']>;
};

export type TransferOrderReceivingItemQopInput = {
  filters?: InputMaybe<TransferOrderReceivingItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferOrderReceivingItemUpdateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  transferOrderReceivingItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type TransferOrderReceivingPaged = {
  __typename?: 'TransferOrderReceivingPaged';
  items: Array<TransferOrderReceiving>;
  pagination: PaginationResult;
};

export type TransferOrderReceivingQopFilterInput = {
  status?: InputMaybe<Scalars['String']['input']>;
  transferOrderNumber?: InputMaybe<Scalars['String']['input']>;
  transferOrderReceivingDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transferOrderReceivingDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  transferOrderReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type TransferOrderReceivingQopInput = {
  filters?: InputMaybe<TransferOrderReceivingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferOrderReceivingUpdateInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  files?: InputMaybe<Array<TransferOrderReceivingFileInput>>;
  items: Array<TransferOrderReceivingItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  transferOrderReceivingDatetime: Scalars['Time']['input'];
  transferOrderReceivingID: Scalars['UUID']['input'];
};

export type TransferOrderUpdateInput = {
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<TransferOrderItemUpdateInput>;
  noteForReceiver: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
  toWarehouseID: Scalars['UUID']['input'];
  transferOrderID: Scalars['UUID']['input'];
};

export type TransferRequest = {
  __typename?: 'TransferRequest';
  approvedByUserID?: Maybe<Scalars['UUID']['output']>;
  approvedByUserName?: Maybe<Scalars['String']['output']>;
  approvedDatetime?: Maybe<Scalars['Time']['output']>;
  approvedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  items: Array<TransferRequestItem>;
  noteApprover?: Maybe<Scalars['String']['output']>;
  noteForApprover: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  rejectedByUserID?: Maybe<Scalars['UUID']['output']>;
  rejectedByUserName?: Maybe<Scalars['String']['output']>;
  rejectedDatetime?: Maybe<Scalars['Time']['output']>;
  rejectedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  replenishmentID?: Maybe<Scalars['UUID']['output']>;
  scheduledDeliveryDate?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  submittedByUserID?: Maybe<Scalars['UUID']['output']>;
  submittedByUserName?: Maybe<Scalars['String']['output']>;
  submittedDatetime?: Maybe<Scalars['Time']['output']>;
  submittedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalItemQtyApproved: Scalars['Float']['output'];
  totalItemQtyRequested: Scalars['Float']['output'];
  transferOrderID?: Maybe<Scalars['UUID']['output']>;
  transferOrderNumber?: Maybe<Scalars['String']['output']>;
  transferRequestDatetime: Scalars['Time']['output'];
  transferRequestDatetimeUtc: Scalars['Time']['output'];
  transferRequestID: Scalars['UUID']['output'];
  transferRequestNumber: Scalars['String']['output'];
};

export type TransferRequestApproveInput = {
  items: Array<TransferRequestApproveItemInput>;
  noteApprover?: InputMaybe<Scalars['String']['input']>;
  transferRequestID: Scalars['UUID']['input'];
};

export type TransferRequestApproveItemInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  qtyApproved: Scalars['Float']['input'];
  transferRequestItemID: Scalars['UUID']['input'];
};

export type TransferRequestCancelInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  transferRequestID: Scalars['UUID']['input'];
};

export type TransferRequestCreateInput = {
  branchID: Scalars['UUID']['input'];
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<TransferRequestItemCreateInput>;
  noteForApprover: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate?: InputMaybe<Scalars['Time']['input']>;
  toWarehouseID: Scalars['UUID']['input'];
  transferRequestDatetime: Scalars['Time']['input'];
  transferRequestNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TransferRequestImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TransferRequestImportFileMappingInput = {
  columns: Array<TransferRequestImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  rowFilters?: InputMaybe<Array<TransferRequestImportRowFilterInput>>;
};

export type TransferRequestImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: TransferRequestImportFileMappingInput;
};

export type TransferRequestImportRowFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
};

export type TransferRequestImportRowReport = {
  __typename?: 'TransferRequestImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<TransferRequestImportRowViolation>;
};

export type TransferRequestImportRowViolation = {
  __typename?: 'TransferRequestImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TransferRequestImportValidateCodesInput = {
  branchCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  fileMapping?: InputMaybe<TransferRequestImportFileMappingInput>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransferRequestImportValidateCodesResult = {
  __typename?: 'TransferRequestImportValidateCodesResult';
  consignmentProductCodes: Array<Scalars['String']['output']>;
  duplicateProductCodes: Array<Scalars['String']['output']>;
  missingBranchCodes: Array<Scalars['String']['output']>;
  missingProductCodes: Array<Scalars['String']['output']>;
  missingWarehouseCodes: Array<Scalars['String']['output']>;
  rowReport?: Maybe<TransferRequestImportRowReport>;
};

export type TransferRequestItem = {
  __typename?: 'TransferRequestItem';
  availability?: Maybe<TransferRequestItemAvailability>;
  baseUomQtyApproved: Scalars['Float']['output'];
  baseUomQtyRequested: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  noteApprover?: Maybe<Scalars['String']['output']>;
  noteRequester?: Maybe<Scalars['String']['output']>;
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyApproved: Scalars['Float']['output'];
  qtyRequested: Scalars['Float']['output'];
  transferRequestID: Scalars['UUID']['output'];
  transferRequestItemID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type TransferRequestItemAvailability = {
  __typename?: 'TransferRequestItemAvailability';
  qtyAvailable: Scalars['Float']['output'];
  qtyOutstandingIn: Scalars['Float']['output'];
  qtyOutstandingOut: Scalars['Float']['output'];
  qtyRealAvailable: Scalars['Float']['output'];
  warehouseID: Scalars['UUID']['output'];
};

export type TransferRequestItemCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type TransferRequestItemPaged = {
  __typename?: 'TransferRequestItemPaged';
  items: Array<TransferRequestItem>;
  pagination: PaginationResult;
};

export type TransferRequestItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  transferRequestID?: InputMaybe<Scalars['String']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type TransferRequestItemQopInput = {
  filters?: InputMaybe<TransferRequestItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferRequestItemUpdateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  transferRequestItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type TransferRequestPaged = {
  __typename?: 'TransferRequestPaged';
  items: Array<TransferRequest>;
  pagination: PaginationResult;
};

export type TransferRequestQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  transferOrderID?: InputMaybe<Scalars['UUID']['input']>;
  transferRequestDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transferRequestDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  transferRequestNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TransferRequestQopInput = {
  filters?: InputMaybe<TransferRequestQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferRequestRejectInput = {
  rejectionReason: Scalars['String']['input'];
  transferRequestID: Scalars['UUID']['input'];
};

export type TransferRequestSubmitInput = {
  transferRequestID: Scalars['UUID']['input'];
};

export type TransferRequestUpdateInput = {
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<TransferRequestItemUpdateInput>;
  noteForApprover: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate?: InputMaybe<Scalars['Time']['input']>;
  toWarehouseID: Scalars['UUID']['input'];
  transferRequestID: Scalars['UUID']['input'];
};

export type TriggerIngestionInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Uom = {
  __typename?: 'Uom';
  conversionInfo: Scalars['String']['output'];
  convertionDecimal: Scalars['Int']['output'];
  convertionRate: Scalars['Float']['output'];
  convertionRateMultiplier: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  relationType: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  uniqueKey2: Scalars['String']['output'];
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type UomCategory = {
  __typename?: 'UomCategory';
  baseUom: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  nonMainUoms: Array<Uom>;
  uniqueKey: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomCategoryName: Scalars['String']['output'];
  uomItems: Scalars['String']['output'];
  uoms: Array<Uom>;
};

export type UomCategoryCreateInput = {
  baseUom: Scalars['String']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  uom: Array<UomCreateFromUomCategoryInput>;
  uomCategoryName: Scalars['String']['input'];
};

export type UomCategoryDeleteInput = {
  uomCategoryID: Scalars['UUID']['input'];
};

export type UomCategoryPaged = {
  __typename?: 'UomCategoryPaged';
  items: Array<UomCategory>;
  pagination: PaginationResult;
};

export type UomCategoryQopFilterInput = {
  baseUom?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type UomCategoryQopInput = {
  filters?: InputMaybe<UomCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UomCategoryUpdateInput = {
  baseUom: Scalars['String']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  uom: Array<UomCreateFromUomCategoryInput>;
  uomCategoryID: Scalars['UUID']['input'];
  uomCategoryName: Scalars['String']['input'];
};

export type UomCreateFromUomCategoryInput = {
  convertionDecimal: Scalars['Int']['input'];
  convertionRate: Scalars['Float']['input'];
  convertionRateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  relationType: Scalars['String']['input'];
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  uomName: Scalars['String']['input'];
};

export type UomCreateInput = {
  convertionDecimal: Scalars['Int']['input'];
  convertionRate: Scalars['Float']['input'];
  convertionRateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  relationType: Scalars['String']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  uomName: Scalars['String']['input'];
};

export type UomPaged = {
  __typename?: 'UomPaged';
  items: Array<Uom>;
  pagination: PaginationResult;
};

export type UomQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  relationType?: InputMaybe<Scalars['String']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type UomQopInput = {
  filters?: InputMaybe<UomQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UomUpdateInput = {
  convertionDecimal: Scalars['Int']['input'];
  convertionRate: Scalars['Float']['input'];
  convertionRateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  relationType: Scalars['String']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
  uomName: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
};

export type UpdateErpProductInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  canBePurchased?: InputMaybe<Scalars['Boolean']['input']>;
  canBeSold?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  productCategoryID?: InputMaybe<Scalars['Int']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['Int']['input']>;
  purchaseUomID?: InputMaybe<Scalars['Int']['input']>;
  salesTaxID?: InputMaybe<Scalars['Int']['input']>;
  salesUomID?: InputMaybe<Scalars['Int']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate?: InputMaybe<Scalars['Boolean']['input']>;
  trackStock?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UploadTemplate = {
  __typename?: 'UploadTemplate';
  columnMapping: Array<UploadTemplateColumnMapping>;
  delimiter?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  headerRow?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  referenceIDs: Array<Scalars['UUID']['output']>;
  uniqueKey: Scalars['String']['output'];
  uploadTemplateID: Scalars['UUID']['output'];
  uploadTemplateKey: Scalars['String']['output'];
  uploadTemplateName: Scalars['String']['output'];
  uploadTemplateType: Scalars['String']['output'];
};

export type UploadTemplateColumnMapping = {
  __typename?: 'UploadTemplateColumnMapping';
  contains?: Maybe<Array<Scalars['String']['output']>>;
  format?: Maybe<Scalars['String']['output']>;
  gt?: Maybe<Scalars['Float']['output']>;
  gte?: Maybe<Scalars['Float']['output']>;
  notContains?: Maybe<Array<Scalars['String']['output']>>;
  sourceColumn: Scalars['String']['output'];
  standardKey: Scalars['String']['output'];
  transform?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UploadTemplateColumnMappingInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  transform?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UploadTemplateCreateInput = {
  columnMapping: Array<UploadTemplateColumnMappingInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  referenceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uploadTemplateKey: Scalars['String']['input'];
  uploadTemplateName: Scalars['String']['input'];
  uploadTemplateType: Scalars['String']['input'];
};

export type UploadTemplatePaged = {
  __typename?: 'UploadTemplatePaged';
  items?: Maybe<Array<UploadTemplate>>;
  pagination: PaginationResult;
};

export type UploadTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  uploadTemplateKey?: InputMaybe<Scalars['String']['input']>;
  uploadTemplateName?: InputMaybe<Scalars['String']['input']>;
  uploadTemplateType?: InputMaybe<Scalars['String']['input']>;
};

export type UploadTemplateQopInput = {
  filters?: InputMaybe<UploadTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UploadTemplateUpdateInput = {
  columnMapping: Array<UploadTemplateColumnMappingInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  referenceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uploadTemplateID: Scalars['UUID']['input'];
  uploadTemplateKey: Scalars['String']['input'];
  uploadTemplateName: Scalars['String']['input'];
  uploadTemplateType: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  employeeID?: Maybe<Scalars['Int64']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAllBranches?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  pinPlainText?: Maybe<Scalars['String']['output']>;
  userBranches: Array<UserBranch>;
  userID: Scalars['UUID']['output'];
  userRoles: Array<UserRole>;
  userType: Scalars['String']['output'];
  vendorID?: Maybe<Scalars['String']['output']>;
};

export type UserBranch = {
  __typename?: 'UserBranch';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  userID: Scalars['UUID']['output'];
};

export type UserCreateInput = {
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  email: Scalars['String']['input'];
  employeeID?: InputMaybe<Scalars['Int64']['input']>;
  firstName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  roleIDs: Array<InputMaybe<Scalars['UUID']['input']>>;
  userType: Scalars['String']['input'];
  vendorID?: InputMaybe<Scalars['String']['input']>;
};

export type UserDetail = {
  __typename?: 'UserDetail';
  email: Scalars['String']['output'];
  employeeID?: Maybe<Scalars['Int64']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAllBranches?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  userBranches: Array<UserBranch>;
  userID: Scalars['UUID']['output'];
  userRoles: Array<UserRole>;
  userType: Scalars['String']['output'];
  vendorID?: Maybe<Scalars['String']['output']>;
};

export type UserLiteFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  roleID?: InputMaybe<Scalars['UUID']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type UserLiteItem = {
  __typename?: 'UserLiteItem';
  fullName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  userID: Scalars['UUID']['output'];
  userType: Scalars['String']['output'];
};

export type UserLitePaged = {
  __typename?: 'UserLitePaged';
  items?: Maybe<Array<UserLiteItem>>;
  pagination: PaginationResult;
};

export type UserLiteQopInput = {
  filters?: InputMaybe<UserLiteFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UserPaged = {
  __typename?: 'UserPaged';
  items?: Maybe<Array<User>>;
  pagination: PaginationResult;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  branches?: Maybe<Array<BranchProfile>>;
  defaultBranchCode?: Maybe<Scalars['String']['output']>;
  defaultBranchID?: Maybe<Scalars['UUID']['output']>;
  defaultBranchName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employeeID?: Maybe<Scalars['Int64']['output']>;
  fullName: Scalars['String']['output'];
  isAllBranches?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber: Scalars['String']['output'];
  pinPlainText?: Maybe<Scalars['String']['output']>;
  userID: Scalars['String']['output'];
  vendorID?: Maybe<Scalars['String']['output']>;
};

export type UserQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roleID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type UserQopInput = {
  filters?: InputMaybe<UserQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UserRole = {
  __typename?: 'UserRole';
  role: Roles;
  roleID: Scalars['UUID']['output'];
  userID: Scalars['UUID']['output'];
};

export type UserToken = {
  __typename?: 'UserToken';
  email: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiredAt: Scalars['Time']['output'];
  isActive: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  tokenCode: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
  user?: Maybe<User>;
  userID: Scalars['UUID']['output'];
};

export type UserUpdateInput = {
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  employeeID?: InputMaybe<Scalars['Int64']['input']>;
  firstName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  roleIDs: Array<InputMaybe<Scalars['UUID']['input']>>;
  userID: Scalars['UUID']['input'];
  vendorID?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateBeforeIcFinishConfirmInput = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type ValidateBeforeIcFinishRow = {
  __typename?: 'ValidateBeforeICFinishRow';
  counted: Scalars['Float']['output'];
  diff: Scalars['Float']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  systemFrozen: Scalars['Float']['output'];
  systemLive: Scalars['Float']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type ValidateSupervisorPinInput = {
  branchID: Scalars['UUID']['input'];
  pin: Scalars['String']['input'];
  userID: Scalars['UUID']['input'];
};

export type Vendor = {
  __typename?: 'Vendor';
  addressLabel: Scalars['String']['output'];
  bankAccountName?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  canBeReturned?: Maybe<Scalars['Boolean']['output']>;
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  consignmentCommisionFeePerc?: Maybe<Scalars['Float']['output']>;
  consignmentPeriodEndDate?: Maybe<Scalars['Time']['output']>;
  consignmentPeriodStartDate?: Maybe<Scalars['Time']['output']>;
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fullAddress: Scalars['String']['output'];
  hasPortalAccess?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isConsignment?: Maybe<Scalars['Boolean']['output']>;
  isPKP: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['Time']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  npwp: Scalars['String']['output'];
  npwpCompanyName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  portalAccountActivated?: Maybe<Scalars['Boolean']['output']>;
  portalSuperadminEmail?: Maybe<Scalars['String']['output']>;
  portalSuperadminFirstName?: Maybe<Scalars['String']['output']>;
  portalSuperadminLastName?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  taxIncluded?: Maybe<Scalars['Boolean']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  taxpayerIDNumber: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorCategory: VendorCategory;
  vendorCategoryID: Scalars['UUID']['output'];
  vendorCode: Scalars['String']['output'];
  vendorConsignmentBranch: Array<VendorConsignmentBranch>;
  vendorConsignmentProducts: Array<VendorConsignmentProduct>;
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
  vendorPicContacts: Array<VendorPicContact>;
};

export type VendorCategory = {
  __typename?: 'VendorCategory';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorCategoryID: Scalars['UUID']['output'];
  vendorCategoryName: Scalars['String']['output'];
};

export type VendorCategoryCreateInput = {
  isActive: Scalars['Boolean']['input'];
  vendorCategoryName: Scalars['String']['input'];
};

export type VendorCategoryPaged = {
  __typename?: 'VendorCategoryPaged';
  items?: Maybe<Array<VendorCategory>>;
  pagination: PaginationResult;
};

export type VendorCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorCategoryName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorCategoryQopInput = {
  filters?: InputMaybe<VendorCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorCategoryUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  vendorCategoryID: Scalars['UUID']['input'];
  vendorCategoryName: Scalars['String']['input'];
};

export type VendorConsignmentBranch = {
  __typename?: 'VendorConsignmentBranch';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  commissionFeePerc: Scalars['Float']['output'];
  currentPeriod?: Maybe<VendorConsignmentBranchPeriod>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isRent: Scalars['Boolean']['output'];
  rentPrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorConsignmentBranchID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
};

export type VendorConsignmentBranchBulkDeleteFailure = {
  __typename?: 'VendorConsignmentBranchBulkDeleteFailure';
  reason: Scalars['String']['output'];
  vendorConsignmentBranchID: Scalars['UUID']['output'];
};

export type VendorConsignmentBranchBulkDeleteResult = {
  __typename?: 'VendorConsignmentBranchBulkDeleteResult';
  deletedCount: Scalars['Int']['output'];
  deletedIDs: Array<Scalars['UUID']['output']>;
  failures: Array<VendorConsignmentBranchBulkDeleteFailure>;
};

export type VendorConsignmentBranchCreateInput = {
  branchID: Scalars['UUID']['input'];
  commissionFeePerc: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  isRent: Scalars['Boolean']['input'];
  rentPrice?: InputMaybe<Scalars['Float']['input']>;
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchInput = {
  branchID: Scalars['UUID']['input'];
  commissionFeePerc: Scalars['Float']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRent?: InputMaybe<Scalars['Boolean']['input']>;
  rentPrice?: InputMaybe<Scalars['Float']['input']>;
  vendorConsignmentBranchID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentBranchPaged = {
  __typename?: 'VendorConsignmentBranchPaged';
  items?: Maybe<Array<VendorConsignmentBranch>>;
  pagination: PaginationResult;
};

export type VendorConsignmentBranchPeriod = {
  __typename?: 'VendorConsignmentBranchPeriod';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  daysGrantedTotal: Scalars['Int']['output'];
  effectiveEndDate?: Maybe<Scalars['Time']['output']>;
  effectiveStartDate?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  lastGrantSource: Scalars['String']['output'];
  lastGrantSourcePaymentID?: Maybe<Scalars['UUID']['output']>;
  lastGrantSourcePaymentNumber: Scalars['String']['output'];
  lastGrantedAt?: Maybe<Scalars['Time']['output']>;
  lastGrantedByUserID?: Maybe<Scalars['UUID']['output']>;
  lastGrantedByUserName: Scalars['String']['output'];
  rentalStatus: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['Time']['output']>;
  revokedByUserID?: Maybe<Scalars['UUID']['output']>;
  revokedByUserName: Scalars['String']['output'];
  revokedReason: Scalars['String']['output'];
  suspendedAt?: Maybe<Scalars['Time']['output']>;
  suspendedByUserID?: Maybe<Scalars['UUID']['output']>;
  suspendedByUserName: Scalars['String']['output'];
  suspendedReason: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  vendor: Vendor;
  vendorConsignmentBranchID: Scalars['UUID']['output'];
  vendorConsignmentBranchPeriodID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
};

export type VendorConsignmentBranchPeriodGrantInput = {
  branchID: Scalars['UUID']['input'];
  daysGrantedTotal?: InputMaybe<Scalars['Int']['input']>;
  effectiveEndDate: Scalars['Time']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  sourcePaymentID?: InputMaybe<Scalars['UUID']['input']>;
  sourcePaymentNumber?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentBranchID: Scalars['UUID']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchPeriodPaged = {
  __typename?: 'VendorConsignmentBranchPeriodPaged';
  items?: Maybe<Array<VendorConsignmentBranchPeriod>>;
  pagination: PaginationResult;
};

export type VendorConsignmentBranchPeriodQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  effectiveEndDateTo?: InputMaybe<Scalars['Time']['input']>;
  effectiveStartDateFrom?: InputMaybe<Scalars['Time']['input']>;
  rentalStatus?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentBranchID?: InputMaybe<Scalars['UUID']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentBranchPeriodQopInput = {
  filters?: InputMaybe<VendorConsignmentBranchPeriodQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentBranchPeriodResumeInput = {
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchPeriodRevokeInput = {
  reason: Scalars['String']['input'];
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchPeriodSuspendInput = {
  reason: Scalars['String']['input'];
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentBranchQopInput = {
  filters?: InputMaybe<VendorConsignmentBranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentBranchUpdateInput = {
  branchID: Scalars['UUID']['input'];
  commissionFeePerc: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  isRent: Scalars['Boolean']['input'];
  rentPrice?: InputMaybe<Scalars['Float']['input']>;
  vendorConsignmentBranchID: Scalars['UUID']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentDashboard = {
  __typename?: 'VendorConsignmentDashboard';
  salesByBranch: Array<VendorConsignmentDashboardBranchPoint>;
  summary: VendorConsignmentDashboardSummary;
  topProducts: Array<VendorConsignmentDashboardProductPoint>;
  topProductsByRevenue: Array<VendorConsignmentDashboardProductPoint>;
};

export type VendorConsignmentDashboardBranchPoint = {
  __typename?: 'VendorConsignmentDashboardBranchPoint';
  branchID: Scalars['UUID']['output'];
  grossSales: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type VendorConsignmentDashboardFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentDashboardProductPoint = {
  __typename?: 'VendorConsignmentDashboardProductPoint';
  grossSales: Scalars['Float']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type VendorConsignmentDashboardSummary = {
  __typename?: 'VendorConsignmentDashboardSummary';
  commissionAmount: Scalars['Float']['output'];
  /** Gross commission (commissionAmount + tax). commissionAmount stays net; this is the display value for the Total Komisi KPI. */
  commissionInclTaxAmount: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  unitsSold: Scalars['Float']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type VendorConsignmentImportItem = {
  __typename?: 'VendorConsignmentImportItem';
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
};

export type VendorConsignmentImportItemPaged = {
  __typename?: 'VendorConsignmentImportItemPaged';
  items?: Maybe<Array<VendorConsignmentImportItem>>;
  pagination: PaginationResult;
};

export type VendorConsignmentInvoice = {
  __typename?: 'VendorConsignmentInvoice';
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName: Scalars['String']['output'];
  cancelledReason: Scalars['String']['output'];
  chargeAmount: Scalars['Float']['output'];
  commissionAmount: Scalars['Float']['output'];
  cutoffDate: Scalars['Time']['output'];
  cutoffDay: Scalars['Int']['output'];
  discountAmount: Scalars['Float']['output'];
  emailSentAt?: Maybe<Scalars['Time']['output']>;
  emailStatus: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  isManual: Scalars['Boolean']['output'];
  manualAt?: Maybe<Scalars['Time']['output']>;
  manualByUserName: Scalars['String']['output'];
  manualReason: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['Time']['output']>;
  paidByUserID?: Maybe<Scalars['UUID']['output']>;
  paidByUserName: Scalars['String']['output'];
  paidReference: Scalars['String']['output'];
  paymentDueDate?: Maybe<Scalars['Time']['output']>;
  payoutBankAccountNumber: Scalars['String']['output'];
  payoutBankID?: Maybe<Scalars['UUID']['output']>;
  payoutBankName: Scalars['String']['output'];
  periodEndDate: Scalars['Time']['output'];
  periodStartDate: Scalars['Time']['output'];
  returnsAdjustmentAmount: Scalars['Float']['output'];
  settlementBankAccountID?: Maybe<Scalars['UUID']['output']>;
  settlementBankAccountName: Scalars['String']['output'];
  settlementBankAccountNumber: Scalars['String']['output'];
  settlementBankName: Scalars['String']['output'];
  sourceInvoiceCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalPayableAmount: Scalars['Float']['output'];
  transferFeeAmount: Scalars['Float']['output'];
  vendor?: Maybe<Vendor>;
  vendorConsignmentInvoiceDatetime: Scalars['Time']['output'];
  vendorConsignmentInvoiceDatetimeUtc: Scalars['Time']['output'];
  vendorConsignmentInvoiceID: Scalars['UUID']['output'];
  vendorConsignmentInvoiceNumber: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
  vendorPayoutBeforeTax: Scalars['Float']['output'];
  vendorPayoutTotal: Scalars['Float']['output'];
};

export type VendorConsignmentInvoiceCancelInput = {
  cancelledReason: Scalars['String']['input'];
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type VendorConsignmentInvoiceConfig = {
  __typename?: 'VendorConsignmentInvoiceConfig';
  /** Day/week/month: units per period (month x 2 = every two months). month_segment: periods per month, at least 2 (2 x cutoff 15 = 1..15, 16..end of month). */
  billCycleInterval: Scalars['Int']['output'];
  /** Anchor of the first day/week/month period when the vendor has no settlement yet; month_segment follows the calendar. */
  billCycleStartDate?: Maybe<Scalars['Time']['output']>;
  /** Cycle unit: month_segment (each month cut every cutoffDay days; the last period runs to month-end), day, week or month. */
  billCycleType: Scalars['String']['output'];
  cutoffDay: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  graceDays: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  paymentDueDays: Scalars['Int']['output'];
  vendorConsignmentInvoiceConfigID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
};

export type VendorConsignmentInvoiceConfigCreateInput = {
  billCycleInterval?: InputMaybe<Scalars['Int']['input']>;
  billCycleStartDate?: InputMaybe<Scalars['Time']['input']>;
  billCycleType?: InputMaybe<Scalars['String']['input']>;
  cutoffDay: Scalars['Int']['input'];
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDueDays?: InputMaybe<Scalars['Int']['input']>;
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentInvoiceConfigFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentInvoiceConfigImportColumnInput = {
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
};

export type VendorConsignmentInvoiceConfigImportFileMappingInput = {
  columns: Array<VendorConsignmentInvoiceConfigImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorConsignmentInvoiceConfigImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: VendorConsignmentInvoiceConfigImportFileMappingInput;
};

export type VendorConsignmentInvoiceConfigImportIssue = {
  __typename?: 'VendorConsignmentInvoiceConfigImportIssue';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VendorConsignmentInvoiceConfigImportResult = {
  __typename?: 'VendorConsignmentInvoiceConfigImportResult';
  createdCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type VendorConsignmentInvoiceConfigImportRowReport = {
  __typename?: 'VendorConsignmentInvoiceConfigImportRowReport';
  createRowCount: Scalars['Int']['output'];
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  updateRowCount: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<VendorConsignmentInvoiceConfigImportIssue>;
  warningRowCount: Scalars['Int']['output'];
  warningSample: Array<VendorConsignmentInvoiceConfigImportIssue>;
};

export type VendorConsignmentInvoiceConfigImportValidateResult = {
  __typename?: 'VendorConsignmentInvoiceConfigImportValidateResult';
  missingVendorCodes: Array<Scalars['String']['output']>;
  rowReport: VendorConsignmentInvoiceConfigImportRowReport;
  status: Scalars['String']['output'];
};

export type VendorConsignmentInvoiceConfigPaged = {
  __typename?: 'VendorConsignmentInvoiceConfigPaged';
  items?: Maybe<Array<VendorConsignmentInvoiceConfig>>;
  pagination: PaginationResult;
};

export type VendorConsignmentInvoiceConfigQopInput = {
  filters?: InputMaybe<VendorConsignmentInvoiceConfigFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentInvoiceConfigUpdateInput = {
  billCycleInterval?: InputMaybe<Scalars['Int']['input']>;
  billCycleStartDate?: InputMaybe<Scalars['Time']['input']>;
  billCycleType?: InputMaybe<Scalars['String']['input']>;
  cutoffDay: Scalars['Int']['input'];
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDueDays?: InputMaybe<Scalars['Int']['input']>;
  vendorConsignmentInvoiceConfigID: Scalars['UUID']['input'];
};

export type VendorConsignmentInvoiceFilterInput = {
  cutoffDate?: InputMaybe<Scalars['Time']['input']>;
  cutoffDateFrom?: InputMaybe<Scalars['Time']['input']>;
  cutoffDateTo?: InputMaybe<Scalars['Time']['input']>;
  periodEndDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentInvoicePaged = {
  __typename?: 'VendorConsignmentInvoicePaged';
  items?: Maybe<Array<VendorConsignmentInvoice>>;
  pagination: PaginationResult;
};

export type VendorConsignmentInvoicePayInput = {
  paidReference?: InputMaybe<Scalars['String']['input']>;
  settlementBankAccountID: Scalars['UUID']['input'];
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type VendorConsignmentInvoiceQopInput = {
  filters?: InputMaybe<VendorConsignmentInvoiceFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentInvoiceSummary = {
  __typename?: 'VendorConsignmentInvoiceSummary';
  count: Scalars['Int']['output'];
  draftCount: Scalars['Int']['output'];
  emailableCount: Scalars['Int']['output'];
  proformaCount: Scalars['Int']['output'];
  totalCommissionAmount: Scalars['Float']['output'];
  totalSubtotal: Scalars['Float']['output'];
  totalTaxAmount: Scalars['Float']['output'];
  totalVendorPayoutTotal: Scalars['Float']['output'];
};

export type VendorConsignmentPaymentChargeConfig = {
  __typename?: 'VendorConsignmentPaymentChargeConfig';
  chargePerc: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  paymentMethodName: Scalars['String']['output'];
  paymentMethodTypeCode: Scalars['String']['output'];
  vendorConsignmentPaymentChargeConfigID: Scalars['UUID']['output'];
};

export type VendorConsignmentPaymentChargeConfigFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentPaymentChargeConfigPaged = {
  __typename?: 'VendorConsignmentPaymentChargeConfigPaged';
  items?: Maybe<Array<VendorConsignmentPaymentChargeConfig>>;
  pagination: PaginationResult;
};

export type VendorConsignmentPaymentChargeConfigQopInput = {
  filters?: InputMaybe<VendorConsignmentPaymentChargeConfigFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentProduct = {
  __typename?: 'VendorConsignmentProduct';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  commissionFeePerc: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product: Product;
  productCommissionFeePerc: Scalars['Float']['output'];
  productID: Scalars['UUID']['output'];
  sellingPrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorConsignmentProductID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
};

export type VendorConsignmentProductAggregated = {
  __typename?: 'VendorConsignmentProductAggregated';
  branchPrices: Array<VendorConsignmentProduct>;
  product: Product;
  productID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
};

export type VendorConsignmentProductAggregatedPaged = {
  __typename?: 'VendorConsignmentProductAggregatedPaged';
  items?: Maybe<Array<VendorConsignmentProductAggregated>>;
  pagination: PaginationResult;
};

export type VendorConsignmentProductBranchPriceInput = {
  isActive: Scalars['Boolean']['input'];
  productCommissionFeePerc: Scalars['Float']['input'];
  sellingPrice: Scalars['Float']['input'];
  vendorConsignmentProductID: Scalars['UUID']['input'];
  vendorConsignmentProductVersion: Scalars['UUID']['input'];
};

export type VendorConsignmentProductBulkUpdateResult = {
  __typename?: 'VendorConsignmentProductBulkUpdateResult';
  product: Product;
  updatedBranchPrices: Array<VendorConsignmentProduct>;
};

export type VendorConsignmentProductCreateInput = {
  branchID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productCommissionFeePerc: Scalars['Float']['input'];
  productID: Scalars['UUID']['input'];
  sellingPrice: Scalars['Float']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentProductPaged = {
  __typename?: 'VendorConsignmentProductPaged';
  items?: Maybe<Array<VendorConsignmentProduct>>;
  pagination: PaginationResult;
};

export type VendorConsignmentProductPriceBulkUpdateInput = {
  branchPrices: Array<VendorConsignmentProductBranchPriceInput>;
  isActive: Scalars['Boolean']['input'];
  masterSellingPrice: Scalars['Float']['input'];
  productID: Scalars['UUID']['input'];
  productVersion: Scalars['UUID']['input'];
};

export type VendorConsignmentProductPriceInput = {
  branchID: Scalars['UUID']['input'];
  commissionFeePerc?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sellingPrice: Scalars['Float']['input'];
  vendorConsignmentProductVersion?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentProductQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  searchKeyFull?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentProductQopInput = {
  filters?: InputMaybe<VendorConsignmentProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentProductUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productCommissionFeePerc: Scalars['Float']['input'];
  sellingPrice: Scalars['Float']['input'];
  vendorConsignmentProductID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPayment = {
  __typename?: 'VendorConsignmentRentalPayment';
  activeFrom?: Maybe<Scalars['Time']['output']>;
  activeUntil?: Maybe<Scalars['Time']['output']>;
  approvedAt?: Maybe<Scalars['Time']['output']>;
  approvedByUserID?: Maybe<Scalars['UUID']['output']>;
  approvedByUserName: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  daysGranted: Scalars['Int']['output'];
  effectiveEndDate: Scalars['Time']['output'];
  effectiveStartDate: Scalars['Time']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<VendorConsignmentRentalPaymentFile>>;
  rejectedAt?: Maybe<Scalars['Time']['output']>;
  rejectedByUserID?: Maybe<Scalars['UUID']['output']>;
  rejectedByUserName: Scalars['String']['output'];
  rejectedReason: Scalars['String']['output'];
  rentPeriodDaysSnapshot: Scalars['Int']['output'];
  rentPriceSnapshot: Scalars['Float']['output'];
  settlementBankAccountID?: Maybe<Scalars['UUID']['output']>;
  settlementBankAccountNumber: Scalars['String']['output'];
  settlementBankName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transferAmount: Scalars['Float']['output'];
  transferDate: Scalars['Time']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorConsignmentBranchID: Scalars['UUID']['output'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['output'];
  vendorConsignmentRentalPaymentNumber: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
  vendorNote: Scalars['String']['output'];
};

export type VendorConsignmentRentalPaymentApproveInput = {
  bankAccountID: Scalars['UUID']['input'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPaymentCancelInput = {
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPaymentCreateInput = {
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<VendorConsignmentRentalPaymentFileInput>>;
  rentPeriodDaysSnapshot?: InputMaybe<Scalars['Int']['input']>;
  rentPriceSnapshot: Scalars['Float']['input'];
  transferAmount: Scalars['Float']['input'];
  transferDate: Scalars['Time']['input'];
  vendorConsignmentBranchID: Scalars['UUID']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorName: Scalars['String']['input'];
  vendorNote?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentRentalPaymentFile = {
  __typename?: 'VendorConsignmentRentalPaymentFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorConsignmentRentalPaymentFileID: Scalars['UUID']['output'];
  vendorConsignmentRentalPaymentFileType: Scalars['String']['output'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['output'];
};

export type VendorConsignmentRentalPaymentFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentRentalPaymentFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transferDateFrom?: InputMaybe<Scalars['Time']['input']>;
  transferDateTo?: InputMaybe<Scalars['Time']['input']>;
  vendorConsignmentBranchID?: InputMaybe<Scalars['UUID']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentRentalPaymentPaged = {
  __typename?: 'VendorConsignmentRentalPaymentPaged';
  items?: Maybe<Array<VendorConsignmentRentalPayment>>;
  pagination: PaginationResult;
};

export type VendorConsignmentRentalPaymentQopInput = {
  filters?: InputMaybe<VendorConsignmentRentalPaymentFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentRentalPaymentRejectInput = {
  rejectedReason: Scalars['String']['input'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPaymentSubmitInput = {
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPaymentUpdateInput = {
  effectiveStartDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<VendorConsignmentRentalPaymentFileInput>>;
  rentPeriodDaysSnapshot?: InputMaybe<Scalars['Int']['input']>;
  rentPriceSnapshot: Scalars['Float']['input'];
  transferAmount: Scalars['Float']['input'];
  transferDate: Scalars['Time']['input'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
  vendorNote?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentSalesExportFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Optional period. A branch wall clock stamped Z — see the contract in repository/consignment_period_filter.go. */
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentSalesExportResult = {
  __typename?: 'VendorConsignmentSalesExportResult';
  /** Short-lived signed URL to download the generated .xlsx from object storage. */
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type VendorConsignmentStockByBranchFilterInput = {
  /** Optional — omit to aggregate across all of the vendor's cabang (Semua Cabang). */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Optional warehouse type to restrict to: "storage" (sellable/main) or "transit".
   *   Omit to aggregate across both, netted per cabang/product.
   */
  warehouseType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One row of a vendor's consignment stock aggregated per cabang (branch). Only the
 * branch's sellable (storage) warehouse is counted — transit warehouses are excluded —
 * so a product's main on-hand shows once per cabang instead of as separate +/- rows.
 */
export type VendorConsignmentStockByBranchItem = {
  __typename?: 'VendorConsignmentStockByBranchItem';
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  qtyAvailable: Scalars['Decimal']['output'];
  qtyCommitted: Scalars['Decimal']['output'];
  qtyOnHand: Scalars['Decimal']['output'];
  qtyRejected: Scalars['Decimal']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type VendorConsignmentStockByBranchPaged = {
  __typename?: 'VendorConsignmentStockByBranchPaged';
  items?: Maybe<Array<VendorConsignmentStockByBranchItem>>;
  pagination: PaginationResult;
};

export type VendorConsignmentStockByBranchQopInput = {
  filter: VendorConsignmentStockByBranchFilterInput;
  pagination?: InputMaybe<Pagination>;
};

export type VendorCreateAccessInput = {
  portalSuperadminEmail: Scalars['String']['input'];
  portalSuperadminFirstName: Scalars['String']['input'];
  portalSuperadminLastName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorCreateInput = {
  addressLabel: Scalars['String']['input'];
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  canBeReturned?: InputMaybe<Scalars['Boolean']['input']>;
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  consignmentCommisionFeePerc?: InputMaybe<Scalars['Float']['input']>;
  consignmentPeriodEndDate?: InputMaybe<Scalars['Time']['input']>;
  consignmentPeriodStartDate?: InputMaybe<Scalars['Time']['input']>;
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullAddress: Scalars['String']['input'];
  hasPortalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isPKP?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  npwp: Scalars['String']['input'];
  npwpCompanyName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  portalAccountActivated?: InputMaybe<Scalars['Boolean']['input']>;
  portalSuperadminEmail?: InputMaybe<Scalars['String']['input']>;
  portalSuperadminFirstName?: InputMaybe<Scalars['String']['input']>;
  portalSuperadminLastName?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
  taxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  taxpayerIDNumber: Scalars['String']['input'];
  vendorCategoryID: Scalars['UUID']['input'];
  vendorCode: Scalars['String']['input'];
  vendorConsignmentBranches?: InputMaybe<Array<VendorConsignmentBranchInput>>;
  vendorName: Scalars['String']['input'];
  vendorPicContacts?: InputMaybe<Array<VendorPicContactCreateFromVendorInput>>;
};

export type VendorDeleteInput = {
  vendorID: Scalars['UUID']['input'];
};

/** Who ran the opname. There is no verifier stage in this system, so none is reported. */
export type VendorInventoryCountExecution = {
  __typename?: 'VendorInventoryCountExecution';
  /** Federated branch of the opname. The report header shows its name as Cabang. */
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  gmt: Scalars['Int']['output'];
  inventoryCountTransactionDatetimeUtc: Scalars['Time']['output'];
  inventoryCountTransactionNumber: Scalars['String']['output'];
  note: Scalars['String']['output'];
  /** Every assignee who counted, in assignment order. Recounts add more than one. */
  officers: Array<Scalars['String']['output']>;
  /** partial | full_count */
  taskType: Scalars['String']['output'];
  /** The warehouse the opname ran in. Needed by inventory's vendorStockReconciliation; a branch has both storage and transit warehouses, so it cannot be derived from branchID. */
  warehouseID: Scalars['UUID']['output'];
};

export type VendorInventoryCountExportResult = {
  __typename?: 'VendorInventoryCountExportResult';
  /** Short-lived signed URL to download the generated .xlsx from object storage. */
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type VendorInventoryCountItem = {
  __typename?: 'VendorInventoryCountItem';
  barcode: Scalars['String']['output'];
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  /** Canonical UTC instant of the opname. Render as branch local time by adding gmt. */
  countedAtUtc: Scalars['Time']['output'];
  gmt: Scalars['Int']['output'];
  /** The opname this row came from. In period mode the same SKU appears once per opname, so these identify the row. */
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionNumber: Scalars['String']['output'];
  inventoryCountTransactionResultItemID: Scalars['UUID']['output'];
  /**
   * What backoffice wrote on this product's line of the stock adjustment while
   *   reviewing it. autoConfirmFromInventoryCount is false in staging and production,
   *   so every count-generated adjustment waits as a draft until someone fills it in
   *   and confirms — that review is where the explanation comes from.
   *
   *   Empty for a matched product: a zero-diff item never gets an adjustment line, and
   *   needs no explanation. Also empty when the reviewer left it blank. Never null.
   */
  note: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  /**
   * The adjustment reason picked for this product's line. Starts as the system
   *   inventory-count reason and becomes meaningful only if the reviewer changed it.
   *   Empty for a matched product. Never null.
   */
  reasonName: Scalars['String']['output'];
  /** sesuai | kurang | lebih, derived from the sign of qtyDiff. */
  result: Scalars['String']['output'];
  /** Harga per base UOM at the time of the count. For consignment products this is the vendor selling price less the branch commission, so it is already vendor money. */
  unitCost: Scalars['Float']['output'];
  uomName: Scalars['String']['output'];
  /** qty_diff x unitCost, already net of branch commission for consignment products. */
  varianceValue: Scalars['Float']['output'];
  /** The warehouse the opname ran in — what inventory's vendorStockReconciliation needs for this row. */
  warehouseID: Scalars['UUID']['output'];
};

export type VendorInventoryCountItemPaged = {
  __typename?: 'VendorInventoryCountItemPaged';
  items?: Maybe<Array<VendorInventoryCountItem>>;
  pagination: PaginationResult;
};

/**
 * Picker filter: which finished stock opnames to offer the vendor. The period only
 * narrows the picker; the opname the vendor picks decides the branch of the report.
 */
export type VendorInventoryCountListFilterInput = {
  /** Optional — omit to list opnames across all of the vendor's cabang (Semua Cabang). */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Optional period. A branch wall clock stamped Z — see the contract in repository/vendor_inventory_count_period_filter.go. */
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

/** One finished opname that touched at least one of the vendor's products. */
export type VendorInventoryCountListItem = {
  __typename?: 'VendorInventoryCountListItem';
  /** Federated branch, so the picker can label the row with a cabang name instead of a UUID. */
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  gmt: Scalars['Int']['output'];
  /** Canonical UTC instant. Render as branch local time by adding gmt. */
  inventoryCountTransactionDatetimeUtc: Scalars['Time']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionNumber: Scalars['String']['output'];
  /** How many of the vendor's products this opname covered. */
  productCount: Scalars['Int']['output'];
  /** partial | full_count — the scope of the opname, shown as Cakupan. */
  taskType: Scalars['String']['output'];
};

export type VendorInventoryCountReport = {
  __typename?: 'VendorInventoryCountReport';
  /** Null in period mode: the block describes one count run, and a window spanning several has no single number, officer list or note. */
  execution?: Maybe<VendorInventoryCountExecution>;
  items: VendorInventoryCountItemPaged;
  summary: VendorInventoryCountSummary;
};

/**
 * Two modes, never both. Send inventoryCountTransactionID for one opname, or
 * dateStart+dateEnd for every posted opname in a window. Sending both is rejected,
 * and so is sending neither — an unbounded report would return the vendor's whole
 * history in one page.
 */
export type VendorInventoryCountReportFilterInput = {
  /** Mode periode only: narrow to one cabang. Omit for every cabang the vendor was counted in. */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  /** Mode periode, sent together with dateStart. */
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Mode periode, sent together with dateEnd. A branch wall clock stamped Z — same contract as the picker. */
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  /** Mode satu opname. The execution block is only returned in this mode. */
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Narrows to one product. Sent with inventoryCountTransactionID, it returns exactly
   *   one row, so the detail page can re-read itself after a refresh or a shared link
   *   instead of depending on router state.
   */
  productID?: InputMaybe<Scalars['UUID']['input']>;
  /** all | sesuai | kurang | lebih. Omit or 'all' to keep every row. */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Free text over product code, barcode and product name. */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it.
   */
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Sorting is not offered: the order is part of the report's meaning. A period report
 * groups by opname newest first, then by product, so a SKU counted several times reads
 * as a history; a single-opname report orders by product.
 */
export type VendorInventoryCountReportQopInput = {
  filter: VendorInventoryCountReportFilterInput;
  pagination?: InputMaybe<Pagination>;
};

/** Summary cards. Counts and values cover only the vendor's products inside this opname. */
export type VendorInventoryCountSummary = {
  __typename?: 'VendorInventoryCountSummary';
  matched: Scalars['Int']['output'];
  /** Signed sum of total_cost, already net of branch commission for consignment products. */
  netVarianceValue: Scalars['Float']['output'];
  /** How many opnames the report spans. Always 1 in single mode; in period mode it explains why productCounted can exceed the vendor's SKU count. */
  opnameCount: Scalars['Int']['output'];
  /** The positive half of netVarianceValue. */
  overageValue: Scalars['Float']['output'];
  /** Baris hasil hitung in scope. In period mode a SKU counted in three opnames contributes three. */
  productCounted: Scalars['Int']['output'];
  /** The negative half of netVarianceValue, so a card showing 0 can still explain itself. */
  shortageValue: Scalars['Float']['output'];
  variance: Scalars['Int']['output'];
};

export type VendorPaged = {
  __typename?: 'VendorPaged';
  items?: Maybe<Array<Vendor>>;
  pagination: PaginationResult;
};

export type VendorPicContact = {
  __typename?: 'VendorPicContact';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  picDepartment: Scalars['String']['output'];
  picEmail: Scalars['String']['output'];
  picName: Scalars['String']['output'];
  picPhoneNumber: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorPicContactID: Scalars['UUID']['output'];
};

export type VendorPicContactCreateFromVendorInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  picDepartment: Scalars['String']['input'];
  picEmail: Scalars['String']['input'];
  picName: Scalars['String']['input'];
  picPhoneNumber: Scalars['String']['input'];
};

export type VendorPicContactCreateInput = {
  isActive: Scalars['Boolean']['input'];
  picDepartment: Scalars['String']['input'];
  picEmail: Scalars['String']['input'];
  picName: Scalars['String']['input'];
  picPhoneNumber: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorPicContactPaged = {
  __typename?: 'VendorPicContactPaged';
  items?: Maybe<Array<VendorPicContact>>;
  pagination: PaginationResult;
};

export type VendorPicContactQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  picDepartment?: InputMaybe<Scalars['String']['input']>;
  picEmail?: InputMaybe<Scalars['String']['input']>;
  picName?: InputMaybe<Scalars['String']['input']>;
  picPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorPicContactQopInput = {
  filters?: InputMaybe<VendorPicContactQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorPicContactUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  picDepartment: Scalars['String']['input'];
  picEmail: Scalars['String']['input'];
  picName: Scalars['String']['input'];
  picPhoneNumber: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorPicContactID: Scalars['UUID']['input'];
};

export type VendorQopFilterInput = {
  bankCode?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasPortalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isPKP?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  portalUsername?: InputMaybe<Scalars['String']['input']>;
  provinceName?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  vendorCode?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorQopInput = {
  filters?: InputMaybe<VendorQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorSetPortalAccessActiveInput = {
  isActive: Scalars['Boolean']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorStockExportFilterInput = {
  /** Optional — omit to export the vendor's consignment stock across all cabang. The export is aggregated per cabang (storage warehouse only). */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorStockExportResult = {
  __typename?: 'VendorStockExportResult';
  /** Short-lived signed URL to download the generated .xlsx from object storage. */
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

/**
 * Why a product's system stock reached the figure the opname counted against.
 * Quantities keep the ledger's sign convention: stock in positive, stock out negative,
 * so openingQty plus every line equals closingQty.
 */
export type VendorStockReconciliation = {
  __typename?: 'VendorStockReconciliation';
  /**
   * Penyesuaian stok: every inventory_adjustment — manual correction, waste, system
   *   fix or opening balance. Signed, because an opening balance adds stock. Kept apart
   *   from returnQty: an adjustment filed under "returns" reads as damaged goods that
   *   increased stock. The four subtypes are not separable here — the reason lives in
   *   the transaction service, not on the ledger.
   */
  adjustmentQty: Scalars['Decimal']['output'];
  /** openingQty plus every movement line. */
  closingQty: Scalars['Decimal']['output'];
  countedAt: Scalars['Time']['output'];
  /**
   * False when a ledger document in the window never reached status done, so the
   *   lines cannot be expected to balance. Covers movements that arrived but did not
   *   finish posting; it does not detect movements that never arrived at all.
   */
  ledgerComplete: Scalars['Boolean']['output'];
  /**
   * False when the period's first day has no daily-movement row — history only
   *   starts when the warehouse was configured, and the nightly carry-forward can skip
   *   days. Render "tidak tersedia", never a zero.
   */
  openingBalanceAvailable: Scalars['Boolean']['output'];
  /** Stok awal periode. Meaningless unless openingBalanceAvailable is true. */
  openingQty: Scalars['Decimal']['output'];
  /** Any movement type not covered above, so the lines always add up. */
  otherQty: Scalars['Decimal']['output'];
  periodStart: Scalars['Time']['output'];
  /** Retur / barang rusak — returns to the vendor or to a supplier. Always moves stock out, so this never reads positive. */
  returnQty: Scalars['Decimal']['output'];
  /** Terjual di kasir. */
  soldQty: Scalars['Decimal']['output'];
  /** Stok in diterima. */
  stockInQty: Scalars['Decimal']['output'];
  /** Stock out — transfers and deliveries out of this warehouse. */
  stockOutQty: Scalars['Decimal']['output'];
};

/**
 * Scopes the stock reconciliation behind one product on the vendor portal's stock
 * opname detail page. The window runs from periodStart to the instant of the count —
 * movements made after the physical count are not part of what it explains.
 */
export type VendorStockReconciliationFilterInput = {
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  /** The opname's own timestamp. Movements at or after this instant are excluded. */
  countedAt: Scalars['Time']['input'];
  /** Start of the period, typically the first day of the month the opname ran in. */
  periodStart: Scalars['Time']['input'];
  productID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type VendorUpdateAccessInput = {
  portalSuperadminEmail: Scalars['String']['input'];
  portalSuperadminFirstName: Scalars['String']['input'];
  portalSuperadminLastName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorUpdateInput = {
  addressLabel: Scalars['String']['input'];
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  canBeReturned?: InputMaybe<Scalars['Boolean']['input']>;
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  consignmentCommisionFeePerc?: InputMaybe<Scalars['Float']['input']>;
  consignmentPeriodEndDate?: InputMaybe<Scalars['Time']['input']>;
  consignmentPeriodStartDate?: InputMaybe<Scalars['Time']['input']>;
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullAddress: Scalars['String']['input'];
  hasPortalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isPKP?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  npwp: Scalars['String']['input'];
  npwpCompanyName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  portalAccountActivated?: InputMaybe<Scalars['Boolean']['input']>;
  portalSuperadminEmail?: InputMaybe<Scalars['String']['input']>;
  portalSuperadminFirstName?: InputMaybe<Scalars['String']['input']>;
  portalSuperadminLastName?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
  taxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  taxpayerIDNumber: Scalars['String']['input'];
  vendorCategoryID: Scalars['UUID']['input'];
  vendorCode: Scalars['String']['input'];
  vendorConsignmentBranches?: InputMaybe<Array<VendorConsignmentBranchInput>>;
  vendorID: Scalars['UUID']['input'];
  vendorName: Scalars['String']['input'];
  vendorPicContacts?: InputMaybe<Array<VendorPicContactCreateFromVendorInput>>;
  version: Scalars['UUID']['input'];
};

export type Village = {
  __typename?: 'Village';
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  postalCode: Scalars['String']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  subdistrict?: Maybe<Subdistrict>;
  subdistrictID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  villageID: Scalars['String']['output'];
  villageName: Scalars['String']['output'];
};

export type VillageCreateInput = {
  cityID: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  villageID: Scalars['String']['input'];
  villageName: Scalars['String']['input'];
};

export type VillagePaged = {
  __typename?: 'VillagePaged';
  items?: Maybe<Array<Village>>;
  pagination: PaginationResult;
};

export type VillageQopFilterInput = {
  cityID?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  villageName?: InputMaybe<Scalars['String']['input']>;
};

export type VillageQopInput = {
  filters?: InputMaybe<VillageQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VillageUpdateInput = {
  cityID: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  villageID: Scalars['String']['input'];
  villageName: Scalars['String']['input'];
};

export type Voucher = {
  __typename?: 'Voucher';
  autoGenerateAllVouchers: Scalars['Boolean']['output'];
  canBeUsedWithOthers: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['Time']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiredAfterDays: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  issuedCount: Scalars['Int']['output'];
  maxNumberOfVouchers: Scalars['Int']['output'];
  membersOnly: Scalars['Boolean']['output'];
  startDate: Scalars['Time']['output'];
  uniqueKey: Scalars['String']['output'];
  unusedCount: Scalars['Int']['output'];
  usedCount: Scalars['Int']['output'];
  voidCount: Scalars['Int']['output'];
  voucherCategory?: Maybe<VoucherCategory>;
  voucherCategoryID: Scalars['UUID']['output'];
  voucherCategoryName: Scalars['String']['output'];
  voucherCategoryPrefix: Scalars['String']['output'];
  voucherCode: Scalars['String']['output'];
  voucherExpiryType: VoucherExpiryType;
  voucherID: Scalars['UUID']['output'];
  voucherName: Scalars['String']['output'];
  voucherType?: Maybe<VoucherType>;
  voucherValue: Scalars['Float']['output'];
};

export type VoucherCategory = {
  __typename?: 'VoucherCategory';
  entityAuditMetadata: EntityAuditMetadata;
  expenseAccountCode: Scalars['String']['output'];
  expenseAccountErpRefID?: Maybe<Scalars['String']['output']>;
  expenseAccountErpRefName?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  prefix: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  uniqueKey2: Scalars['String']['output'];
  voucherCategoryID: Scalars['UUID']['output'];
  voucherCategoryName: Scalars['String']['output'];
  voucherType?: Maybe<VoucherType>;
};

export type VoucherCategoryCreateInput = {
  expenseAccountCode: Scalars['String']['input'];
  expenseAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  prefix: Scalars['String']['input'];
  voucherCategoryName: Scalars['String']['input'];
  voucherType: VoucherType;
};

export type VoucherCategoryPaged = {
  __typename?: 'VoucherCategoryPaged';
  items?: Maybe<Array<VoucherCategory>>;
  pagination: PaginationResult;
};

export type VoucherCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  voucherCategoryName?: InputMaybe<Scalars['String']['input']>;
  voucherType?: InputMaybe<VoucherType>;
};

export type VoucherCategoryQopInput = {
  filters?: InputMaybe<VoucherCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VoucherCategoryUpdateInput = {
  expenseAccountCode: Scalars['String']['input'];
  expenseAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  prefix: Scalars['String']['input'];
  voucherCategoryID: Scalars['UUID']['input'];
  voucherCategoryName: Scalars['String']['input'];
  voucherType: VoucherType;
};

export type VoucherCreateInput = {
  autoGenerateAllVouchers: Scalars['Boolean']['input'];
  canBeUsedWithOthers: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  endDate: Scalars['Time']['input'];
  expiredAfterDays: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  maxNumberOfVouchers: Scalars['Int']['input'];
  membersOnly: Scalars['Boolean']['input'];
  startDate: Scalars['Time']['input'];
  voucherCategoryID: Scalars['UUID']['input'];
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  voucherExpiryType: VoucherExpiryType;
  voucherName: Scalars['String']['input'];
  voucherValue: Scalars['Float']['input'];
};

export enum VoucherExpiryType {
  DaysFromIssuedDate = 'days_from_issued_date',
  EndDate = 'end_date'
}

export type VoucherItem = {
  __typename?: 'VoucherItem';
  customer?: Maybe<Customer>;
  customerCode: Scalars['String']['output'];
  customerID?: Maybe<Scalars['UUID']['output']>;
  customerName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  isVoid: Scalars['Boolean']['output'];
  issuedTimeUTC: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  usedOnTransactionID?: Maybe<Scalars['UUID']['output']>;
  usedOnTransactionNo: Scalars['String']['output'];
  usedTime?: Maybe<Scalars['Time']['output']>;
  usedTimeUTC?: Maybe<Scalars['Time']['output']>;
  voucher?: Maybe<Voucher>;
  voucherCode: Scalars['String']['output'];
  voucherID: Scalars['UUID']['output'];
  voucherItemCode: Scalars['String']['output'];
  voucherItemID: Scalars['UUID']['output'];
  voucherValue: Scalars['Float']['output'];
};

export type VoucherItemGenerateInput = {
  count: Scalars['Int']['input'];
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  voucherID: Scalars['UUID']['input'];
};

export type VoucherItemImportInput = {
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  expiryDate: Scalars['Time']['input'];
  issuedTimeUTC: Scalars['Time']['input'];
  voucherID: Scalars['UUID']['input'];
  voucherItemCode: Scalars['String']['input'];
};

export type VoucherItemPaged = {
  __typename?: 'VoucherItemPaged';
  items?: Maybe<Array<VoucherItem>>;
  pagination: PaginationResult;
};

export type VoucherItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  isVoid?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  voucherID?: InputMaybe<Scalars['UUID']['input']>;
  voucherItemCode?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherItemQopInput = {
  filters?: InputMaybe<VoucherItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VoucherPaged = {
  __typename?: 'VoucherPaged';
  items?: Maybe<Array<Voucher>>;
  pagination: PaginationResult;
};

export type VoucherQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  membersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  voucherCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  voucherExpiryType?: InputMaybe<VoucherExpiryType>;
  voucherID?: InputMaybe<Scalars['UUID']['input']>;
  voucherName?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherQopInput = {
  filters?: InputMaybe<VoucherQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export enum VoucherType {
  External = 'external',
  Internal = 'internal'
}

export type VoucherUpdateInput = {
  autoGenerateAllVouchers: Scalars['Boolean']['input'];
  canBeUsedWithOthers: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  endDate: Scalars['Time']['input'];
  expiredAfterDays: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  maxNumberOfVouchers: Scalars['Int']['input'];
  membersOnly: Scalars['Boolean']['input'];
  startDate: Scalars['Time']['input'];
  voucherCategoryID: Scalars['UUID']['input'];
  voucherExpiryType: VoucherExpiryType;
  voucherID: Scalars['UUID']['input'];
  voucherName: Scalars['String']['input'];
  voucherValue: Scalars['Float']['input'];
};

export type Warehouse = {
  __typename?: 'Warehouse';
  addressLabel: Scalars['String']['output'];
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  erpRefID?: Maybe<Scalars['String']['output']>;
  erpRefName?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  postalCode: Scalars['String']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  subdistrict?: Maybe<Subdistrict>;
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  warehouseCode: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseName: Scalars['String']['output'];
  warehouseType: Scalars['String']['output'];
};

export type WarehouseCreateInput = {
  addressLabel: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  cityID?: InputMaybe<Scalars['String']['input']>;
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID: Scalars['String']['input'];
  warehouseCode: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  warehouseType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocation = {
  __typename?: 'WarehouseLocation';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isHoldInventory: Scalars['Boolean']['output'];
  isSystemGenerated?: Maybe<Scalars['Boolean']['output']>;
  parentWarehouseLocation?: Maybe<WarehouseLocation>;
  parentWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  uniqueKey: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationGroup?: Maybe<WarehouseLocationGroup>;
  warehouseLocationGroupID?: Maybe<Scalars['UUID']['output']>;
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
  warehouseLocationType: Scalars['String']['output'];
  warehouseStorageType?: Maybe<Scalars['String']['output']>;
};

export type WarehouseLocationBulkCreateInput = {
  digit: Scalars['Int']['input'];
  endingNumber: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  isHoldInventory: Scalars['Boolean']['input'];
  parentWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  prefix: Scalars['String']['input'];
  startingNumber: Scalars['Int']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationGroupID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationType?: InputMaybe<Scalars['String']['input']>;
  warehouseStorageType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocationCreateInput = {
  isActive: Scalars['Boolean']['input'];
  isHoldInventory: Scalars['Boolean']['input'];
  parentWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationGroupID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationName: Scalars['String']['input'];
  warehouseLocationType?: InputMaybe<Scalars['String']['input']>;
  warehouseStorageType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocationGroup = {
  __typename?: 'WarehouseLocationGroup';
  entityAuditMetadata: EntityAuditMetadata;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  uniqueKey: Scalars['String']['output'];
  warehouseLocationGroupID: Scalars['UUID']['output'];
  warehouseLocationGroupName: Scalars['String']['output'];
};

export type WarehouseLocationGroupCreateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationGroupName: Scalars['String']['input'];
};

export type WarehouseLocationGroupPaged = {
  __typename?: 'WarehouseLocationGroupPaged';
  items?: Maybe<Array<WarehouseLocationGroup>>;
  pagination: PaginationResult;
};

export type WarehouseLocationGroupQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseLocationGroupName?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocationGroupQopInput = {
  filters?: InputMaybe<WarehouseLocationGroupQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseLocationGroupUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationGroupID: Scalars['UUID']['input'];
  warehouseLocationGroupName: Scalars['String']['input'];
};

export type WarehouseLocationPaged = {
  __typename?: 'WarehouseLocationPaged';
  items?: Maybe<Array<WarehouseLocation>>;
  pagination: PaginationResult;
};

export type WarehouseLocationQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isHoldInventory?: InputMaybe<Scalars['Boolean']['input']>;
  parentWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationGroupID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationName?: InputMaybe<Scalars['String']['input']>;
  warehouseLocationType?: InputMaybe<Scalars['String']['input']>;
  warehouseLocationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseStorageType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocationQopInput = {
  filters?: InputMaybe<WarehouseLocationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseLocationRelationMap = {
  __typename?: 'WarehouseLocationRelationMap';
  entityAuditMetadata: EntityAuditMetadata;
  uniqueKey: Scalars['String']['output'];
  warehouseLocationChildID: Scalars['UUID']['output'];
  warehouseLocationParentID: Scalars['UUID']['output'];
};

export type WarehouseLocationRelationMapCreateInput = {
  warehouseLocationChildID: Scalars['UUID']['input'];
  warehouseLocationParentID: Scalars['UUID']['input'];
};

export type WarehouseLocationRelationMapDeleteInput = {
  warehouseLocationChildID: Scalars['UUID']['input'];
  warehouseLocationParentID: Scalars['UUID']['input'];
};

export type WarehouseLocationRelationMapPaged = {
  __typename?: 'WarehouseLocationRelationMapPaged';
  items?: Maybe<Array<WarehouseLocationRelationMap>>;
  pagination: PaginationResult;
};

export type WarehouseLocationRelationMapQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseLocationChildID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationParentID?: InputMaybe<Scalars['UUID']['input']>;
};

export type WarehouseLocationRelationMapQopInput = {
  filters?: InputMaybe<WarehouseLocationRelationMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseLocationRelationMapUpdateInput = {
  warehouseLocationChildID: Scalars['UUID']['input'];
  warehouseLocationParentID: Scalars['UUID']['input'];
};

export type WarehouseLocationUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  isHoldInventory: Scalars['Boolean']['input'];
  parentWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationGroupID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID: Scalars['UUID']['input'];
  warehouseLocationName: Scalars['String']['input'];
  warehouseLocationType?: InputMaybe<Scalars['String']['input']>;
  warehouseStorageType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehousePaged = {
  __typename?: 'WarehousePaged';
  items?: Maybe<Array<Warehouse>>;
  pagination: PaginationResult;
};

export type WarehouseProductLocationMap = {
  __typename?: 'WarehouseProductLocationMap';
  entityAuditMetadata: EntityAuditMetadata;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  product: Product;
  productCategory?: Maybe<ProductCategory>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  warehouseCode: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
  warehouseName: Scalars['String']['output'];
  warehouseProductLocationMapID: Scalars['UUID']['output'];
};

export type WarehouseProductLocationMapCreateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type WarehouseProductLocationMapPaged = {
  __typename?: 'WarehouseProductLocationMapPaged';
  items?: Maybe<Array<WarehouseProductLocationMap>>;
  pagination: PaginationResult;
};

export type WarehouseProductLocationMapQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productSubDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type WarehouseProductLocationMapQopInput = {
  filters?: InputMaybe<WarehouseProductLocationMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseProductLocationMapUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationID: Scalars['UUID']['input'];
  warehouseProductLocationMapID: Scalars['UUID']['input'];
};

export type WarehouseQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  branchType?: InputMaybe<Scalars['String']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseCode?: InputMaybe<Scalars['String']['input']>;
  warehouseName?: InputMaybe<Scalars['String']['input']>;
  warehouseType?: InputMaybe<Scalars['String']['input']>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WarehouseQopInput = {
  filters?: InputMaybe<WarehouseQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseReplenishmentTemplate = {
  __typename?: 'WarehouseReplenishmentTemplate';
  entityAuditMetadata: EntityAuditMetadata;
  replenishmentTemplateID: Scalars['UUID']['output'];
  replenishmentTemplateName: Scalars['String']['output'];
  warehouseCode: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseName: Scalars['String']['output'];
  warehouseReplenishmentTemplateID: Scalars['UUID']['output'];
};

export type WarehouseReplenishmentTemplateCreateBulkInput = {
  replenishmentTemplateIDs: Array<Scalars['UUID']['input']>;
  warehouseID: Scalars['UUID']['input'];
};

export type WarehouseReplenishmentTemplateCreateInput = {
  replenishmentTemplateID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type WarehouseReplenishmentTemplatePaged = {
  __typename?: 'WarehouseReplenishmentTemplatePaged';
  items?: Maybe<Array<WarehouseReplenishmentTemplate>>;
  pagination: PaginationResult;
};

export type WarehouseReplenishmentTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentTemplateName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type WarehouseReplenishmentTemplateQopInput = {
  filters?: InputMaybe<WarehouseReplenishmentTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseUpdateInput = {
  addressLabel: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  cityID?: InputMaybe<Scalars['String']['input']>;
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID: Scalars['String']['input'];
  warehouseCode: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseName: Scalars['String']['input'];
  warehouseType?: InputMaybe<Scalars['String']['input']>;
};


export const AuthLoginDocument = gql`
    mutation AuthLogin($input: LoginInput!) {
  authLogin(input: $input) {
    accessToken
    refreshToken
    user {
      userID
      fullName
      email
      phoneNumber
      employeeID
      vendorID
    }
    defaultBranchID
    defaultBranchCode
    defaultBranchName
    defaultRoleName
    defaultWarehouseID
    defaultWarehouseName
    isAllBranches
    branches {
      branchID
      branchCode
      branchName
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
    }
    appRolePermissions {
      appID
      appName
      roles {
        resourceID
        resourceName
        permissions {
          permissionID
          permissionName
        }
      }
    }
  }
}
    `;

export function useAuthLoginMutation() {
  return Urql.useMutation<AuthLoginMutation, AuthLoginMutationVariables>(AuthLoginDocument);
};
export const AuthLoginVendorDocument = gql`
    mutation AuthLoginVendor($input: LoginInput!) {
  authLoginVendor(input: $input) {
    accessToken
    refreshToken
    user {
      userID
      fullName
      email
      phoneNumber
      employeeID
      vendorID
    }
    defaultBranchID
    defaultBranchCode
    defaultBranchName
    defaultRoleName
    defaultWarehouseID
    defaultWarehouseName
    isAllBranches
    branches {
      branchID
      branchCode
      branchName
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
    }
    appRolePermissions {
      appID
      appName
      roles {
        resourceID
        resourceName
        permissions {
          permissionID
          permissionName
        }
      }
    }
  }
}
    `;

export function useAuthLoginVendorMutation() {
  return Urql.useMutation<AuthLoginVendorMutation, AuthLoginVendorMutationVariables>(AuthLoginVendorDocument);
};
export const AuthRefreshTokenDocument = gql`
    mutation AuthRefreshToken($refreshToken: String!) {
  authRefreshToken(refreshToken: $refreshToken) {
    accessToken
    refreshToken
    user {
      userID
      fullName
      email
      phoneNumber
      employeeID
      vendorID
    }
    defaultBranchID
    defaultBranchCode
    defaultBranchName
    defaultRoleName
    defaultWarehouseID
    defaultWarehouseName
    isAllBranches
    branches {
      branchID
      branchCode
      branchName
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
    }
    appRolePermissions {
      appID
      appName
      roles {
        resourceID
        resourceName
        permissions {
          permissionID
          permissionName
        }
      }
    }
  }
}
    `;

export function useAuthRefreshTokenMutation() {
  return Urql.useMutation<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>(AuthRefreshTokenDocument);
};
export const AuthSetDefaultBranchDocument = gql`
    mutation AuthSetDefaultBranch($input: SetDefaultBranchInput!) {
  authSetDefaultBranch(input: $input) {
    accessToken
    refreshToken
    isAllBranches
    defaultBranchID
    defaultBranchCode
    defaultBranchName
    defaultWarehouseID
    defaultWarehouseName
    defaultRoleID
    defaultRoleName
    defaultRoleAppID
    defaultRoleAppName
    branches {
      branchID
      branchCode
      branchName
    }
    appRoles {
      roleID
      roleName
      appID
      appName
    }
    appRolePermissions {
      appID
      appName
    }
  }
}
    `;

export function useAuthSetDefaultBranchMutation() {
  return Urql.useMutation<AuthSetDefaultBranchMutation, AuthSetDefaultBranchMutationVariables>(AuthSetDefaultBranchDocument);
};
export const GenerateLinkResetPasswordDocument = gql`
    mutation GenerateLinkResetPassword($input: GenerateLinkResetPasswordInput!) {
  generateLinkResetPassword(input: $input) {
    success
    nextRetryDelay
    nextSessionDelay
    remainingAttempts
  }
}
    `;

export function useGenerateLinkResetPasswordMutation() {
  return Urql.useMutation<GenerateLinkResetPasswordMutation, GenerateLinkResetPasswordMutationVariables>(GenerateLinkResetPasswordDocument);
};
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const BranchAutocompleteDocument = gql`
    query BranchAutocomplete($qop: BranchQopInput) {
  branches(qop: $qop) {
    items {
      branchID
      branchName
      branchCode
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useBranchAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<BranchAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchAutocompleteQuery, BranchAutocompleteQueryVariables>({ query: BranchAutocompleteDocument, ...options });
};
export const BranchCreateDocument = gql`
    mutation BranchCreate($input: BranchCreateInput!) {
  branchCreate(input: $input) {
    branchID
    branchCode
    branchName
    branchType
    branchCategoryID
    pricelistID
    mainSupplyWarehouseID
    gmt
    canSell
    isMain
    cashJournalAccountCode
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
    country {
      countryID
      countryName
      uniqueKey
      isActive
    }
    province {
      provinceID
      provinceName
      countryID
      uniqueKey
      isActive
    }
    city {
      cityID
      cityName
      gmt
      provinceID
      countryID
      uniqueKey
      isActive
    }
    subdistrict {
      subdistrictID
      subdistrictName
      cityID
      provinceID
      countryID
      uniqueKey
      isActive
    }
  }
}
    `;

export function useBranchCreateMutation() {
  return Urql.useMutation<BranchCreateMutation, BranchCreateMutationVariables>(BranchCreateDocument);
};
export const BranchDeleteDocument = gql`
    mutation branchDelete($branchID: UUID!) {
  branchDelete(branchID: $branchID)
}
    `;

export function useBranchDeleteMutation() {
  return Urql.useMutation<BranchDeleteMutation, BranchDeleteMutationVariables>(BranchDeleteDocument);
};
export const BranchListDocument = gql`
    query branchList($qop: BranchQopInput) {
  branches(qop: $qop) {
    items {
      branchID
      branchCode
      branchName
      branchType
      branchCategoryID
      pricelistID
      productAvailabilityTemplateID
      mainSupplyWarehouseID
      gmt
      picName
      picPhoneNumber
      canSell
      isMain
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
      branchCategory {
        branchCategoryName
      }
      pricelist {
        pricelistId
        pricelistCode
        pricelistName
        isActive
        uniqueKey
      }
      productAvailabilityTemplate {
        productAvailabilityTemplateID
        productAvailabilityTemplateName
        isActive
        uniqueKey
      }
      mainSupplyWarehouse {
        warehouseID
        warehouseCode
        warehouseName
        branchID
        addressLabel
        fullAddress
        countryID
        countryName
        provinceID
        provinceName
        cityID
        cityName
        subdistrictID
        subdistrictName
        postalCode
        longitude
        latitude
        uniqueKey
        isActive
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useBranchListQuery(options?: Omit<Urql.UseQueryArgs<BranchListQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchListQuery, BranchListQueryVariables>({ query: BranchListDocument, ...options });
};
export const BranchLoadDocument = gql`
    query BranchLoad($branchID: UUID!) {
  branch(branchID: $branchID) {
    branchID
    branchCode
    branchName
    branchType
    branchCategoryID
    pricelistID
    productAvailabilityTemplateID
    mainSupplyWarehouseID
    gmt
    picName
    picPhoneNumber
    canSell
    isMain
    cashJournalAccountCode
    cashJournalAccountErpRefID
    cashJournalAccountErpRefName
    pettyCashJournalAccountCode
    pettyCashJournalAccountErpRefID
    pettyCashJournalAccountErpRefName
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
    branchStoreSupervisors {
      branchStoreSupervisorID
      user {
        fullName
      }
      userID
    }
    branchCategory {
      branchCategoryName
    }
    pricelist {
      pricelistId
      pricelistCode
      pricelistName
      isActive
      uniqueKey
    }
    productAvailabilityTemplate {
      productAvailabilityTemplateID
      productAvailabilityTemplateName
      isActive
      uniqueKey
    }
    mainSupplyWarehouse {
      warehouseID
      warehouseCode
      warehouseName
      branchID
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
    country {
      countryID
      countryName
      uniqueKey
      isActive
    }
    province {
      provinceID
      provinceName
      countryID
      uniqueKey
      isActive
    }
    city {
      cityID
      cityName
      gmt
      provinceID
      countryID
      uniqueKey
      isActive
    }
    subdistrict {
      subdistrictID
      subdistrictName
      cityID
      provinceID
      countryID
      uniqueKey
      isActive
    }
    branchSalesPaymentMethods {
      branchSalesPaymentMethodID
      branchID
      paymentMethodID
      uniqueKey
      paymentMethod {
        salesPaymentMethodID
        salesPaymentMethodName
        salesPaymentMethodTypeID
        salesPaymentMethodTypeCode
        uniqueKey
        isActive
      }
    }
    branchPosBookmarks {
      branchPosBookmarkID
      branchID
      posBookmarkID
      uniqueKey
      posBookmark {
        posBookmarkID
        posBookmarkName
        uniqueKey
      }
    }
    edcTerminals {
      edcTerminalID
      edcTerminalName
      serialNumber
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useBranchLoadQuery(options: Omit<Urql.UseQueryArgs<BranchLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchLoadQuery, BranchLoadQueryVariables>({ query: BranchLoadDocument, ...options });
};
export const BranchStoreSupervisorAutocompleteDocument = gql`
    query BranchStoreSupervisorAutocomplete($qop: BranchStoreSupervisorQopInput!) {
  branchStoreSupervisors(qop: $qop) {
    items {
      branchStoreSupervisorID
      branchID
      userID
      user {
        fullName
      }
      uniqueKey
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useBranchStoreSupervisorAutocompleteQuery(options: Omit<Urql.UseQueryArgs<BranchStoreSupervisorAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchStoreSupervisorAutocompleteQuery, BranchStoreSupervisorAutocompleteQueryVariables>({ query: BranchStoreSupervisorAutocompleteDocument, ...options });
};
export const BranchUpdateDocument = gql`
    mutation BranchUpdate($input: BranchUpdateInput!) {
  branchUpdate(input: $input) {
    branchID
    branchCode
    branchName
    branchType
    branchCategoryID
    pricelistID
    mainSupplyWarehouseID
    gmt
    canSell
    isMain
    cashJournalAccountCode
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
  }
}
    `;

export function useBranchUpdateMutation() {
  return Urql.useMutation<BranchUpdateMutation, BranchUpdateMutationVariables>(BranchUpdateDocument);
};
export const ProductAutocompleteDocument = gql`
    query ProductAutocomplete($qop: ProductQopInput) {
  products(qop: $qop) {
    items {
      productID
      productCode
      productName
      barcode
      uomCategoryID
      sellingPrice
      purchaseCost
      baseUom {
        uomID
        uomName
      }
      purchaseUom {
        uomID
        uomName
      }
      purchaseTax {
        taxID
        taxCode
        taxName
        taxType
        taxRate
        uniqueKey
        isActive
      }
      canBePurchased
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ProductAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAutocompleteQuery, ProductAutocompleteQueryVariables>({ query: ProductAutocompleteDocument, ...options });
};
export const ProductCreateDocument = gql`
    mutation ProductCreate($input: ProductCreateInput!) {
  productCreate(input: $input) {
    productID
    productCode
    productName
    productNameAlias
    productType
    barcode
    altBarcode1
    altBarcode2
    uomCategoryID
    baseUomID
    description
    productBrandID
    productSourceID
    productCategoryID
    productSubCategoryID
    pricelistProducts {
      pricelistProductID
      pricelistPeriodID
      pricelistID
      productID
      sellingPrice
      salesChannelPrice
      uniqueKey
      pricelistPeriod {
        pricelistPeriodID
        pricelistPeriodName
        pricelistID
        effectiveStartDate
        effectiveEndDate
        effectiveStartHour
        effectiveEndHour
        effectiveStartMinute
        effectiveEndMinute
        useTime
        priority
        isActive
        uniqueKey
      }
    }
    mainImageFileID
    mainImageFileSmallPathURL
    mainImageFileMediumPathURL
    mainImageFileLargePathURL
    isConsignment
    consignmentVendorID
    trackExpiredDate
    isProduced
    weight
    volumeLength
    volumeHeight
    volumeWidth
    canBePurchased
    purchaseCost
    minimumOrder
    purchaseUomID
    purchaseTaxID
    canBeSold
    salesUomID
    salesTaxID
    salesScanType
    uniqueKey
    isActive
  }
}
    `;

export function useProductCreateMutation() {
  return Urql.useMutation<ProductCreateMutation, ProductCreateMutationVariables>(ProductCreateDocument);
};
export const ProductDeleteDocument = gql`
    mutation ProductDelete($productID: UUID!) {
  productDelete(productID: $productID)
}
    `;

export function useProductDeleteMutation() {
  return Urql.useMutation<ProductDeleteMutation, ProductDeleteMutationVariables>(ProductDeleteDocument);
};
export const ProductListDocument = gql`
    query ProductList($qop: ProductQopInput) {
  products(qop: $qop) {
    items {
      productID
      productCode
      productName
      productNameAlias
      productType
      barcode
      altBarcode1
      altBarcode2
      uomCategoryID
      baseUomID
      description
      productBrandID
      productSourceID
      productCategoryID
      productSubCategoryID
      mainImageFileID
      mainImageFileSmallPathURL
      mainImageFileMediumPathURL
      mainImageFileLargePathURL
      isConsignment
      consignmentVendorID
      uniqueKey
      trackExpiredDate
      isProduced
      weight
      volumeLength
      volumeHeight
      volumeWidth
      canBePurchased
      purchaseCost
      productBarcodeMaps {
        productBarcodeMapID
      }
      minimumOrder
      purchaseUomID
      purchaseTaxID
      canBeSold
      salesUomID
      salesTaxID
      salesScanType
      uniqueKey
      isActive
      consignmentVendor {
        vendorName
      }
      baseUom {
        uomID
        uomCategoryID
        uomName
        relationType
        convertionRate
        convertionDecimal
        isMain
        uniqueKey
        uniqueKey2
        isActive
      }
      productBrand {
        productBrandID
        productBrandName
        uniqueKey
        isActive
      }
      productSource {
        productSourceID
        productSourceCode
        productSourceName
        uniqueKey
        isActive
      }
      pricelistProducts {
        pricelistProductID
        sellingPrice
        pricelistPeriod {
          pricelistPeriodName
          pricelist {
            pricelistName
          }
        }
      }
      productCategory {
        productCategoryID
        productCategoryName
        productCategoryFullName
        productSubDepartmentID
        productSubDepartmentName
        productDepartmentID
        productDepartmentName
        productDivisionID
        productDivisionName
        uniqueKey
        isActive
      }
      productSubCategory {
        productSubCategoryID
        productSubCategoryName
        productCategoryID
        uniqueKey
        isActive
      }
      purchaseTax {
        taxID
        taxCode
        taxName
        taxRate
        uniqueKey
        isActive
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductListQuery(options?: Omit<Urql.UseQueryArgs<ProductListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductListQuery, ProductListQueryVariables>({ query: ProductListDocument, ...options });
};
export const ProductLoadDocument = gql`
    query ProductLoad($productID: UUID!) {
  product(productID: $productID) {
    productID
    productCode
    productName
    productNameAlias
    productType
    barcode
    altBarcode1
    altBarcode2
    uomCategoryID
    baseUomID
    description
    productBrandID
    productSourceID
    productCategoryID
    productSubCategoryID
    mainImageFileID
    mainImageFileSmallPathURL
    mainImageFileMediumPathURL
    mainImageFileLargePathURL
    isConsignment
    consignmentVendorID
    trackExpiredDate
    isProduced
    weight
    volumeLength
    volumeHeight
    volumeWidth
    canBePurchased
    purchaseCost
    minimumOrder
    purchaseUomID
    purchaseTaxID
    canBeSold
    sellingPrice
    salesUomID
    salesTaxID
    salesScanType
    countryID
    country {
      countryName
    }
    productAccountingCategoryID
    productAccountingCategory {
      productAccountingCategoryID
      productAccountingCategoryName
    }
    productAccountingCategoryErpRefID
    productAccountingCategoryErpRefName
    hasAddon
    addonGroupID
    addonGroup {
      productAddonGroupID
      name
    }
    consignmentVendor {
      vendorName
      vendorConsignmentBranch {
        branchID
        branchCode
        branchName
      }
      vendorConsignmentProducts {
        vendorConsignmentProductID
        sellingPrice
        commissionFeePerc
        productCommissionFeePerc
        branchID
        productID
        isActive
        entityAuditMetadata {
          version
        }
      }
    }
    pricelistProducts {
      pricelistProductID
      sellingPrice
      pricelistPeriod {
        pricelistPeriodID
        pricelistPeriodName
        pricelist {
          pricelistId
          pricelistName
        }
      }
    }
    uniqueKey
    isActive
    uomCategory {
      uomCategoryName
    }
    baseUom {
      uomID
      uomCategoryID
      uomCategory {
        uomCategoryID
        uomCategoryName
      }
      uomName
      relationType
      convertionRate
      convertionRateMultiplier
      convertionDecimal
      isMain
      uniqueKey
      uniqueKey2
      isActive
    }
    productBrand {
      productBrandID
      productBrandName
      uniqueKey
      isActive
    }
    productSource {
      productSourceID
      productSourceCode
      productSourceName
      uniqueKey
      isActive
    }
    productVendors {
      productVendorID
      productId
      vendorId
      purchasePrice
      minimumOrder
      canBeReturned
      uniqueKey
      isActive
      discountType
      discountPerc
      discountPercPlus
      discountAmount
    }
    productCategory {
      productCategoryID
      productCategoryName
      productCategoryFullName
      productSubDepartmentID
      productSubDepartmentName
      productDepartmentID
      productDepartmentName
      productDivisionID
      productDivisionName
      uniqueKey
      isActive
    }
    productSubCategory {
      productSubCategoryID
      productSubCategoryName
      productCategoryID
      uniqueKey
      isActive
    }
    productFiles {
      productFileID
      productID
      productFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    productAIImages {
      productAIImageID
      productID
      aiImageType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    purchaseUom {
      uomID
      uomCategoryID
      uomName
      relationType
      convertionRate
      convertionRateMultiplier
      convertionDecimal
      isMain
      uniqueKey
      uniqueKey2
      isActive
    }
    purchaseTax {
      taxID
      taxCode
      taxName
      taxRate
      uniqueKey
      isActive
    }
    salesUom {
      uomID
      uomCategoryID
      uomName
      relationType
      convertionRate
      convertionRateMultiplier
      convertionDecimal
      isMain
      uniqueKey
      uniqueKey2
      isActive
    }
    salesTax {
      taxID
      taxCode
      taxName
      taxRate
      uniqueKey
      isActive
    }
    productBarcodeMaps {
      productBarcodeMapID
      productID
      barcode
      uniqueKey
      isActive
    }
    productAvailabilityTemplateItems {
      productAvailabilityTemplateItemID
      productAvailabilityTemplateID
      productID
      uniqueKey
      isActive
      productAvailabilityTemplate {
        productAvailabilityTemplateID
        productAvailabilityTemplateName
        isActive
        uniqueKey
      }
    }
    productBundleComponents {
      productBundleComponentID
      productID
      componentProductID
      qty
      uomCategoryID
      uomID
      uniqueKey
      isActive
      componentProduct {
        productID
        productCode
        productName
        productNameAlias
        productType
        barcode
        altBarcode1
        altBarcode2
        uomCategoryID
        baseUomID
        description
        productBrandID
        productSourceID
        productCategoryID
        productSubCategoryID
        mainImageFileID
        mainImageFileSmallPathURL
        mainImageFileMediumPathURL
        mainImageFileLargePathURL
        isConsignment
        consignmentVendorID
        trackExpiredDate
        isProduced
        weight
        volumeLength
        volumeHeight
        volumeWidth
        canBePurchased
        purchaseCost
        minimumOrder
        purchaseUomID
        purchaseTaxID
        canBeSold
        salesUomID
        salesTaxID
        salesScanType
        uniqueKey
        isActive
      }
      uom {
        uomID
        uomCategoryID
        uomName
        relationType
        convertionRate
        convertionRateMultiplier
        convertionDecimal
        isMain
        uniqueKey
        uniqueKey2
        isActive
      }
    }
    productTagProducts {
      productTagProductID
      productTagID
      productID
      productTag {
        productTagName
      }
      uniqueKey
    }
    productVendors {
      productVendorID
      productId
      vendorId
      purchasePrice
      minimumOrder
      canBeReturned
      uniqueKey
      isActive
      vendor {
        vendorID
        vendorCode
        vendorName
        vendorCategoryID
        email
        phoneNumber
        npwp
        npwpCompanyName
        taxpayerIDNumber
        addressLabel
        fullAddress
        countryID
        countryName
        provinceID
        provinceName
        cityID
        cityName
        subdistrictID
        subdistrictName
        postalCode
        longitude
        latitude
        taxable
        taxIncluded
        canBeReturned
        isConsignment
        consignmentCommisionFeePerc
        consignmentPeriodStartDate
        consignmentPeriodEndDate
        hasPortalAccess
        portalSuperadminFirstName
        portalSuperadminLastName
        portalSuperadminEmail
        portalAccountActivated
        uniqueKey
        isActive
      }
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductLoadQuery(options: Omit<Urql.UseQueryArgs<ProductLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductLoadQuery, ProductLoadQueryVariables>({ query: ProductLoadDocument, ...options });
};
export const ProductUpdateDocument = gql`
    mutation ProductUpdate($input: ProductUpdateInput!) {
  productUpdate(input: $input) {
    productID
    productCode
    productName
    productNameAlias
    productType
    barcode
    altBarcode1
    altBarcode2
    uomCategoryID
    baseUomID
    description
    productBrandID
    productSourceID
    productCategoryID
    productSubCategoryID
    mainImageFileID
    mainImageFileSmallPathURL
    mainImageFileMediumPathURL
    mainImageFileLargePathURL
    isConsignment
    consignmentVendorID
    trackExpiredDate
    isProduced
    weight
    volumeLength
    volumeHeight
    volumeWidth
    canBePurchased
    purchaseCost
    minimumOrder
    purchaseUomID
    purchaseTaxID
    canBeSold
    salesUomID
    salesTaxID
    salesScanType
    uniqueKey
    isActive
  }
}
    `;

export function useProductUpdateMutation() {
  return Urql.useMutation<ProductUpdateMutation, ProductUpdateMutationVariables>(ProductUpdateDocument);
};
export const ProductVendorCreateDocument = gql`
    mutation ProductVendorCreate($input: ProductVendorCreateInput!) {
  productVendorCreate(input: $input) {
    productVendorID
    productId
    vendorId
    purchasePrice
    minimumOrder
    canBeReturned
    uniqueKey
    isActive
  }
}
    `;

export function useProductVendorCreateMutation() {
  return Urql.useMutation<ProductVendorCreateMutation, ProductVendorCreateMutationVariables>(ProductVendorCreateDocument);
};
export const ProductVendorDeleteDocument = gql`
    mutation ProductVendorDelete($productVendorID: UUID!) {
  productVendorDelete(productVendorID: $productVendorID)
}
    `;

export function useProductVendorDeleteMutation() {
  return Urql.useMutation<ProductVendorDeleteMutation, ProductVendorDeleteMutationVariables>(ProductVendorDeleteDocument);
};
export const ProductVendorListDocument = gql`
    query ProductVendorList($qop: ProductVendorQopInput) {
  productVendors(qop: $qop) {
    items {
      productVendorID
      productId
      vendorId
      purchasePrice
      minimumOrder
      canBeReturned
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductVendorListQuery(options?: Omit<Urql.UseQueryArgs<ProductVendorListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductVendorListQuery, ProductVendorListQueryVariables>({ query: ProductVendorListDocument, ...options });
};
export const ProductVendorLoadDocument = gql`
    query ProductVendorLoad($productVendorID: UUID!) {
  productVendor(productVendorID: $productVendorID) {
    productVendorID
    productId
    vendorId
    purchasePrice
    minimumOrder
    canBeReturned
    uniqueKey
    isActive
    discountType
    discountPerc
    discountPercPlus
    discountAmount
    vendor {
      vendorID
      vendorCode
      vendorName
      vendorCategoryID
      email
      phoneNumber
      npwp
      npwpCompanyName
      taxpayerIDNumber
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      taxable
      taxIncluded
      canBeReturned
      isConsignment
      consignmentCommisionFeePerc
      consignmentPeriodStartDate
      consignmentPeriodEndDate
      hasPortalAccess
      portalSuperadminFirstName
      portalSuperadminLastName
      portalSuperadminEmail
      portalAccountActivated
      uniqueKey
      isActive
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductVendorLoadQuery(options: Omit<Urql.UseQueryArgs<ProductVendorLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductVendorLoadQuery, ProductVendorLoadQueryVariables>({ query: ProductVendorLoadDocument, ...options });
};
export const ProductVendorUpdateDocument = gql`
    mutation ProductVendorUpdate($input: ProductVendorUpdateInput!) {
  productVendorUpdate(input: $input) {
    productVendorID
    productId
    vendorId
    purchasePrice
    minimumOrder
    canBeReturned
    uniqueKey
    isActive
  }
}
    `;

export function useProductVendorUpdateMutation() {
  return Urql.useMutation<ProductVendorUpdateMutation, ProductVendorUpdateMutationVariables>(ProductVendorUpdateDocument);
};
export const VendorAppBranchStockDocument = gql`
    query VendorAppBranchStock($qop: VendorConsignmentStockByBranchQopInput!) {
  vendorConsignmentStockByBranch(qop: $qop) {
    items {
      branchID
      branchName
      productID
      product {
        productID
        productCode
        productName
        barcode
        productType
        isActive
        baseUom {
          uomName
        }
      }
      qty
      qtyCommitted
      qtyRejected
      qtyOnHand
      qtyAvailable
      updatedAt
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppBranchStockQuery(options: Omit<Urql.UseQueryArgs<VendorAppBranchStockQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppBranchStockQuery, VendorAppBranchStockQueryVariables>({ query: VendorAppBranchStockDocument, ...options });
};
export const VendorAppConsignmentProductAutocompleteDocument = gql`
    query VendorAppConsignmentProductAutocomplete($qop: VendorConsignmentProductQopInput) {
  vendorConsignmentProducts(qop: $qop) {
    items {
      productID
      product {
        productID
        productCode
        productName
        barcode
        isActive
        baseUom {
          uomID
          uomName
        }
        purchaseUom {
          uomID
          uomName
        }
      }
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorAppConsignmentProductAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<VendorAppConsignmentProductAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppConsignmentProductAutocompleteQuery, VendorAppConsignmentProductAutocompleteQueryVariables>({ query: VendorAppConsignmentProductAutocompleteDocument, ...options });
};
export const VendorAppConsignmentProductDetailDocument = gql`
    query VendorAppConsignmentProductDetail($qop: VendorConsignmentProductQopInput) {
  vendorConsignmentProducts(qop: $qop) {
    items {
      productID
      product {
        productCode
        productName
        barcode
        sellingPrice
        mainImageFileMediumPathURL
        isActive
      }
      branchPrices {
        vendorConsignmentProductID
        branchID
        branch {
          branchCode
          branchName
        }
        sellingPrice
        commissionFeePerc
        productCommissionFeePerc
        isActive
      }
    }
  }
}
    `;

export function useVendorAppConsignmentProductDetailQuery(options?: Omit<Urql.UseQueryArgs<VendorAppConsignmentProductDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppConsignmentProductDetailQuery, VendorAppConsignmentProductDetailQueryVariables>({ query: VendorAppConsignmentProductDetailDocument, ...options });
};
export const VendorAppConsignmentProductListDocument = gql`
    query VendorAppConsignmentProductList($qop: VendorConsignmentProductQopInput) {
  vendorConsignmentProducts(qop: $qop) {
    items {
      productID
      product {
        productCode
        barcode
        productName
        sellingPrice
        mainImageFileSmallPathURL
        mainImageFileLargePathURL
        isActive
      }
      branchPrices {
        branchID
        sellingPrice
        isActive
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppConsignmentProductListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppConsignmentProductListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppConsignmentProductListQuery, VendorAppConsignmentProductListQueryVariables>({ query: VendorAppConsignmentProductListDocument, ...options });
};
export const VendorAppProductListDocument = gql`
    query VendorAppProductList($qop: ProductQopInput) {
  products(qop: $qop) {
    items {
      productID
      productCode
      productName
      barcode
      productType
      consignmentVendorID
      isActive
      mainImageFileSmallPathURL
      mainImageFileLargePathURL
      baseUom {
        uomName
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppProductListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppProductListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppProductListQuery, VendorAppProductListQueryVariables>({ query: VendorAppProductListDocument, ...options });
};
export const VendorAppProductLoadDocument = gql`
    query VendorAppProductLoad($productID: UUID!) {
  product(productID: $productID) {
    productID
    productCode
    productName
    productNameAlias
    barcode
    altBarcode1
    altBarcode2
    productType
    description
    weight
    volumeLength
    volumeHeight
    volumeWidth
    isConsignment
    consignmentVendorID
    isActive
    mainImageFileSmallPathURL
    mainImageFileMediumPathURL
    mainImageFileLargePathURL
    baseUom {
      uomName
    }
    productBrand {
      productBrandName
    }
    productCategory {
      productCategoryName
    }
    productSubCategory {
      productSubCategoryName
    }
    productFiles {
      productFileID
      imageFileMediumPathURL
    }
  }
}
    `;

export function useVendorAppProductLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppProductLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppProductLoadQuery, VendorAppProductLoadQueryVariables>({ query: VendorAppProductLoadDocument, ...options });
};
export const VendorAppProductsByCodesDocument = gql`
    query VendorAppProductsByCodes($qop: ProductQopInput) {
  products(qop: $qop) {
    items {
      productID
      productCode
      productName
      barcode
      baseUom {
        uomID
        uomName
      }
      purchaseUom {
        uomID
        uomName
      }
    }
  }
}
    `;

export function useVendorAppProductsByCodesQuery(options?: Omit<Urql.UseQueryArgs<VendorAppProductsByCodesQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppProductsByCodesQuery, VendorAppProductsByCodesQueryVariables>({ query: VendorAppProductsByCodesDocument, ...options });
};
export const VendorAppRentalBranchListDocument = gql`
    query VendorAppRentalBranchList($vendorID: UUID!) {
  vendor(vendorID: $vendorID) {
    vendorID
    vendorName
    vendorConsignmentBranch {
      vendorConsignmentBranchID
      branchID
      branchCode
      branchName
      isRent
      rentPrice
      isActive
      currentPeriod {
        vendorConsignmentBranchPeriodID
        effectiveStartDate
        effectiveEndDate
        rentalStatus
      }
    }
  }
}
    `;

export function useVendorAppRentalBranchListQuery(options: Omit<Urql.UseQueryArgs<VendorAppRentalBranchListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppRentalBranchListQuery, VendorAppRentalBranchListQueryVariables>({ query: VendorAppRentalBranchListDocument, ...options });
};
export const VendorAppRentalPaymentCancelDocument = gql`
    mutation VendorAppRentalPaymentCancel($input: VendorConsignmentRentalPaymentCancelInput!) {
  vendorConsignmentRentalPaymentCancel(input: $input) {
    vendorConsignmentRentalPaymentID
    status
  }
}
    `;

export function useVendorAppRentalPaymentCancelMutation() {
  return Urql.useMutation<VendorAppRentalPaymentCancelMutation, VendorAppRentalPaymentCancelMutationVariables>(VendorAppRentalPaymentCancelDocument);
};
export const VendorAppRentalPaymentCreateDocument = gql`
    mutation VendorAppRentalPaymentCreate($input: VendorConsignmentRentalPaymentCreateInput!) {
  vendorConsignmentRentalPaymentCreate(input: $input) {
    vendorConsignmentRentalPaymentID
    status
    rentPriceSnapshot
    rentPeriodDaysSnapshot
    transferAmount
    transferDate
  }
}
    `;

export function useVendorAppRentalPaymentCreateMutation() {
  return Urql.useMutation<VendorAppRentalPaymentCreateMutation, VendorAppRentalPaymentCreateMutationVariables>(VendorAppRentalPaymentCreateDocument);
};
export const VendorAppRentalPaymentListDocument = gql`
    query VendorAppRentalPaymentList($qop: VendorConsignmentRentalPaymentQopInput) {
  vendorConsignmentRentalPayments(qop: $qop) {
    items {
      vendorConsignmentRentalPaymentID
      vendorConsignmentRentalPaymentNumber
      vendorConsignmentBranchID
      vendorID
      vendorName
      branchID
      branchName
      transferAmount
      transferDate
      vendorNote
      rentPriceSnapshot
      rentPeriodDaysSnapshot
      status
      approvedAt
      rejectedReason
      rejectedAt
      files {
        vendorConsignmentRentalPaymentFileID
        vendorConsignmentRentalPaymentFileType
        fileID
        imageFileSmallPathURL
        imageFileMediumPathURL
        imageFileLargePathURL
      }
      entityAuditMetadata {
        createdAt
        updatedAt
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorAppRentalPaymentListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppRentalPaymentListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppRentalPaymentListQuery, VendorAppRentalPaymentListQueryVariables>({ query: VendorAppRentalPaymentListDocument, ...options });
};
export const VendorAppRentalPaymentLoadDocument = gql`
    query VendorAppRentalPaymentLoad($vendorConsignmentRentalPaymentID: UUID!) {
  vendorConsignmentRentalPayment(
    vendorConsignmentRentalPaymentID: $vendorConsignmentRentalPaymentID
  ) {
    vendorConsignmentRentalPaymentID
    vendorConsignmentRentalPaymentNumber
    vendorConsignmentBranchID
    vendorID
    vendorName
    branchID
    branchName
    transferAmount
    transferDate
    vendorNote
    rentPriceSnapshot
    rentPeriodDaysSnapshot
    effectiveStartDate
    effectiveEndDate
    status
    settlementBankName
    settlementBankAccountNumber
    approvedByUserName
    approvedAt
    rejectedReason
    rejectedByUserName
    rejectedAt
    files {
      vendorConsignmentRentalPaymentFileID
      vendorConsignmentRentalPaymentFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
    }
    entityAuditMetadata {
      createdAt
      updatedAt
    }
  }
}
    `;

export function useVendorAppRentalPaymentLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppRentalPaymentLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppRentalPaymentLoadQuery, VendorAppRentalPaymentLoadQueryVariables>({ query: VendorAppRentalPaymentLoadDocument, ...options });
};
export const VendorAppRentalPaymentSubmitDocument = gql`
    mutation VendorAppRentalPaymentSubmit($input: VendorConsignmentRentalPaymentSubmitInput!) {
  vendorConsignmentRentalPaymentSubmit(input: $input) {
    vendorConsignmentRentalPaymentID
    status
  }
}
    `;

export function useVendorAppRentalPaymentSubmitMutation() {
  return Urql.useMutation<VendorAppRentalPaymentSubmitMutation, VendorAppRentalPaymentSubmitMutationVariables>(VendorAppRentalPaymentSubmitDocument);
};
export const VendorAppRentalPaymentUpdateDocument = gql`
    mutation VendorAppRentalPaymentUpdate($input: VendorConsignmentRentalPaymentUpdateInput!) {
  vendorConsignmentRentalPaymentUpdate(input: $input) {
    vendorConsignmentRentalPaymentID
    status
    transferAmount
    transferDate
  }
}
    `;

export function useVendorAppRentalPaymentUpdateMutation() {
  return Urql.useMutation<VendorAppRentalPaymentUpdateMutation, VendorAppRentalPaymentUpdateMutationVariables>(VendorAppRentalPaymentUpdateDocument);
};
export const VendorAppSalesItemsListDocument = gql`
    query VendorAppSalesItemsList($qop: SalesConsignmentInvoiceItemQopInput) {
  salesConsignmentInvoiceItems(qop: $qop) {
    items {
      salesConsignmentInvoiceItemID
      productID
      productCode
      productName
      barcode
      qty
      uomName
      unitPrice
      discountType
      discountPerc
      discountPercPlus
      discountAmount
      additionalDiscountPerc
      additionalDiscountAmount
      commissionAmount
      commissionInclTaxAmount
      taxAmount
      consignmentVendorTotal
      salesInvoiceItem {
        promoType
        promoParentProductID
      }
      salesConsignmentInvoice {
        salesConsignmentInvoiceID
        salesConsignmentInvoiceNumber
        salesConsignmentInvoiceDatetime
        salesConsignmentInvoiceDatetimeUtc
        salesInvoiceID
        salesInvoiceNumber
        consignmentVendorID
        consignmentCommissionFeePerc
        totalItemQty
        subtotal
        discountAmount
        taxAmount
        commissionAmount
        total
        consignmentVendorTotal
        status
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppSalesItemsListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppSalesItemsListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppSalesItemsListQuery, VendorAppSalesItemsListQueryVariables>({ query: VendorAppSalesItemsListDocument, ...options });
};
export const VendorAppSalesListDocument = gql`
    query VendorAppSalesList($qop: SalesConsignmentInvoiceQopInput) {
  salesConsignmentInvoices(qop: $qop) {
    items {
      salesConsignmentInvoiceID
      salesConsignmentInvoiceNumber
      salesConsignmentInvoiceDatetime
      salesConsignmentInvoiceDatetimeUtc
      salesInvoiceID
      salesInvoiceNumber
      consignmentVendorID
      consignmentCommissionFeePerc
      totalItemQty
      subtotal
      discountAmount
      taxAmount
      commissionAmount
      total
      consignmentVendorTotal
      status
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppSalesListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppSalesListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppSalesListQuery, VendorAppSalesListQueryVariables>({ query: VendorAppSalesListDocument, ...options });
};
export const VendorAppSalesLoadDocument = gql`
    query VendorAppSalesLoad($salesConsignmentInvoiceID: UUID!) {
  salesConsignmentInvoice(salesConsignmentInvoiceID: $salesConsignmentInvoiceID) {
    salesConsignmentInvoiceID
    salesConsignmentInvoiceNumber
    salesConsignmentInvoiceDatetime
    salesInvoiceID
    salesInvoiceNumber
    consignmentVendorID
    totalItemQty
    status
  }
}
    `;

export function useVendorAppSalesLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppSalesLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppSalesLoadQuery, VendorAppSalesLoadQueryVariables>({ query: VendorAppSalesLoadDocument, ...options });
};
export const VendorAppStockInItemsListDocument = gql`
    query VendorAppStockInItemsList($qop: ConsignmentStockInItemQopInput) {
  consignmentStockInItems(qop: $qop) {
    items {
      consignmentStockInItemID
      consignmentStockInID
      productID
      productCode
      productName
      description
      qtyReceived
      uomName
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockInItemsListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockInItemsListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInItemsListQuery, VendorAppStockInItemsListQueryVariables>({ query: VendorAppStockInItemsListDocument, ...options });
};
export const VendorAppStockInListDocument = gql`
    query VendorAppStockInList($qop: ConsignmentStockInQopInput) {
  consignmentStockIns(qop: $qop) {
    items {
      consignmentStockInID
      consignmentStockInNumber
      consignmentStockInDatetime
      vendorID
      warehouseID
      externalReferenceNumber
      receivedByName
      totalItemQtyReceived
      status
      branch {
        branchID
        branchCode
        branchName
      }
      warehouse {
        warehouseName
        branch {
          branchID
          branchCode
          branchName
        }
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockInListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockInListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInListQuery, VendorAppStockInListQueryVariables>({ query: VendorAppStockInListDocument, ...options });
};
export const VendorAppStockInLoadDocument = gql`
    query VendorAppStockInLoad($consignmentStockInID: UUID!) {
  consignmentStockIn(consignmentStockInID: $consignmentStockInID) {
    consignmentStockInID
    consignmentStockInNumber
    consignmentStockInDatetime
    status
    externalReferenceNumber
    receivedByName
    totalItemQtyReceived
    noteInternal
    branch {
      branchID
      branchCode
      branchName
    }
    warehouse {
      warehouseName
      branch {
        branchName
      }
    }
    entityAuditMetadata {
      createdAt
      updatedAt
    }
    files {
      consignmentStockInFileID
      consignmentStockInFileType
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
    }
  }
}
    `;

export function useVendorAppStockInLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppStockInLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInLoadQuery, VendorAppStockInLoadQueryVariables>({ query: VendorAppStockInLoadDocument, ...options });
};
export const VendorAppStockInRequestCreateDocument = gql`
    mutation VendorAppStockInRequestCreate($input: ConsignmentStockInRequestCreateInput!) {
  consignmentStockInRequestCreate(input: $input) {
    consignmentStockInRequestID
    consignmentStockInRequestNumber
    requestDatetime
    estimatedDeliveryDate
    status
    branchID
    branchName
    totalItemQtyRequested
  }
}
    `;

export function useVendorAppStockInRequestCreateMutation() {
  return Urql.useMutation<VendorAppStockInRequestCreateMutation, VendorAppStockInRequestCreateMutationVariables>(VendorAppStockInRequestCreateDocument);
};
export const VendorAppStockInRequestFilesListDocument = gql`
    query VendorAppStockInRequestFilesList($qop: ConsignmentStockInRequestFileQopInput) {
  consignmentStockInRequestFiles(qop: $qop) {
    items {
      consignmentStockInRequestFileID
      consignmentStockInRequestFileRole
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorAppStockInRequestFilesListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockInRequestFilesListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInRequestFilesListQuery, VendorAppStockInRequestFilesListQueryVariables>({ query: VendorAppStockInRequestFilesListDocument, ...options });
};
export const VendorAppStockInRequestItemsListDocument = gql`
    query VendorAppStockInRequestItemsList($qop: ConsignmentStockInRequestItemQopInput) {
  consignmentStockInRequestItems(qop: $qop) {
    items {
      consignmentStockInRequestItemID
      consignmentStockInRequestID
      productID
      productCode
      productName
      description
      qtyRequested
      qtyApproved
      qtyReceived
      uomID
      uomName
      expiredDate
      expiredDateConfirmed
      noteRequester
      noteReason
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockInRequestItemsListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockInRequestItemsListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInRequestItemsListQuery, VendorAppStockInRequestItemsListQueryVariables>({ query: VendorAppStockInRequestItemsListDocument, ...options });
};
export const VendorAppStockInRequestLabelsDocument = gql`
    query VendorAppStockInRequestLabels($consignmentStockInRequestID: UUID!) {
  consignmentStockInRequestLabels(
    consignmentStockInRequestID: $consignmentStockInRequestID
  ) {
    productID
    productCode
    productName
    barcode
    sellingPrice
    expiredDate
    copies
    printable
  }
}
    `;

export function useVendorAppStockInRequestLabelsQuery(options: Omit<Urql.UseQueryArgs<VendorAppStockInRequestLabelsQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInRequestLabelsQuery, VendorAppStockInRequestLabelsQueryVariables>({ query: VendorAppStockInRequestLabelsDocument, ...options });
};
export const VendorAppStockInRequestListDocument = gql`
    query VendorAppStockInRequestList($qop: ConsignmentStockInRequestQopInput) {
  consignmentStockInRequests(qop: $qop) {
    items {
      consignmentStockInRequestID
      consignmentStockInRequestNumber
      requestDatetime
      estimatedDeliveryDate
      status
      branchID
      branchCode
      branchName
      totalItemQtyRequested
      totalItemQtyApproved
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockInRequestListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockInRequestListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInRequestListQuery, VendorAppStockInRequestListQueryVariables>({ query: VendorAppStockInRequestListDocument, ...options });
};
export const VendorAppStockInRequestLoadDocument = gql`
    query VendorAppStockInRequestLoad($consignmentStockInRequestID: UUID!) {
  consignmentStockInRequest(
    consignmentStockInRequestID: $consignmentStockInRequestID
  ) {
    consignmentStockInRequestID
    consignmentStockInRequestNumber
    requestDatetime
    estimatedDeliveryDate
    status
    branchID
    branchCode
    branchName
    vendorCode
    vendorName
    noteAdditional
    totalItemQtyRequested
    totalItemQtyApproved
    consignmentStockInID
    consignmentStockInNumber
    submittedByUserName
    submittedDatetime
    approvedByUserName
    approvedDatetime
    rejectedByUserName
    rejectedDatetime
    rejectionReason
    cancelledByUserName
    cancelledDatetime
    cancellationReason
    entityAuditMetadata {
      createdAt
      updatedAt
    }
  }
}
    `;

export function useVendorAppStockInRequestLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppStockInRequestLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInRequestLoadQuery, VendorAppStockInRequestLoadQueryVariables>({ query: VendorAppStockInRequestLoadDocument, ...options });
};
export const VendorAppStockInRequestSummaryDocument = gql`
    query VendorAppStockInRequestSummary($branchID: UUID) {
  consignmentStockInRequestSummary(branchID: $branchID) {
    totalRequest
    pending
    approved
    rejected
  }
}
    `;

export function useVendorAppStockInRequestSummaryQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockInRequestSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInRequestSummaryQuery, VendorAppStockInRequestSummaryQueryVariables>({ query: VendorAppStockInRequestSummaryDocument, ...options });
};
export const VendorAppStockOutItemsListDocument = gql`
    query VendorAppStockOutItemsList($qop: ConsignmentStockOutItemQopInput) {
  consignmentStockOutItems(qop: $qop) {
    items {
      consignmentStockOutItemID
      consignmentStockOutID
      productID
      productCode
      productName
      description
      qty
      uomName
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockOutItemsListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockOutItemsListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockOutItemsListQuery, VendorAppStockOutItemsListQueryVariables>({ query: VendorAppStockOutItemsListDocument, ...options });
};
export const VendorAppStockOutListDocument = gql`
    query VendorAppStockOutList($qop: ConsignmentStockOutQopInput) {
  consignmentStockOuts(qop: $qop) {
    items {
      consignmentStockOutID
      consignmentStockOutNumber
      consignmentStockOutDatetime
      vendorID
      warehouseID
      externalReferenceNumber
      receivedByVendorName
      totalItemQty
      status
      warehouse {
        warehouseName
        branch {
          branchID
          branchCode
          branchName
        }
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockOutListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockOutListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockOutListQuery, VendorAppStockOutListQueryVariables>({ query: VendorAppStockOutListDocument, ...options });
};
export const VendorAppStockOutLoadDocument = gql`
    query VendorAppStockOutLoad($consignmentStockOutID: UUID!) {
  consignmentStockOut(consignmentStockOutID: $consignmentStockOutID) {
    consignmentStockOutID
    consignmentStockOutNumber
    consignmentStockOutDatetime
    status
    externalReferenceNumber
    receivedByVendorName
    totalItemQty
    noteInternal
    warehouse {
      warehouseName
      branch {
        branchName
      }
    }
    files {
      consignmentStockOutFileID
      consignmentStockOutFileType
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
    }
  }
}
    `;

export function useVendorAppStockOutLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppStockOutLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockOutLoadQuery, VendorAppStockOutLoadQueryVariables>({ query: VendorAppStockOutLoadDocument, ...options });
};
export const VendorConsignmentDashboardDocument = gql`
    query VendorConsignmentDashboard($filter: VendorConsignmentDashboardFilterInput!) {
  vendorConsignmentDashboard(filter: $filter) {
    summary {
      grossSales
      commissionAmount
      commissionInclTaxAmount
      vendorShareAmount
      unitsSold
      invoiceCount
    }
    salesByBranch {
      branchID
      grossSales
      vendorShareAmount
      invoiceCount
    }
    topProducts {
      productID
      productName
      qty
      grossSales
      vendorShareAmount
    }
    topProductsByRevenue {
      productID
      productName
      qty
      grossSales
      vendorShareAmount
    }
  }
}
    `;

export function useVendorConsignmentDashboardQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentDashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentDashboardQuery, VendorConsignmentDashboardQueryVariables>({ query: VendorConsignmentDashboardDocument, ...options });
};
export const VendorConsignmentSalesExportDocument = gql`
    query VendorConsignmentSalesExport($filter: VendorConsignmentSalesExportFilterInput!) {
  vendorConsignmentSalesExport(filter: $filter) {
    fileName
    downloadURL
  }
}
    `;

export function useVendorConsignmentSalesExportQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentSalesExportQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentSalesExportQuery, VendorConsignmentSalesExportQueryVariables>({ query: VendorConsignmentSalesExportDocument, ...options });
};
export const VendorInventoryCountExportDocument = gql`
    query VendorInventoryCountExport($filter: VendorInventoryCountReportFilterInput!) {
  vendorInventoryCountExport(filter: $filter) {
    fileName
    downloadURL
  }
}
    `;

export function useVendorInventoryCountExportQuery(options: Omit<Urql.UseQueryArgs<VendorInventoryCountExportQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorInventoryCountExportQuery, VendorInventoryCountExportQueryVariables>({ query: VendorInventoryCountExportDocument, ...options });
};
export const VendorInventoryCountListDocument = gql`
    query VendorInventoryCountList($filter: VendorInventoryCountListFilterInput!) {
  vendorInventoryCountList(filter: $filter) {
    inventoryCountTransactionID
    inventoryCountTransactionNumber
    inventoryCountTransactionDatetimeUtc
    gmt
    branchID
    branch {
      branchID
      branchName
      branchCode
    }
    taskType
    productCount
  }
}
    `;

export function useVendorInventoryCountListQuery(options: Omit<Urql.UseQueryArgs<VendorInventoryCountListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorInventoryCountListQuery, VendorInventoryCountListQueryVariables>({ query: VendorInventoryCountListDocument, ...options });
};
export const VendorInventoryCountReportDocument = gql`
    query VendorInventoryCountReport($qop: VendorInventoryCountReportQopInput!) {
  vendorInventoryCountReport(qop: $qop) {
    execution {
      inventoryCountTransactionNumber
      inventoryCountTransactionDatetimeUtc
      gmt
      branchID
      branch {
        branchID
        branchName
        branchCode
      }
      warehouseID
      taskType
      note
      officers
    }
    summary {
      opnameCount
      productCounted
      matched
      variance
      netVarianceValue
      shortageValue
      overageValue
    }
    items {
      items {
        inventoryCountTransactionResultItemID
        inventoryCountTransactionID
        inventoryCountTransactionNumber
        countedAtUtc
        gmt
        branchID
        branch {
          branchID
          branchName
          branchCode
        }
        warehouseID
        productID
        productCode
        barcode
        productName
        uomName
        qtySystem
        qtyCounted
        qtyDiff
        note
        unitCost
        varianceValue
        result
      }
      pagination {
        page
        pageSize
        totalPages
        totalRows
        hasNext
      }
    }
  }
}
    `;

export function useVendorInventoryCountReportQuery(options: Omit<Urql.UseQueryArgs<VendorInventoryCountReportQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorInventoryCountReportQuery, VendorInventoryCountReportQueryVariables>({ query: VendorInventoryCountReportDocument, ...options });
};
export const VendorStockExportDocument = gql`
    query VendorStockExport($filter: VendorStockExportFilterInput!) {
  vendorStockExport(filter: $filter) {
    fileName
    downloadURL
  }
}
    `;

export function useVendorStockExportQuery(options: Omit<Urql.UseQueryArgs<VendorStockExportQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorStockExportQuery, VendorStockExportQueryVariables>({ query: VendorStockExportDocument, ...options });
};
export const VendorStockReconciliationDocument = gql`
    query VendorStockReconciliation($filter: VendorStockReconciliationFilterInput!) {
  vendorStockReconciliation(filter: $filter) {
    periodStart
    countedAt
    openingQty
    stockInQty
    soldQty
    stockOutQty
    returnQty
    adjustmentQty
    otherQty
    closingQty
    openingBalanceAvailable
    ledgerComplete
  }
}
    `;

export function useVendorStockReconciliationQuery(options: Omit<Urql.UseQueryArgs<VendorStockReconciliationQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorStockReconciliationQuery, VendorStockReconciliationQueryVariables>({ query: VendorStockReconciliationDocument, ...options });
};
export const VendorConsignmentRentalPaymentApproveDocument = gql`
    mutation VendorConsignmentRentalPaymentApprove($input: VendorConsignmentRentalPaymentApproveInput!) {
  vendorConsignmentRentalPaymentApprove(input: $input) {
    vendorConsignmentRentalPaymentID
    status
    approvedByUserName
    approvedAt
  }
}
    `;

export function useVendorConsignmentRentalPaymentApproveMutation() {
  return Urql.useMutation<VendorConsignmentRentalPaymentApproveMutation, VendorConsignmentRentalPaymentApproveMutationVariables>(VendorConsignmentRentalPaymentApproveDocument);
};
export const VendorConsignmentRentalPaymentListDocument = gql`
    query VendorConsignmentRentalPaymentList($qop: VendorConsignmentRentalPaymentQopInput) {
  vendorConsignmentRentalPayments(qop: $qop) {
    items {
      vendorConsignmentRentalPaymentID
      vendorConsignmentRentalPaymentNumber
      vendorConsignmentBranchID
      vendorID
      vendorName
      branchID
      branchName
      transferAmount
      transferDate
      vendorNote
      rentPriceSnapshot
      rentPeriodDaysSnapshot
      effectiveStartDate
      effectiveEndDate
      status
      approvedByUserName
      approvedAt
      rejectedReason
      rejectedByUserName
      rejectedAt
      files {
        vendorConsignmentRentalPaymentFileID
        vendorConsignmentRentalPaymentFileType
        fileID
        imageFileSmallPathURL
        imageFileMediumPathURL
        imageFileLargePathURL
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorConsignmentRentalPaymentListQuery(options?: Omit<Urql.UseQueryArgs<VendorConsignmentRentalPaymentListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentRentalPaymentListQuery, VendorConsignmentRentalPaymentListQueryVariables>({ query: VendorConsignmentRentalPaymentListDocument, ...options });
};
export const VendorConsignmentRentalPaymentLoadDocument = gql`
    query VendorConsignmentRentalPaymentLoad($vendorConsignmentRentalPaymentID: UUID!) {
  vendorConsignmentRentalPayment(
    vendorConsignmentRentalPaymentID: $vendorConsignmentRentalPaymentID
  ) {
    vendorConsignmentRentalPaymentID
    vendorConsignmentRentalPaymentNumber
    vendorConsignmentBranchID
    vendorID
    vendorName
    branchID
    branchName
    transferAmount
    transferDate
    vendorNote
    rentPriceSnapshot
    rentPeriodDaysSnapshot
    effectiveStartDate
    effectiveEndDate
    status
    settlementBankAccountID
    settlementBankName
    settlementBankAccountNumber
    approvedByUserName
    approvedAt
    rejectedReason
    rejectedByUserName
    rejectedAt
    files {
      vendorConsignmentRentalPaymentFileID
      vendorConsignmentRentalPaymentFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
    }
    entityAuditMetadata {
      createdAt
      updatedAt
    }
  }
}
    `;

export function useVendorConsignmentRentalPaymentLoadQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentRentalPaymentLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentRentalPaymentLoadQuery, VendorConsignmentRentalPaymentLoadQueryVariables>({ query: VendorConsignmentRentalPaymentLoadDocument, ...options });
};
export const VendorConsignmentRentalPaymentRejectDocument = gql`
    mutation VendorConsignmentRentalPaymentReject($input: VendorConsignmentRentalPaymentRejectInput!) {
  vendorConsignmentRentalPaymentReject(input: $input) {
    vendorConsignmentRentalPaymentID
    status
    rejectedReason
    rejectedByUserName
    rejectedAt
  }
}
    `;

export function useVendorConsignmentRentalPaymentRejectMutation() {
  return Urql.useMutation<VendorConsignmentRentalPaymentRejectMutation, VendorConsignmentRentalPaymentRejectMutationVariables>(VendorConsignmentRentalPaymentRejectDocument);
};
export const VendorCreateAccessDocument = gql`
    mutation VendorCreateAccess($input: VendorCreateAccessInput!) {
  vendorCreateAccess(input: $input) {
    vendorID
  }
}
    `;

export function useVendorCreateAccessMutation() {
  return Urql.useMutation<VendorCreateAccessMutation, VendorCreateAccessMutationVariables>(VendorCreateAccessDocument);
};
export const VendorUpdateAccessDocument = gql`
    mutation VendorUpdateAccess($input: VendorUpdateAccessInput!) {
  vendorUpdateAccess(input: $input) {
    vendorID
  }
}
    `;

export function useVendorUpdateAccessMutation() {
  return Urql.useMutation<VendorUpdateAccessMutation, VendorUpdateAccessMutationVariables>(VendorUpdateAccessDocument);
};
export const VendorAutocompleteDocument = gql`
    query VendorAutocomplete($qop: VendorQopInput) {
  vendors(qop: $qop) {
    items {
      vendorID
      vendorName
      taxIncluded
      vendorCode
      cityID
      cityName
      taxable
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<VendorAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAutocompleteQuery, VendorAutocompleteQueryVariables>({ query: VendorAutocompleteDocument, ...options });
};
export const VendorConsignmentBranchDeleteDocument = gql`
    mutation VendorConsignmentBranchDelete($vendorConsignmentBranchID: UUID!) {
  vendorConsignmentBranchDelete(
    vendorConsignmentBranchID: $vendorConsignmentBranchID
  )
}
    `;

export function useVendorConsignmentBranchDeleteMutation() {
  return Urql.useMutation<VendorConsignmentBranchDeleteMutation, VendorConsignmentBranchDeleteMutationVariables>(VendorConsignmentBranchDeleteDocument);
};
export const VendorCreateDocument = gql`
    mutation VendorCreate($input: VendorCreateInput!) {
  vendorCreate(input: $input) {
    vendorID
    vendorCode
    vendorName
    isConsignment
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
  }
}
    `;

export function useVendorCreateMutation() {
  return Urql.useMutation<VendorCreateMutation, VendorCreateMutationVariables>(VendorCreateDocument);
};
export const VendorDeleteDocument = gql`
    mutation VendorDelete($input: VendorDeleteInput!) {
  vendorDelete(input: $input)
}
    `;

export function useVendorDeleteMutation() {
  return Urql.useMutation<VendorDeleteMutation, VendorDeleteMutationVariables>(VendorDeleteDocument);
};
export const VendorListDocument = gql`
    query VendorList($qop: VendorQopInput) {
  vendors(qop: $qop) {
    items {
      vendorID
      vendorCode
      vendorName
      vendorCategoryID
      email
      phoneNumber
      npwp
      npwpCompanyName
      isPKP
      taxpayerIDNumber
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      taxIncluded
      canBeReturned
      isConsignment
      consignmentCommisionFeePerc
      consignmentPeriodStartDate
      consignmentPeriodEndDate
      hasPortalAccess
      portalSuperadminFirstName
      portalSuperadminLastName
      portalSuperadminEmail
      portalAccountActivated
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorListQuery(options?: Omit<Urql.UseQueryArgs<VendorListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorListQuery, VendorListQueryVariables>({ query: VendorListDocument, ...options });
};
export const VendorLoadDocument = gql`
    query VendorLoad($vendorID: UUID!) {
  vendor(vendorID: $vendorID) {
    vendorID
    vendorCode
    vendorName
    vendorCategoryID
    vendorCategory {
      vendorCategoryName
    }
    email
    phoneNumber
    npwp
    npwpCompanyName
    isPKP
    taxable
    taxpayerIDNumber
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    taxIncluded
    canBeReturned
    isConsignment
    consignmentPeriodStartDate
    consignmentPeriodEndDate
    hasPortalAccess
    portalSuperadminFirstName
    portalSuperadminLastName
    portalSuperadminEmail
    portalAccountActivated
    uniqueKey
    isActive
    vendorPicContacts {
      vendorPicContactID
      vendorID
      picName
      picDepartment
      picEmail
      picPhoneNumber
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    vendorConsignmentProducts {
      productID
      product {
        productCode
        productName
        barcode
        baseUom {
          uomName
        }
      }
      sellingPrice
    }
    vendorConsignmentBranch {
      vendorConsignmentBranchID
      vendorID
      branchID
      branchCode
      branchName
      commissionFeePerc
      isRent
      rentPrice
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useVendorLoadQuery(options: Omit<Urql.UseQueryArgs<VendorLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorLoadQuery, VendorLoadQueryVariables>({ query: VendorLoadDocument, ...options });
};
export const VendorConsignmentProductCreateDocument = gql`
    mutation VendorConsignmentProductCreate($input: VendorConsignmentProductCreateInput!) {
  vendorConsignmentProductCreate(input: $input) {
    vendorConsignmentProductID
  }
}
    `;

export function useVendorConsignmentProductCreateMutation() {
  return Urql.useMutation<VendorConsignmentProductCreateMutation, VendorConsignmentProductCreateMutationVariables>(VendorConsignmentProductCreateDocument);
};
export const VendorConsignmentProductDeleteDocument = gql`
    mutation VendorConsignmentProductDelete($vendorConsignmentProductID: UUID!) {
  vendorConsignmentProductDelete(
    vendorConsignmentProductID: $vendorConsignmentProductID
  )
}
    `;

export function useVendorConsignmentProductDeleteMutation() {
  return Urql.useMutation<VendorConsignmentProductDeleteMutation, VendorConsignmentProductDeleteMutationVariables>(VendorConsignmentProductDeleteDocument);
};
export const VendorConsignmentProductListDocument = gql`
    query VendorConsignmentProductList($qop: VendorConsignmentProductQopInput!) {
  vendorConsignmentProducts(qop: $qop) {
    items {
      productID
      product {
        productCode
        productName
        barcode
        sellingPrice
        baseUom {
          uomName
        }
        isActive
        entityAuditMetadata {
          version
        }
      }
      branchPrices {
        vendorConsignmentProductID
        branch {
          branchCode
          branchName
        }
        sellingPrice
        productCommissionFeePerc
        isActive
        entityAuditMetadata {
          version
        }
      }
      branchPrices {
        vendorConsignmentProductID
        branchID
        sellingPrice
        productCommissionFeePerc
        isActive
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useVendorConsignmentProductListQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentProductListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentProductListQuery, VendorConsignmentProductListQueryVariables>({ query: VendorConsignmentProductListDocument, ...options });
};
export const VendorConsignmentProductLoadDocument = gql`
    query VendorConsignmentProductLoad($vendorConsignmentProductID: UUID!) {
  vendorConsignmentProduct(
    vendorConsignmentProductID: $vendorConsignmentProductID
  ) {
    vendorConsignmentProductID
    vendorID
    productID
    branchID
    sellingPrice
    isActive
    uniqueKey
  }
}
    `;

export function useVendorConsignmentProductLoadQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentProductLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentProductLoadQuery, VendorConsignmentProductLoadQueryVariables>({ query: VendorConsignmentProductLoadDocument, ...options });
};
export const VendorConsignmentProductPricesUpdateDocument = gql`
    mutation VendorConsignmentProductPricesUpdate($input: VendorConsignmentProductPriceBulkUpdateInput!) {
  vendorConsignmentProductPriceBulkUpdate(input: $input) {
    product {
      productID
    }
    updatedBranchPrices {
      vendorConsignmentProductID
    }
  }
}
    `;

export function useVendorConsignmentProductPricesUpdateMutation() {
  return Urql.useMutation<VendorConsignmentProductPricesUpdateMutation, VendorConsignmentProductPricesUpdateMutationVariables>(VendorConsignmentProductPricesUpdateDocument);
};
export const VendorConsignmentProductUpdateDocument = gql`
    mutation VendorConsignmentProductUpdate($input: VendorConsignmentProductUpdateInput!) {
  vendorConsignmentProductUpdate(input: $input) {
    vendorConsignmentProductID
  }
}
    `;

export function useVendorConsignmentProductUpdateMutation() {
  return Urql.useMutation<VendorConsignmentProductUpdateMutation, VendorConsignmentProductUpdateMutationVariables>(VendorConsignmentProductUpdateDocument);
};
export const VendorSetPortalAccessActiveDocument = gql`
    mutation VendorSetPortalAccessActive($input: VendorSetPortalAccessActiveInput!) {
  vendorSetPortalAccessActive(input: $input) {
    vendorID
    hasPortalAccess
  }
}
    `;

export function useVendorSetPortalAccessActiveMutation() {
  return Urql.useMutation<VendorSetPortalAccessActiveMutation, VendorSetPortalAccessActiveMutationVariables>(VendorSetPortalAccessActiveDocument);
};
export const VendorUpdateDocument = gql`
    mutation VendorUpdate($input: VendorUpdateInput!) {
  vendorUpdate(input: $input) {
    vendorID
    vendorCode
    vendorName
    isConsignment
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
  }
}
    `;

export function useVendorUpdateMutation() {
  return Urql.useMutation<VendorUpdateMutation, VendorUpdateMutationVariables>(VendorUpdateDocument);
};
export type AuthLoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type AuthLoginMutation = { __typename?: 'Mutation', authLogin: { __typename?: 'AuthResponse', accessToken: string, refreshToken: string, defaultBranchID?: any | null, defaultBranchCode?: string | null, defaultBranchName?: string | null, defaultRoleName?: string | null, defaultWarehouseID?: any | null, defaultWarehouseName?: string | null, isAllBranches?: boolean | null, user: { __typename?: 'UserProfile', userID: string, fullName: string, email: string, phoneNumber: string, employeeID?: any | null, vendorID?: string | null }, branches?: Array<{ __typename?: 'BranchProfile', branchID: any, branchCode: string, branchName: string, warehouse?: { __typename?: 'BranchWarehouseProfile', warehouseID: any, warehouseCode: string, warehouseName: string } | null }> | null, appRolePermissions?: Array<{ __typename?: 'AppRolePermission', appID: string, appName: string, roles?: Array<{ __typename?: 'RoleProfile', resourceID: string, resourceName: string, permissions?: Array<{ __typename?: 'PermissionProfile', permissionID: string, permissionName: string }> | null }> | null }> | null } };

export type AuthLoginVendorMutationVariables = Exact<{
  input: LoginInput;
}>;


export type AuthLoginVendorMutation = { __typename?: 'Mutation', authLoginVendor: { __typename?: 'AuthResponse', accessToken: string, refreshToken: string, defaultBranchID?: any | null, defaultBranchCode?: string | null, defaultBranchName?: string | null, defaultRoleName?: string | null, defaultWarehouseID?: any | null, defaultWarehouseName?: string | null, isAllBranches?: boolean | null, user: { __typename?: 'UserProfile', userID: string, fullName: string, email: string, phoneNumber: string, employeeID?: any | null, vendorID?: string | null }, branches?: Array<{ __typename?: 'BranchProfile', branchID: any, branchCode: string, branchName: string, warehouse?: { __typename?: 'BranchWarehouseProfile', warehouseID: any, warehouseCode: string, warehouseName: string } | null }> | null, appRolePermissions?: Array<{ __typename?: 'AppRolePermission', appID: string, appName: string, roles?: Array<{ __typename?: 'RoleProfile', resourceID: string, resourceName: string, permissions?: Array<{ __typename?: 'PermissionProfile', permissionID: string, permissionName: string }> | null }> | null }> | null } };

export type AuthRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type AuthRefreshTokenMutation = { __typename?: 'Mutation', authRefreshToken: { __typename?: 'AuthResponse', accessToken: string, refreshToken: string, defaultBranchID?: any | null, defaultBranchCode?: string | null, defaultBranchName?: string | null, defaultRoleName?: string | null, defaultWarehouseID?: any | null, defaultWarehouseName?: string | null, isAllBranches?: boolean | null, user: { __typename?: 'UserProfile', userID: string, fullName: string, email: string, phoneNumber: string, employeeID?: any | null, vendorID?: string | null }, branches?: Array<{ __typename?: 'BranchProfile', branchID: any, branchCode: string, branchName: string, warehouse?: { __typename?: 'BranchWarehouseProfile', warehouseID: any, warehouseCode: string, warehouseName: string } | null }> | null, appRolePermissions?: Array<{ __typename?: 'AppRolePermission', appID: string, appName: string, roles?: Array<{ __typename?: 'RoleProfile', resourceID: string, resourceName: string, permissions?: Array<{ __typename?: 'PermissionProfile', permissionID: string, permissionName: string }> | null }> | null }> | null } };

export type AuthSetDefaultBranchMutationVariables = Exact<{
  input: SetDefaultBranchInput;
}>;


export type AuthSetDefaultBranchMutation = { __typename?: 'Mutation', authSetDefaultBranch: { __typename?: 'AuthResponse', accessToken: string, refreshToken: string, isAllBranches?: boolean | null, defaultBranchID?: any | null, defaultBranchCode?: string | null, defaultBranchName?: string | null, defaultWarehouseID?: any | null, defaultWarehouseName?: string | null, defaultRoleID?: any | null, defaultRoleName?: string | null, defaultRoleAppID?: string | null, defaultRoleAppName?: string | null, branches?: Array<{ __typename?: 'BranchProfile', branchID: any, branchCode: string, branchName: string }> | null, appRoles?: Array<{ __typename?: 'AppRole', roleID: any, roleName: string, appID: string, appName: string }> | null, appRolePermissions?: Array<{ __typename?: 'AppRolePermission', appID: string, appName: string }> | null } };

export type GenerateLinkResetPasswordMutationVariables = Exact<{
  input: GenerateLinkResetPasswordInput;
}>;


export type GenerateLinkResetPasswordMutation = { __typename?: 'Mutation', generateLinkResetPassword: { __typename?: 'GenerateLinkResetPasswordResponse', success: boolean, nextRetryDelay: number, nextSessionDelay: number, remainingAttempts: number } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type BranchAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<BranchQopInput>;
}>;


export type BranchAutocompleteQuery = { __typename?: 'Query', branches: { __typename?: 'BranchPaged', items?: Array<{ __typename?: 'Branch', branchID: any, branchName: string, branchCode: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type BranchCreateMutationVariables = Exact<{
  input: BranchCreateInput;
}>;


export type BranchCreateMutation = { __typename?: 'Mutation', branchCreate: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, canSell?: boolean | null, isMain?: boolean | null, cashJournalAccountCode?: string | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null, country?: { __typename?: 'Country', countryID: string, countryName: string, uniqueKey: string, isActive: boolean } | null, province?: { __typename?: 'Province', provinceID: string, provinceName: string, countryID: string, uniqueKey: string, isActive: boolean } | null, city?: { __typename?: 'City', cityID: string, cityName: string, gmt: number, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean } | null, subdistrict?: { __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string, cityID: string, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean } | null } };

export type BranchDeleteMutationVariables = Exact<{
  branchID: Scalars['UUID']['input'];
}>;


export type BranchDeleteMutation = { __typename?: 'Mutation', branchDelete: boolean };

export type BranchListQueryVariables = Exact<{
  qop?: InputMaybe<BranchQopInput>;
}>;


export type BranchListQuery = { __typename?: 'Query', branches: { __typename?: 'BranchPaged', items?: Array<{ __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, productAvailabilityTemplateID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, picName?: string | null, picPhoneNumber?: string | null, canSell?: boolean | null, isMain?: boolean | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null, branchCategory?: { __typename?: 'BranchCategory', branchCategoryName: string } | null, pricelist?: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string } | null, productAvailabilityTemplate?: { __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string } | null, mainSupplyWarehouse?: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type BranchLoadQueryVariables = Exact<{
  branchID: Scalars['UUID']['input'];
}>;


export type BranchLoadQuery = { __typename?: 'Query', branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, productAvailabilityTemplateID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, picName?: string | null, picPhoneNumber?: string | null, canSell?: boolean | null, isMain?: boolean | null, cashJournalAccountCode?: string | null, cashJournalAccountErpRefID?: string | null, cashJournalAccountErpRefName?: string | null, pettyCashJournalAccountCode?: string | null, pettyCashJournalAccountErpRefID?: string | null, pettyCashJournalAccountErpRefName?: string | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null, branchStoreSupervisors: Array<{ __typename?: 'BranchStoreSupervisor', branchStoreSupervisorID: any, userID: any, user?: { __typename?: 'User', fullName: string } | null }>, branchCategory?: { __typename?: 'BranchCategory', branchCategoryName: string } | null, pricelist?: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string } | null, productAvailabilityTemplate?: { __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string } | null, mainSupplyWarehouse?: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } | null, country?: { __typename?: 'Country', countryID: string, countryName: string, uniqueKey: string, isActive: boolean } | null, province?: { __typename?: 'Province', provinceID: string, provinceName: string, countryID: string, uniqueKey: string, isActive: boolean } | null, city?: { __typename?: 'City', cityID: string, cityName: string, gmt: number, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean } | null, subdistrict?: { __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string, cityID: string, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean } | null, branchSalesPaymentMethods: Array<{ __typename?: 'BranchSalesPaymentMethod', branchSalesPaymentMethodID: any, branchID: any, paymentMethodID: any, uniqueKey: string, paymentMethod?: { __typename?: 'SalesPaymentMethod', salesPaymentMethodID: any, salesPaymentMethodName: string, salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, uniqueKey: string, isActive?: boolean | null } | null }>, branchPosBookmarks: Array<{ __typename?: 'BranchPosBookmark', branchPosBookmarkID: any, branchID: any, posBookmarkID: any, uniqueKey: string, posBookmark?: { __typename?: 'PosBookmark', posBookmarkID: any, posBookmarkName: string, uniqueKey: string } | null }>, edcTerminals: Array<{ __typename?: 'EdcTerminal', edcTerminalID: any, edcTerminalName: string, serialNumber: string }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type BranchStoreSupervisorAutocompleteQueryVariables = Exact<{
  qop: BranchStoreSupervisorQopInput;
}>;


export type BranchStoreSupervisorAutocompleteQuery = { __typename?: 'Query', branchStoreSupervisors: { __typename?: 'BranchStoreSupervisorPaged', items?: Array<{ __typename?: 'BranchStoreSupervisor', branchStoreSupervisorID: any, branchID: any, userID: any, uniqueKey: string, isActive: boolean, user?: { __typename?: 'User', fullName: string } | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type BranchUpdateMutationVariables = Exact<{
  input: BranchUpdateInput;
}>;


export type BranchUpdateMutation = { __typename?: 'Mutation', branchUpdate: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, canSell?: boolean | null, isMain?: boolean | null, cashJournalAccountCode?: string | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } };

export type ProductAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ProductQopInput>;
}>;


export type ProductAutocompleteQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaged', items?: Array<{ __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, uomCategoryID: any, sellingPrice?: number | null, purchaseCost?: number | null, canBePurchased: boolean, baseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null, purchaseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null, purchaseTax?: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxType: string, taxRate: number, uniqueKey: string, isActive: boolean } | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductCreateMutationVariables = Exact<{
  input: ProductCreateInput;
}>;


export type ProductCreateMutation = { __typename?: 'Mutation', productCreate: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean, pricelistProducts: Array<{ __typename?: 'PricelistProduct', pricelistProductID: any, pricelistPeriodID: any, pricelistID: any, productID: any, sellingPrice: number, salesChannelPrice?: string | null, uniqueKey: string, pricelistPeriod: { __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelistID: any, effectiveStartDate: any, effectiveEndDate: any, effectiveStartHour?: number | null, effectiveEndHour?: number | null, effectiveStartMinute?: number | null, effectiveEndMinute?: number | null, useTime: boolean, priority: number, isActive: boolean, uniqueKey: string } }> } };

export type ProductDeleteMutationVariables = Exact<{
  productID: Scalars['UUID']['input'];
}>;


export type ProductDeleteMutation = { __typename?: 'Mutation', productDelete: boolean };

export type ProductListQueryVariables = Exact<{
  qop?: InputMaybe<ProductQopInput>;
}>;


export type ProductListQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaged', items?: Array<{ __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, uniqueKey: string, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, isActive: boolean, productBarcodeMaps: Array<{ __typename?: 'ProductBarcodeMap', productBarcodeMapID: any }>, consignmentVendor?: { __typename?: 'Vendor', vendorName: string } | null, baseUom?: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean } | null, productBrand?: { __typename?: 'ProductBrand', productBrandID: any, productBrandName: string, uniqueKey: string, isActive: boolean } | null, productSource?: { __typename?: 'ProductSource', productSourceID: any, productSourceCode: string, productSourceName: string, uniqueKey: string, isActive: boolean } | null, pricelistProducts: Array<{ __typename?: 'PricelistProduct', pricelistProductID: any, sellingPrice: number, pricelistPeriod: { __typename?: 'PricelistPeriod', pricelistPeriodName: string, pricelist: { __typename?: 'Pricelist', pricelistName: string } } }>, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } | null, productSubCategory?: { __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string, productCategoryID: any, uniqueKey: string, isActive: boolean } | null, purchaseTax?: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, uniqueKey: string, isActive: boolean } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductLoadQueryVariables = Exact<{
  productID: Scalars['UUID']['input'];
}>;


export type ProductLoadQuery = { __typename?: 'Query', product: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, sellingPrice?: number | null, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, countryID?: string | null, productAccountingCategoryID?: any | null, productAccountingCategoryErpRefID?: string | null, productAccountingCategoryErpRefName?: string | null, hasAddon: boolean, addonGroupID?: any | null, uniqueKey: string, isActive: boolean, country?: { __typename?: 'Country', countryName: string } | null, productAccountingCategory?: { __typename?: 'ProductAccountingCategory', productAccountingCategoryID: any, productAccountingCategoryName: string } | null, addonGroup?: { __typename?: 'ProductAddonGroup', productAddonGroupID: any, name: string } | null, consignmentVendor?: { __typename?: 'Vendor', vendorName: string, vendorConsignmentBranch: Array<{ __typename?: 'VendorConsignmentBranch', branchID: any, branchCode: string, branchName: string }>, vendorConsignmentProducts: Array<{ __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any, sellingPrice: number, commissionFeePerc: number, productCommissionFeePerc: number, branchID: any, productID: any, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> } | null, pricelistProducts: Array<{ __typename?: 'PricelistProduct', pricelistProductID: any, sellingPrice: number, pricelistPeriod: { __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelist: { __typename?: 'Pricelist', pricelistId: any, pricelistName: string } } }>, uomCategory?: { __typename?: 'UomCategory', uomCategoryName: string } | null, baseUom?: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean, uomCategory?: { __typename?: 'UomCategory', uomCategoryID: any, uomCategoryName: string } | null } | null, productBrand?: { __typename?: 'ProductBrand', productBrandID: any, productBrandName: string, uniqueKey: string, isActive: boolean } | null, productSource?: { __typename?: 'ProductSource', productSourceID: any, productSourceCode: string, productSourceName: string, uniqueKey: string, isActive: boolean } | null, productVendors: Array<{ __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, taxable?: boolean | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentCommisionFeePerc?: number | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null } }>, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } | null, productSubCategory?: { __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string, productCategoryID: any, uniqueKey: string, isActive: boolean } | null, productFiles: Array<{ __typename?: 'ProductFile', productFileID: any, productID: any, productFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }>, productAIImages: Array<{ __typename?: 'ProductAIImage', productAIImageID: any, productID: any, aiImageType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }>, purchaseUom?: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean } | null, purchaseTax?: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, uniqueKey: string, isActive: boolean } | null, salesUom?: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean } | null, salesTax?: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, uniqueKey: string, isActive: boolean } | null, productBarcodeMaps: Array<{ __typename?: 'ProductBarcodeMap', productBarcodeMapID: any, productID: any, barcode: string, uniqueKey: string, isActive: boolean }>, productAvailabilityTemplateItems: Array<{ __typename?: 'ProductAvailabilityTemplateItem', productAvailabilityTemplateItemID: any, productAvailabilityTemplateID: any, productID: any, uniqueKey: string, isActive: boolean, productAvailabilityTemplate?: { __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string } | null }>, productBundleComponents: Array<{ __typename?: 'ProductBundleComponent', productBundleComponentID: any, productID: any, componentProductID: any, qty: number, uomCategoryID: any, uomID: any, uniqueKey: string, isActive: boolean, componentProduct?: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean } | null, uom: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean } }>, productTagProducts: Array<{ __typename?: 'ProductTagProduct', productTagProductID: any, productTagID: any, productID: any, uniqueKey: string, productTag: { __typename?: 'ProductTag', productTagName: string } }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductUpdateMutationVariables = Exact<{
  input: ProductUpdateInput;
}>;


export type ProductUpdateMutation = { __typename?: 'Mutation', productUpdate: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean } };

export type ProductVendorCreateMutationVariables = Exact<{
  input: ProductVendorCreateInput;
}>;


export type ProductVendorCreateMutation = { __typename?: 'Mutation', productVendorCreate: { __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean } };

export type ProductVendorDeleteMutationVariables = Exact<{
  productVendorID: Scalars['UUID']['input'];
}>;


export type ProductVendorDeleteMutation = { __typename?: 'Mutation', productVendorDelete: boolean };

export type ProductVendorListQueryVariables = Exact<{
  qop?: InputMaybe<ProductVendorQopInput>;
}>;


export type ProductVendorListQuery = { __typename?: 'Query', productVendors: { __typename?: 'ProductVendorPaged', items?: Array<{ __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductVendorLoadQueryVariables = Exact<{
  productVendorID: Scalars['UUID']['input'];
}>;


export type ProductVendorLoadQuery = { __typename?: 'Query', productVendor: { __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, taxable?: boolean | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentCommisionFeePerc?: number | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductVendorUpdateMutationVariables = Exact<{
  input: ProductVendorUpdateInput;
}>;


export type ProductVendorUpdateMutation = { __typename?: 'Mutation', productVendorUpdate: { __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean } };

export type VendorAppBranchStockQueryVariables = Exact<{
  qop: VendorConsignmentStockByBranchQopInput;
}>;


export type VendorAppBranchStockQuery = { __typename?: 'Query', vendorConsignmentStockByBranch: { __typename?: 'VendorConsignmentStockByBranchPaged', items?: Array<{ __typename?: 'VendorConsignmentStockByBranchItem', branchID: any, branchName: string, productID: any, qty: any, qtyCommitted: any, qtyRejected: any, qtyOnHand: any, qtyAvailable: any, updatedAt?: any | null, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, productType: string, isActive: boolean, baseUom?: { __typename?: 'Uom', uomName: string } | null } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppConsignmentProductAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentProductQopInput>;
}>;


export type VendorAppConsignmentProductAutocompleteQuery = { __typename?: 'Query', vendorConsignmentProducts: { __typename?: 'VendorConsignmentProductAggregatedPaged', items?: Array<{ __typename?: 'VendorConsignmentProductAggregated', productID: any, product: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, isActive: boolean, baseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null, purchaseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null } }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorAppConsignmentProductDetailQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentProductQopInput>;
}>;


export type VendorAppConsignmentProductDetailQuery = { __typename?: 'Query', vendorConsignmentProducts: { __typename?: 'VendorConsignmentProductAggregatedPaged', items?: Array<{ __typename?: 'VendorConsignmentProductAggregated', productID: any, product: { __typename?: 'Product', productCode: string, productName: string, barcode: string, sellingPrice?: number | null, mainImageFileMediumPathURL?: string | null, isActive: boolean }, branchPrices: Array<{ __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any, branchID: any, sellingPrice: number, commissionFeePerc: number, productCommissionFeePerc: number, isActive: boolean, branch: { __typename?: 'Branch', branchCode: string, branchName: string } }> }> | null } };

export type VendorAppConsignmentProductListQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentProductQopInput>;
}>;


export type VendorAppConsignmentProductListQuery = { __typename?: 'Query', vendorConsignmentProducts: { __typename?: 'VendorConsignmentProductAggregatedPaged', items?: Array<{ __typename?: 'VendorConsignmentProductAggregated', productID: any, product: { __typename?: 'Product', productCode: string, barcode: string, productName: string, sellingPrice?: number | null, mainImageFileSmallPathURL?: string | null, mainImageFileLargePathURL?: string | null, isActive: boolean }, branchPrices: Array<{ __typename?: 'VendorConsignmentProduct', branchID: any, sellingPrice: number, isActive: boolean }> }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppProductListQueryVariables = Exact<{
  qop?: InputMaybe<ProductQopInput>;
}>;


export type VendorAppProductListQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaged', items?: Array<{ __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, productType: string, consignmentVendorID?: any | null, isActive: boolean, mainImageFileSmallPathURL?: string | null, mainImageFileLargePathURL?: string | null, baseUom?: { __typename?: 'Uom', uomName: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppProductLoadQueryVariables = Exact<{
  productID: Scalars['UUID']['input'];
}>;


export type VendorAppProductLoadQuery = { __typename?: 'Query', product: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, productType: string, description: string, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, isConsignment: boolean, consignmentVendorID?: any | null, isActive: boolean, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, baseUom?: { __typename?: 'Uom', uomName: string } | null, productBrand?: { __typename?: 'ProductBrand', productBrandName: string } | null, productCategory?: { __typename?: 'ProductCategory', productCategoryName: string } | null, productSubCategory?: { __typename?: 'ProductSubCategory', productSubCategoryName: string } | null, productFiles: Array<{ __typename?: 'ProductFile', productFileID: any, imageFileMediumPathURL: string }> } };

export type VendorAppProductsByCodesQueryVariables = Exact<{
  qop?: InputMaybe<ProductQopInput>;
}>;


export type VendorAppProductsByCodesQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaged', items?: Array<{ __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, baseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null, purchaseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null }> | null } };

export type VendorAppRentalBranchListQueryVariables = Exact<{
  vendorID: Scalars['UUID']['input'];
}>;


export type VendorAppRentalBranchListQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', vendorID: any, vendorName: string, vendorConsignmentBranch: Array<{ __typename?: 'VendorConsignmentBranch', vendorConsignmentBranchID: any, branchID: any, branchCode: string, branchName: string, isRent: boolean, rentPrice: number, isActive: boolean, currentPeriod?: { __typename?: 'VendorConsignmentBranchPeriod', vendorConsignmentBranchPeriodID: any, effectiveStartDate?: any | null, effectiveEndDate?: any | null, rentalStatus: string } | null }> } };

export type VendorAppRentalPaymentCancelMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentCancelInput;
}>;


export type VendorAppRentalPaymentCancelMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentCancel: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string } };

export type VendorAppRentalPaymentCreateMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentCreateInput;
}>;


export type VendorAppRentalPaymentCreateMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentCreate: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, transferAmount: number, transferDate: any } };

export type VendorAppRentalPaymentListQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentRentalPaymentQopInput>;
}>;


export type VendorAppRentalPaymentListQuery = { __typename?: 'Query', vendorConsignmentRentalPayments: { __typename?: 'VendorConsignmentRentalPaymentPaged', items?: Array<{ __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, vendorConsignmentRentalPaymentNumber: string, vendorConsignmentBranchID: any, vendorID: any, vendorName: string, branchID: any, branchName: string, transferAmount: number, transferDate: any, vendorNote: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, status: string, approvedAt?: any | null, rejectedReason: string, rejectedAt?: any | null, files?: Array<{ __typename?: 'VendorConsignmentRentalPaymentFile', vendorConsignmentRentalPaymentFileID: any, vendorConsignmentRentalPaymentFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorAppRentalPaymentLoadQueryVariables = Exact<{
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
}>;


export type VendorAppRentalPaymentLoadQuery = { __typename?: 'Query', vendorConsignmentRentalPayment?: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, vendorConsignmentRentalPaymentNumber: string, vendorConsignmentBranchID: any, vendorID: any, vendorName: string, branchID: any, branchName: string, transferAmount: number, transferDate: any, vendorNote: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, effectiveStartDate: any, effectiveEndDate: any, status: string, settlementBankName: string, settlementBankAccountNumber: string, approvedByUserName: string, approvedAt?: any | null, rejectedReason: string, rejectedByUserName: string, rejectedAt?: any | null, files?: Array<{ __typename?: 'VendorConsignmentRentalPaymentFile', vendorConsignmentRentalPaymentFileID: any, vendorConsignmentRentalPaymentFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any } } | null };

export type VendorAppRentalPaymentSubmitMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentSubmitInput;
}>;


export type VendorAppRentalPaymentSubmitMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentSubmit: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string } };

export type VendorAppRentalPaymentUpdateMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentUpdateInput;
}>;


export type VendorAppRentalPaymentUpdateMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentUpdate: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string, transferAmount: number, transferDate: any } };

export type VendorAppSalesItemsListQueryVariables = Exact<{
  qop?: InputMaybe<SalesConsignmentInvoiceItemQopInput>;
}>;


export type VendorAppSalesItemsListQuery = { __typename?: 'Query', salesConsignmentInvoiceItems: { __typename?: 'SalesConsignmentInvoiceItemPaged', items: Array<{ __typename?: 'SalesConsignmentInvoiceItem', salesConsignmentInvoiceItemID: any, productID: any, productCode: string, productName: string, barcode: string, qty: number, uomName: string, unitPrice: number, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, additionalDiscountPerc?: number | null, additionalDiscountAmount?: number | null, commissionAmount?: number | null, commissionInclTaxAmount?: number | null, taxAmount: number, consignmentVendorTotal: number, salesInvoiceItem: { __typename?: 'SalesInvoiceItem', promoType?: string | null, promoParentProductID?: any | null }, salesConsignmentInvoice: { __typename?: 'SalesConsignmentInvoice', salesConsignmentInvoiceID: any, salesConsignmentInvoiceNumber: string, salesConsignmentInvoiceDatetime: any, salesConsignmentInvoiceDatetimeUtc: any, salesInvoiceID: any, salesInvoiceNumber: string, consignmentVendorID?: any | null, consignmentCommissionFeePerc?: number | null, totalItemQty: number, subtotal: number, discountAmount: number, taxAmount: number, commissionAmount: number, total: number, consignmentVendorTotal: number, status: string } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppSalesListQueryVariables = Exact<{
  qop?: InputMaybe<SalesConsignmentInvoiceQopInput>;
}>;


export type VendorAppSalesListQuery = { __typename?: 'Query', salesConsignmentInvoices: { __typename?: 'SalesConsignmentInvoicePaged', items: Array<{ __typename?: 'SalesConsignmentInvoice', salesConsignmentInvoiceID: any, salesConsignmentInvoiceNumber: string, salesConsignmentInvoiceDatetime: any, salesConsignmentInvoiceDatetimeUtc: any, salesInvoiceID: any, salesInvoiceNumber: string, consignmentVendorID?: any | null, consignmentCommissionFeePerc?: number | null, totalItemQty: number, subtotal: number, discountAmount: number, taxAmount: number, commissionAmount: number, total: number, consignmentVendorTotal: number, status: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppSalesLoadQueryVariables = Exact<{
  salesConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type VendorAppSalesLoadQuery = { __typename?: 'Query', salesConsignmentInvoice?: { __typename?: 'SalesConsignmentInvoice', salesConsignmentInvoiceID: any, salesConsignmentInvoiceNumber: string, salesConsignmentInvoiceDatetime: any, salesInvoiceID: any, salesInvoiceNumber: string, consignmentVendorID?: any | null, totalItemQty: number, status: string } | null };

export type VendorAppStockInItemsListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInItemQopInput>;
}>;


export type VendorAppStockInItemsListQuery = { __typename?: 'Query', consignmentStockInItems: { __typename?: 'ConsignmentStockInItemPaged', items: Array<{ __typename?: 'ConsignmentStockInItem', consignmentStockInItemID: any, consignmentStockInID: any, productID: any, productCode: string, productName: string, description: string, qtyReceived: number, uomName: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockInListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInQopInput>;
}>;


export type VendorAppStockInListQuery = { __typename?: 'Query', consignmentStockIns: { __typename?: 'ConsignmentStockInPaged', items: Array<{ __typename?: 'ConsignmentStockIn', consignmentStockInID: any, consignmentStockInNumber: string, consignmentStockInDatetime: any, vendorID: any, warehouseID: any, externalReferenceNumber?: string | null, receivedByName?: string | null, totalItemQtyReceived: number, status: string, branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string } | null, warehouse: { __typename?: 'Warehouse', warehouseName: string, branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string } | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockInLoadQueryVariables = Exact<{
  consignmentStockInID: Scalars['UUID']['input'];
}>;


export type VendorAppStockInLoadQuery = { __typename?: 'Query', consignmentStockIn?: { __typename?: 'ConsignmentStockIn', consignmentStockInID: any, consignmentStockInNumber: string, consignmentStockInDatetime: any, status: string, externalReferenceNumber?: string | null, receivedByName?: string | null, totalItemQtyReceived: number, noteInternal: string, branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string } | null, warehouse: { __typename?: 'Warehouse', warehouseName: string, branch?: { __typename?: 'Branch', branchName: string } | null }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any }, files?: Array<{ __typename?: 'ConsignmentStockInFile', consignmentStockInFileID: any, consignmentStockInFileType: string, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null } | null };

export type VendorAppStockInRequestCreateMutationVariables = Exact<{
  input: ConsignmentStockInRequestCreateInput;
}>;


export type VendorAppStockInRequestCreateMutation = { __typename?: 'Mutation', consignmentStockInRequestCreate: { __typename?: 'ConsignmentStockInRequest', consignmentStockInRequestID: any, consignmentStockInRequestNumber: string, requestDatetime: any, estimatedDeliveryDate: any, status: string, branchID: any, branchName: string, totalItemQtyRequested: number } };

export type VendorAppStockInRequestFilesListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInRequestFileQopInput>;
}>;


export type VendorAppStockInRequestFilesListQuery = { __typename?: 'Query', consignmentStockInRequestFiles: { __typename?: 'ConsignmentStockInRequestFilePaged', items: Array<{ __typename?: 'ConsignmentStockInRequestFile', consignmentStockInRequestFileID: any, consignmentStockInRequestFileRole: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockInRequestItemsListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInRequestItemQopInput>;
}>;


export type VendorAppStockInRequestItemsListQuery = { __typename?: 'Query', consignmentStockInRequestItems: { __typename?: 'ConsignmentStockInRequestItemPaged', items: Array<{ __typename?: 'ConsignmentStockInRequestItem', consignmentStockInRequestItemID: any, consignmentStockInRequestID: any, productID: any, productCode: string, productName: string, description: string, qtyRequested: number, qtyApproved: number, qtyReceived: number, uomID: any, uomName: string, expiredDate?: any | null, expiredDateConfirmed?: any | null, noteRequester: string, noteReason: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockInRequestLabelsQueryVariables = Exact<{
  consignmentStockInRequestID: Scalars['UUID']['input'];
}>;


export type VendorAppStockInRequestLabelsQuery = { __typename?: 'Query', consignmentStockInRequestLabels: Array<{ __typename?: 'ConsignmentStockInRequestLabel', productID: any, productCode: string, productName: string, barcode: string, sellingPrice: number, expiredDate?: any | null, copies: number, printable: boolean }> };

export type VendorAppStockInRequestListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInRequestQopInput>;
}>;


export type VendorAppStockInRequestListQuery = { __typename?: 'Query', consignmentStockInRequests: { __typename?: 'ConsignmentStockInRequestPaged', items: Array<{ __typename?: 'ConsignmentStockInRequest', consignmentStockInRequestID: any, consignmentStockInRequestNumber: string, requestDatetime: any, estimatedDeliveryDate: any, status: string, branchID: any, branchCode: string, branchName: string, totalItemQtyRequested: number, totalItemQtyApproved: number }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockInRequestLoadQueryVariables = Exact<{
  consignmentStockInRequestID: Scalars['UUID']['input'];
}>;


export type VendorAppStockInRequestLoadQuery = { __typename?: 'Query', consignmentStockInRequest?: { __typename?: 'ConsignmentStockInRequest', consignmentStockInRequestID: any, consignmentStockInRequestNumber: string, requestDatetime: any, estimatedDeliveryDate: any, status: string, branchID: any, branchCode: string, branchName: string, vendorCode: string, vendorName: string, noteAdditional: string, totalItemQtyRequested: number, totalItemQtyApproved: number, consignmentStockInID?: any | null, consignmentStockInNumber: string, submittedByUserName?: string | null, submittedDatetime?: any | null, approvedByUserName?: string | null, approvedDatetime?: any | null, rejectedByUserName?: string | null, rejectedDatetime?: any | null, rejectionReason?: string | null, cancelledByUserName?: string | null, cancelledDatetime?: any | null, cancellationReason?: string | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any } } | null };

export type VendorAppStockInRequestSummaryQueryVariables = Exact<{
  branchID?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type VendorAppStockInRequestSummaryQuery = { __typename?: 'Query', consignmentStockInRequestSummary: { __typename?: 'ConsignmentStockInRequestSummary', totalRequest: number, pending: number, approved: number, rejected: number } };

export type VendorAppStockOutItemsListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockOutItemQopInput>;
}>;


export type VendorAppStockOutItemsListQuery = { __typename?: 'Query', consignmentStockOutItems: { __typename?: 'ConsignmentStockOutItemPaged', items: Array<{ __typename?: 'ConsignmentStockOutItem', consignmentStockOutItemID: any, consignmentStockOutID: any, productID: any, productCode: string, productName: string, description: string, qty: number, uomName: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockOutListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockOutQopInput>;
}>;


export type VendorAppStockOutListQuery = { __typename?: 'Query', consignmentStockOuts: { __typename?: 'ConsignmentStockOutPaged', items: Array<{ __typename?: 'ConsignmentStockOut', consignmentStockOutID: any, consignmentStockOutNumber: string, consignmentStockOutDatetime: any, vendorID: any, warehouseID: any, externalReferenceNumber?: string | null, receivedByVendorName?: string | null, totalItemQty: number, status: string, warehouse: { __typename?: 'Warehouse', warehouseName: string, branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string } | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockOutLoadQueryVariables = Exact<{
  consignmentStockOutID: Scalars['UUID']['input'];
}>;


export type VendorAppStockOutLoadQuery = { __typename?: 'Query', consignmentStockOut?: { __typename?: 'ConsignmentStockOut', consignmentStockOutID: any, consignmentStockOutNumber: string, consignmentStockOutDatetime: any, status: string, externalReferenceNumber?: string | null, receivedByVendorName?: string | null, totalItemQty: number, noteInternal: string, warehouse: { __typename?: 'Warehouse', warehouseName: string, branch?: { __typename?: 'Branch', branchName: string } | null }, files?: Array<{ __typename?: 'ConsignmentStockOutFile', consignmentStockOutFileID: any, consignmentStockOutFileType: string, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null } | null };

export type VendorConsignmentDashboardQueryVariables = Exact<{
  filter: VendorConsignmentDashboardFilterInput;
}>;


export type VendorConsignmentDashboardQuery = { __typename?: 'Query', vendorConsignmentDashboard: { __typename?: 'VendorConsignmentDashboard', summary: { __typename?: 'VendorConsignmentDashboardSummary', grossSales: number, commissionAmount: number, commissionInclTaxAmount: number, vendorShareAmount: number, unitsSold: number, invoiceCount: number }, salesByBranch: Array<{ __typename?: 'VendorConsignmentDashboardBranchPoint', branchID: any, grossSales: number, vendorShareAmount: number, invoiceCount: number }>, topProducts: Array<{ __typename?: 'VendorConsignmentDashboardProductPoint', productID: any, productName: string, qty: number, grossSales: number, vendorShareAmount: number }>, topProductsByRevenue: Array<{ __typename?: 'VendorConsignmentDashboardProductPoint', productID: any, productName: string, qty: number, grossSales: number, vendorShareAmount: number }> } };

export type VendorConsignmentSalesExportQueryVariables = Exact<{
  filter: VendorConsignmentSalesExportFilterInput;
}>;


export type VendorConsignmentSalesExportQuery = { __typename?: 'Query', vendorConsignmentSalesExport: { __typename?: 'VendorConsignmentSalesExportResult', fileName: string, downloadURL: string } };

export type VendorInventoryCountExportQueryVariables = Exact<{
  filter: VendorInventoryCountReportFilterInput;
}>;


export type VendorInventoryCountExportQuery = { __typename?: 'Query', vendorInventoryCountExport: { __typename?: 'VendorInventoryCountExportResult', fileName: string, downloadURL: string } };

export type VendorInventoryCountListQueryVariables = Exact<{
  filter: VendorInventoryCountListFilterInput;
}>;


export type VendorInventoryCountListQuery = { __typename?: 'Query', vendorInventoryCountList: Array<{ __typename?: 'VendorInventoryCountListItem', inventoryCountTransactionID: any, inventoryCountTransactionNumber: string, inventoryCountTransactionDatetimeUtc: any, gmt: number, branchID: any, taskType: string, productCount: number, branch: { __typename?: 'Branch', branchID: any, branchName: string, branchCode: string } }> };

export type VendorInventoryCountReportQueryVariables = Exact<{
  qop: VendorInventoryCountReportQopInput;
}>;


export type VendorInventoryCountReportQuery = { __typename?: 'Query', vendorInventoryCountReport: { __typename?: 'VendorInventoryCountReport', execution?: { __typename?: 'VendorInventoryCountExecution', inventoryCountTransactionNumber: string, inventoryCountTransactionDatetimeUtc: any, gmt: number, branchID: any, warehouseID: any, taskType: string, note: string, officers: Array<string>, branch: { __typename?: 'Branch', branchID: any, branchName: string, branchCode: string } } | null, summary: { __typename?: 'VendorInventoryCountSummary', opnameCount: number, productCounted: number, matched: number, variance: number, netVarianceValue: number, shortageValue: number, overageValue: number }, items: { __typename?: 'VendorInventoryCountItemPaged', items?: Array<{ __typename?: 'VendorInventoryCountItem', inventoryCountTransactionResultItemID: any, inventoryCountTransactionID: any, inventoryCountTransactionNumber: string, countedAtUtc: any, gmt: number, branchID: any, warehouseID: any, productID: any, productCode: string, barcode: string, productName: string, uomName: string, qtySystem: number, qtyCounted: number, qtyDiff: number, note: string, unitCost: number, varianceValue: number, result: string, branch: { __typename?: 'Branch', branchID: any, branchName: string, branchCode: string } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } } };

export type VendorStockExportQueryVariables = Exact<{
  filter: VendorStockExportFilterInput;
}>;


export type VendorStockExportQuery = { __typename?: 'Query', vendorStockExport: { __typename?: 'VendorStockExportResult', fileName: string, downloadURL: string } };

export type VendorStockReconciliationQueryVariables = Exact<{
  filter: VendorStockReconciliationFilterInput;
}>;


export type VendorStockReconciliationQuery = { __typename?: 'Query', vendorStockReconciliation: { __typename?: 'VendorStockReconciliation', periodStart: any, countedAt: any, openingQty: any, stockInQty: any, soldQty: any, stockOutQty: any, returnQty: any, adjustmentQty: any, otherQty: any, closingQty: any, openingBalanceAvailable: boolean, ledgerComplete: boolean } };

export type VendorConsignmentRentalPaymentApproveMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentApproveInput;
}>;


export type VendorConsignmentRentalPaymentApproveMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentApprove: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string, approvedByUserName: string, approvedAt?: any | null } };

export type VendorConsignmentRentalPaymentListQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentRentalPaymentQopInput>;
}>;


export type VendorConsignmentRentalPaymentListQuery = { __typename?: 'Query', vendorConsignmentRentalPayments: { __typename?: 'VendorConsignmentRentalPaymentPaged', items?: Array<{ __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, vendorConsignmentRentalPaymentNumber: string, vendorConsignmentBranchID: any, vendorID: any, vendorName: string, branchID: any, branchName: string, transferAmount: number, transferDate: any, vendorNote: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, effectiveStartDate: any, effectiveEndDate: any, status: string, approvedByUserName: string, approvedAt?: any | null, rejectedReason: string, rejectedByUserName: string, rejectedAt?: any | null, files?: Array<{ __typename?: 'VendorConsignmentRentalPaymentFile', vendorConsignmentRentalPaymentFileID: any, vendorConsignmentRentalPaymentFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorConsignmentRentalPaymentLoadQueryVariables = Exact<{
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
}>;


export type VendorConsignmentRentalPaymentLoadQuery = { __typename?: 'Query', vendorConsignmentRentalPayment?: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, vendorConsignmentRentalPaymentNumber: string, vendorConsignmentBranchID: any, vendorID: any, vendorName: string, branchID: any, branchName: string, transferAmount: number, transferDate: any, vendorNote: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, effectiveStartDate: any, effectiveEndDate: any, status: string, settlementBankAccountID?: any | null, settlementBankName: string, settlementBankAccountNumber: string, approvedByUserName: string, approvedAt?: any | null, rejectedReason: string, rejectedByUserName: string, rejectedAt?: any | null, files?: Array<{ __typename?: 'VendorConsignmentRentalPaymentFile', vendorConsignmentRentalPaymentFileID: any, vendorConsignmentRentalPaymentFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any } } | null };

export type VendorConsignmentRentalPaymentRejectMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentRejectInput;
}>;


export type VendorConsignmentRentalPaymentRejectMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentReject: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string, rejectedReason: string, rejectedByUserName: string, rejectedAt?: any | null } };

export type VendorCreateAccessMutationVariables = Exact<{
  input: VendorCreateAccessInput;
}>;


export type VendorCreateAccessMutation = { __typename?: 'Mutation', vendorCreateAccess: { __typename?: 'Vendor', vendorID: any } };

export type VendorUpdateAccessMutationVariables = Exact<{
  input: VendorUpdateAccessInput;
}>;


export type VendorUpdateAccessMutation = { __typename?: 'Mutation', vendorUpdateAccess: { __typename?: 'Vendor', vendorID: any } };

export type VendorAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<VendorQopInput>;
}>;


export type VendorAutocompleteQuery = { __typename?: 'Query', vendors: { __typename?: 'VendorPaged', items?: Array<{ __typename?: 'Vendor', vendorID: any, vendorName: string, taxIncluded?: boolean | null, vendorCode: string, cityID: string, cityName: string, taxable?: boolean | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorConsignmentBranchDeleteMutationVariables = Exact<{
  vendorConsignmentBranchID: Scalars['UUID']['input'];
}>;


export type VendorConsignmentBranchDeleteMutation = { __typename?: 'Mutation', vendorConsignmentBranchDelete: boolean };

export type VendorCreateMutationVariables = Exact<{
  input: VendorCreateInput;
}>;


export type VendorCreateMutation = { __typename?: 'Mutation', vendorCreate: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, isConsignment?: boolean | null, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, uniqueKey: string, isActive?: boolean | null } };

export type VendorDeleteMutationVariables = Exact<{
  input: VendorDeleteInput;
}>;


export type VendorDeleteMutation = { __typename?: 'Mutation', vendorDelete: boolean };

export type VendorListQueryVariables = Exact<{
  qop?: InputMaybe<VendorQopInput>;
}>;


export type VendorListQuery = { __typename?: 'Query', vendors: { __typename?: 'VendorPaged', items?: Array<{ __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, isPKP: boolean, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentCommisionFeePerc?: number | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorLoadQueryVariables = Exact<{
  vendorID: Scalars['UUID']['input'];
}>;


export type VendorLoadQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, isPKP: boolean, taxable?: boolean | null, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null, vendorCategory: { __typename?: 'VendorCategory', vendorCategoryName: string }, vendorPicContacts: Array<{ __typename?: 'VendorPicContact', vendorPicContactID: any, vendorID: any, picName: string, picDepartment: string, picEmail: string, picPhoneNumber: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, vendorConsignmentProducts: Array<{ __typename?: 'VendorConsignmentProduct', productID: any, sellingPrice: number, product: { __typename?: 'Product', productCode: string, productName: string, barcode: string, baseUom?: { __typename?: 'Uom', uomName: string } | null } }>, vendorConsignmentBranch: Array<{ __typename?: 'VendorConsignmentBranch', vendorConsignmentBranchID: any, vendorID: any, branchID: any, branchCode: string, branchName: string, commissionFeePerc: number, isRent: boolean, rentPrice: number, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type VendorConsignmentProductCreateMutationVariables = Exact<{
  input: VendorConsignmentProductCreateInput;
}>;


export type VendorConsignmentProductCreateMutation = { __typename?: 'Mutation', vendorConsignmentProductCreate: { __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any } };

export type VendorConsignmentProductDeleteMutationVariables = Exact<{
  vendorConsignmentProductID: Scalars['UUID']['input'];
}>;


export type VendorConsignmentProductDeleteMutation = { __typename?: 'Mutation', vendorConsignmentProductDelete: boolean };

export type VendorConsignmentProductListQueryVariables = Exact<{
  qop: VendorConsignmentProductQopInput;
}>;


export type VendorConsignmentProductListQuery = { __typename?: 'Query', vendorConsignmentProducts: { __typename?: 'VendorConsignmentProductAggregatedPaged', items?: Array<{ __typename?: 'VendorConsignmentProductAggregated', productID: any, product: { __typename?: 'Product', productCode: string, productName: string, barcode: string, sellingPrice?: number | null, isActive: boolean, baseUom?: { __typename?: 'Uom', uomName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }, branchPrices: Array<{ __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any, sellingPrice: number, productCommissionFeePerc: number, isActive: boolean, branchID: any, branch: { __typename?: 'Branch', branchCode: string, branchName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type VendorConsignmentProductLoadQueryVariables = Exact<{
  vendorConsignmentProductID: Scalars['UUID']['input'];
}>;


export type VendorConsignmentProductLoadQuery = { __typename?: 'Query', vendorConsignmentProduct: { __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any, vendorID: any, productID: any, branchID: any, sellingPrice: number, isActive: boolean, uniqueKey: string } };

export type VendorConsignmentProductPricesUpdateMutationVariables = Exact<{
  input: VendorConsignmentProductPriceBulkUpdateInput;
}>;


export type VendorConsignmentProductPricesUpdateMutation = { __typename?: 'Mutation', vendorConsignmentProductPriceBulkUpdate: { __typename?: 'VendorConsignmentProductBulkUpdateResult', product: { __typename?: 'Product', productID: any }, updatedBranchPrices: Array<{ __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any }> } };

export type VendorConsignmentProductUpdateMutationVariables = Exact<{
  input: VendorConsignmentProductUpdateInput;
}>;


export type VendorConsignmentProductUpdateMutation = { __typename?: 'Mutation', vendorConsignmentProductUpdate: { __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any } };

export type VendorSetPortalAccessActiveMutationVariables = Exact<{
  input: VendorSetPortalAccessActiveInput;
}>;


export type VendorSetPortalAccessActiveMutation = { __typename?: 'Mutation', vendorSetPortalAccessActive: { __typename?: 'Vendor', vendorID: any, hasPortalAccess?: boolean | null } };

export type VendorUpdateMutationVariables = Exact<{
  input: VendorUpdateInput;
}>;


export type VendorUpdateMutation = { __typename?: 'Mutation', vendorUpdate: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, isConsignment?: boolean | null, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, uniqueKey: string, isActive?: boolean | null } };
